/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type {
  AcceptReferral,
  AddPaymentMethodRequest,
  AddPaymentMethodResponse,
  AmbassadorReferFromMessageExperiment,
  AmbassadorReferFromProfileExperiment,
  AnnouncementsDetailViewSchema,
  ApiAcceptReferralCreate200,
  ApiAccountSignupAppleCreateBody,
  ApiAccountSignupEmailCreateBody,
  ApiAccountSignupGoogleCreateBody,
  ApiAmbassadorReferFromMessageViewRetrieveParams,
  ApiAmbassadorReferFromProfileViewRetrieveParams,
  ApiAnnouncementsGlobalListParams,
  ApiAnnouncementsGlobalMobileListParams,
  ApiAnnouncementsMenuListParams,
  ApiAnnouncementsNotificationsListParams,
  ApiAppInstallSmsCreate200,
  ApiAppInstallSmsCreate400,
  ApiBlockingModalRetrieve200,
  ApiBreedListParams,
  ApiBrightHorizonsGlobalBannerRetrieveParams,
  ApiBrightHorizonsSitterProfileBannerRetrieveParams,
  ApiBundleRequestCreateListParams,
  ApiCatProviderProfileUpdate404,
  ApiChangeBirthdateCreate400,
  ApiChangeBirthdateCreateBody,
  ApiCheckDeactivationKetchCreate200,
  ApiCheckDeactivationKetchCreateBody,
  ApiCitiesAndNeighborhoodsRetrieve200,
  ApiCitiesAndNeighborhoodsRetrieveParams,
  ApiCommerceCheckoutScreenViewRetrieveParams,
  ApiCommerceOrderAdminToolbarViewRetrieveParams,
  ApiConversationAdhocListParams,
  ApiConversationDetailRetrieveParams,
  ApiConversationEventsListParams,
  ApiConversationListParams,
  ApiConversationReviewsListParams,
  ApiConversationScreenRetrieveParams,
  ApiConversationStayCancelCreate202,
  ApiConversationTodayUrlListRetrieve200,
  ApiConversationTractiveDiscountCodeRetrieve2Params,
  ApiConversationTractiveDiscountCodeRetrieveParams,
  ApiConversationVideosListParams,
  ApiCountryConfigurationListParams,
  ApiCountryFooterLinksListParams,
  ApiCountryRegionLinksListParams,
  ApiDailyBookingsRetrieveParams,
  ApiDeactivateKetchCreate200,
  ApiDeactivateKetchCreateBody,
  ApiDeviceListParams,
  ApiExperimentsCreate201,
  ApiExperimentsCreateBody,
  ApiExperimentsListParams,
  ApiFacilitiesContactPageRetrieveParams,
  ApiFacilitiesReservationTypesRetrieve200,
  ApiFacilitiesServiceHoursRetrieve200,
  ApiFacilitiesVetListParams,
  ApiFacilityBookingVaccineUploadCreateBody,
  ApiFavoriteSittersListParams,
  ApiFixturesBuildsRetrieveParams,
  ApiFixturesStepsRunEphemeralCreate200,
  ApiFixturesStepsRunEphemeralCreateBody,
  ApiFixturesTemplateRunCreate400,
  ApiFixturesTemplateRunCreate500,
  ApiFixturesTemplateRunCreateBody,
  ApiFixturesTemplatesListParams,
  ApiFixZendeskConflictErrorRetrieve202,
  ApiFixZendeskConflictErrorRetrieve400,
  ApiFrontendConfigurationRetrieve200,
  ApiFrontendConfigurationRetrieveParams,
  ApiFrontendDjangoMessagesListParams,
  ApiFrontendExperimentsListParams,
  ApiFrontendHomepageServiceTypesListParams,
  ApiFrontendHrefLangsRetrieve200,
  ApiFrontendHrefLangsRetrieveParams,
  ApiFrontendInternalLinkingCityRetrieve200,
  ApiFrontendInternalLinkingNeighborhoodRetrieve200,
  ApiFrontendInternalLinkingRegionRetrieve200,
  ApiFrontendServiceTypesListParams,
  ApiGenerateQrCodeRetrieve200,
  ApiGenerateQrCodeRetrieve400,
  ApiGenerateQrCodeRetrieveParams,
  ApiGeofenceListParams,
  ApiGoodpupReviewsSeoCityListParams,
  ApiGoodpupReviewsSeoCityWithoutCountryListParams,
  ApiHomeProfileDetailImagesListParams,
  ApiIdentityVerificationCandidateCheckRetrieve200,
  ApiIdentityVerificationCandidateSdkTokenRetrieve200,
  ApiIdentityVerificationCandidateSdkTokenRetrieve400,
  ApiIdentityVerificationCandidateSdkTokenRetrieve404,
  ApiIdentityVerificationCandidateUpdate200,
  ApiIdentityVerificationCandidateUpdate201,
  ApiIdentityVerificationCandidateUpdateBody,
  ApiIdentityVerificationInformationRetrieve200,
  ApiImagesUploadAuthorizeCreate201,
  ApiImagesUploadAuthorizeCreate400,
  ApiImagesUploadAuthorizeCreate403,
  ApiInboxListParams,
  ApiInboxSectionScreenRetrieveParams,
  ApiJobBoardListingAvailablePostingsRetrieveParams,
  ApiJobBoardListingRetrieveParams,
  ApiKey,
  ApiKeyFacebook,
  ApiKeyGoogle,
  ApiKeyPassword,
  ApiKnownPetsBucketingViewRetrieveParams,
  ApiLocationAutocompleteRetrieve200,
  ApiLocationAutocompleteRetrieveParams,
  ApiLocationDetailsCreate200,
  ApiLocationDetailsCreateParams,
  ApiLocationGeocodeRetrieve200,
  ApiLocationGeocodeRetrieveParams,
  ApiLocationQueryRetrieve200,
  ApiLocationQueryRetrieve400,
  ApiLocationQueryRetrieveParams,
  ApiMarketingOptInRetrieve200,
  ApiMobileSearchRetrieveParams,
  ApiNearbyTrainerCountRetrieveParams,
  ApiNewsletterSignupCreate200,
  ApiNonceCreate201,
  ApiPaymentMethodCreditcardCreate200,
  ApiPaymentMethodCreditcardCreate201,
  ApiPaymentMethodCreditcardListParams,
  ApiPaymentMethodCreditunitmethodListParams,
  ApiPaymentMethodDetailCreditcardCreate200,
  ApiPaymentMethodDetailCreditcardCreate201,
  ApiPaymentMethodDetailCreditcardListParams,
  ApiPaymentMethodDetailCreditunitmethodListParams,
  ApiPaymentMethodDetailGenericpaymentmethodListParams,
  ApiPaymentMethodDetailPayoutbankaccountCreate201,
  ApiPaymentMethodDetailPayoutbankaccountListParams,
  ApiPaymentMethodDetailPromoListParams,
  ApiPaymentMethodDetailWalletListParams,
  ApiPaymentMethodGenericpaymentmethodListParams,
  ApiPaymentMethodListParams,
  ApiPaymentMethodPayoutbankaccountCreate201,
  ApiPaymentMethodPayoutbankaccountListParams,
  ApiPaymentMethodPromoListParams,
  ApiPaymentMethodWalletListParams,
  ApiPersonCalendarPartialUpdateParams,
  ApiPersonCalendarRetrieveParams,
  ApiPersonCalendarUpdateParams,
  ApiPersonDataRedactionKetchCreate200,
  ApiPersonDataRedactionKetchCreateBody,
  ApiPersonDetailImagesListParams,
  ApiPersonDetailReviewsListParams,
  ApiPersonDetailStayMediaListParams,
  ApiPersonDetailVideosListParams,
  ApiPersonDsrEligibilityKetchCreate200,
  ApiPersonDsrEligibilityKetchCreateBody,
  ApiPersonEnhancedAddOnsListParams,
  ApiPersonFullSitterProfileRetrieveParams,
  ApiPersonListParams,
  ApiPersonProfileCitySeoRetrieveParams,
  ApiPersonPublicCalendarRetrieveParams,
  ApiPersonRelatedProvidersListParams,
  ApiPetDetailImagesCachedListParams,
  ApiPetDetailImagesListParams,
  ApiPetReviewsSummaryListParams,
  ApiPhoneDetailMakeDefaultUpdateBody,
  ApiPhoneDetailVerifyUpdateBody,
  ApiPhoneExistsCreate200,
  ApiPhoneExistsCreateBody,
  ApiPhoneListParams,
  ApiPhysicalArtifactsViewRetrieveParams,
  ApiPostalCodeLookupRetrieveParams,
  ApiProviderProfileRecommendedRatesCalculatorListParams,
  ApiQuizResponseCreate201,
  ApiRecommendedProvidersForConversationRetrieveParams,
  ApiRecurringBillingListParams,
  ApiRecurringSwitchToOneTimeCreateBody,
  ApiRelatedServicesListParams,
  ApiRelationshipCallPreferenceChoicesListParams,
  ApiRelationshipDetailRetrieveParams,
  ApiRelationshipListParams,
  ApiReviewsPetCreateCreate201,
  ApiReviewsTrainerTestimonialsCreate201,
  ApiSafetyQuizQuestionsRetrieve200,
  ApiSchemaRetrieve200One,
  ApiSchemaRetrieve200Two,
  ApiSchemaRetrieveParams,
  ApiSearchEndpointsRetrieve200,
  ApiSearchOptimizedRetrieveParams,
  ApiSearchRetrieveParams,
  ApiSearchSeoCityReviewsListParams,
  ApiSearchSeoCityWithoutCountryReviewsListParams,
  ApiSearchSeoNeighborhoodReviewsListParams,
  ApiSearchSeoNeighborhoodWithoutCountryReviewsListParams,
  ApiSearchServiceTypeRetrieveParams,
  ApiSearchWithTextCreate400,
  ApiSearchWithTextCreateBody,
  ApiServiceAreaIsochroneCreate200,
  ApiServiceContactabilityCreate200,
  ApiServiceDeliveryDetailImagesListParams,
  ApiServiceDeliveryListParams,
  ApiServiceDetailCalendarCreateBody,
  ApiServiceDetailCalendarRetrieve200,
  ApiServiceHolidayRateCheckRetrieveParams,
  ApiServiceLinksRetrieve200,
  ApiServiceTypesListParams,
  ApiSessionTypeOptionsListParams,
  ApiShortUrlCreateBody,
  ApiSsoZendeskRetrieve200,
  ApiSspArtifactsBucketingViewRetrieveParams,
  ApiTodayViewListParams,
  ApiTrainerCredentialOrganizationsListParams,
  ApiTrainingConversationsListParams,
  ApiTrainingCredentialsUploadCreateBody,
  ApiTrainingSearchRetrieveParams,
  ApiUserAgentRetrieve200,
  ApiUserEmailExistsKetchCreate200,
  ApiUserEmailExistsKetchCreateBody,
  ApiUserStaffNotesDeletionApprovedKetchCreate200,
  ApiUserStaffNotesDeletionApprovedKetchCreateBody,
  ApiUserStaffNotesDeletionDeniedKetchCreate200,
  ApiUserStaffNotesDeletionDeniedKetchCreateBody,
  ApiUserStaffNotesSarApprovedKetchCreate200,
  ApiUserStaffNotesSarApprovedKetchCreateBody,
  ApiVideoUploadAuthorizeCreate201,
  ApiVideoUploadAuthorizeCreate400,
  ApiVideoUploadAuthorizeCreate403,
  ApiWalletRedemptionCouponListParams,
  ApiWalletRedemptionListCreateBody,
  ApiWalletRedemptionListParams,
  ApiWebhookZendeskAssignTicketsToCorrespondingAgentCreateBody,
  ApiWebhookZendeskInboundCallTicketCreateBody,
  ApiWebhookZendeskUpdateUserCreateBody,
  AppInstallSMS,
  AuthorizeRequest,
  AuthorizeResponse,
  AutomaticRecordResponse,
  BackgroundCheckOrderInvoice,
  BackgroundCheckStatus,
  BaseUrlsIndex,
  BrightHorizonsCheckoutRequest,
  BrightHorizonsCheckoutResponse,
  BrightHorizonsCreditInactivity,
  BrightHorizonsExitPartnership,
  BrightHorizonsGlobalBanner,
  BrightHorizonsHubConfiguration,
  BrightHorizonsRedeemCredits,
  BrightHorizonsRedeemCreditsDetail,
  BrightHorizonsSitterProfileBanner,
  BuildSchema,
  BundleConversationDetailRequest,
  BundleOffering,
  BundleOfferingWrite,
  BundlePurchasePricingBody,
  BundleRequestCreation,
  BundleSessionPricing,
  CalculatedLockedServiceAddOns,
  CalendarPromptMessageSerializerOrEmpty,
  CalendarSettingsService,
  CalendarSettingsServiceSerializerListOrObject,
  CancelPagePricerRequest,
  CancelPaymentIntentRequest,
  CancelStayPricing,
  CatProviderProfile,
  Checkout,
  CheckoutCreditInfo,
  CheckoutPage,
  Choices,
  CitySEO,
  ClaimResponse,
  CombinedConfig,
  CommerceOrder,
  Config,
  Configuration,
  ConfirmationCheckout,
  ConnectAccountBookingModal,
  ContactPricerRequest,
  Conversation,
  ConversationCreation,
  ConversationDetail,
  ConversationDetailRequest,
  ConversationImages,
  ConversationRecommendedProvidersRead,
  ConversationRecommendedProvidersWrite,
  ConversationScreen,
  ConversationStayCancel,
  ConversationVideoCallRelationship,
  CountryConfiguration,
  CouponRedemption,
  CreateConfirmationTokenPaymentIntentRequest,
  CreateConfirmationTokenPaymentIntentResponse,
  CreateCreditCardMethod,
  CreateGenericPaymentIntentRequest,
  CreateGenericPIConfirmationTokenRequest,
  CreatePaymentIntentRequest,
  CreatePaymentIntentResponse,
  CreatePayoutBankAccountMethod,
  CreatePhone,
  CreateStripeConnectAccount,
  CredentialOrganization,
  CreditCardMethodSerializerListOrObject,
  CreditLedgerResponse,
  CreditUnitMethodSerializerListOrObject,
  CurrentUserViewSchema,
  DailyBookings,
  DailyDashboard,
  DateWithTimeRanges,
  Device,
  DeviceCreation,
  DeviceCreationRequest,
  DeviceNotificationCallback,
  DismissedTooltip,
  DogbuddyMigrationStatus,
  DogTrainingBehavior,
  DogTrainingResponse,
  DogTrainingTool,
  EdgeCacheMetric,
  EmailUpdate,
  EmailUpdateResponse,
  EmailVerificationCodeCreateRequest,
  EmailVerificationCodeRedeemRequest,
  EnhancedPersonSitterProfile,
  Error,
  ErrorResponsePlatformTaxReportingLogin400,
  ErrorResponsePlatformTaxReportingLogin500,
  EUSitterRequirement,
  ExternalReview,
  FacebookSignup,
  Facility,
  FacilityBookingCharges,
  FacilityBookingDetails,
  FacilityBookingMarkAsRead,
  FacilityBookingOwnerInfoViewOptional,
  FacilityBookingOwnerInfoViewRequired,
  FacilityBookingVaccineStatus,
  FacilityContactDefaultValues,
  FacilityContactOutreach,
  FacilityContactOutreachResponse,
  FacilityContactRequest,
  FacilityContactResponse,
  FacilityDaycarePreferences,
  FacilityEvalBook,
  FacilityEvalRequirement,
  FacilityEvalRequirementRequest,
  FacilityOperatingHours,
  FacilityReview,
  FacilityVeterinarian,
  FacilityWaiverAPIResponse,
  FlagSubmitRequest,
  Footer,
  FrontendEdgeCacheSafeExperiments,
  FrontendEventsResult,
  GenericPaymentMethodSerializerListOrObject,
  GetConnectAccounts,
  GiftCardRedemption,
  GingrGroupedReservationType,
  GlobalAnnouncements,
  GroomingSearchResults,
  HolidayAvailabilitySurveyDetailViewPutRequest,
  HolidayAvailabilitySurveyDetailViewPutResponse,
  HolidayRateResponse,
  HolidaySerializerOrEmpty,
  HomeAddressUpdate,
  HomepageConfiguration,
  HomepageRebookingProfile,
  HomepageServiceType,
  HomeProfile,
  HostingServicePreferences,
  HubResponse,
  Image,
  ImageOrdering,
  ImportedUserOnboarding,
  ImportedUserStatus,
  InboxMarkAllAsReadRequest,
  InboxMetadata,
  InboxScreen,
  InboxSectionContent,
  InternalCreditMethodSerializerListOrObject,
  JobBoardDetail,
  JobBoardListingView,
  JobBoardPostingCreateFromConversation,
  KnownPetsBucketing,
  LemonadePetInsuranceAvailability,
  LemonadePetUserForm,
  LemonadePetUserFormResponse,
  LemonadePetUserFormSubmit,
  LocalizedBrandService,
  LocalizedLinkURL,
  Lockbox,
  LockedServiceAddOn,
  LockedServiceAddOnRequest,
  LockedServiceAddOnsForRelationship,
  MarketingOptInModalRequest,
  Me,
  MeetAndGreet,
  MeetAndGreetSurvey,
  Message,
  MessageWithEvents,
  MobileSearchResponse,
  ModificationReasonChoices,
  ModuleGetResponse,
  ModulePostBody,
  ModulePostResponse,
  ModuleStateRequest,
  MultiDimensionalReview,
  MultiDimensionalReviewResponse,
  NearbyTrainerCountResponse,
  NewsletterSignup,
  NotificationEventTracking,
  NotificationsAnnouncements,
  OptimizedSearchResponse,
  Order,
  OrderAdminToolbar,
  OwnerDetail,
  PaginatedAdditionalSDVList,
  PaginatedBreedList,
  PaginatedBuildsSchema,
  PaginatedCategoryMenuAnnouncementsList,
  PaginatedConversationList,
  PaginatedCountryConfigurationList,
  PaginatedCountryFooterLinkList,
  PaginatedCountryRegionLinkList,
  PaginatedCouponRedemptionList,
  PaginatedDashboardTodayList,
  PaginatedDeviceList,
  PaginatedDjangoMessageList,
  PaginatedEnhancedAddOnsList,
  PaginatedEventList,
  PaginatedExperimentList,
  PaginatedFavoriteSitterList,
  PaginatedFrontendExperimentList,
  PaginatedGeofenceList,
  PaginatedGlobalAnnouncementsList,
  PaginatedGlobalAnnouncementsMobileList,
  PaginatedHolidayList,
  PaginatedImageList,
  PaginatedInboxList,
  PaginatedMediaList,
  PaginatedNotificationsAnnouncementsList,
  PaginatedPersonSummaryList,
  PaginatedPetReviewSummaryList,
  PaginatedPhoneList,
  PaginatedProviderRatingList,
  PaginatedRecurringBillingRelationshipList,
  PaginatedRedemptionSerializerBaseList,
  PaginatedRelationshipCallPreferenceList,
  PaginatedRelationshipList,
  PaginatedReviewDispatchList,
  PaginatedSEOOwnerReviewList,
  PaginatedServiceDeliveryList,
  PaginatedServiceList,
  PaginatedServiceTypeList,
  PaginatedVideoList,
  PartnerGiftCardInput,
  PartnerGiftCardOutput,
  PatchedBackgroundCheckOrderCompletePurchase,
  PatchedCalendarSettingsService,
  PatchedConversationProviderInterest,
  PatchedDogbuddyMigrationStatus,
  PatchedGlobalAnnouncements,
  PatchedHomeProfile,
  PatchedHostingServicePreferences,
  PatchedMultiDimensionalReview,
  PatchedMultiDimensionalReviewResponse,
  PatchedNotificationsAnnouncements,
  PatchedPersonCalendar,
  PatchedPersonConfirmedAvailabilityCalendar,
  PatchedPersonLocalization,
  PatchedPersonPrivateData,
  PatchedPetPreferences,
  PatchedPetWithProfileCompletion,
  PatchedProfileService,
  PatchedRatingResponse,
  PatchedService,
  PatchedServiceAreaPreferences,
  PatchedServiceCalendarSettings,
  PatchedServiceDelivery,
  PatchedServicePreferencesContent,
  PatchedTrainerProfileBehaviorsCustomWrite,
  PatchedTrainerProfileBehaviorsWrite,
  PatchedTrainerProfileSkillsCustomWrite,
  PatchedTrainerProfileSkillsWrite,
  PatchedTrainerProfileTrainerEducationWrite,
  PatchedTravelingServicePreferences,
  PatchedUpdateCreditCardMethod,
  PatchedWeekendAvailability,
  PayAcceptedRequest,
  PaymentDispatch,
  PaymentMethodDefaultViewPutRequest,
  PaymentMethodDefaultViewSchema,
  PaymentSheetRequest,
  PaymentSheetResponse,
  PayoutBankAccountMethodSerializerListOrObject,
  PendingReviews,
  Person,
  PersonCalendar,
  PersonCheckOrderResponse,
  PersonConfirmedAvailabilityCalendar,
  PersonDetailsShortIdentifier,
  PersonIDVOrderResponse,
  PersonLocalization,
  PersonLocation,
  PersonPets,
  PersonPreferences,
  PersonPrivateData,
  PersonPromotionAndReferral,
  PersonReferralUrl,
  PersonSitterProfile,
  PersonSummaryDetail,
  PersonTrainerProfile,
  Pet,
  PetPreferences,
  PetRatingURLReversal,
  PetReview,
  PetReviewDefinition,
  PetReviewResponse,
  PetSelector,
  PetWithProfileCompletion,
  Phone,
  PhoneVerificationMethod,
  PlatformTaxReporting,
  PostalCode,
  PostingsPage,
  PricingBody,
  ProfileService,
  ProfileServiceAddOn,
  ProviderInsightsViewResult,
  ProviderInterestedWithMessageInput,
  ProviderProfileAvailabilityPreferences,
  ProviderProfileServiceType,
  QuizResponse,
  RatingResponse,
  Recap2025,
  RecommendedRatesCalculator,
  RecurringBillingPricingListResponse,
  RecurringBillingRelationship,
  RecurringBillingRelationshipCancel,
  RecurringBillingRelationshipCreation,
  RecurringBillingRelationshipDetailRequest,
  RecurringPricing,
  RecurringScheduleUnit,
  RecurringScheduleWeeklyTemplates,
  RedemptionSerializerBase,
  ReferEmail,
  RelatedProviders,
  Relationship,
  RelationshipDetailBody,
  ReplicateSearchEventRequest,
  Report,
  ReportableReview,
  ReportConversation,
  ReportReasonsResponse,
  ReportResponse,
  ReportSubreasonsResponse,
  RequestDetail,
  RequesterReview,
  RequesterReviewApi,
  RetrieveCatProviderProfile,
  RetrieveSurvey,
  ReviewDispatch,
  Routing,
  RoverCardsMenuItem,
  S3Upload,
  SafetyAcknowledgement,
  SearchResponse,
  SeoLocationSchema,
  SerializedTrainerTestimonialRequest,
  Service,
  ServiceAreaIsochrone,
  ServiceAreaPreferences,
  ServiceCalendarSettings,
  ServiceContactability,
  ServiceDelivery,
  ServiceExperience,
  ServiceListViewRequest,
  ServicePreferencesContent,
  ServiceRatesResponse,
  ServiceRelationshipVideoLinkRead,
  ServiceRelationshipVideoLinkWrite,
  ServiceSelector,
  ServiceSelectorView,
  ServicesRates,
  SessionTypeOption,
  SetImageVisibilityRequest,
  SetLanguageRequest,
  ShortURL,
  SSPArtifactsBucketing,
  SSPBucketing,
  StarSitterInsights,
  StarSitterRolling,
  SterlingCandidateCreation,
  SurveySubmission,
  TemplateDetailSchema,
  Tip,
  TipChoiceList,
  TractiveDiscountCodeResponse,
  TrainerProfileBehaviors,
  TrainerProfileBehaviorsCustom,
  TrainerProfileBehaviorsCustomWrite,
  TrainerProfileBehaviorsWrite,
  TrainerProfileDetails,
  TrainerProfileDetailsDataRead,
  TrainerProfileDetailsDataWrite,
  TrainerProfileSkills,
  TrainerProfileSkillsCustom,
  TrainerProfileSkillsCustomWrite,
  TrainerProfileSkillsWrite,
  TrainerProfileTrainerEducation,
  TrainerProfileTrainerEducationWrite,
  TrainerReviewWrite,
  TrainerTestimonialCreateAPIInput,
  TrainerTestimonialRequestCreateAPIInput,
  TrainerTestimonialRequestCreateResponse,
  TrainingBehaviorSkillOptionsList,
  TrainingBundleSessionCreation,
  TrainingConversationBundleRequest,
  TrainingConversationCreation,
  TrainingSearchResponse,
  TravelingServicePreferences,
  TwilioWebhookNotification,
  UpcomingWeeklyUnits,
  UserFacilitiesContextResponse,
  ValidateEmailValidationErrorResponse,
  ValidatePassword,
  ValidatePasswordValidationErrorResponse,
  ValidateZipCode,
  Video,
  VideoCallRoom,
  VideoWithEvents,
  Walk,
  WalletMethodSerializerListOrObject,
  WebhookFixtureMinSchema,
  WebhookFixturePostSchema,
  WebhookFixtureSchema,
  WeekendAvailability,
  ZipLocation,
} from './model';

export const apiBaseUrlsIndexRetrieve = (signal?: AbortSignal) => {
  return HTTP<BaseUrlsIndex>({ url: `/api/v7/`, method: 'get', signal });
};

export const getApiBaseUrlsIndexRetrieveQueryKey = () => [`/api/v7/`];

export type ApiBaseUrlsIndexRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiBaseUrlsIndexRetrieve>>
>;
export type ApiBaseUrlsIndexRetrieveQueryError = ErrorType<unknown>;

export const useApiBaseUrlsIndexRetrieve = <
  TData = Awaited<ReturnType<typeof apiBaseUrlsIndexRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiBaseUrlsIndexRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiBaseUrlsIndexRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiBaseUrlsIndexRetrieve>>> = ({
    signal,
  }) => apiBaseUrlsIndexRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiBaseUrlsIndexRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiAcceptReferralCreate = (acceptReferral: AcceptReferral) => {
  return HTTP<ApiAcceptReferralCreate200>({
    url: `/api/v7/accept-referral/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: acceptReferral,
  });
};

export type ApiAcceptReferralCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAcceptReferralCreate>>
>;
export type ApiAcceptReferralCreateMutationBody = AcceptReferral;
export type ApiAcceptReferralCreateMutationError = ErrorType<AcceptReferral>;

export const useApiAcceptReferralCreate = <
  TError = ErrorType<AcceptReferral>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAcceptReferralCreate>>,
    TError,
    { data: AcceptReferral },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAcceptReferralCreate>>,
    { data: AcceptReferral }
  > = (props) => {
    const { data } = props ?? {};

    return apiAcceptReferralCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiAcceptReferralCreate>>,
    TError,
    { data: AcceptReferral },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Generate a PDF of the annual 1099k summary for a given year and currency.
 */
export const apiAccountAnnual1099kSummaryPdfRetrieve = (
  currency: string,
  year: string,
  signal?: AbortSignal
) => {
  return HTTP<void>({
    url: `/api/v7/account/annual-1099k-summary-pdf/${currency}/${year}/`,
    method: 'get',
    signal,
  });
};

export const getApiAccountAnnual1099kSummaryPdfRetrieveQueryKey = (
  currency: string,
  year: string
) => [`/api/v7/account/annual-1099k-summary-pdf/${currency}/${year}/`];

export type ApiAccountAnnual1099kSummaryPdfRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountAnnual1099kSummaryPdfRetrieve>>
>;
export type ApiAccountAnnual1099kSummaryPdfRetrieveQueryError = ErrorType<unknown>;

export const useApiAccountAnnual1099kSummaryPdfRetrieve = <
  TData = Awaited<ReturnType<typeof apiAccountAnnual1099kSummaryPdfRetrieve>>,
  TError = ErrorType<unknown>
>(
  currency: string,
  year: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiAccountAnnual1099kSummaryPdfRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiAccountAnnual1099kSummaryPdfRetrieveQueryKey(currency, year);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiAccountAnnual1099kSummaryPdfRetrieve>>
  > = ({ signal }) => apiAccountAnnual1099kSummaryPdfRetrieve(currency, year, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiAccountAnnual1099kSummaryPdfRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(currency && year),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiAccountCollectOwnerPhotoDisplayedCreate = () => {
  return HTTP<void>({ url: `/api/v7/account/collect-owner-photo-displayed/`, method: 'post' });
};

export type ApiAccountCollectOwnerPhotoDisplayedCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountCollectOwnerPhotoDisplayedCreate>>
>;

export type ApiAccountCollectOwnerPhotoDisplayedCreateMutationError = ErrorType<unknown>;

export const useApiAccountCollectOwnerPhotoDisplayedCreate = <
  TError = ErrorType<unknown>,
  TVariables = void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAccountCollectOwnerPhotoDisplayedCreate>>,
    TError,
    TVariables,
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAccountCollectOwnerPhotoDisplayedCreate>>,
    TVariables
  > = () => {
    return apiAccountCollectOwnerPhotoDisplayedCreate();
  };

  return useMutation<
    Awaited<ReturnType<typeof apiAccountCollectOwnerPhotoDisplayedCreate>>,
    TError,
    TVariables,
    TContext
  >(mutationFn, mutationOptions);
};

export const apiAccountDismissTooltipCreate = (dismissedTooltip: DismissedTooltip) => {
  return HTTP<DismissedTooltip>({
    url: `/api/v7/account/dismiss-tooltip/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: dismissedTooltip,
  });
};

export type ApiAccountDismissTooltipCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountDismissTooltipCreate>>
>;
export type ApiAccountDismissTooltipCreateMutationBody = DismissedTooltip;
export type ApiAccountDismissTooltipCreateMutationError = ErrorType<Error>;

export const useApiAccountDismissTooltipCreate = <
  TError = ErrorType<Error>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAccountDismissTooltipCreate>>,
    TError,
    { data: DismissedTooltip },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAccountDismissTooltipCreate>>,
    { data: DismissedTooltip }
  > = (props) => {
    const { data } = props ?? {};

    return apiAccountDismissTooltipCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiAccountDismissTooltipCreate>>,
    TError,
    { data: DismissedTooltip },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiAccountEmailUpdateCreate = (emailUpdate: EmailUpdate) => {
  return HTTP<EmailUpdateResponse>({
    url: `/api/v7/account/email-update/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: emailUpdate,
  });
};

export type ApiAccountEmailUpdateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountEmailUpdateCreate>>
>;
export type ApiAccountEmailUpdateCreateMutationBody = EmailUpdate;
export type ApiAccountEmailUpdateCreateMutationError = ErrorType<Error>;

export const useApiAccountEmailUpdateCreate = <
  TError = ErrorType<Error>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAccountEmailUpdateCreate>>,
    TError,
    { data: EmailUpdate },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAccountEmailUpdateCreate>>,
    { data: EmailUpdate }
  > = (props) => {
    const { data } = props ?? {};

    return apiAccountEmailUpdateCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiAccountEmailUpdateCreate>>,
    TError,
    { data: EmailUpdate },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiAccountEmailVerificationGenerateCreate = (
  emailVerificationCodeCreateRequest: EmailVerificationCodeCreateRequest
) => {
  return HTTP<void>({
    url: `/api/v7/account/email-verification/code/generate/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: emailVerificationCodeCreateRequest,
  });
};

export type ApiAccountEmailVerificationGenerateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountEmailVerificationGenerateCreate>>
>;
export type ApiAccountEmailVerificationGenerateCreateMutationBody =
  EmailVerificationCodeCreateRequest;
export type ApiAccountEmailVerificationGenerateCreateMutationError = ErrorType<unknown>;

export const useApiAccountEmailVerificationGenerateCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAccountEmailVerificationGenerateCreate>>,
    TError,
    { data: EmailVerificationCodeCreateRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAccountEmailVerificationGenerateCreate>>,
    { data: EmailVerificationCodeCreateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiAccountEmailVerificationGenerateCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiAccountEmailVerificationGenerateCreate>>,
    TError,
    { data: EmailVerificationCodeCreateRequest },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiAccountEmailVerificationRedeemCreate = (
  emailVerificationCodeRedeemRequest: EmailVerificationCodeRedeemRequest
) => {
  return HTTP<void>({
    url: `/api/v7/account/email-verification/code/redeem/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: emailVerificationCodeRedeemRequest,
  });
};

export type ApiAccountEmailVerificationRedeemCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountEmailVerificationRedeemCreate>>
>;
export type ApiAccountEmailVerificationRedeemCreateMutationBody =
  EmailVerificationCodeRedeemRequest;
export type ApiAccountEmailVerificationRedeemCreateMutationError = ErrorType<unknown>;

export const useApiAccountEmailVerificationRedeemCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAccountEmailVerificationRedeemCreate>>,
    TError,
    { data: EmailVerificationCodeRedeemRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAccountEmailVerificationRedeemCreate>>,
    { data: EmailVerificationCodeRedeemRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiAccountEmailVerificationRedeemCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiAccountEmailVerificationRedeemCreate>>,
    TError,
    { data: EmailVerificationCodeRedeemRequest },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Generate a PDF of the 1099k for a given year and currency.
 */
export const apiAccountForm1099kPdfRetrieve = (
  year: string,
  jurisdiction: string,
  signal?: AbortSignal
) => {
  return HTTP<void>({
    url: `/api/v7/account/form-1099k-pdf/${year}/${jurisdiction}/`,
    method: 'get',
    signal,
  });
};

export const getApiAccountForm1099kPdfRetrieveQueryKey = (year: string, jurisdiction: string) => [
  `/api/v7/account/form-1099k-pdf/${year}/${jurisdiction}/`,
];

export type ApiAccountForm1099kPdfRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountForm1099kPdfRetrieve>>
>;
export type ApiAccountForm1099kPdfRetrieveQueryError = ErrorType<unknown>;

export const useApiAccountForm1099kPdfRetrieve = <
  TData = Awaited<ReturnType<typeof apiAccountForm1099kPdfRetrieve>>,
  TError = ErrorType<unknown>
>(
  year: string,
  jurisdiction: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiAccountForm1099kPdfRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiAccountForm1099kPdfRetrieveQueryKey(year, jurisdiction);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountForm1099kPdfRetrieve>>> = ({
    signal,
  }) => apiAccountForm1099kPdfRetrieve(year, jurisdiction, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiAccountForm1099kPdfRetrieve>>, TError, TData>(
    {
      queryKey,
      queryFn,
      enabled: !!(year && jurisdiction),
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      ...queryOptions,
    }
  ) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiAccountHomeAddressUpdateCreate = (homeAddressUpdate: HomeAddressUpdate) => {
  return HTTP<PersonLocation>({
    url: `/api/v7/account/home-address-update/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: homeAddressUpdate,
  });
};

export type ApiAccountHomeAddressUpdateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountHomeAddressUpdateCreate>>
>;
export type ApiAccountHomeAddressUpdateCreateMutationBody = HomeAddressUpdate;
export type ApiAccountHomeAddressUpdateCreateMutationError = ErrorType<Error>;

export const useApiAccountHomeAddressUpdateCreate = <
  TError = ErrorType<Error>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAccountHomeAddressUpdateCreate>>,
    TError,
    { data: HomeAddressUpdate },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAccountHomeAddressUpdateCreate>>,
    { data: HomeAddressUpdate }
  > = (props) => {
    const { data } = props ?? {};

    return apiAccountHomeAddressUpdateCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiAccountHomeAddressUpdateCreate>>,
    TError,
    { data: HomeAddressUpdate },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiAccountSignupAppleCreate = (
  apiAccountSignupAppleCreateBody: ApiAccountSignupAppleCreateBody
) => {
  return HTTP<ApiKey>({
    url: `/api/v7/account/signup/apple/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiAccountSignupAppleCreateBody,
  });
};

export type ApiAccountSignupAppleCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountSignupAppleCreate>>
>;
export type ApiAccountSignupAppleCreateMutationBody = ApiAccountSignupAppleCreateBody;
export type ApiAccountSignupAppleCreateMutationError = ErrorType<unknown>;

export const useApiAccountSignupAppleCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAccountSignupAppleCreate>>,
    TError,
    { data: ApiAccountSignupAppleCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAccountSignupAppleCreate>>,
    { data: ApiAccountSignupAppleCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiAccountSignupAppleCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiAccountSignupAppleCreate>>,
    TError,
    { data: ApiAccountSignupAppleCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiAccountSignupEmailCreate = (
  apiAccountSignupEmailCreateBody: ApiAccountSignupEmailCreateBody
) => {
  return HTTP<ApiKey>({
    url: `/api/v7/account/signup/email/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiAccountSignupEmailCreateBody,
  });
};

export type ApiAccountSignupEmailCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountSignupEmailCreate>>
>;
export type ApiAccountSignupEmailCreateMutationBody = ApiAccountSignupEmailCreateBody;
export type ApiAccountSignupEmailCreateMutationError = ErrorType<void>;

export const useApiAccountSignupEmailCreate = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAccountSignupEmailCreate>>,
    TError,
    { data: ApiAccountSignupEmailCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAccountSignupEmailCreate>>,
    { data: ApiAccountSignupEmailCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiAccountSignupEmailCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiAccountSignupEmailCreate>>,
    TError,
    { data: ApiAccountSignupEmailCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiAccountSignupFacebookCreate = (facebookSignup: FacebookSignup) => {
  return HTTP<ApiKey>({
    url: `/api/v7/account/signup/facebook/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: facebookSignup,
  });
};

export type ApiAccountSignupFacebookCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountSignupFacebookCreate>>
>;
export type ApiAccountSignupFacebookCreateMutationBody = FacebookSignup;
export type ApiAccountSignupFacebookCreateMutationError = ErrorType<unknown>;

export const useApiAccountSignupFacebookCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAccountSignupFacebookCreate>>,
    TError,
    { data: FacebookSignup },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAccountSignupFacebookCreate>>,
    { data: FacebookSignup }
  > = (props) => {
    const { data } = props ?? {};

    return apiAccountSignupFacebookCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiAccountSignupFacebookCreate>>,
    TError,
    { data: FacebookSignup },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiAccountSignupGoogleCreate = (
  apiAccountSignupGoogleCreateBody: ApiAccountSignupGoogleCreateBody
) => {
  return HTTP<ApiKey>({
    url: `/api/v7/account/signup/google/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiAccountSignupGoogleCreateBody,
  });
};

export type ApiAccountSignupGoogleCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAccountSignupGoogleCreate>>
>;
export type ApiAccountSignupGoogleCreateMutationBody = ApiAccountSignupGoogleCreateBody;
export type ApiAccountSignupGoogleCreateMutationError = ErrorType<unknown>;

export const useApiAccountSignupGoogleCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAccountSignupGoogleCreate>>,
    TError,
    { data: ApiAccountSignupGoogleCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAccountSignupGoogleCreate>>,
    { data: ApiAccountSignupGoogleCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiAccountSignupGoogleCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiAccountSignupGoogleCreate>>,
    TError,
    { data: ApiAccountSignupGoogleCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * API to attach a payment method created in Stripe Payment elements to the Stripe
customer and save in Rover DB
Sometimes Stripe passes us a payment method ID that the customer already has
so we've added our own de-duping.
If the card already exists, return it rather than adding it again.
 */
export const apiAddPaymentMethodCreate = (addPaymentMethodRequest: AddPaymentMethodRequest) => {
  return HTTP<AddPaymentMethodResponse>({
    url: `/api/v7/add-payment-method/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: addPaymentMethodRequest,
  });
};

export type ApiAddPaymentMethodCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAddPaymentMethodCreate>>
>;
export type ApiAddPaymentMethodCreateMutationBody = AddPaymentMethodRequest;
export type ApiAddPaymentMethodCreateMutationError = ErrorType<unknown>;

export const useApiAddPaymentMethodCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAddPaymentMethodCreate>>,
    TError,
    { data: AddPaymentMethodRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAddPaymentMethodCreate>>,
    { data: AddPaymentMethodRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiAddPaymentMethodCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiAddPaymentMethodCreate>>,
    TError,
    { data: AddPaymentMethodRequest },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiAmbassadorReferFromMessageViewRetrieve = (
  params?: ApiAmbassadorReferFromMessageViewRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<AmbassadorReferFromMessageExperiment>({
    url: `/api/v7/ambassador/refer-from-message/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiAmbassadorReferFromMessageViewRetrieveQueryKey = (
  params?: ApiAmbassadorReferFromMessageViewRetrieveParams
) => [`/api/v7/ambassador/refer-from-message/`, ...(params ? [params] : [])];

export type ApiAmbassadorReferFromMessageViewRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAmbassadorReferFromMessageViewRetrieve>>
>;
export type ApiAmbassadorReferFromMessageViewRetrieveQueryError = ErrorType<unknown>;

export const useApiAmbassadorReferFromMessageViewRetrieve = <
  TData = Awaited<ReturnType<typeof apiAmbassadorReferFromMessageViewRetrieve>>,
  TError = ErrorType<unknown>
>(
  params?: ApiAmbassadorReferFromMessageViewRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiAmbassadorReferFromMessageViewRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiAmbassadorReferFromMessageViewRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiAmbassadorReferFromMessageViewRetrieve>>
  > = ({ signal }) => apiAmbassadorReferFromMessageViewRetrieve(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiAmbassadorReferFromMessageViewRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiAmbassadorReferFromProfileViewRetrieve = (
  params?: ApiAmbassadorReferFromProfileViewRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<AmbassadorReferFromProfileExperiment>({
    url: `/api/v7/ambassador/refer-from-profile/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiAmbassadorReferFromProfileViewRetrieveQueryKey = (
  params?: ApiAmbassadorReferFromProfileViewRetrieveParams
) => [`/api/v7/ambassador/refer-from-profile/`, ...(params ? [params] : [])];

export type ApiAmbassadorReferFromProfileViewRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAmbassadorReferFromProfileViewRetrieve>>
>;
export type ApiAmbassadorReferFromProfileViewRetrieveQueryError = ErrorType<unknown>;

export const useApiAmbassadorReferFromProfileViewRetrieve = <
  TData = Awaited<ReturnType<typeof apiAmbassadorReferFromProfileViewRetrieve>>,
  TError = ErrorType<unknown>
>(
  params?: ApiAmbassadorReferFromProfileViewRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiAmbassadorReferFromProfileViewRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiAmbassadorReferFromProfileViewRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiAmbassadorReferFromProfileViewRetrieve>>
  > = ({ signal }) => apiAmbassadorReferFromProfileViewRetrieve(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiAmbassadorReferFromProfileViewRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiAnnouncementsDetailRetrieve = (signal?: AbortSignal) => {
  return HTTP<AnnouncementsDetailViewSchema>({
    url: `/api/v7/announcements/`,
    method: 'get',
    signal,
  });
};

export const getApiAnnouncementsDetailRetrieveQueryKey = () => [`/api/v7/announcements/`];

export type ApiAnnouncementsDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAnnouncementsDetailRetrieve>>
>;
export type ApiAnnouncementsDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiAnnouncementsDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiAnnouncementsDetailRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiAnnouncementsDetailRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiAnnouncementsDetailRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAnnouncementsDetailRetrieve>>> = ({
    signal,
  }) => apiAnnouncementsDetailRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiAnnouncementsDetailRetrieve>>, TError, TData>(
    { queryKey, queryFn, refetchOnMount: false, refetchOnWindowFocus: false, ...queryOptions }
  ) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiAnnouncementsGlobalList = (
  params?: ApiAnnouncementsGlobalListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedGlobalAnnouncementsList>({
    url: `/api/v7/announcements/global/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiAnnouncementsGlobalListQueryKey = (
  params?: ApiAnnouncementsGlobalListParams
) => [`/api/v7/announcements/global/`, ...(params ? [params] : [])];

export type ApiAnnouncementsGlobalListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAnnouncementsGlobalList>>
>;
export type ApiAnnouncementsGlobalListQueryError = ErrorType<unknown>;

export const useApiAnnouncementsGlobalList = <
  TData = Awaited<ReturnType<typeof apiAnnouncementsGlobalList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiAnnouncementsGlobalListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiAnnouncementsGlobalList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiAnnouncementsGlobalListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAnnouncementsGlobalList>>> = ({
    signal,
  }) => apiAnnouncementsGlobalList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiAnnouncementsGlobalList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiAnnouncementsGlobalDetailRetrieve = (slug: string, signal?: AbortSignal) => {
  return HTTP<GlobalAnnouncements>({
    url: `/api/v7/announcements/global/${slug}/`,
    method: 'get',
    signal,
  });
};

export const getApiAnnouncementsGlobalDetailRetrieveQueryKey = (slug: string) => [
  `/api/v7/announcements/global/${slug}/`,
];

export type ApiAnnouncementsGlobalDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAnnouncementsGlobalDetailRetrieve>>
>;
export type ApiAnnouncementsGlobalDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiAnnouncementsGlobalDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiAnnouncementsGlobalDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiAnnouncementsGlobalDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiAnnouncementsGlobalDetailRetrieveQueryKey(slug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiAnnouncementsGlobalDetailRetrieve>>
  > = ({ signal }) => apiAnnouncementsGlobalDetailRetrieve(slug, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiAnnouncementsGlobalDetailRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!slug,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiAnnouncementsGlobalDetailUpdate = (
  slug: string,
  globalAnnouncements: GlobalAnnouncements
) => {
  return HTTP<GlobalAnnouncements>({
    url: `/api/v7/announcements/global/${slug}/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: globalAnnouncements,
  });
};

export type ApiAnnouncementsGlobalDetailUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAnnouncementsGlobalDetailUpdate>>
>;
export type ApiAnnouncementsGlobalDetailUpdateMutationBody = GlobalAnnouncements;
export type ApiAnnouncementsGlobalDetailUpdateMutationError = ErrorType<unknown>;

export const useApiAnnouncementsGlobalDetailUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAnnouncementsGlobalDetailUpdate>>,
    TError,
    { slug: string; data: GlobalAnnouncements },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAnnouncementsGlobalDetailUpdate>>,
    { slug: string; data: GlobalAnnouncements }
  > = (props) => {
    const { slug, data } = props ?? {};

    return apiAnnouncementsGlobalDetailUpdate(slug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiAnnouncementsGlobalDetailUpdate>>,
    TError,
    { slug: string; data: GlobalAnnouncements },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiAnnouncementsGlobalDetailPartialUpdate = (
  slug: string,
  patchedGlobalAnnouncements: PatchedGlobalAnnouncements
) => {
  return HTTP<GlobalAnnouncements>({
    url: `/api/v7/announcements/global/${slug}/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedGlobalAnnouncements,
  });
};

export type ApiAnnouncementsGlobalDetailPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAnnouncementsGlobalDetailPartialUpdate>>
>;
export type ApiAnnouncementsGlobalDetailPartialUpdateMutationBody = PatchedGlobalAnnouncements;
export type ApiAnnouncementsGlobalDetailPartialUpdateMutationError = ErrorType<unknown>;

export const useApiAnnouncementsGlobalDetailPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAnnouncementsGlobalDetailPartialUpdate>>,
    TError,
    { slug: string; data: PatchedGlobalAnnouncements },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAnnouncementsGlobalDetailPartialUpdate>>,
    { slug: string; data: PatchedGlobalAnnouncements }
  > = (props) => {
    const { slug, data } = props ?? {};

    return apiAnnouncementsGlobalDetailPartialUpdate(slug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiAnnouncementsGlobalDetailPartialUpdate>>,
    TError,
    { slug: string; data: PatchedGlobalAnnouncements },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiAnnouncementsGlobalMobileList = (
  params?: ApiAnnouncementsGlobalMobileListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedGlobalAnnouncementsMobileList>({
    url: `/api/v7/announcements/global/mobile/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiAnnouncementsGlobalMobileListQueryKey = (
  params?: ApiAnnouncementsGlobalMobileListParams
) => [`/api/v7/announcements/global/mobile/`, ...(params ? [params] : [])];

export type ApiAnnouncementsGlobalMobileListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAnnouncementsGlobalMobileList>>
>;
export type ApiAnnouncementsGlobalMobileListQueryError = ErrorType<unknown>;

export const useApiAnnouncementsGlobalMobileList = <
  TData = Awaited<ReturnType<typeof apiAnnouncementsGlobalMobileList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiAnnouncementsGlobalMobileListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiAnnouncementsGlobalMobileList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiAnnouncementsGlobalMobileListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAnnouncementsGlobalMobileList>>> = ({
    signal,
  }) => apiAnnouncementsGlobalMobileList(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiAnnouncementsGlobalMobileList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiAnnouncementsMenuList = (
  params?: ApiAnnouncementsMenuListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedCategoryMenuAnnouncementsList>({
    url: `/api/v7/announcements/menu/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiAnnouncementsMenuListQueryKey = (params?: ApiAnnouncementsMenuListParams) => [
  `/api/v7/announcements/menu/`,
  ...(params ? [params] : []),
];

export type ApiAnnouncementsMenuListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAnnouncementsMenuList>>
>;
export type ApiAnnouncementsMenuListQueryError = ErrorType<unknown>;

export const useApiAnnouncementsMenuList = <
  TData = Awaited<ReturnType<typeof apiAnnouncementsMenuList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiAnnouncementsMenuListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiAnnouncementsMenuList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiAnnouncementsMenuListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAnnouncementsMenuList>>> = ({
    signal,
  }) => apiAnnouncementsMenuList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiAnnouncementsMenuList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiAnnouncementsNotificationsList = (
  params?: ApiAnnouncementsNotificationsListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedNotificationsAnnouncementsList>({
    url: `/api/v7/announcements/notifications/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiAnnouncementsNotificationsListQueryKey = (
  params?: ApiAnnouncementsNotificationsListParams
) => [`/api/v7/announcements/notifications/`, ...(params ? [params] : [])];

export type ApiAnnouncementsNotificationsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAnnouncementsNotificationsList>>
>;
export type ApiAnnouncementsNotificationsListQueryError = ErrorType<unknown>;

export const useApiAnnouncementsNotificationsList = <
  TData = Awaited<ReturnType<typeof apiAnnouncementsNotificationsList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiAnnouncementsNotificationsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiAnnouncementsNotificationsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiAnnouncementsNotificationsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAnnouncementsNotificationsList>>> = ({
    signal,
  }) => apiAnnouncementsNotificationsList(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiAnnouncementsNotificationsList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiAnnouncementsNotificationsDetailRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<NotificationsAnnouncements>({
    url: `/api/v7/announcements/notifications/${opk}/`,
    method: 'get',
    signal,
  });
};

export const getApiAnnouncementsNotificationsDetailRetrieveQueryKey = (opk: string) => [
  `/api/v7/announcements/notifications/${opk}/`,
];

export type ApiAnnouncementsNotificationsDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAnnouncementsNotificationsDetailRetrieve>>
>;
export type ApiAnnouncementsNotificationsDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiAnnouncementsNotificationsDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiAnnouncementsNotificationsDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiAnnouncementsNotificationsDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiAnnouncementsNotificationsDetailRetrieveQueryKey(opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiAnnouncementsNotificationsDetailRetrieve>>
  > = ({ signal }) => apiAnnouncementsNotificationsDetailRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiAnnouncementsNotificationsDetailRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiAnnouncementsNotificationsDetailUpdate = (
  opk: string,
  notificationsAnnouncements: NotificationsAnnouncements
) => {
  return HTTP<NotificationsAnnouncements>({
    url: `/api/v7/announcements/notifications/${opk}/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: notificationsAnnouncements,
  });
};

export type ApiAnnouncementsNotificationsDetailUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAnnouncementsNotificationsDetailUpdate>>
>;
export type ApiAnnouncementsNotificationsDetailUpdateMutationBody = NotificationsAnnouncements;
export type ApiAnnouncementsNotificationsDetailUpdateMutationError = ErrorType<unknown>;

export const useApiAnnouncementsNotificationsDetailUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAnnouncementsNotificationsDetailUpdate>>,
    TError,
    { opk: string; data: NotificationsAnnouncements },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAnnouncementsNotificationsDetailUpdate>>,
    { opk: string; data: NotificationsAnnouncements }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiAnnouncementsNotificationsDetailUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiAnnouncementsNotificationsDetailUpdate>>,
    TError,
    { opk: string; data: NotificationsAnnouncements },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiAnnouncementsNotificationsDetailPartialUpdate = (
  opk: string,
  patchedNotificationsAnnouncements: PatchedNotificationsAnnouncements
) => {
  return HTTP<NotificationsAnnouncements>({
    url: `/api/v7/announcements/notifications/${opk}/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedNotificationsAnnouncements,
  });
};

export type ApiAnnouncementsNotificationsDetailPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAnnouncementsNotificationsDetailPartialUpdate>>
>;
export type ApiAnnouncementsNotificationsDetailPartialUpdateMutationBody =
  PatchedNotificationsAnnouncements;
export type ApiAnnouncementsNotificationsDetailPartialUpdateMutationError = ErrorType<unknown>;

export const useApiAnnouncementsNotificationsDetailPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAnnouncementsNotificationsDetailPartialUpdate>>,
    TError,
    { opk: string; data: PatchedNotificationsAnnouncements },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAnnouncementsNotificationsDetailPartialUpdate>>,
    { opk: string; data: PatchedNotificationsAnnouncements }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiAnnouncementsNotificationsDetailPartialUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiAnnouncementsNotificationsDetailPartialUpdate>>,
    TError,
    { opk: string; data: PatchedNotificationsAnnouncements },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiApiKeyResponseRetrieve = (signal?: AbortSignal) => {
  return HTTP<ApiKey>({ url: `/api/v7/api_key/`, method: 'get', signal });
};

export const getApiApiKeyResponseRetrieveQueryKey = () => [`/api/v7/api_key/`];

export type ApiApiKeyResponseRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiApiKeyResponseRetrieve>>
>;
export type ApiApiKeyResponseRetrieveQueryError = ErrorType<unknown>;

export const useApiApiKeyResponseRetrieve = <
  TData = Awaited<ReturnType<typeof apiApiKeyResponseRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiApiKeyResponseRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiApiKeyResponseRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiApiKeyResponseRetrieve>>> = ({
    signal,
  }) => apiApiKeyResponseRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiApiKeyResponseRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiApiKeyFacebookCreate = (apiKeyFacebook: ApiKeyFacebook) => {
  return HTTP<ApiKey>({
    url: `/api/v7/api_key/facebook/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiKeyFacebook,
  });
};

export type ApiApiKeyFacebookCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiApiKeyFacebookCreate>>
>;
export type ApiApiKeyFacebookCreateMutationBody = ApiKeyFacebook;
export type ApiApiKeyFacebookCreateMutationError = ErrorType<unknown>;

export const useApiApiKeyFacebookCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiApiKeyFacebookCreate>>,
    TError,
    { data: ApiKeyFacebook },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiApiKeyFacebookCreate>>,
    { data: ApiKeyFacebook }
  > = (props) => {
    const { data } = props ?? {};

    return apiApiKeyFacebookCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiApiKeyFacebookCreate>>,
    TError,
    { data: ApiKeyFacebook },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiApiKeyGoogleCreate = (apiKeyGoogle: ApiKeyGoogle) => {
  return HTTP<ApiKey>({
    url: `/api/v7/api_key/google/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiKeyGoogle,
  });
};

export type ApiApiKeyGoogleCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiApiKeyGoogleCreate>>
>;
export type ApiApiKeyGoogleCreateMutationBody = ApiKeyGoogle;
export type ApiApiKeyGoogleCreateMutationError = ErrorType<unknown>;

export const useApiApiKeyGoogleCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiApiKeyGoogleCreate>>,
    TError,
    { data: ApiKeyGoogle },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiApiKeyGoogleCreate>>,
    { data: ApiKeyGoogle }
  > = (props) => {
    const { data } = props ?? {};

    return apiApiKeyGoogleCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiApiKeyGoogleCreate>>,
    TError,
    { data: ApiKeyGoogle },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiApiKeyPasswordCreate = (apiKeyPassword: ApiKeyPassword) => {
  return HTTP<ApiKey>({
    url: `/api/v7/api_key/password/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiKeyPassword,
  });
};

export type ApiApiKeyPasswordCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiApiKeyPasswordCreate>>
>;
export type ApiApiKeyPasswordCreateMutationBody = ApiKeyPassword;
export type ApiApiKeyPasswordCreateMutationError = ErrorType<unknown>;

export const useApiApiKeyPasswordCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiApiKeyPasswordCreate>>,
    TError,
    { data: ApiKeyPassword },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiApiKeyPasswordCreate>>,
    { data: ApiKeyPassword }
  > = (props) => {
    const { data } = props ?? {};

    return apiApiKeyPasswordCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiApiKeyPasswordCreate>>,
    TError,
    { data: ApiKeyPassword },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiAppInstallSmsCreate = (appInstallSMS: AppInstallSMS) => {
  return HTTP<ApiAppInstallSmsCreate200>({
    url: `/api/v7/app-install-sms/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: appInstallSMS,
  });
};

export type ApiAppInstallSmsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiAppInstallSmsCreate>>
>;
export type ApiAppInstallSmsCreateMutationBody = AppInstallSMS;
export type ApiAppInstallSmsCreateMutationError = ErrorType<ApiAppInstallSmsCreate400>;

export const useApiAppInstallSmsCreate = <
  TError = ErrorType<ApiAppInstallSmsCreate400>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiAppInstallSmsCreate>>,
    TError,
    { data: AppInstallSMS },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiAppInstallSmsCreate>>,
    { data: AppInstallSMS }
  > = (props) => {
    const { data } = props ?? {};

    return apiAppInstallSmsCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiAppInstallSmsCreate>>,
    TError,
    { data: AppInstallSMS },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiAssignmentConfigurationRetrieve = (signal?: AbortSignal) => {
  return HTTP<Configuration>({ url: `/api/v7/assignment/configuration/`, method: 'get', signal });
};

export const getApiAssignmentConfigurationRetrieveQueryKey = () => [
  `/api/v7/assignment/configuration/`,
];

export type ApiAssignmentConfigurationRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiAssignmentConfigurationRetrieve>>
>;
export type ApiAssignmentConfigurationRetrieveQueryError = ErrorType<unknown>;

export const useApiAssignmentConfigurationRetrieve = <
  TData = Awaited<ReturnType<typeof apiAssignmentConfigurationRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiAssignmentConfigurationRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiAssignmentConfigurationRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAssignmentConfigurationRetrieve>>> = ({
    signal,
  }) => apiAssignmentConfigurationRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiAssignmentConfigurationRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiChangeBirthdateCreate = (
  apiChangeBirthdateCreateBody: ApiChangeBirthdateCreateBody
) => {
  return HTTP<void>({
    url: `/api/v7/birthday/change/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiChangeBirthdateCreateBody,
  });
};

export type ApiChangeBirthdateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiChangeBirthdateCreate>>
>;
export type ApiChangeBirthdateCreateMutationBody = ApiChangeBirthdateCreateBody;
export type ApiChangeBirthdateCreateMutationError = ErrorType<ApiChangeBirthdateCreate400>;

export const useApiChangeBirthdateCreate = <
  TError = ErrorType<ApiChangeBirthdateCreate400>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiChangeBirthdateCreate>>,
    TError,
    { data: ApiChangeBirthdateCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiChangeBirthdateCreate>>,
    { data: ApiChangeBirthdateCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiChangeBirthdateCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiChangeBirthdateCreate>>,
    TError,
    { data: ApiChangeBirthdateCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiBlockingModalRetrieve = (signal?: AbortSignal) => {
  return HTTP<ApiBlockingModalRetrieve200>({
    url: `/api/v7/blocking-modal/`,
    method: 'get',
    signal,
  });
};

export const getApiBlockingModalRetrieveQueryKey = () => [`/api/v7/blocking-modal/`];

export type ApiBlockingModalRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiBlockingModalRetrieve>>
>;
export type ApiBlockingModalRetrieveQueryError = ErrorType<unknown>;

export const useApiBlockingModalRetrieve = <
  TData = Awaited<ReturnType<typeof apiBlockingModalRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiBlockingModalRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiBlockingModalRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiBlockingModalRetrieve>>> = ({
    signal,
  }) => apiBlockingModalRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiBlockingModalRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiCommunityGuidelinesCreate = () => {
  return HTTP<void>({ url: `/api/v7/blocking-modal/community-guidelines/`, method: 'post' });
};

export type ApiCommunityGuidelinesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiCommunityGuidelinesCreate>>
>;

export type ApiCommunityGuidelinesCreateMutationError = ErrorType<unknown>;

export const useApiCommunityGuidelinesCreate = <
  TError = ErrorType<unknown>,
  TVariables = void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiCommunityGuidelinesCreate>>,
    TError,
    TVariables,
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiCommunityGuidelinesCreate>>,
    TVariables
  > = () => {
    return apiCommunityGuidelinesCreate();
  };

  return useMutation<
    Awaited<ReturnType<typeof apiCommunityGuidelinesCreate>>,
    TError,
    TVariables,
    TContext
  >(mutationFn, mutationOptions);
};

export const apiMarketingOptInRetrieve = (signal?: AbortSignal) => {
  return HTTP<ApiMarketingOptInRetrieve200>({
    url: `/api/v7/blocking-modal/marketing-opt-in/`,
    method: 'get',
    signal,
  });
};

export const getApiMarketingOptInRetrieveQueryKey = () => [
  `/api/v7/blocking-modal/marketing-opt-in/`,
];

export type ApiMarketingOptInRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMarketingOptInRetrieve>>
>;
export type ApiMarketingOptInRetrieveQueryError = ErrorType<unknown>;

export const useApiMarketingOptInRetrieve = <
  TData = Awaited<ReturnType<typeof apiMarketingOptInRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiMarketingOptInRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMarketingOptInRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMarketingOptInRetrieve>>> = ({
    signal,
  }) => apiMarketingOptInRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiMarketingOptInRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiMarketingOptInCreate = (marketingOptInModalRequest: MarketingOptInModalRequest) => {
  return HTTP<void>({
    url: `/api/v7/blocking-modal/marketing-opt-in/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: marketingOptInModalRequest,
  });
};

export type ApiMarketingOptInCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiMarketingOptInCreate>>
>;
export type ApiMarketingOptInCreateMutationBody = MarketingOptInModalRequest;
export type ApiMarketingOptInCreateMutationError = ErrorType<unknown>;

export const useApiMarketingOptInCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiMarketingOptInCreate>>,
    TError,
    { data: MarketingOptInModalRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiMarketingOptInCreate>>,
    { data: MarketingOptInModalRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiMarketingOptInCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiMarketingOptInCreate>>,
    TError,
    { data: MarketingOptInModalRequest },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiBreedList = (params?: ApiBreedListParams, signal?: AbortSignal) => {
  return HTTP<PaginatedBreedList>({ url: `/api/v7/breeds/`, method: 'get', params, signal });
};

export const getApiBreedListQueryKey = (params?: ApiBreedListParams) => [
  `/api/v7/breeds/`,
  ...(params ? [params] : []),
];

export type ApiBreedListQueryResult = NonNullable<Awaited<ReturnType<typeof apiBreedList>>>;
export type ApiBreedListQueryError = ErrorType<unknown>;

export const useApiBreedList = <
  TData = Awaited<ReturnType<typeof apiBreedList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiBreedListParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof apiBreedList>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiBreedListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiBreedList>>> = ({ signal }) =>
    apiBreedList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiBreedList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiBrightHorizonsCreditInactivityRetrieve = (signal?: AbortSignal) => {
  return HTTP<BrightHorizonsCreditInactivity>({
    url: `/api/v7/bright-horizons/credit-inactivity/`,
    method: 'get',
    signal,
  });
};

export const getApiBrightHorizonsCreditInactivityRetrieveQueryKey = () => [
  `/api/v7/bright-horizons/credit-inactivity/`,
];

export type ApiBrightHorizonsCreditInactivityRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiBrightHorizonsCreditInactivityRetrieve>>
>;
export type ApiBrightHorizonsCreditInactivityRetrieveQueryError = ErrorType<unknown>;

export const useApiBrightHorizonsCreditInactivityRetrieve = <
  TData = Awaited<ReturnType<typeof apiBrightHorizonsCreditInactivityRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiBrightHorizonsCreditInactivityRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiBrightHorizonsCreditInactivityRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiBrightHorizonsCreditInactivityRetrieve>>
  > = ({ signal }) => apiBrightHorizonsCreditInactivityRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiBrightHorizonsCreditInactivityRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiBrightHorizonsExitPartnershipDestroy = () => {
  return HTTP<BrightHorizonsExitPartnership>({
    url: `/api/v7/bright-horizons/exit-partnership/`,
    method: 'delete',
  });
};

export type ApiBrightHorizonsExitPartnershipDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiBrightHorizonsExitPartnershipDestroy>>
>;

export type ApiBrightHorizonsExitPartnershipDestroyMutationError = ErrorType<unknown>;

export const useApiBrightHorizonsExitPartnershipDestroy = <
  TError = ErrorType<unknown>,
  TVariables = void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiBrightHorizonsExitPartnershipDestroy>>,
    TError,
    TVariables,
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiBrightHorizonsExitPartnershipDestroy>>,
    TVariables
  > = () => {
    return apiBrightHorizonsExitPartnershipDestroy();
  };

  return useMutation<
    Awaited<ReturnType<typeof apiBrightHorizonsExitPartnershipDestroy>>,
    TError,
    TVariables,
    TContext
  >(mutationFn, mutationOptions);
};

export const apiBrightHorizonsGlobalBannerRetrieve = (
  params?: ApiBrightHorizonsGlobalBannerRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<BrightHorizonsGlobalBanner>({
    url: `/api/v7/bright-horizons/global-banner/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiBrightHorizonsGlobalBannerRetrieveQueryKey = (
  params?: ApiBrightHorizonsGlobalBannerRetrieveParams
) => [`/api/v7/bright-horizons/global-banner/`, ...(params ? [params] : [])];

export type ApiBrightHorizonsGlobalBannerRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiBrightHorizonsGlobalBannerRetrieve>>
>;
export type ApiBrightHorizonsGlobalBannerRetrieveQueryError = ErrorType<unknown>;

export const useApiBrightHorizonsGlobalBannerRetrieve = <
  TData = Awaited<ReturnType<typeof apiBrightHorizonsGlobalBannerRetrieve>>,
  TError = ErrorType<unknown>
>(
  params?: ApiBrightHorizonsGlobalBannerRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiBrightHorizonsGlobalBannerRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiBrightHorizonsGlobalBannerRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiBrightHorizonsGlobalBannerRetrieve>>
  > = ({ signal }) => apiBrightHorizonsGlobalBannerRetrieve(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiBrightHorizonsGlobalBannerRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiBrightHorizonsRedeemCreditsCreate = (
  brightHorizonsRedeemCredits: BrightHorizonsRedeemCredits
) => {
  return HTTP<BrightHorizonsRedeemCreditsDetail>({
    url: `/api/v7/bright-horizons/redeem-credits/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: brightHorizonsRedeemCredits,
  });
};

export type ApiBrightHorizonsRedeemCreditsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiBrightHorizonsRedeemCreditsCreate>>
>;
export type ApiBrightHorizonsRedeemCreditsCreateMutationBody = BrightHorizonsRedeemCredits;
export type ApiBrightHorizonsRedeemCreditsCreateMutationError = ErrorType<unknown>;

export const useApiBrightHorizonsRedeemCreditsCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiBrightHorizonsRedeemCreditsCreate>>,
    TError,
    { data: BrightHorizonsRedeemCredits },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiBrightHorizonsRedeemCreditsCreate>>,
    { data: BrightHorizonsRedeemCredits }
  > = (props) => {
    const { data } = props ?? {};

    return apiBrightHorizonsRedeemCreditsCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiBrightHorizonsRedeemCreditsCreate>>,
    TError,
    { data: BrightHorizonsRedeemCredits },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiBrightHorizonsSitterProfileBannerRetrieve = (
  params: ApiBrightHorizonsSitterProfileBannerRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<BrightHorizonsSitterProfileBanner>({
    url: `/api/v7/bright-horizons/sitter-profile-banner/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiBrightHorizonsSitterProfileBannerRetrieveQueryKey = (
  params: ApiBrightHorizonsSitterProfileBannerRetrieveParams
) => [`/api/v7/bright-horizons/sitter-profile-banner/`, ...(params ? [params] : [])];

export type ApiBrightHorizonsSitterProfileBannerRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiBrightHorizonsSitterProfileBannerRetrieve>>
>;
export type ApiBrightHorizonsSitterProfileBannerRetrieveQueryError = ErrorType<unknown>;

export const useApiBrightHorizonsSitterProfileBannerRetrieve = <
  TData = Awaited<ReturnType<typeof apiBrightHorizonsSitterProfileBannerRetrieve>>,
  TError = ErrorType<unknown>
>(
  params: ApiBrightHorizonsSitterProfileBannerRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiBrightHorizonsSitterProfileBannerRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiBrightHorizonsSitterProfileBannerRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiBrightHorizonsSitterProfileBannerRetrieve>>
  > = ({ signal }) => apiBrightHorizonsSitterProfileBannerRetrieve(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiBrightHorizonsSitterProfileBannerRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiCancelPaymentIntentCreate = (
  cancelPaymentIntentRequest: CancelPaymentIntentRequest
) => {
  return HTTP<void>({
    url: `/api/v7/cancel-payment-intent/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: cancelPaymentIntentRequest,
  });
};

export type ApiCancelPaymentIntentCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiCancelPaymentIntentCreate>>
>;
export type ApiCancelPaymentIntentCreateMutationBody = CancelPaymentIntentRequest;
export type ApiCancelPaymentIntentCreateMutationError = ErrorType<unknown>;

export const useApiCancelPaymentIntentCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiCancelPaymentIntentCreate>>,
    TError,
    { data: CancelPaymentIntentRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiCancelPaymentIntentCreate>>,
    { data: CancelPaymentIntentRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiCancelPaymentIntentCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiCancelPaymentIntentCreate>>,
    TError,
    { data: CancelPaymentIntentRequest },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiCommerceCheckoutScreenViewRetrieve = (
  orderCollectionOpk: string,
  params: ApiCommerceCheckoutScreenViewRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<CheckoutPage>({
    url: `/api/v7/checkout/${orderCollectionOpk}/screen/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiCommerceCheckoutScreenViewRetrieveQueryKey = (
  orderCollectionOpk: string,
  params: ApiCommerceCheckoutScreenViewRetrieveParams
) => [`/api/v7/checkout/${orderCollectionOpk}/screen/`, ...(params ? [params] : [])];

export type ApiCommerceCheckoutScreenViewRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiCommerceCheckoutScreenViewRetrieve>>
>;
export type ApiCommerceCheckoutScreenViewRetrieveQueryError = ErrorType<unknown>;

export const useApiCommerceCheckoutScreenViewRetrieve = <
  TData = Awaited<ReturnType<typeof apiCommerceCheckoutScreenViewRetrieve>>,
  TError = ErrorType<unknown>
>(
  orderCollectionOpk: string,
  params: ApiCommerceCheckoutScreenViewRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiCommerceCheckoutScreenViewRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiCommerceCheckoutScreenViewRetrieveQueryKey(orderCollectionOpk, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiCommerceCheckoutScreenViewRetrieve>>
  > = ({ signal }) => apiCommerceCheckoutScreenViewRetrieve(orderCollectionOpk, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiCommerceCheckoutScreenViewRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!orderCollectionOpk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiCheckoutAuthorizeCreate = (
  orderOpk: string,
  authorizeRequest: AuthorizeRequest
) => {
  return HTTP<AuthorizeResponse>({
    url: `/api/v7/checkout/${orderOpk}/authorize/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: authorizeRequest,
  });
};

export type ApiCheckoutAuthorizeCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiCheckoutAuthorizeCreate>>
>;
export type ApiCheckoutAuthorizeCreateMutationBody = AuthorizeRequest;
export type ApiCheckoutAuthorizeCreateMutationError = ErrorType<unknown>;

export const useApiCheckoutAuthorizeCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiCheckoutAuthorizeCreate>>,
    TError,
    { orderOpk: string; data: AuthorizeRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiCheckoutAuthorizeCreate>>,
    { orderOpk: string; data: AuthorizeRequest }
  > = (props) => {
    const { orderOpk, data } = props ?? {};

    return apiCheckoutAuthorizeCreate(orderOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiCheckoutAuthorizeCreate>>,
    TError,
    { orderOpk: string; data: AuthorizeRequest },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiCommerceCancelCheckoutViewCreate = (orderOpk: string, checkout: Checkout) => {
  return HTTP<void>({
    url: `/api/v7/checkout/${orderOpk}/cancel/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: checkout,
  });
};

export type ApiCommerceCancelCheckoutViewCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiCommerceCancelCheckoutViewCreate>>
>;
export type ApiCommerceCancelCheckoutViewCreateMutationBody = Checkout;
export type ApiCommerceCancelCheckoutViewCreateMutationError = ErrorType<unknown>;

export const useApiCommerceCancelCheckoutViewCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiCommerceCancelCheckoutViewCreate>>,
    TError,
    { orderOpk: string; data: Checkout },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiCommerceCancelCheckoutViewCreate>>,
    { orderOpk: string; data: Checkout }
  > = (props) => {
    const { orderOpk, data } = props ?? {};

    return apiCommerceCancelCheckoutViewCreate(orderOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiCommerceCancelCheckoutViewCreate>>,
    TError,
    { orderOpk: string; data: Checkout },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiCommerceCompleteCheckoutViewCreate = (orderOpk: string, checkout: Checkout) => {
  return HTTP<void>({
    url: `/api/v7/checkout/${orderOpk}/complete/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: checkout,
  });
};

export type ApiCommerceCompleteCheckoutViewCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiCommerceCompleteCheckoutViewCreate>>
>;
export type ApiCommerceCompleteCheckoutViewCreateMutationBody = Checkout;
export type ApiCommerceCompleteCheckoutViewCreateMutationError = ErrorType<unknown>;

export const useApiCommerceCompleteCheckoutViewCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiCommerceCompleteCheckoutViewCreate>>,
    TError,
    { orderOpk: string; data: Checkout },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiCommerceCompleteCheckoutViewCreate>>,
    { orderOpk: string; data: Checkout }
  > = (props) => {
    const { orderOpk, data } = props ?? {};

    return apiCommerceCompleteCheckoutViewCreate(orderOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiCommerceCompleteCheckoutViewCreate>>,
    TError,
    { orderOpk: string; data: Checkout },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiCommerceConfirmationDetailsCheckoutViewRetrieve = (
  orderOpk: string,
  signal?: AbortSignal
) => {
  return HTTP<ConfirmationCheckout>({
    url: `/api/v7/checkout/${orderOpk}/confirmation-details/`,
    method: 'get',
    signal,
  });
};

export const getApiCommerceConfirmationDetailsCheckoutViewRetrieveQueryKey = (orderOpk: string) => [
  `/api/v7/checkout/${orderOpk}/confirmation-details/`,
];

export type ApiCommerceConfirmationDetailsCheckoutViewRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiCommerceConfirmationDetailsCheckoutViewRetrieve>>
>;
export type ApiCommerceConfirmationDetailsCheckoutViewRetrieveQueryError = ErrorType<unknown>;

export const useApiCommerceConfirmationDetailsCheckoutViewRetrieve = <
  TData = Awaited<ReturnType<typeof apiCommerceConfirmationDetailsCheckoutViewRetrieve>>,
  TError = ErrorType<unknown>
>(
  orderOpk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiCommerceConfirmationDetailsCheckoutViewRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiCommerceConfirmationDetailsCheckoutViewRetrieveQueryKey(orderOpk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiCommerceConfirmationDetailsCheckoutViewRetrieve>>
  > = ({ signal }) => apiCommerceConfirmationDetailsCheckoutViewRetrieve(orderOpk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiCommerceConfirmationDetailsCheckoutViewRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!orderOpk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiCitiesAndNeighborhoodsRetrieve = (
  params?: ApiCitiesAndNeighborhoodsRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<ApiCitiesAndNeighborhoodsRetrieve200>({
    url: `/api/v7/cities-and-neighborhoods/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiCitiesAndNeighborhoodsRetrieveQueryKey = (
  params?: ApiCitiesAndNeighborhoodsRetrieveParams
) => [`/api/v7/cities-and-neighborhoods/`, ...(params ? [params] : [])];

export type ApiCitiesAndNeighborhoodsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiCitiesAndNeighborhoodsRetrieve>>
>;
export type ApiCitiesAndNeighborhoodsRetrieveQueryError = ErrorType<unknown>;

export const useApiCitiesAndNeighborhoodsRetrieve = <
  TData = Awaited<ReturnType<typeof apiCitiesAndNeighborhoodsRetrieve>>,
  TError = ErrorType<unknown>
>(
  params?: ApiCitiesAndNeighborhoodsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiCitiesAndNeighborhoodsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiCitiesAndNeighborhoodsRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiCitiesAndNeighborhoodsRetrieve>>> = ({
    signal,
  }) => apiCitiesAndNeighborhoodsRetrieve(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiCitiesAndNeighborhoodsRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiCombinedConfigRetrieve = (signal?: AbortSignal) => {
  return HTTP<CombinedConfig>({ url: `/api/v7/combined-config/`, method: 'get', signal });
};

export const getApiCombinedConfigRetrieveQueryKey = () => [`/api/v7/combined-config/`];

export type ApiCombinedConfigRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiCombinedConfigRetrieve>>
>;
export type ApiCombinedConfigRetrieveQueryError = ErrorType<unknown>;

export const useApiCombinedConfigRetrieve = <
  TData = Awaited<ReturnType<typeof apiCombinedConfigRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiCombinedConfigRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiCombinedConfigRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiCombinedConfigRetrieve>>> = ({
    signal,
  }) => apiCombinedConfigRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiCombinedConfigRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiConfigurationRetrieve = (signal?: AbortSignal) => {
  return HTTP<Config>({ url: `/api/v7/configuration/`, method: 'get', signal });
};

export const getApiConfigurationRetrieveQueryKey = () => [`/api/v7/configuration/`];

export type ApiConfigurationRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConfigurationRetrieve>>
>;
export type ApiConfigurationRetrieveQueryError = ErrorType<unknown>;

export const useApiConfigurationRetrieve = <
  TData = Awaited<ReturnType<typeof apiConfigurationRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiConfigurationRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiConfigurationRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiConfigurationRetrieve>>> = ({
    signal,
  }) => apiConfigurationRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiConfigurationRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiCreateConfirmationTokenPaymentIntentsCreate = (
  createConfirmationTokenPaymentIntentRequest: CreateConfirmationTokenPaymentIntentRequest
) => {
  return HTTP<CreateConfirmationTokenPaymentIntentResponse>({
    url: `/api/v7/confirmation-token-payment-intents/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: createConfirmationTokenPaymentIntentRequest,
  });
};

export type ApiCreateConfirmationTokenPaymentIntentsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiCreateConfirmationTokenPaymentIntentsCreate>>
>;
export type ApiCreateConfirmationTokenPaymentIntentsCreateMutationBody =
  CreateConfirmationTokenPaymentIntentRequest;
export type ApiCreateConfirmationTokenPaymentIntentsCreateMutationError = ErrorType<unknown>;

export const useApiCreateConfirmationTokenPaymentIntentsCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiCreateConfirmationTokenPaymentIntentsCreate>>,
    TError,
    { data: CreateConfirmationTokenPaymentIntentRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiCreateConfirmationTokenPaymentIntentsCreate>>,
    { data: CreateConfirmationTokenPaymentIntentRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiCreateConfirmationTokenPaymentIntentsCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiCreateConfirmationTokenPaymentIntentsCreate>>,
    TError,
    { data: CreateConfirmationTokenPaymentIntentRequest },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiConnectAccountBookingModalRetrieve = (signal?: AbortSignal) => {
  return HTTP<ConnectAccountBookingModal>({
    url: `/api/v7/connect-account-booking-modal/`,
    method: 'get',
    signal,
  });
};

export const getApiConnectAccountBookingModalRetrieveQueryKey = () => [
  `/api/v7/connect-account-booking-modal/`,
];

export type ApiConnectAccountBookingModalRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConnectAccountBookingModalRetrieve>>
>;
export type ApiConnectAccountBookingModalRetrieveQueryError = ErrorType<unknown>;

export const useApiConnectAccountBookingModalRetrieve = <
  TData = Awaited<ReturnType<typeof apiConnectAccountBookingModalRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiConnectAccountBookingModalRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiConnectAccountBookingModalRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiConnectAccountBookingModalRetrieve>>
  > = ({ signal }) => apiConnectAccountBookingModalRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiConnectAccountBookingModalRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiGetConnectAccountsList = (signal?: AbortSignal) => {
  return HTTP<GetConnectAccounts[]>({ url: `/api/v7/connect-accounts/`, method: 'get', signal });
};

export const getApiGetConnectAccountsListQueryKey = () => [`/api/v7/connect-accounts/`];

export type ApiGetConnectAccountsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiGetConnectAccountsList>>
>;
export type ApiGetConnectAccountsListQueryError = ErrorType<unknown>;

export const useApiGetConnectAccountsList = <
  TData = Awaited<ReturnType<typeof apiGetConnectAccountsList>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiGetConnectAccountsList>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiGetConnectAccountsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetConnectAccountsList>>> = ({
    signal,
  }) => apiGetConnectAccountsList(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiGetConnectAccountsList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Rely primarily on the super call chain, handling normal failure
modes by responding with an HTTP 400 response.
 */
export const apiConversationList = (params?: ApiConversationListParams, signal?: AbortSignal) => {
  return HTTP<PaginatedConversationList>({
    url: `/api/v7/conversations/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiConversationListQueryKey = (params?: ApiConversationListParams) => [
  `/api/v7/conversations/`,
  ...(params ? [params] : []),
];

export type ApiConversationListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationList>>
>;
export type ApiConversationListQueryError = ErrorType<unknown>;

export const useApiConversationList = <
  TData = Awaited<ReturnType<typeof apiConversationList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiConversationListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiConversationList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiConversationListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiConversationList>>> = ({ signal }) =>
    apiConversationList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiConversationList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Raises EmailVerificationNeededAPIException if the user needs to validate their email.

Runs for every request method by default.
Implement get_verify_email_for_verbs to specify which methods to verify.
 */
export const apiConversationListCreate = (conversationCreation: ConversationCreation) => {
  return HTTP<Conversation>({
    url: `/api/v7/conversations/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: conversationCreation,
  });
};

export type ApiConversationListCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationListCreate>>
>;
export type ApiConversationListCreateMutationBody = ConversationCreation;
export type ApiConversationListCreateMutationError = ErrorType<void>;

export const useApiConversationListCreate = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiConversationListCreate>>,
    TError,
    { data: ConversationCreation },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiConversationListCreate>>,
    { data: ConversationCreation }
  > = (props) => {
    const { data } = props ?? {};

    return apiConversationListCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiConversationListCreate>>,
    TError,
    { data: ConversationCreation },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiConversationMultidimensionalReviewsRetrieve = (
  conversationOpk: string,
  eventType: string,
  signal?: AbortSignal
) => {
  return HTTP<MultiDimensionalReview>({
    url: `/api/v7/conversations/${conversationOpk}/mdreviews/${eventType}/`,
    method: 'get',
    signal,
  });
};

export const getApiConversationMultidimensionalReviewsRetrieveQueryKey = (
  conversationOpk: string,
  eventType: string
) => [`/api/v7/conversations/${conversationOpk}/mdreviews/${eventType}/`];

export type ApiConversationMultidimensionalReviewsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationMultidimensionalReviewsRetrieve>>
>;
export type ApiConversationMultidimensionalReviewsRetrieveQueryError = ErrorType<unknown>;

export const useApiConversationMultidimensionalReviewsRetrieve = <
  TData = Awaited<ReturnType<typeof apiConversationMultidimensionalReviewsRetrieve>>,
  TError = ErrorType<unknown>
>(
  conversationOpk: string,
  eventType: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiConversationMultidimensionalReviewsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiConversationMultidimensionalReviewsRetrieveQueryKey(conversationOpk, eventType);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiConversationMultidimensionalReviewsRetrieve>>
  > = ({ signal }) =>
    apiConversationMultidimensionalReviewsRetrieve(conversationOpk, eventType, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiConversationMultidimensionalReviewsRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(conversationOpk && eventType),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiRatingResponseDestroy = (conversationOpk: string, opk: string) => {
  return HTTP<void>({
    url: `/api/v7/conversations/${conversationOpk}/responses/${opk}/`,
    method: 'delete',
  });
};

export type ApiRatingResponseDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiRatingResponseDestroy>>
>;

export type ApiRatingResponseDestroyMutationError = ErrorType<unknown>;

export const useApiRatingResponseDestroy = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiRatingResponseDestroy>>,
    TError,
    { conversationOpk: string; opk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiRatingResponseDestroy>>,
    { conversationOpk: string; opk: string }
  > = (props) => {
    const { conversationOpk, opk } = props ?? {};

    return apiRatingResponseDestroy(conversationOpk, opk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiRatingResponseDestroy>>,
    TError,
    { conversationOpk: string; opk: string },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiConversationDetailRetrieve = (
  opk: string,
  params?: ApiConversationDetailRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<ConversationDetail>({
    url: `/api/v7/conversations/${opk}/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiConversationDetailRetrieveQueryKey = (
  opk: string,
  params?: ApiConversationDetailRetrieveParams
) => [`/api/v7/conversations/${opk}/`, ...(params ? [params] : [])];

export type ApiConversationDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationDetailRetrieve>>
>;
export type ApiConversationDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiConversationDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiConversationDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiConversationDetailRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiConversationDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiConversationDetailRetrieveQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiConversationDetailRetrieve>>> = ({
    signal,
  }) => apiConversationDetailRetrieve(opk, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiConversationDetailRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiConversationDetailUpdate = (
  opk: string,
  conversationDetailRequest: ConversationDetailRequest
) => {
  return HTTP<ConversationDetail>({
    url: `/api/v7/conversations/${opk}/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: conversationDetailRequest,
  });
};

export type ApiConversationDetailUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationDetailUpdate>>
>;
export type ApiConversationDetailUpdateMutationBody = ConversationDetailRequest;
export type ApiConversationDetailUpdateMutationError = ErrorType<unknown>;

export const useApiConversationDetailUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiConversationDetailUpdate>>,
    TError,
    { opk: string; data: ConversationDetailRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiConversationDetailUpdate>>,
    { opk: string; data: ConversationDetailRequest }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiConversationDetailUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiConversationDetailUpdate>>,
    TError,
    { opk: string; data: ConversationDetailRequest },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiBrightHorizonsCheckoutCreditInfoRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<CheckoutCreditInfo>({
    url: `/api/v7/conversations/${opk}/bright-horizons-checkout-credit-info/`,
    method: 'get',
    signal,
  });
};

export const getApiBrightHorizonsCheckoutCreditInfoRetrieveQueryKey = (opk: string) => [
  `/api/v7/conversations/${opk}/bright-horizons-checkout-credit-info/`,
];

export type ApiBrightHorizonsCheckoutCreditInfoRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiBrightHorizonsCheckoutCreditInfoRetrieve>>
>;
export type ApiBrightHorizonsCheckoutCreditInfoRetrieveQueryError = ErrorType<unknown>;

export const useApiBrightHorizonsCheckoutCreditInfoRetrieve = <
  TData = Awaited<ReturnType<typeof apiBrightHorizonsCheckoutCreditInfoRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiBrightHorizonsCheckoutCreditInfoRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiBrightHorizonsCheckoutCreditInfoRetrieveQueryKey(opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiBrightHorizonsCheckoutCreditInfoRetrieve>>
  > = ({ signal }) => apiBrightHorizonsCheckoutCreditInfoRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiBrightHorizonsCheckoutCreditInfoRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiBrightHorizonsCheckoutLedgerCreate = (
  opk: string,
  brightHorizonsCheckoutRequest: BrightHorizonsCheckoutRequest
) => {
  return HTTP<BrightHorizonsCheckoutResponse>({
    url: `/api/v7/conversations/${opk}/bright-horizons-checkout-ledger/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: brightHorizonsCheckoutRequest,
  });
};

export type ApiBrightHorizonsCheckoutLedgerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiBrightHorizonsCheckoutLedgerCreate>>
>;
export type ApiBrightHorizonsCheckoutLedgerCreateMutationBody = BrightHorizonsCheckoutRequest;
export type ApiBrightHorizonsCheckoutLedgerCreateMutationError = ErrorType<unknown>;

export const useApiBrightHorizonsCheckoutLedgerCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiBrightHorizonsCheckoutLedgerCreate>>,
    TError,
    { opk: string; data: BrightHorizonsCheckoutRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiBrightHorizonsCheckoutLedgerCreate>>,
    { opk: string; data: BrightHorizonsCheckoutRequest }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiBrightHorizonsCheckoutLedgerCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiBrightHorizonsCheckoutLedgerCreate>>,
    TError,
    { opk: string; data: BrightHorizonsCheckoutRequest },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiConversationStayCancelCreate = (
  opk: string,
  conversationStayCancel: ConversationStayCancel
) => {
  return HTTP<ApiConversationStayCancelCreate202>({
    url: `/api/v7/conversations/${opk}/cancel/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: conversationStayCancel,
  });
};

export type ApiConversationStayCancelCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationStayCancelCreate>>
>;
export type ApiConversationStayCancelCreateMutationBody = ConversationStayCancel;
export type ApiConversationStayCancelCreateMutationError = ErrorType<unknown>;

export const useApiConversationStayCancelCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiConversationStayCancelCreate>>,
    TError,
    { opk: string; data: ConversationStayCancel },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiConversationStayCancelCreate>>,
    { opk: string; data: ConversationStayCancel }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiConversationStayCancelCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiConversationStayCancelCreate>>,
    TError,
    { opk: string; data: ConversationStayCancel },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiConversationEventsList = (
  opk: string,
  params?: ApiConversationEventsListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedEventList>({
    url: `/api/v7/conversations/${opk}/events/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiConversationEventsListQueryKey = (
  opk: string,
  params?: ApiConversationEventsListParams
) => [`/api/v7/conversations/${opk}/events/`, ...(params ? [params] : [])];

export type ApiConversationEventsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationEventsList>>
>;
export type ApiConversationEventsListQueryError = ErrorType<unknown>;

export const useApiConversationEventsList = <
  TData = Awaited<ReturnType<typeof apiConversationEventsList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiConversationEventsListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiConversationEventsList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiConversationEventsListQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiConversationEventsList>>> = ({
    signal,
  }) => apiConversationEventsList(opk, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiConversationEventsList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiConversationHomeProfileRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<HomeProfile>({
    url: `/api/v7/conversations/${opk}/home-profile/`,
    method: 'get',
    signal,
  });
};

export const getApiConversationHomeProfileRetrieveQueryKey = (opk: string) => [
  `/api/v7/conversations/${opk}/home-profile/`,
];

export type ApiConversationHomeProfileRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationHomeProfileRetrieve>>
>;
export type ApiConversationHomeProfileRetrieveQueryError = ErrorType<unknown>;

export const useApiConversationHomeProfileRetrieve = <
  TData = Awaited<ReturnType<typeof apiConversationHomeProfileRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiConversationHomeProfileRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiConversationHomeProfileRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiConversationHomeProfileRetrieve>>> = ({
    signal,
  }) => apiConversationHomeProfileRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiConversationHomeProfileRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Treat web users like we do on the website by redirecting them
to our /account/continue/ page with the current URL to be followed
after successful authentication.

Ignore API clients (usually allowing the 403 or 404 to propagate.)
 */
export const apiConversationItineraryRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<void>({ url: `/api/v7/conversations/${opk}/itinerary/`, method: 'get', signal });
};

export const getApiConversationItineraryRetrieveQueryKey = (opk: string) => [
  `/api/v7/conversations/${opk}/itinerary/`,
];

export type ApiConversationItineraryRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationItineraryRetrieve>>
>;
export type ApiConversationItineraryRetrieveQueryError = ErrorType<unknown>;

export const useApiConversationItineraryRetrieve = <
  TData = Awaited<ReturnType<typeof apiConversationItineraryRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiConversationItineraryRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiConversationItineraryRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiConversationItineraryRetrieve>>> = ({
    signal,
  }) => apiConversationItineraryRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiConversationItineraryRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiMeetAndGreetCreate = (opk: string, meetAndGreet: MeetAndGreet) => {
  return HTTP<MeetAndGreet>({
    url: `/api/v7/conversations/${opk}/meet-and-greet/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: meetAndGreet,
  });
};

export type ApiMeetAndGreetCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiMeetAndGreetCreate>>
>;
export type ApiMeetAndGreetCreateMutationBody = MeetAndGreet;
export type ApiMeetAndGreetCreateMutationError = ErrorType<unknown>;

export const useApiMeetAndGreetCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiMeetAndGreetCreate>>,
    TError,
    { opk: string; data: MeetAndGreet },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiMeetAndGreetCreate>>,
    { opk: string; data: MeetAndGreet }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiMeetAndGreetCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiMeetAndGreetCreate>>,
    TError,
    { opk: string; data: MeetAndGreet },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiMeetAndGreetSurveyUpdate = (
  opk: string,
  meetAndGreetSurvey: MeetAndGreetSurvey
) => {
  return HTTP<MeetAndGreetSurvey>({
    url: `/api/v7/conversations/${opk}/meet-and-greet-survey/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: meetAndGreetSurvey,
  });
};

export type ApiMeetAndGreetSurveyUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiMeetAndGreetSurveyUpdate>>
>;
export type ApiMeetAndGreetSurveyUpdateMutationBody = MeetAndGreetSurvey;
export type ApiMeetAndGreetSurveyUpdateMutationError = ErrorType<unknown>;

export const useApiMeetAndGreetSurveyUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiMeetAndGreetSurveyUpdate>>,
    TError,
    { opk: string; data: MeetAndGreetSurvey },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiMeetAndGreetSurveyUpdate>>,
    { opk: string; data: MeetAndGreetSurvey }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiMeetAndGreetSurveyUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiMeetAndGreetSurveyUpdate>>,
    TError,
    { opk: string; data: MeetAndGreetSurvey },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiMessageListCreate = (opk: string, message: Message) => {
  return HTTP<MessageWithEvents>({
    url: `/api/v7/conversations/${opk}/messages/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: message,
  });
};

export type ApiMessageListCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiMessageListCreate>>
>;
export type ApiMessageListCreateMutationBody = Message;
export type ApiMessageListCreateMutationError = ErrorType<unknown>;

export const useApiMessageListCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiMessageListCreate>>,
    TError,
    { opk: string; data: Message },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiMessageListCreate>>,
    { opk: string; data: Message }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiMessageListCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiMessageListCreate>>,
    TError,
    { opk: string; data: Message },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Mark the messages in a conversation belonging to this user
as read.
 */
export const apiMessageListUpdate = (opk: string) => {
  return HTTP<void>({ url: `/api/v7/conversations/${opk}/messages/`, method: 'put' });
};

export type ApiMessageListUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiMessageListUpdate>>
>;

export type ApiMessageListUpdateMutationError = ErrorType<unknown>;

export const useApiMessageListUpdate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiMessageListUpdate>>,
    TError,
    { opk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiMessageListUpdate>>,
    { opk: string }
  > = (props) => {
    const { opk } = props ?? {};

    return apiMessageListUpdate(opk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiMessageListUpdate>>,
    TError,
    { opk: string },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiOrderViewCreate = (opk: string, order: Order) => {
  return HTTP<ConversationDetail>({
    url: `/api/v7/conversations/${opk}/order/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: order,
  });
};

export type ApiOrderViewCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiOrderViewCreate>>
>;
export type ApiOrderViewCreateMutationBody = Order;
export type ApiOrderViewCreateMutationError = ErrorType<unknown>;

export const useApiOrderViewCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiOrderViewCreate>>,
    TError,
    { opk: string; data: Order },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiOrderViewCreate>>,
    { opk: string; data: Order }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiOrderViewCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiOrderViewCreate>>,
    TError,
    { opk: string; data: Order },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiConversationPricingCreate = (
  opk: string,
  conversationVersion: string,
  pricingBody: PricingBody
) => {
  return HTTP<PricingBody>({
    url: `/api/v7/conversations/${opk}/pricing/${conversationVersion}/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: pricingBody,
  });
};

export type ApiConversationPricingCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationPricingCreate>>
>;
export type ApiConversationPricingCreateMutationBody = PricingBody;
export type ApiConversationPricingCreateMutationError = ErrorType<unknown>;

export const useApiConversationPricingCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiConversationPricingCreate>>,
    TError,
    { opk: string; conversationVersion: string; data: PricingBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiConversationPricingCreate>>,
    { opk: string; conversationVersion: string; data: PricingBody }
  > = (props) => {
    const { opk, conversationVersion, data } = props ?? {};

    return apiConversationPricingCreate(opk, conversationVersion, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiConversationPricingCreate>>,
    TError,
    { opk: string; conversationVersion: string; data: PricingBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiConversationPricingCancelCreate = (
  opk: string,
  conversationVersion: string,
  cancelStayPricing: CancelStayPricing
) => {
  return HTTP<CancelStayPricing>({
    url: `/api/v7/conversations/${opk}/pricing/${conversationVersion}/cancel/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: cancelStayPricing,
  });
};

export type ApiConversationPricingCancelCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationPricingCancelCreate>>
>;
export type ApiConversationPricingCancelCreateMutationBody = CancelStayPricing;
export type ApiConversationPricingCancelCreateMutationError = ErrorType<unknown>;

export const useApiConversationPricingCancelCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiConversationPricingCancelCreate>>,
    TError,
    { opk: string; conversationVersion: string; data: CancelStayPricing },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiConversationPricingCancelCreate>>,
    { opk: string; conversationVersion: string; data: CancelStayPricing }
  > = (props) => {
    const { opk, conversationVersion, data } = props ?? {};

    return apiConversationPricingCancelCreate(opk, conversationVersion, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiConversationPricingCancelCreate>>,
    TError,
    { opk: string; conversationVersion: string; data: CancelStayPricing },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiConversationProviderInterestPartialUpdate = (
  opk: string,
  patchedConversationProviderInterest: PatchedConversationProviderInterest
) => {
  return HTTP<void>({
    url: `/api/v7/conversations/${opk}/provider-interest/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedConversationProviderInterest,
  });
};

export type ApiConversationProviderInterestPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationProviderInterestPartialUpdate>>
>;
export type ApiConversationProviderInterestPartialUpdateMutationBody =
  PatchedConversationProviderInterest;
export type ApiConversationProviderInterestPartialUpdateMutationError = ErrorType<unknown>;

export const useApiConversationProviderInterestPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiConversationProviderInterestPartialUpdate>>,
    TError,
    { opk: string; data: PatchedConversationProviderInterest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiConversationProviderInterestPartialUpdate>>,
    { opk: string; data: PatchedConversationProviderInterest }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiConversationProviderInterestPartialUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiConversationProviderInterestPartialUpdate>>,
    TError,
    { opk: string; data: PatchedConversationProviderInterest },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiRecommendedProvidersForConversationRetrieve = (
  opk: string,
  params?: ApiRecommendedProvidersForConversationRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<ConversationRecommendedProvidersRead>({
    url: `/api/v7/conversations/${opk}/recommended-providers/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiRecommendedProvidersForConversationRetrieveQueryKey = (
  opk: string,
  params?: ApiRecommendedProvidersForConversationRetrieveParams
) => [`/api/v7/conversations/${opk}/recommended-providers/`, ...(params ? [params] : [])];

export type ApiRecommendedProvidersForConversationRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiRecommendedProvidersForConversationRetrieve>>
>;
export type ApiRecommendedProvidersForConversationRetrieveQueryError = ErrorType<unknown>;

export const useApiRecommendedProvidersForConversationRetrieve = <
  TData = Awaited<ReturnType<typeof apiRecommendedProvidersForConversationRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiRecommendedProvidersForConversationRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiRecommendedProvidersForConversationRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiRecommendedProvidersForConversationRetrieveQueryKey(opk, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiRecommendedProvidersForConversationRetrieve>>
  > = ({ signal }) => apiRecommendedProvidersForConversationRetrieve(opk, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiRecommendedProvidersForConversationRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiRecommendedProvidersForConversationCreate = (
  opk: string,
  conversationRecommendedProvidersWrite: ConversationRecommendedProvidersWrite
) => {
  return HTTP<void>({
    url: `/api/v7/conversations/${opk}/recommended-providers/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: conversationRecommendedProvidersWrite,
  });
};

export type ApiRecommendedProvidersForConversationCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiRecommendedProvidersForConversationCreate>>
>;
export type ApiRecommendedProvidersForConversationCreateMutationBody =
  ConversationRecommendedProvidersWrite;
export type ApiRecommendedProvidersForConversationCreateMutationError = ErrorType<unknown>;

export const useApiRecommendedProvidersForConversationCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiRecommendedProvidersForConversationCreate>>,
    TError,
    { opk: string; data: ConversationRecommendedProvidersWrite },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiRecommendedProvidersForConversationCreate>>,
    { opk: string; data: ConversationRecommendedProvidersWrite }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiRecommendedProvidersForConversationCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiRecommendedProvidersForConversationCreate>>,
    TError,
    { opk: string; data: ConversationRecommendedProvidersWrite },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiConversationReportCreate = (
  opk: string,
  reportConversation: ReportConversation
) => {
  return HTTP<ReportResponse>({
    url: `/api/v7/conversations/${opk}/report/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: reportConversation,
  });
};

export type ApiConversationReportCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationReportCreate>>
>;
export type ApiConversationReportCreateMutationBody = ReportConversation;
export type ApiConversationReportCreateMutationError = ErrorType<unknown>;

export const useApiConversationReportCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiConversationReportCreate>>,
    TError,
    { opk: string; data: ReportConversation },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiConversationReportCreate>>,
    { opk: string; data: ReportConversation }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiConversationReportCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiConversationReportCreate>>,
    TError,
    { opk: string; data: ReportConversation },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiConversationRetryFailedStayPaymentCreate = (
  opk: string,
  payAcceptedRequest: PayAcceptedRequest
) => {
  return HTTP<RequestDetail>({
    url: `/api/v7/conversations/${opk}/retry-payment/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: payAcceptedRequest,
  });
};

export type ApiConversationRetryFailedStayPaymentCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationRetryFailedStayPaymentCreate>>
>;
export type ApiConversationRetryFailedStayPaymentCreateMutationBody = PayAcceptedRequest;
export type ApiConversationRetryFailedStayPaymentCreateMutationError = ErrorType<unknown>;

export const useApiConversationRetryFailedStayPaymentCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiConversationRetryFailedStayPaymentCreate>>,
    TError,
    { opk: string; data: PayAcceptedRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiConversationRetryFailedStayPaymentCreate>>,
    { opk: string; data: PayAcceptedRequest }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiConversationRetryFailedStayPaymentCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiConversationRetryFailedStayPaymentCreate>>,
    TError,
    { opk: string; data: PayAcceptedRequest },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for list views that provides functionality to merge querysets in
order to return paginated results.
 */
export const apiConversationReviewsList = (
  opk: string,
  params?: ApiConversationReviewsListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedReviewDispatchList>({
    url: `/api/v7/conversations/${opk}/reviews/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiConversationReviewsListQueryKey = (
  opk: string,
  params?: ApiConversationReviewsListParams
) => [`/api/v7/conversations/${opk}/reviews/`, ...(params ? [params] : [])];

export type ApiConversationReviewsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationReviewsList>>
>;
export type ApiConversationReviewsListQueryError = ErrorType<unknown>;

export const useApiConversationReviewsList = <
  TData = Awaited<ReturnType<typeof apiConversationReviewsList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiConversationReviewsListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiConversationReviewsList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiConversationReviewsListQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiConversationReviewsList>>> = ({
    signal,
  }) => apiConversationReviewsList(opk, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiConversationReviewsList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiConversationCreateTipRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<Tip>({ url: `/api/v7/conversations/${opk}/tip/`, method: 'get', signal });
};

export const getApiConversationCreateTipRetrieveQueryKey = (opk: string) => [
  `/api/v7/conversations/${opk}/tip/`,
];

export type ApiConversationCreateTipRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationCreateTipRetrieve>>
>;
export type ApiConversationCreateTipRetrieveQueryError = ErrorType<unknown>;

export const useApiConversationCreateTipRetrieve = <
  TData = Awaited<ReturnType<typeof apiConversationCreateTipRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiConversationCreateTipRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiConversationCreateTipRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiConversationCreateTipRetrieve>>> = ({
    signal,
  }) => apiConversationCreateTipRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiConversationCreateTipRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiConversationCreateTipUpdate = (opk: string, tip: Tip) => {
  return HTTP<Tip>({
    url: `/api/v7/conversations/${opk}/tip/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: tip,
  });
};

export type ApiConversationCreateTipUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationCreateTipUpdate>>
>;
export type ApiConversationCreateTipUpdateMutationBody = Tip;
export type ApiConversationCreateTipUpdateMutationError = ErrorType<unknown>;

export const useApiConversationCreateTipUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiConversationCreateTipUpdate>>,
    TError,
    { opk: string; data: Tip },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiConversationCreateTipUpdate>>,
    { opk: string; data: Tip }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiConversationCreateTipUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiConversationCreateTipUpdate>>,
    TError,
    { opk: string; data: Tip },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiConversationTipsListRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<TipChoiceList>({
    url: `/api/v7/conversations/${opk}/tip-choices/`,
    method: 'get',
    signal,
  });
};

export const getApiConversationTipsListRetrieveQueryKey = (opk: string) => [
  `/api/v7/conversations/${opk}/tip-choices/`,
];

export type ApiConversationTipsListRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationTipsListRetrieve>>
>;
export type ApiConversationTipsListRetrieveQueryError = ErrorType<unknown>;

export const useApiConversationTipsListRetrieve = <
  TData = Awaited<ReturnType<typeof apiConversationTipsListRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiConversationTipsListRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiConversationTipsListRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiConversationTipsListRetrieve>>> = ({
    signal,
  }) => apiConversationTipsListRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiConversationTipsListRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiConversationSwitchToRecurringCreate = (opk: string) => {
  return HTTP<Conversation>({ url: `/api/v7/conversations/${opk}/to-recurring/`, method: 'post' });
};

export type ApiConversationSwitchToRecurringCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationSwitchToRecurringCreate>>
>;

export type ApiConversationSwitchToRecurringCreateMutationError = ErrorType<unknown>;

export const useApiConversationSwitchToRecurringCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiConversationSwitchToRecurringCreate>>,
    TError,
    { opk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiConversationSwitchToRecurringCreate>>,
    { opk: string }
  > = (props) => {
    const { opk } = props ?? {};

    return apiConversationSwitchToRecurringCreate(opk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiConversationSwitchToRecurringCreate>>,
    TError,
    { opk: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Get tractive discount code if user meets eligibility criteria. Can be used with or without conversation context.
 */
export const apiConversationTractiveDiscountCodeRetrieve = (
  opk: string,
  params?: ApiConversationTractiveDiscountCodeRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<TractiveDiscountCodeResponse>({
    url: `/api/v7/conversations/${opk}/tractive-discount-code/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiConversationTractiveDiscountCodeRetrieveQueryKey = (
  opk: string,
  params?: ApiConversationTractiveDiscountCodeRetrieveParams
) => [`/api/v7/conversations/${opk}/tractive-discount-code/`, ...(params ? [params] : [])];

export type ApiConversationTractiveDiscountCodeRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationTractiveDiscountCodeRetrieve>>
>;
export type ApiConversationTractiveDiscountCodeRetrieveQueryError = ErrorType<unknown>;

export const useApiConversationTractiveDiscountCodeRetrieve = <
  TData = Awaited<ReturnType<typeof apiConversationTractiveDiscountCodeRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiConversationTractiveDiscountCodeRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiConversationTractiveDiscountCodeRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiConversationTractiveDiscountCodeRetrieveQueryKey(opk, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiConversationTractiveDiscountCodeRetrieve>>
  > = ({ signal }) => apiConversationTractiveDiscountCodeRetrieve(opk, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiConversationTractiveDiscountCodeRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiConversationRoomRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<VideoCallRoom>({
    url: `/api/v7/conversations/${opk}/video-call/`,
    method: 'get',
    signal,
  });
};

export const getApiConversationRoomRetrieveQueryKey = (opk: string) => [
  `/api/v7/conversations/${opk}/video-call/`,
];

export type ApiConversationRoomRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationRoomRetrieve>>
>;
export type ApiConversationRoomRetrieveQueryError = ErrorType<unknown>;

export const useApiConversationRoomRetrieve = <
  TData = Awaited<ReturnType<typeof apiConversationRoomRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiConversationRoomRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiConversationRoomRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiConversationRoomRetrieve>>> = ({
    signal,
  }) => apiConversationRoomRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiConversationRoomRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * creates the room for a given conversation OPK
 */
export const apiConversationRoomCreate = (opk: string, videoCallRoom: VideoCallRoom) => {
  return HTTP<VideoCallRoom>({
    url: `/api/v7/conversations/${opk}/video-call/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: videoCallRoom,
  });
};

export type ApiConversationRoomCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationRoomCreate>>
>;
export type ApiConversationRoomCreateMutationBody = VideoCallRoom;
export type ApiConversationRoomCreateMutationError = ErrorType<unknown>;

export const useApiConversationRoomCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiConversationRoomCreate>>,
    TError,
    { opk: string; data: VideoCallRoom },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiConversationRoomCreate>>,
    { opk: string; data: VideoCallRoom }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiConversationRoomCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiConversationRoomCreate>>,
    TError,
    { opk: string; data: VideoCallRoom },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiConversationVideoCallRelationshipRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<ConversationVideoCallRelationship>({
    url: `/api/v7/conversations/${opk}/video-call-relationship/`,
    method: 'get',
    signal,
  });
};

export const getApiConversationVideoCallRelationshipRetrieveQueryKey = (opk: string) => [
  `/api/v7/conversations/${opk}/video-call-relationship/`,
];

export type ApiConversationVideoCallRelationshipRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationVideoCallRelationshipRetrieve>>
>;
export type ApiConversationVideoCallRelationshipRetrieveQueryError = ErrorType<unknown>;

export const useApiConversationVideoCallRelationshipRetrieve = <
  TData = Awaited<ReturnType<typeof apiConversationVideoCallRelationshipRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiConversationVideoCallRelationshipRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiConversationVideoCallRelationshipRetrieveQueryKey(opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiConversationVideoCallRelationshipRetrieve>>
  > = ({ signal }) => apiConversationVideoCallRelationshipRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiConversationVideoCallRelationshipRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list/create views.
 */
export const apiConversationVideosList = (
  opk: string,
  params?: ApiConversationVideosListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedVideoList>({
    url: `/api/v7/conversations/${opk}/videos/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiConversationVideosListQueryKey = (
  opk: string,
  params?: ApiConversationVideosListParams
) => [`/api/v7/conversations/${opk}/videos/`, ...(params ? [params] : [])];

export type ApiConversationVideosListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationVideosList>>
>;
export type ApiConversationVideosListQueryError = ErrorType<unknown>;

export const useApiConversationVideosList = <
  TData = Awaited<ReturnType<typeof apiConversationVideosList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiConversationVideosListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiConversationVideosList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiConversationVideosListQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiConversationVideosList>>> = ({
    signal,
  }) => apiConversationVideosList(opk, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiConversationVideosList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list/create views.
 */
export const apiConversationVideosListCreate = (opk: string, video: Video) => {
  return HTTP<VideoWithEvents>({
    url: `/api/v7/conversations/${opk}/videos/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: video,
  });
};

export type ApiConversationVideosListCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationVideosListCreate>>
>;
export type ApiConversationVideosListCreateMutationBody = Video;
export type ApiConversationVideosListCreateMutationError = ErrorType<Error>;

export const useApiConversationVideosListCreate = <
  TError = ErrorType<Error>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiConversationVideosListCreate>>,
    TError,
    { opk: string; data: Video },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiConversationVideosListCreate>>,
    { opk: string; data: Video }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiConversationVideosListCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiConversationVideosListCreate>>,
    TError,
    { opk: string; data: Video },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiConversationAdhocList = (
  params?: ApiConversationAdhocListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedAdditionalSDVList>({
    url: `/api/v7/conversations/adhoc/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiConversationAdhocListQueryKey = (params?: ApiConversationAdhocListParams) => [
  `/api/v7/conversations/adhoc/`,
  ...(params ? [params] : []),
];

export type ApiConversationAdhocListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationAdhocList>>
>;
export type ApiConversationAdhocListQueryError = ErrorType<unknown>;

export const useApiConversationAdhocList = <
  TData = Awaited<ReturnType<typeof apiConversationAdhocList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiConversationAdhocListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiConversationAdhocList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiConversationAdhocListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiConversationAdhocList>>> = ({
    signal,
  }) => apiConversationAdhocList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiConversationAdhocList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiProviderArchivedReasonsRetrieve = (signal?: AbortSignal) => {
  return HTTP<Choices>({
    url: `/api/v7/conversations/provider-archived-reasons/`,
    method: 'get',
    signal,
  });
};

export const getApiProviderArchivedReasonsRetrieveQueryKey = () => [
  `/api/v7/conversations/provider-archived-reasons/`,
];

export type ApiProviderArchivedReasonsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderArchivedReasonsRetrieve>>
>;
export type ApiProviderArchivedReasonsRetrieveQueryError = ErrorType<unknown>;

export const useApiProviderArchivedReasonsRetrieve = <
  TData = Awaited<ReturnType<typeof apiProviderArchivedReasonsRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiProviderArchivedReasonsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiProviderArchivedReasonsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiProviderArchivedReasonsRetrieve>>> = ({
    signal,
  }) => apiProviderArchivedReasonsRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiProviderArchivedReasonsRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiConversationReportReasonsViewList = (signal?: AbortSignal) => {
  return HTTP<ReportReasonsResponse[]>({
    url: `/api/v7/conversations/report/reasons/`,
    method: 'get',
    signal,
  });
};

export const getApiConversationReportReasonsViewListQueryKey = () => [
  `/api/v7/conversations/report/reasons/`,
];

export type ApiConversationReportReasonsViewListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationReportReasonsViewList>>
>;
export type ApiConversationReportReasonsViewListQueryError = ErrorType<unknown>;

export const useApiConversationReportReasonsViewList = <
  TData = Awaited<ReturnType<typeof apiConversationReportReasonsViewList>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiConversationReportReasonsViewList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiConversationReportReasonsViewListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiConversationReportReasonsViewList>>
  > = ({ signal }) => apiConversationReportReasonsViewList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiConversationReportReasonsViewList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiRequesterArchivedReasonsRetrieve = (signal?: AbortSignal) => {
  return HTTP<Choices>({
    url: `/api/v7/conversations/requester-archived-reasons/`,
    method: 'get',
    signal,
  });
};

export const getApiRequesterArchivedReasonsRetrieveQueryKey = () => [
  `/api/v7/conversations/requester-archived-reasons/`,
];

export type ApiRequesterArchivedReasonsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiRequesterArchivedReasonsRetrieve>>
>;
export type ApiRequesterArchivedReasonsRetrieveQueryError = ErrorType<unknown>;

export const useApiRequesterArchivedReasonsRetrieve = <
  TData = Awaited<ReturnType<typeof apiRequesterArchivedReasonsRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiRequesterArchivedReasonsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiRequesterArchivedReasonsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiRequesterArchivedReasonsRetrieve>>> = ({
    signal,
  }) => apiRequesterArchivedReasonsRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiRequesterArchivedReasonsRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiConversationTodayUrlListRetrieve = (signal?: AbortSignal) => {
  return HTTP<ApiConversationTodayUrlListRetrieve200>({
    url: `/api/v7/conversations/today/`,
    method: 'get',
    signal,
  });
};

export const getApiConversationTodayUrlListRetrieveQueryKey = () => [
  `/api/v7/conversations/today/`,
];

export type ApiConversationTodayUrlListRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationTodayUrlListRetrieve>>
>;
export type ApiConversationTodayUrlListRetrieveQueryError = ErrorType<unknown>;

export const useApiConversationTodayUrlListRetrieve = <
  TData = Awaited<ReturnType<typeof apiConversationTodayUrlListRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiConversationTodayUrlListRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiConversationTodayUrlListRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiConversationTodayUrlListRetrieve>>> = ({
    signal,
  }) => apiConversationTodayUrlListRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiConversationTodayUrlListRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiCountryConfigurationList = (
  params?: ApiCountryConfigurationListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedCountryConfigurationList>({
    url: `/api/v7/country-configuration/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiCountryConfigurationListQueryKey = (
  params?: ApiCountryConfigurationListParams
) => [`/api/v7/country-configuration/`, ...(params ? [params] : [])];

export type ApiCountryConfigurationListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiCountryConfigurationList>>
>;
export type ApiCountryConfigurationListQueryError = ErrorType<unknown>;

export const useApiCountryConfigurationList = <
  TData = Awaited<ReturnType<typeof apiCountryConfigurationList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiCountryConfigurationListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiCountryConfigurationList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiCountryConfigurationListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiCountryConfigurationList>>> = ({
    signal,
  }) => apiCountryConfigurationList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiCountryConfigurationList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiCountryConfigurationCurrentRetrieve = (signal?: AbortSignal) => {
  return HTTP<CountryConfiguration>({
    url: `/api/v7/country-configuration/current/`,
    method: 'get',
    signal,
  });
};

export const getApiCountryConfigurationCurrentRetrieveQueryKey = () => [
  `/api/v7/country-configuration/current/`,
];

export type ApiCountryConfigurationCurrentRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiCountryConfigurationCurrentRetrieve>>
>;
export type ApiCountryConfigurationCurrentRetrieveQueryError = ErrorType<unknown>;

export const useApiCountryConfigurationCurrentRetrieve = <
  TData = Awaited<ReturnType<typeof apiCountryConfigurationCurrentRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiCountryConfigurationCurrentRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiCountryConfigurationCurrentRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiCountryConfigurationCurrentRetrieve>>
  > = ({ signal }) => apiCountryConfigurationCurrentRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiCountryConfigurationCurrentRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiCountryConfigurationNavigationRetrieve = (signal?: AbortSignal) => {
  return HTTP<CountryConfiguration>({
    url: `/api/v7/country-configuration/navigation/`,
    method: 'get',
    signal,
  });
};

export const getApiCountryConfigurationNavigationRetrieveQueryKey = () => [
  `/api/v7/country-configuration/navigation/`,
];

export type ApiCountryConfigurationNavigationRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiCountryConfigurationNavigationRetrieve>>
>;
export type ApiCountryConfigurationNavigationRetrieveQueryError = ErrorType<unknown>;

export const useApiCountryConfigurationNavigationRetrieve = <
  TData = Awaited<ReturnType<typeof apiCountryConfigurationNavigationRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiCountryConfigurationNavigationRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiCountryConfigurationNavigationRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiCountryConfigurationNavigationRetrieve>>
  > = ({ signal }) => apiCountryConfigurationNavigationRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiCountryConfigurationNavigationRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiCreateConnectAccountCreate = (
  createStripeConnectAccount: CreateStripeConnectAccount
) => {
  return HTTP<CreateStripeConnectAccount>({
    url: `/api/v7/create-connect-account/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: createStripeConnectAccount,
  });
};

export type ApiCreateConnectAccountCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiCreateConnectAccountCreate>>
>;
export type ApiCreateConnectAccountCreateMutationBody = CreateStripeConnectAccount;
export type ApiCreateConnectAccountCreateMutationError = ErrorType<unknown>;

export const useApiCreateConnectAccountCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiCreateConnectAccountCreate>>,
    TError,
    { data: CreateStripeConnectAccount },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiCreateConnectAccountCreate>>,
    { data: CreateStripeConnectAccount }
  > = (props) => {
    const { data } = props ?? {};

    return apiCreateConnectAccountCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiCreateConnectAccountCreate>>,
    TError,
    { data: CreateStripeConnectAccount },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiJobBoardCreatePostingFromConversationCreate = (
  conversationOpk: string,
  jobBoardPostingCreateFromConversation: JobBoardPostingCreateFromConversation
) => {
  return HTTP<JobBoardPostingCreateFromConversation>({
    url: `/api/v7/create-posting/from-conversation/${conversationOpk}/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: jobBoardPostingCreateFromConversation,
  });
};

export type ApiJobBoardCreatePostingFromConversationCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiJobBoardCreatePostingFromConversationCreate>>
>;
export type ApiJobBoardCreatePostingFromConversationCreateMutationBody =
  JobBoardPostingCreateFromConversation;
export type ApiJobBoardCreatePostingFromConversationCreateMutationError = ErrorType<unknown>;

export const useApiJobBoardCreatePostingFromConversationCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiJobBoardCreatePostingFromConversationCreate>>,
    TError,
    { conversationOpk: string; data: JobBoardPostingCreateFromConversation },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiJobBoardCreatePostingFromConversationCreate>>,
    { conversationOpk: string; data: JobBoardPostingCreateFromConversation }
  > = (props) => {
    const { conversationOpk, data } = props ?? {};

    return apiJobBoardCreatePostingFromConversationCreate(conversationOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiJobBoardCreatePostingFromConversationCreate>>,
    TError,
    { conversationOpk: string; data: JobBoardPostingCreateFromConversation },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiJobBoardCreatePostingFromRecurringConversationCreate = (
  recurringBillingRelationshipOpk: string,
  jobBoardPostingCreateFromConversation: JobBoardPostingCreateFromConversation
) => {
  return HTTP<JobBoardPostingCreateFromConversation>({
    url: `/api/v7/create-posting/from-recurring-conversation/${recurringBillingRelationshipOpk}/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: jobBoardPostingCreateFromConversation,
  });
};

export type ApiJobBoardCreatePostingFromRecurringConversationCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiJobBoardCreatePostingFromRecurringConversationCreate>>
>;
export type ApiJobBoardCreatePostingFromRecurringConversationCreateMutationBody =
  JobBoardPostingCreateFromConversation;
export type ApiJobBoardCreatePostingFromRecurringConversationCreateMutationError =
  ErrorType<unknown>;

export const useApiJobBoardCreatePostingFromRecurringConversationCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiJobBoardCreatePostingFromRecurringConversationCreate>>,
    TError,
    { recurringBillingRelationshipOpk: string; data: JobBoardPostingCreateFromConversation },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiJobBoardCreatePostingFromRecurringConversationCreate>>,
    { recurringBillingRelationshipOpk: string; data: JobBoardPostingCreateFromConversation }
  > = (props) => {
    const { recurringBillingRelationshipOpk, data } = props ?? {};

    return apiJobBoardCreatePostingFromRecurringConversationCreate(
      recurringBillingRelationshipOpk,
      data
    );
  };

  return useMutation<
    Awaited<ReturnType<typeof apiJobBoardCreatePostingFromRecurringConversationCreate>>,
    TError,
    { recurringBillingRelationshipOpk: string; data: JobBoardPostingCreateFromConversation },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiDailyBookingsRetrieve = (
  params?: ApiDailyBookingsRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<DailyBookings[]>({ url: `/api/v7/daily-bookings/`, method: 'get', params, signal });
};

export const getApiDailyBookingsRetrieveQueryKey = (params?: ApiDailyBookingsRetrieveParams) => [
  `/api/v7/daily-bookings/`,
  ...(params ? [params] : []),
];

export type ApiDailyBookingsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDailyBookingsRetrieve>>
>;
export type ApiDailyBookingsRetrieveQueryError = ErrorType<unknown>;

export const useApiDailyBookingsRetrieve = <
  TData = Awaited<ReturnType<typeof apiDailyBookingsRetrieve>>,
  TError = ErrorType<unknown>
>(
  params?: ApiDailyBookingsRetrieveParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiDailyBookingsRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDailyBookingsRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDailyBookingsRetrieve>>> = ({
    signal,
  }) => apiDailyBookingsRetrieve(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiDailyBookingsRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiDailyDashboardRetrieve = (signal?: AbortSignal) => {
  return HTTP<DailyDashboard>({ url: `/api/v7/dashboard/`, method: 'get', signal });
};

export const getApiDailyDashboardRetrieveQueryKey = () => [`/api/v7/dashboard/`];

export type ApiDailyDashboardRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDailyDashboardRetrieve>>
>;
export type ApiDailyDashboardRetrieveQueryError = ErrorType<unknown>;

export const useApiDailyDashboardRetrieve = <
  TData = Awaited<ReturnType<typeof apiDailyDashboardRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiDailyDashboardRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDailyDashboardRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDailyDashboardRetrieve>>> = ({
    signal,
  }) => apiDailyDashboardRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiDailyDashboardRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiTodayViewList = (params?: ApiTodayViewListParams, signal?: AbortSignal) => {
  return HTTP<PaginatedDashboardTodayList>({
    url: `/api/v7/dashboard/today/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiTodayViewListQueryKey = (params?: ApiTodayViewListParams) => [
  `/api/v7/dashboard/today/`,
  ...(params ? [params] : []),
];

export type ApiTodayViewListQueryResult = NonNullable<Awaited<ReturnType<typeof apiTodayViewList>>>;
export type ApiTodayViewListQueryError = ErrorType<unknown>;

export const useApiTodayViewList = <
  TData = Awaited<ReturnType<typeof apiTodayViewList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiTodayViewListParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof apiTodayViewList>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTodayViewListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTodayViewList>>> = ({ signal }) =>
    apiTodayViewList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiTodayViewList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiDeviceList = (params?: ApiDeviceListParams, signal?: AbortSignal) => {
  return HTTP<PaginatedDeviceList>({ url: `/api/v7/devices/`, method: 'get', params, signal });
};

export const getApiDeviceListQueryKey = (params?: ApiDeviceListParams) => [
  `/api/v7/devices/`,
  ...(params ? [params] : []),
];

export type ApiDeviceListQueryResult = NonNullable<Awaited<ReturnType<typeof apiDeviceList>>>;
export type ApiDeviceListQueryError = ErrorType<unknown>;

export const useApiDeviceList = <
  TData = Awaited<ReturnType<typeof apiDeviceList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiDeviceListParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof apiDeviceList>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDeviceListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDeviceList>>> = ({ signal }) =>
    apiDeviceList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiDeviceList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiDeviceListCreate = (deviceCreationRequest: DeviceCreationRequest) => {
  return HTTP<Device | DeviceCreation>({
    url: `/api/v7/devices/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: deviceCreationRequest,
  });
};

export type ApiDeviceListCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiDeviceListCreate>>
>;
export type ApiDeviceListCreateMutationBody = DeviceCreationRequest;
export type ApiDeviceListCreateMutationError = ErrorType<unknown>;

export const useApiDeviceListCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDeviceListCreate>>,
    TError,
    { data: DeviceCreationRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiDeviceListCreate>>,
    { data: DeviceCreationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiDeviceListCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiDeviceListCreate>>,
    TError,
    { data: DeviceCreationRequest },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiDeviceDetailRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<Device>({ url: `/api/v7/devices/${opk}/`, method: 'get', signal });
};

export const getApiDeviceDetailRetrieveQueryKey = (opk: string) => [`/api/v7/devices/${opk}/`];

export type ApiDeviceDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDeviceDetailRetrieve>>
>;
export type ApiDeviceDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiDeviceDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiDeviceDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiDeviceDetailRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDeviceDetailRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDeviceDetailRetrieve>>> = ({
    signal,
  }) => apiDeviceDetailRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiDeviceDetailRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * ExperimentsView lists the groups the request is in for each APIExperiment.
If the request is not yet in a group for an APIExperiment, it will return
a random unpersisted bucketing for it.
In order for groups to be persisted for that request, the client must POST
back the buckets received to this endpoint.
 */
export const apiExperimentsList = (params?: ApiExperimentsListParams, signal?: AbortSignal) => {
  return HTTP<PaginatedExperimentList>({
    url: `/api/v7/experiments/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiExperimentsListQueryKey = (params?: ApiExperimentsListParams) => [
  `/api/v7/experiments/`,
  ...(params ? [params] : []),
];

export type ApiExperimentsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiExperimentsList>>
>;
export type ApiExperimentsListQueryError = ErrorType<unknown>;

export const useApiExperimentsList = <
  TData = Awaited<ReturnType<typeof apiExperimentsList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiExperimentsListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiExperimentsList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiExperimentsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiExperimentsList>>> = ({ signal }) =>
    apiExperimentsList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiExperimentsList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * ExperimentsView lists the groups the request is in for each APIExperiment.
If the request is not yet in a group for an APIExperiment, it will return
a random unpersisted bucketing for it.
In order for groups to be persisted for that request, the client must POST
back the buckets received to this endpoint.
 */
export const apiExperimentsCreate = (apiExperimentsCreateBody: ApiExperimentsCreateBody) => {
  return HTTP<ApiExperimentsCreate201>({
    url: `/api/v7/experiments/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiExperimentsCreateBody,
  });
};

export type ApiExperimentsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiExperimentsCreate>>
>;
export type ApiExperimentsCreateMutationBody = ApiExperimentsCreateBody;
export type ApiExperimentsCreateMutationError = ErrorType<unknown>;

export const useApiExperimentsCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiExperimentsCreate>>,
    TError,
    { data: ApiExperimentsCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiExperimentsCreate>>,
    { data: ApiExperimentsCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiExperimentsCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiExperimentsCreate>>,
    TError,
    { data: ApiExperimentsCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiFacilitiesRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<Facility>({ url: `/api/v7/facilities/${opk}/`, method: 'get', signal });
};

export const getApiFacilitiesRetrieveQueryKey = (opk: string) => [`/api/v7/facilities/${opk}/`];

export type ApiFacilitiesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFacilitiesRetrieve>>
>;
export type ApiFacilitiesRetrieveQueryError = ErrorType<void>;

export const useApiFacilitiesRetrieve = <
  TData = Awaited<ReturnType<typeof apiFacilitiesRetrieve>>,
  TError = ErrorType<void>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiFacilitiesRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFacilitiesRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFacilitiesRetrieve>>> = ({ signal }) =>
    apiFacilitiesRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiFacilitiesRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Raises EmailVerificationNeededAPIException if the user needs to validate their email.

Runs for every request method by default.
Implement get_verify_email_for_verbs to specify which methods to verify.
 */
export const apiFacilitiesContactPageRetrieve = (
  opk: string,
  params?: ApiFacilitiesContactPageRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<FacilityContactDefaultValues>({
    url: `/api/v7/facilities/${opk}/contact/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiFacilitiesContactPageRetrieveQueryKey = (
  opk: string,
  params?: ApiFacilitiesContactPageRetrieveParams
) => [`/api/v7/facilities/${opk}/contact/`, ...(params ? [params] : [])];

export type ApiFacilitiesContactPageRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFacilitiesContactPageRetrieve>>
>;
export type ApiFacilitiesContactPageRetrieveQueryError = ErrorType<void>;

export const useApiFacilitiesContactPageRetrieve = <
  TData = Awaited<ReturnType<typeof apiFacilitiesContactPageRetrieve>>,
  TError = ErrorType<void>
>(
  opk: string,
  params?: ApiFacilitiesContactPageRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFacilitiesContactPageRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiFacilitiesContactPageRetrieveQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFacilitiesContactPageRetrieve>>> = ({
    signal,
  }) => apiFacilitiesContactPageRetrieve(opk, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFacilitiesContactPageRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Raises EmailVerificationNeededAPIException if the user needs to validate their email.

Runs for every request method by default.
Implement get_verify_email_for_verbs to specify which methods to verify.
 */
export const apiFacilitiesContactPageCreate = (
  opk: string,
  facilityContactRequest: FacilityContactRequest
) => {
  return HTTP<FacilityContactResponse>({
    url: `/api/v7/facilities/${opk}/contact/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: facilityContactRequest,
  });
};

export type ApiFacilitiesContactPageCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiFacilitiesContactPageCreate>>
>;
export type ApiFacilitiesContactPageCreateMutationBody = FacilityContactRequest;
export type ApiFacilitiesContactPageCreateMutationError = ErrorType<void>;

export const useApiFacilitiesContactPageCreate = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiFacilitiesContactPageCreate>>,
    TError,
    { opk: string; data: FacilityContactRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiFacilitiesContactPageCreate>>,
    { opk: string; data: FacilityContactRequest }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiFacilitiesContactPageCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiFacilitiesContactPageCreate>>,
    TError,
    { opk: string; data: FacilityContactRequest },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiFacilitiesContactOutreachCreate = (
  opk: string,
  facilityContactOutreach: FacilityContactOutreach
) => {
  return HTTP<FacilityContactOutreachResponse>({
    url: `/api/v7/facilities/${opk}/contact-outreach/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: facilityContactOutreach,
  });
};

export type ApiFacilitiesContactOutreachCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiFacilitiesContactOutreachCreate>>
>;
export type ApiFacilitiesContactOutreachCreateMutationBody = FacilityContactOutreach;
export type ApiFacilitiesContactOutreachCreateMutationError = ErrorType<void>;

export const useApiFacilitiesContactOutreachCreate = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiFacilitiesContactOutreachCreate>>,
    TError,
    { opk: string; data: FacilityContactOutreach },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiFacilitiesContactOutreachCreate>>,
    { opk: string; data: FacilityContactOutreach }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiFacilitiesContactOutreachCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiFacilitiesContactOutreachCreate>>,
    TError,
    { opk: string; data: FacilityContactOutreach },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiFacilityDaycarePreferencesRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<FacilityDaycarePreferences>({
    url: `/api/v7/facilities/${opk}/daycare-preferences/`,
    method: 'get',
    signal,
  });
};

export const getApiFacilityDaycarePreferencesRetrieveQueryKey = (opk: string) => [
  `/api/v7/facilities/${opk}/daycare-preferences/`,
];

export type ApiFacilityDaycarePreferencesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFacilityDaycarePreferencesRetrieve>>
>;
export type ApiFacilityDaycarePreferencesRetrieveQueryError = ErrorType<void>;

export const useApiFacilityDaycarePreferencesRetrieve = <
  TData = Awaited<ReturnType<typeof apiFacilityDaycarePreferencesRetrieve>>,
  TError = ErrorType<void>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFacilityDaycarePreferencesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFacilityDaycarePreferencesRetrieveQueryKey(opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFacilityDaycarePreferencesRetrieve>>
  > = ({ signal }) => apiFacilityDaycarePreferencesRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFacilityDaycarePreferencesRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiGingrGroupedReservationTypesList = (opk: string, signal?: AbortSignal) => {
  return HTTP<GingrGroupedReservationType[]>({
    url: `/api/v7/facilities/${opk}/gingr-grouped-reservation-types/`,
    method: 'get',
    signal,
  });
};

export const getApiGingrGroupedReservationTypesListQueryKey = (opk: string) => [
  `/api/v7/facilities/${opk}/gingr-grouped-reservation-types/`,
];

export type ApiGingrGroupedReservationTypesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiGingrGroupedReservationTypesList>>
>;
export type ApiGingrGroupedReservationTypesListQueryError = ErrorType<unknown>;

export const useApiGingrGroupedReservationTypesList = <
  TData = Awaited<ReturnType<typeof apiGingrGroupedReservationTypesList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiGingrGroupedReservationTypesList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiGingrGroupedReservationTypesListQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGingrGroupedReservationTypesList>>> = ({
    signal,
  }) => apiGingrGroupedReservationTypesList(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiGingrGroupedReservationTypesList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFacilitiesOperatingHoursList = (opk: string, signal?: AbortSignal) => {
  return HTTP<FacilityOperatingHours[]>({
    url: `/api/v7/facilities/${opk}/operating-hours/`,
    method: 'get',
    signal,
  });
};

export const getApiFacilitiesOperatingHoursListQueryKey = (opk: string) => [
  `/api/v7/facilities/${opk}/operating-hours/`,
];

export type ApiFacilitiesOperatingHoursListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFacilitiesOperatingHoursList>>
>;
export type ApiFacilitiesOperatingHoursListQueryError = ErrorType<unknown>;

export const useApiFacilitiesOperatingHoursList = <
  TData = Awaited<ReturnType<typeof apiFacilitiesOperatingHoursList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFacilitiesOperatingHoursList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFacilitiesOperatingHoursListQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFacilitiesOperatingHoursList>>> = ({
    signal,
  }) => apiFacilitiesOperatingHoursList(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFacilitiesOperatingHoursList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFacilitiesReservationTypesRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<ApiFacilitiesReservationTypesRetrieve200>({
    url: `/api/v7/facilities/${opk}/reservation-types/`,
    method: 'get',
    signal,
  });
};

export const getApiFacilitiesReservationTypesRetrieveQueryKey = (opk: string) => [
  `/api/v7/facilities/${opk}/reservation-types/`,
];

export type ApiFacilitiesReservationTypesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFacilitiesReservationTypesRetrieve>>
>;
export type ApiFacilitiesReservationTypesRetrieveQueryError = ErrorType<void>;

export const useApiFacilitiesReservationTypesRetrieve = <
  TData = Awaited<ReturnType<typeof apiFacilitiesReservationTypesRetrieve>>,
  TError = ErrorType<void>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFacilitiesReservationTypesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFacilitiesReservationTypesRetrieveQueryKey(opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFacilitiesReservationTypesRetrieve>>
  > = ({ signal }) => apiFacilitiesReservationTypesRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFacilitiesReservationTypesRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFacilitiesServiceHoursRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<ApiFacilitiesServiceHoursRetrieve200>({
    url: `/api/v7/facilities/${opk}/service-hours/`,
    method: 'get',
    signal,
  });
};

export const getApiFacilitiesServiceHoursRetrieveQueryKey = (opk: string) => [
  `/api/v7/facilities/${opk}/service-hours/`,
];

export type ApiFacilitiesServiceHoursRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFacilitiesServiceHoursRetrieve>>
>;
export type ApiFacilitiesServiceHoursRetrieveQueryError = ErrorType<void>;

export const useApiFacilitiesServiceHoursRetrieve = <
  TData = Awaited<ReturnType<typeof apiFacilitiesServiceHoursRetrieve>>,
  TError = ErrorType<void>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFacilitiesServiceHoursRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFacilitiesServiceHoursRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFacilitiesServiceHoursRetrieve>>> = ({
    signal,
  }) => apiFacilitiesServiceHoursRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFacilitiesServiceHoursRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFacilitiesWaiverRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<FacilityWaiverAPIResponse>({
    url: `/api/v7/facilities/${opk}/waiver/`,
    method: 'get',
    signal,
  });
};

export const getApiFacilitiesWaiverRetrieveQueryKey = (opk: string) => [
  `/api/v7/facilities/${opk}/waiver/`,
];

export type ApiFacilitiesWaiverRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFacilitiesWaiverRetrieve>>
>;
export type ApiFacilitiesWaiverRetrieveQueryError = ErrorType<unknown>;

export const useApiFacilitiesWaiverRetrieve = <
  TData = Awaited<ReturnType<typeof apiFacilitiesWaiverRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiFacilitiesWaiverRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFacilitiesWaiverRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFacilitiesWaiverRetrieve>>> = ({
    signal,
  }) => apiFacilitiesWaiverRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiFacilitiesWaiverRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * This view returns data about the current user as
it relates to facilities in general. The main purpose of this
is to support Statsig experiments on the frontend that
require extra context.
 */
export const apiFacilitiesUserContextRetrieve = (signal?: AbortSignal) => {
  return HTTP<UserFacilitiesContextResponse>({
    url: `/api/v7/facilities/user-context/`,
    method: 'get',
    signal,
  });
};

export const getApiFacilitiesUserContextRetrieveQueryKey = () => [
  `/api/v7/facilities/user-context/`,
];

export type ApiFacilitiesUserContextRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFacilitiesUserContextRetrieve>>
>;
export type ApiFacilitiesUserContextRetrieveQueryError = ErrorType<unknown>;

export const useApiFacilitiesUserContextRetrieve = <
  TData = Awaited<ReturnType<typeof apiFacilitiesUserContextRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiFacilitiesUserContextRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFacilitiesUserContextRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFacilitiesUserContextRetrieve>>> = ({
    signal,
  }) => apiFacilitiesUserContextRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFacilitiesUserContextRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFacilitiesVetList = (params?: ApiFacilitiesVetListParams, signal?: AbortSignal) => {
  return HTTP<FacilityVeterinarian[]>({
    url: `/api/v7/facilities/vet-list/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiFacilitiesVetListQueryKey = (params?: ApiFacilitiesVetListParams) => [
  `/api/v7/facilities/vet-list/`,
  ...(params ? [params] : []),
];

export type ApiFacilitiesVetListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFacilitiesVetList>>
>;
export type ApiFacilitiesVetListQueryError = ErrorType<unknown>;

export const useApiFacilitiesVetList = <
  TData = Awaited<ReturnType<typeof apiFacilitiesVetList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiFacilitiesVetListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiFacilitiesVetList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFacilitiesVetListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFacilitiesVetList>>> = ({ signal }) =>
    apiFacilitiesVetList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiFacilitiesVetList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFacilityBookingChargesRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<FacilityBookingCharges>({
    url: `/api/v7/facility-booking/${opk}/charges/`,
    method: 'get',
    signal,
  });
};

export const getApiFacilityBookingChargesRetrieveQueryKey = (opk: string) => [
  `/api/v7/facility-booking/${opk}/charges/`,
];

export type ApiFacilityBookingChargesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFacilityBookingChargesRetrieve>>
>;
export type ApiFacilityBookingChargesRetrieveQueryError = ErrorType<unknown>;

export const useApiFacilityBookingChargesRetrieve = <
  TData = Awaited<ReturnType<typeof apiFacilityBookingChargesRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFacilityBookingChargesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFacilityBookingChargesRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFacilityBookingChargesRetrieve>>> = ({
    signal,
  }) => apiFacilityBookingChargesRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFacilityBookingChargesRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFacilityEvalRequirementRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<FacilityEvalRequirement>({
    url: `/api/v7/facility-booking/${opk}/eval-requirement/`,
    method: 'get',
    signal,
  });
};

export const getApiFacilityEvalRequirementRetrieveQueryKey = (opk: string) => [
  `/api/v7/facility-booking/${opk}/eval-requirement/`,
];

export type ApiFacilityEvalRequirementRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFacilityEvalRequirementRetrieve>>
>;
export type ApiFacilityEvalRequirementRetrieveQueryError = ErrorType<unknown>;

export const useApiFacilityEvalRequirementRetrieve = <
  TData = Awaited<ReturnType<typeof apiFacilityEvalRequirementRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFacilityEvalRequirementRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFacilityEvalRequirementRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFacilityEvalRequirementRetrieve>>> = ({
    signal,
  }) => apiFacilityEvalRequirementRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFacilityEvalRequirementRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFacilityEvalRequirementCreate = (
  opk: string,
  facilityEvalBook: FacilityEvalBook
) => {
  return HTTP<FacilityEvalBook>({
    url: `/api/v7/facility-booking/${opk}/eval-requirement/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: facilityEvalBook,
  });
};

export type ApiFacilityEvalRequirementCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiFacilityEvalRequirementCreate>>
>;
export type ApiFacilityEvalRequirementCreateMutationBody = FacilityEvalBook;
export type ApiFacilityEvalRequirementCreateMutationError = ErrorType<unknown>;

export const useApiFacilityEvalRequirementCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiFacilityEvalRequirementCreate>>,
    TError,
    { opk: string; data: FacilityEvalBook },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiFacilityEvalRequirementCreate>>,
    { opk: string; data: FacilityEvalBook }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiFacilityEvalRequirementCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiFacilityEvalRequirementCreate>>,
    TError,
    { opk: string; data: FacilityEvalBook },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiFacilityEvalRequirementUpdate = (
  opk: string,
  facilityEvalRequirementRequest: FacilityEvalRequirementRequest
) => {
  return HTTP<FacilityEvalRequirementRequest>({
    url: `/api/v7/facility-booking/${opk}/eval-requirement/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: facilityEvalRequirementRequest,
  });
};

export type ApiFacilityEvalRequirementUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiFacilityEvalRequirementUpdate>>
>;
export type ApiFacilityEvalRequirementUpdateMutationBody = FacilityEvalRequirementRequest;
export type ApiFacilityEvalRequirementUpdateMutationError = ErrorType<unknown>;

export const useApiFacilityEvalRequirementUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiFacilityEvalRequirementUpdate>>,
    TError,
    { opk: string; data: FacilityEvalRequirementRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiFacilityEvalRequirementUpdate>>,
    { opk: string; data: FacilityEvalRequirementRequest }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiFacilityEvalRequirementUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiFacilityEvalRequirementUpdate>>,
    TError,
    { opk: string; data: FacilityEvalRequirementRequest },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiFacilityBookingMarkAsReadCreate = (opk: string) => {
  return HTTP<FacilityBookingMarkAsRead>({
    url: `/api/v7/facility-booking/${opk}/mark-as-read/`,
    method: 'post',
  });
};

export type ApiFacilityBookingMarkAsReadCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiFacilityBookingMarkAsReadCreate>>
>;

export type ApiFacilityBookingMarkAsReadCreateMutationError = ErrorType<void>;

export const useApiFacilityBookingMarkAsReadCreate = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiFacilityBookingMarkAsReadCreate>>,
    TError,
    { opk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiFacilityBookingMarkAsReadCreate>>,
    { opk: string }
  > = (props) => {
    const { opk } = props ?? {};

    return apiFacilityBookingMarkAsReadCreate(opk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiFacilityBookingMarkAsReadCreate>>,
    TError,
    { opk: string },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiFacilityBookingOwnerInfoRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<FacilityBookingOwnerInfoViewOptional>({
    url: `/api/v7/facility-booking/${opk}/owner-info/`,
    method: 'get',
    signal,
  });
};

export const getApiFacilityBookingOwnerInfoRetrieveQueryKey = (opk: string) => [
  `/api/v7/facility-booking/${opk}/owner-info/`,
];

export type ApiFacilityBookingOwnerInfoRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFacilityBookingOwnerInfoRetrieve>>
>;
export type ApiFacilityBookingOwnerInfoRetrieveQueryError = ErrorType<void>;

export const useApiFacilityBookingOwnerInfoRetrieve = <
  TData = Awaited<ReturnType<typeof apiFacilityBookingOwnerInfoRetrieve>>,
  TError = ErrorType<void>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFacilityBookingOwnerInfoRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFacilityBookingOwnerInfoRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFacilityBookingOwnerInfoRetrieve>>> = ({
    signal,
  }) => apiFacilityBookingOwnerInfoRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFacilityBookingOwnerInfoRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFacilityBookingOwnerInfoCreate = (
  opk: string,
  facilityBookingOwnerInfoViewRequired: FacilityBookingOwnerInfoViewRequired
) => {
  return HTTP<FacilityBookingOwnerInfoViewRequired>({
    url: `/api/v7/facility-booking/${opk}/owner-info/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: facilityBookingOwnerInfoViewRequired,
  });
};

export type ApiFacilityBookingOwnerInfoCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiFacilityBookingOwnerInfoCreate>>
>;
export type ApiFacilityBookingOwnerInfoCreateMutationBody = FacilityBookingOwnerInfoViewRequired;
export type ApiFacilityBookingOwnerInfoCreateMutationError = ErrorType<unknown>;

export const useApiFacilityBookingOwnerInfoCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiFacilityBookingOwnerInfoCreate>>,
    TError,
    { opk: string; data: FacilityBookingOwnerInfoViewRequired },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiFacilityBookingOwnerInfoCreate>>,
    { opk: string; data: FacilityBookingOwnerInfoViewRequired }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiFacilityBookingOwnerInfoCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiFacilityBookingOwnerInfoCreate>>,
    TError,
    { opk: string; data: FacilityBookingOwnerInfoViewRequired },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiSendCollectRecordsNotificationCreate = (opk: string) => {
  return HTTP<void>({
    url: `/api/v7/facility-booking/${opk}/send-collect-records-notification/`,
    method: 'post',
  });
};

export type ApiSendCollectRecordsNotificationCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSendCollectRecordsNotificationCreate>>
>;

export type ApiSendCollectRecordsNotificationCreateMutationError = ErrorType<unknown>;

export const useApiSendCollectRecordsNotificationCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSendCollectRecordsNotificationCreate>>,
    TError,
    { opk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSendCollectRecordsNotificationCreate>>,
    { opk: string }
  > = (props) => {
    const { opk } = props ?? {};

    return apiSendCollectRecordsNotificationCreate(opk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiSendCollectRecordsNotificationCreate>>,
    TError,
    { opk: string },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiFacilityBookingSummaryDetailsRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<FacilityBookingDetails>({
    url: `/api/v7/facility-booking/${opk}/summary-details/`,
    method: 'get',
    signal,
  });
};

export const getApiFacilityBookingSummaryDetailsRetrieveQueryKey = (opk: string) => [
  `/api/v7/facility-booking/${opk}/summary-details/`,
];

export type ApiFacilityBookingSummaryDetailsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFacilityBookingSummaryDetailsRetrieve>>
>;
export type ApiFacilityBookingSummaryDetailsRetrieveQueryError = ErrorType<unknown>;

export const useApiFacilityBookingSummaryDetailsRetrieve = <
  TData = Awaited<ReturnType<typeof apiFacilityBookingSummaryDetailsRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFacilityBookingSummaryDetailsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiFacilityBookingSummaryDetailsRetrieveQueryKey(opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFacilityBookingSummaryDetailsRetrieve>>
  > = ({ signal }) => apiFacilityBookingSummaryDetailsRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFacilityBookingSummaryDetailsRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFacilityBookingVaccineStatusRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<FacilityBookingVaccineStatus>({
    url: `/api/v7/facility-booking/${opk}/vaccine-status/`,
    method: 'get',
    signal,
  });
};

export const getApiFacilityBookingVaccineStatusRetrieveQueryKey = (opk: string) => [
  `/api/v7/facility-booking/${opk}/vaccine-status/`,
];

export type ApiFacilityBookingVaccineStatusRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFacilityBookingVaccineStatusRetrieve>>
>;
export type ApiFacilityBookingVaccineStatusRetrieveQueryError = ErrorType<unknown>;

export const useApiFacilityBookingVaccineStatusRetrieve = <
  TData = Awaited<ReturnType<typeof apiFacilityBookingVaccineStatusRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFacilityBookingVaccineStatusRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiFacilityBookingVaccineStatusRetrieveQueryKey(opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFacilityBookingVaccineStatusRetrieve>>
  > = ({ signal }) => apiFacilityBookingVaccineStatusRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFacilityBookingVaccineStatusRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFacilityBookingVaccineUploadCreate = (
  opk: string,
  apiFacilityBookingVaccineUploadCreateBody: ApiFacilityBookingVaccineUploadCreateBody
) => {
  const formData = new FormData();
  if (apiFacilityBookingVaccineUploadCreateBody.files !== undefined) {
    apiFacilityBookingVaccineUploadCreateBody.files.forEach((value) =>
      formData.append('files', value)
    );
  }

  return HTTP<void>({
    url: `/api/v7/facility-booking/${opk}/vaccine-upload/`,
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
};

export type ApiFacilityBookingVaccineUploadCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiFacilityBookingVaccineUploadCreate>>
>;
export type ApiFacilityBookingVaccineUploadCreateMutationBody =
  ApiFacilityBookingVaccineUploadCreateBody;
export type ApiFacilityBookingVaccineUploadCreateMutationError = ErrorType<unknown>;

export const useApiFacilityBookingVaccineUploadCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiFacilityBookingVaccineUploadCreate>>,
    TError,
    { opk: string; data: ApiFacilityBookingVaccineUploadCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiFacilityBookingVaccineUploadCreate>>,
    { opk: string; data: ApiFacilityBookingVaccineUploadCreateBody }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiFacilityBookingVaccineUploadCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiFacilityBookingVaccineUploadCreate>>,
    TError,
    { opk: string; data: ApiFacilityBookingVaccineUploadCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiFixturesStepsRunEphemeralCreate = (
  apiFixturesStepsRunEphemeralCreateBody: ApiFixturesStepsRunEphemeralCreateBody
) => {
  return HTTP<ApiFixturesStepsRunEphemeralCreate200>({
    url: `/api/v7/fixtures/steps-run-ephemeral/`,
    method: 'post',
    headers: { 'Content-Type': 'type' },
    data: apiFixturesStepsRunEphemeralCreateBody,
  });
};

export type ApiFixturesStepsRunEphemeralCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiFixturesStepsRunEphemeralCreate>>
>;
export type ApiFixturesStepsRunEphemeralCreateMutationBody = ApiFixturesStepsRunEphemeralCreateBody;
export type ApiFixturesStepsRunEphemeralCreateMutationError = ErrorType<unknown>;

export const useApiFixturesStepsRunEphemeralCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiFixturesStepsRunEphemeralCreate>>,
    TError,
    { data: ApiFixturesStepsRunEphemeralCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiFixturesStepsRunEphemeralCreate>>,
    { data: ApiFixturesStepsRunEphemeralCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiFixturesStepsRunEphemeralCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiFixturesStepsRunEphemeralCreate>>,
    TError,
    { data: ApiFixturesStepsRunEphemeralCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiFixturesBuildsRetrieve = (
  params?: ApiFixturesBuildsRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedBuildsSchema>({
    url: `/api/v7/fixtures/template-builds/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiFixturesBuildsRetrieveQueryKey = (params?: ApiFixturesBuildsRetrieveParams) => [
  `/api/v7/fixtures/template-builds/`,
  ...(params ? [params] : []),
];

export type ApiFixturesBuildsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFixturesBuildsRetrieve>>
>;
export type ApiFixturesBuildsRetrieveQueryError = ErrorType<unknown>;

export const useApiFixturesBuildsRetrieve = <
  TData = Awaited<ReturnType<typeof apiFixturesBuildsRetrieve>>,
  TError = ErrorType<unknown>
>(
  params?: ApiFixturesBuildsRetrieveParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiFixturesBuildsRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFixturesBuildsRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFixturesBuildsRetrieve>>> = ({
    signal,
  }) => apiFixturesBuildsRetrieve(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiFixturesBuildsRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFixturesBuildRetrieve = (id: string, signal?: AbortSignal) => {
  return HTTP<BuildSchema>({
    url: `/api/v7/fixtures/template-builds/${id}/`,
    method: 'get',
    signal,
  });
};

export const getApiFixturesBuildRetrieveQueryKey = (id: string) => [
  `/api/v7/fixtures/template-builds/${id}/`,
];

export type ApiFixturesBuildRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFixturesBuildRetrieve>>
>;
export type ApiFixturesBuildRetrieveQueryError = ErrorType<unknown>;

export const useApiFixturesBuildRetrieve = <
  TData = Awaited<ReturnType<typeof apiFixturesBuildRetrieve>>,
  TError = ErrorType<unknown>
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiFixturesBuildRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFixturesBuildRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFixturesBuildRetrieve>>> = ({
    signal,
  }) => apiFixturesBuildRetrieve(id, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiFixturesBuildRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!id,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFixturesTemplatesList = (
  params?: ApiFixturesTemplatesListParams,
  signal?: AbortSignal
) => {
  return HTTP<TemplateDetailSchema[]>({
    url: `/api/v7/fixtures/templates/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiFixturesTemplatesListQueryKey = (params?: ApiFixturesTemplatesListParams) => [
  `/api/v7/fixtures/templates/`,
  ...(params ? [params] : []),
];

export type ApiFixturesTemplatesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFixturesTemplatesList>>
>;
export type ApiFixturesTemplatesListQueryError = ErrorType<unknown>;

export const useApiFixturesTemplatesList = <
  TData = Awaited<ReturnType<typeof apiFixturesTemplatesList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiFixturesTemplatesListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiFixturesTemplatesList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFixturesTemplatesListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFixturesTemplatesList>>> = ({
    signal,
  }) => apiFixturesTemplatesList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiFixturesTemplatesList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFixturesTemplateRetrieve = (slug: string, signal?: AbortSignal) => {
  return HTTP<TemplateDetailSchema>({
    url: `/api/v7/fixtures/templates/${slug}/`,
    method: 'get',
    signal,
  });
};

export const getApiFixturesTemplateRetrieveQueryKey = (slug: string) => [
  `/api/v7/fixtures/templates/${slug}/`,
];

export type ApiFixturesTemplateRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFixturesTemplateRetrieve>>
>;
export type ApiFixturesTemplateRetrieveQueryError = ErrorType<unknown>;

export const useApiFixturesTemplateRetrieve = <
  TData = Awaited<ReturnType<typeof apiFixturesTemplateRetrieve>>,
  TError = ErrorType<unknown>
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiFixturesTemplateRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFixturesTemplateRetrieveQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFixturesTemplateRetrieve>>> = ({
    signal,
  }) => apiFixturesTemplateRetrieve(slug, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiFixturesTemplateRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!slug,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFixturesTemplateRunCreate = (
  slug: string,
  apiFixturesTemplateRunCreateBody: ApiFixturesTemplateRunCreateBody
) => {
  return HTTP<BuildSchema>({
    url: `/api/v7/fixtures/templates/${slug}/run`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiFixturesTemplateRunCreateBody,
  });
};

export type ApiFixturesTemplateRunCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiFixturesTemplateRunCreate>>
>;
export type ApiFixturesTemplateRunCreateMutationBody = ApiFixturesTemplateRunCreateBody;
export type ApiFixturesTemplateRunCreateMutationError = ErrorType<
  ApiFixturesTemplateRunCreate400 | ApiFixturesTemplateRunCreate500
>;

export const useApiFixturesTemplateRunCreate = <
  TError = ErrorType<ApiFixturesTemplateRunCreate400 | ApiFixturesTemplateRunCreate500>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiFixturesTemplateRunCreate>>,
    TError,
    { slug: string; data: ApiFixturesTemplateRunCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiFixturesTemplateRunCreate>>,
    { slug: string; data: ApiFixturesTemplateRunCreateBody }
  > = (props) => {
    const { slug, data } = props ?? {};

    return apiFixturesTemplateRunCreate(slug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiFixturesTemplateRunCreate>>,
    TError,
    { slug: string; data: ApiFixturesTemplateRunCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiFixtureWebhooksList = (signal?: AbortSignal) => {
  return HTTP<WebhookFixtureMinSchema[]>({
    url: `/api/v7/fixtures/webhooks/`,
    method: 'get',
    signal,
  });
};

export const getApiFixtureWebhooksListQueryKey = () => [`/api/v7/fixtures/webhooks/`];

export type ApiFixtureWebhooksListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFixtureWebhooksList>>
>;
export type ApiFixtureWebhooksListQueryError = ErrorType<unknown>;

export const useApiFixtureWebhooksList = <
  TData = Awaited<ReturnType<typeof apiFixtureWebhooksList>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiFixtureWebhooksList>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFixtureWebhooksListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFixtureWebhooksList>>> = ({ signal }) =>
    apiFixtureWebhooksList(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiFixtureWebhooksList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFixtureWebhooksCreate = (webhookFixturePostSchema: WebhookFixturePostSchema) => {
  return HTTP<WebhookFixtureMinSchema[]>({
    url: `/api/v7/fixtures/webhooks/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: webhookFixturePostSchema,
  });
};

export type ApiFixtureWebhooksCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiFixtureWebhooksCreate>>
>;
export type ApiFixtureWebhooksCreateMutationBody = WebhookFixturePostSchema;
export type ApiFixtureWebhooksCreateMutationError = ErrorType<unknown>;

export const useApiFixtureWebhooksCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiFixtureWebhooksCreate>>,
    TError,
    { data: WebhookFixturePostSchema },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiFixtureWebhooksCreate>>,
    { data: WebhookFixturePostSchema }
  > = (props) => {
    const { data } = props ?? {};

    return apiFixtureWebhooksCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiFixtureWebhooksCreate>>,
    TError,
    { data: WebhookFixturePostSchema },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiFixtureWebhookRetrieve = (slug: string, signal?: AbortSignal) => {
  return HTTP<WebhookFixtureSchema>({
    url: `/api/v7/fixtures/webhooks/${slug}/`,
    method: 'get',
    signal,
  });
};

export const getApiFixtureWebhookRetrieveQueryKey = (slug: string) => [
  `/api/v7/fixtures/webhooks/${slug}/`,
];

export type ApiFixtureWebhookRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFixtureWebhookRetrieve>>
>;
export type ApiFixtureWebhookRetrieveQueryError = ErrorType<void>;

export const useApiFixtureWebhookRetrieve = <
  TData = Awaited<ReturnType<typeof apiFixtureWebhookRetrieve>>,
  TError = ErrorType<void>
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiFixtureWebhookRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFixtureWebhookRetrieveQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFixtureWebhookRetrieve>>> = ({
    signal,
  }) => apiFixtureWebhookRetrieve(slug, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiFixtureWebhookRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!slug,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFlagSubmitCreate = (flagSubmitRequest: FlagSubmitRequest) => {
  return HTTP<void>({
    url: `/api/v7/flagsubmit/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: flagSubmitRequest,
  });
};

export type ApiFlagSubmitCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiFlagSubmitCreate>>
>;
export type ApiFlagSubmitCreateMutationBody = FlagSubmitRequest;
export type ApiFlagSubmitCreateMutationError = ErrorType<unknown>;

export const useApiFlagSubmitCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiFlagSubmitCreate>>,
    TError,
    { data: FlagSubmitRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiFlagSubmitCreate>>,
    { data: FlagSubmitRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiFlagSubmitCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiFlagSubmitCreate>>,
    TError,
    { data: FlagSubmitRequest },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiFrontendConfigurationRetrieve = (
  params?: ApiFrontendConfigurationRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<ApiFrontendConfigurationRetrieve200>({
    url: `/api/v7/frontend/configuration/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiFrontendConfigurationRetrieveQueryKey = (
  params?: ApiFrontendConfigurationRetrieveParams
) => [`/api/v7/frontend/configuration/`, ...(params ? [params] : [])];

export type ApiFrontendConfigurationRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendConfigurationRetrieve>>
>;
export type ApiFrontendConfigurationRetrieveQueryError = ErrorType<unknown>;

export const useApiFrontendConfigurationRetrieve = <
  TData = Awaited<ReturnType<typeof apiFrontendConfigurationRetrieve>>,
  TError = ErrorType<unknown>
>(
  params?: ApiFrontendConfigurationRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendConfigurationRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFrontendConfigurationRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFrontendConfigurationRetrieve>>> = ({
    signal,
  }) => apiFrontendConfigurationRetrieve(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFrontendConfigurationRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiCountryFooterLinksList = (
  params?: ApiCountryFooterLinksListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedCountryFooterLinkList>({
    url: `/api/v7/frontend/country-footer-links/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiCountryFooterLinksListQueryKey = (params?: ApiCountryFooterLinksListParams) => [
  `/api/v7/frontend/country-footer-links/`,
  ...(params ? [params] : []),
];

export type ApiCountryFooterLinksListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiCountryFooterLinksList>>
>;
export type ApiCountryFooterLinksListQueryError = ErrorType<unknown>;

export const useApiCountryFooterLinksList = <
  TData = Awaited<ReturnType<typeof apiCountryFooterLinksList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiCountryFooterLinksListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiCountryFooterLinksList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiCountryFooterLinksListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiCountryFooterLinksList>>> = ({
    signal,
  }) => apiCountryFooterLinksList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiCountryFooterLinksList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiCountryRegionLinksList = (
  params?: ApiCountryRegionLinksListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedCountryRegionLinkList>({
    url: `/api/v7/frontend/country-region-links/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiCountryRegionLinksListQueryKey = (params?: ApiCountryRegionLinksListParams) => [
  `/api/v7/frontend/country-region-links/`,
  ...(params ? [params] : []),
];

export type ApiCountryRegionLinksListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiCountryRegionLinksList>>
>;
export type ApiCountryRegionLinksListQueryError = ErrorType<unknown>;

export const useApiCountryRegionLinksList = <
  TData = Awaited<ReturnType<typeof apiCountryRegionLinksList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiCountryRegionLinksListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiCountryRegionLinksList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiCountryRegionLinksListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiCountryRegionLinksList>>> = ({
    signal,
  }) => apiCountryRegionLinksList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiCountryRegionLinksList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiCurrentUserRetrieve = (signal?: AbortSignal) => {
  return HTTP<CurrentUserViewSchema>({
    url: `/api/v7/frontend/current-user/`,
    method: 'get',
    signal,
  });
};

export const getApiCurrentUserRetrieveQueryKey = () => [`/api/v7/frontend/current-user/`];

export type ApiCurrentUserRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiCurrentUserRetrieve>>
>;
export type ApiCurrentUserRetrieveQueryError = ErrorType<unknown>;

export const useApiCurrentUserRetrieve = <
  TData = Awaited<ReturnType<typeof apiCurrentUserRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiCurrentUserRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiCurrentUserRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiCurrentUserRetrieve>>> = ({ signal }) =>
    apiCurrentUserRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiCurrentUserRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiFrontendDjangoMessagesList = (
  params?: ApiFrontendDjangoMessagesListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedDjangoMessageList>({
    url: `/api/v7/frontend/django-messages/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiFrontendDjangoMessagesListQueryKey = (
  params?: ApiFrontendDjangoMessagesListParams
) => [`/api/v7/frontend/django-messages/`, ...(params ? [params] : [])];

export type ApiFrontendDjangoMessagesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendDjangoMessagesList>>
>;
export type ApiFrontendDjangoMessagesListQueryError = ErrorType<unknown>;

export const useApiFrontendDjangoMessagesList = <
  TData = Awaited<ReturnType<typeof apiFrontendDjangoMessagesList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiFrontendDjangoMessagesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendDjangoMessagesList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFrontendDjangoMessagesListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFrontendDjangoMessagesList>>> = ({
    signal,
  }) => apiFrontendDjangoMessagesList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiFrontendDjangoMessagesList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFrontendEdgeCacheSafeExperimentsRetrieve = (signal?: AbortSignal) => {
  return HTTP<FrontendEdgeCacheSafeExperiments>({
    url: `/api/v7/frontend/edge-cache-safe-experiments/`,
    method: 'get',
    signal,
  });
};

export const getApiFrontendEdgeCacheSafeExperimentsRetrieveQueryKey = () => [
  `/api/v7/frontend/edge-cache-safe-experiments/`,
];

export type ApiFrontendEdgeCacheSafeExperimentsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendEdgeCacheSafeExperimentsRetrieve>>
>;
export type ApiFrontendEdgeCacheSafeExperimentsRetrieveQueryError = ErrorType<unknown>;

export const useApiFrontendEdgeCacheSafeExperimentsRetrieve = <
  TData = Awaited<ReturnType<typeof apiFrontendEdgeCacheSafeExperimentsRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiFrontendEdgeCacheSafeExperimentsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiFrontendEdgeCacheSafeExperimentsRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFrontendEdgeCacheSafeExperimentsRetrieve>>
  > = ({ signal }) => apiFrontendEdgeCacheSafeExperimentsRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFrontendEdgeCacheSafeExperimentsRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFrontendEventsRetrieve = (signal?: AbortSignal) => {
  return HTTP<FrontendEventsResult>({ url: `/api/v7/frontend/events/`, method: 'get', signal });
};

export const getApiFrontendEventsRetrieveQueryKey = () => [`/api/v7/frontend/events/`];

export type ApiFrontendEventsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendEventsRetrieve>>
>;
export type ApiFrontendEventsRetrieveQueryError = ErrorType<unknown>;

export const useApiFrontendEventsRetrieve = <
  TData = Awaited<ReturnType<typeof apiFrontendEventsRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiFrontendEventsRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFrontendEventsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFrontendEventsRetrieve>>> = ({
    signal,
  }) => apiFrontendEventsRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiFrontendEventsRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Returns a list of active experiments meant for consumption
by the React frontend.
 */
export const apiFrontendExperimentsList = (
  params?: ApiFrontendExperimentsListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedFrontendExperimentList>({
    url: `/api/v7/frontend/experiments/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiFrontendExperimentsListQueryKey = (
  params?: ApiFrontendExperimentsListParams
) => [`/api/v7/frontend/experiments/`, ...(params ? [params] : [])];

export type ApiFrontendExperimentsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendExperimentsList>>
>;
export type ApiFrontendExperimentsListQueryError = ErrorType<unknown>;

export const useApiFrontendExperimentsList = <
  TData = Awaited<ReturnType<typeof apiFrontendExperimentsList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiFrontendExperimentsListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiFrontendExperimentsList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFrontendExperimentsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFrontendExperimentsList>>> = ({
    signal,
  }) => apiFrontendExperimentsList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiFrontendExperimentsList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFrontendFooterRetrieve = (signal?: AbortSignal) => {
  return HTTP<Footer>({ url: `/api/v7/frontend/footer/`, method: 'get', signal });
};

export const getApiFrontendFooterRetrieveQueryKey = () => [`/api/v7/frontend/footer/`];

export type ApiFrontendFooterRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendFooterRetrieve>>
>;
export type ApiFrontendFooterRetrieveQueryError = ErrorType<unknown>;

export const useApiFrontendFooterRetrieve = <
  TData = Awaited<ReturnType<typeof apiFrontendFooterRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiFrontendFooterRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFrontendFooterRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFrontendFooterRetrieve>>> = ({
    signal,
  }) => apiFrontendFooterRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiFrontendFooterRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFrontendHomepageConfigurationRetrieve = (signal?: AbortSignal) => {
  return HTTP<HomepageConfiguration>({
    url: `/api/v7/frontend/homepage-configuration/`,
    method: 'get',
    signal,
  });
};

export const getApiFrontendHomepageConfigurationRetrieveQueryKey = () => [
  `/api/v7/frontend/homepage-configuration/`,
];

export type ApiFrontendHomepageConfigurationRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendHomepageConfigurationRetrieve>>
>;
export type ApiFrontendHomepageConfigurationRetrieveQueryError = ErrorType<unknown>;

export const useApiFrontendHomepageConfigurationRetrieve = <
  TData = Awaited<ReturnType<typeof apiFrontendHomepageConfigurationRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiFrontendHomepageConfigurationRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFrontendHomepageConfigurationRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFrontendHomepageConfigurationRetrieve>>
  > = ({ signal }) => apiFrontendHomepageConfigurationRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFrontendHomepageConfigurationRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiFrontendHomepageRebookingProfilesList = (signal?: AbortSignal) => {
  return HTTP<HomepageRebookingProfile[]>({
    url: `/api/v7/frontend/homepage-rebooking-profiles/`,
    method: 'get',
    signal,
  });
};

export const getApiFrontendHomepageRebookingProfilesListQueryKey = () => [
  `/api/v7/frontend/homepage-rebooking-profiles/`,
];

export type ApiFrontendHomepageRebookingProfilesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendHomepageRebookingProfilesList>>
>;
export type ApiFrontendHomepageRebookingProfilesListQueryError = ErrorType<unknown>;

export const useApiFrontendHomepageRebookingProfilesList = <
  TData = Awaited<ReturnType<typeof apiFrontendHomepageRebookingProfilesList>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiFrontendHomepageRebookingProfilesList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFrontendHomepageRebookingProfilesListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFrontendHomepageRebookingProfilesList>>
  > = ({ signal }) => apiFrontendHomepageRebookingProfilesList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFrontendHomepageRebookingProfilesList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiFrontendHomepageServiceTypesList = (
  params?: ApiFrontendHomepageServiceTypesListParams,
  signal?: AbortSignal
) => {
  return HTTP<HomepageServiceType[]>({
    url: `/api/v7/frontend/homepage-service-types/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiFrontendHomepageServiceTypesListQueryKey = (
  params?: ApiFrontendHomepageServiceTypesListParams
) => [`/api/v7/frontend/homepage-service-types/`, ...(params ? [params] : [])];

export type ApiFrontendHomepageServiceTypesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendHomepageServiceTypesList>>
>;
export type ApiFrontendHomepageServiceTypesListQueryError = ErrorType<unknown>;

export const useApiFrontendHomepageServiceTypesList = <
  TData = Awaited<ReturnType<typeof apiFrontendHomepageServiceTypesList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiFrontendHomepageServiceTypesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendHomepageServiceTypesList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFrontendHomepageServiceTypesListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFrontendHomepageServiceTypesList>>> = ({
    signal,
  }) => apiFrontendHomepageServiceTypesList(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFrontendHomepageServiceTypesList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Returns a list of language codes matched with the country specific URL,
given a path that can be resolved to a view,
e.g. `GET /api/vXYZ/frontend/href-langs/?path=%2Fbecome-a-sitter%2F`
 */
export const apiFrontendHrefLangsRetrieve = (
  params?: ApiFrontendHrefLangsRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<ApiFrontendHrefLangsRetrieve200>({
    url: `/api/v7/frontend/href-langs/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiFrontendHrefLangsRetrieveQueryKey = (
  params?: ApiFrontendHrefLangsRetrieveParams
) => [`/api/v7/frontend/href-langs/`, ...(params ? [params] : [])];

export type ApiFrontendHrefLangsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendHrefLangsRetrieve>>
>;
export type ApiFrontendHrefLangsRetrieveQueryError = ErrorType<unknown>;

export const useApiFrontendHrefLangsRetrieve = <
  TData = Awaited<ReturnType<typeof apiFrontendHrefLangsRetrieve>>,
  TError = ErrorType<unknown>
>(
  params?: ApiFrontendHrefLangsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendHrefLangsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFrontendHrefLangsRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFrontendHrefLangsRetrieve>>> = ({
    signal,
  }) => apiFrontendHrefLangsRetrieve(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiFrontendHrefLangsRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFrontendInternalLinkingRegionRetrieve = (
  countryCode: string,
  regionSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<ApiFrontendInternalLinkingRegionRetrieve200>({
    url: `/api/v7/frontend/internal-linking/${countryCode}/${regionSlug}/`,
    method: 'get',
    signal,
  });
};

export const getApiFrontendInternalLinkingRegionRetrieveQueryKey = (
  countryCode: string,
  regionSlug: string
) => [`/api/v7/frontend/internal-linking/${countryCode}/${regionSlug}/`];

export type ApiFrontendInternalLinkingRegionRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendInternalLinkingRegionRetrieve>>
>;
export type ApiFrontendInternalLinkingRegionRetrieveQueryError = ErrorType<unknown>;

export const useApiFrontendInternalLinkingRegionRetrieve = <
  TData = Awaited<ReturnType<typeof apiFrontendInternalLinkingRegionRetrieve>>,
  TError = ErrorType<unknown>
>(
  countryCode: string,
  regionSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendInternalLinkingRegionRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiFrontendInternalLinkingRegionRetrieveQueryKey(countryCode, regionSlug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFrontendInternalLinkingRegionRetrieve>>
  > = ({ signal }) => apiFrontendInternalLinkingRegionRetrieve(countryCode, regionSlug, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFrontendInternalLinkingRegionRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(countryCode && regionSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFrontendInternalLinkingCityRetrieve = (
  countryCode: string,
  regionSlug: string,
  citySlug: string,
  signal?: AbortSignal
) => {
  return HTTP<ApiFrontendInternalLinkingCityRetrieve200>({
    url: `/api/v7/frontend/internal-linking/${countryCode}/${regionSlug}/${citySlug}/`,
    method: 'get',
    signal,
  });
};

export const getApiFrontendInternalLinkingCityRetrieveQueryKey = (
  countryCode: string,
  regionSlug: string,
  citySlug: string
) => [`/api/v7/frontend/internal-linking/${countryCode}/${regionSlug}/${citySlug}/`];

export type ApiFrontendInternalLinkingCityRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendInternalLinkingCityRetrieve>>
>;
export type ApiFrontendInternalLinkingCityRetrieveQueryError = ErrorType<unknown>;

export const useApiFrontendInternalLinkingCityRetrieve = <
  TData = Awaited<ReturnType<typeof apiFrontendInternalLinkingCityRetrieve>>,
  TError = ErrorType<unknown>
>(
  countryCode: string,
  regionSlug: string,
  citySlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendInternalLinkingCityRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiFrontendInternalLinkingCityRetrieveQueryKey(countryCode, regionSlug, citySlug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFrontendInternalLinkingCityRetrieve>>
  > = ({ signal }) =>
    apiFrontendInternalLinkingCityRetrieve(countryCode, regionSlug, citySlug, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFrontendInternalLinkingCityRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(countryCode && regionSlug && citySlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFrontendInternalLinkingNeighborhoodRetrieve = (
  countryCode: string,
  regionSlug: string,
  citySlug: string,
  neighborhoodSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<ApiFrontendInternalLinkingNeighborhoodRetrieve200>({
    url: `/api/v7/frontend/internal-linking/${countryCode}/${regionSlug}/${citySlug}/${neighborhoodSlug}/`,
    method: 'get',
    signal,
  });
};

export const getApiFrontendInternalLinkingNeighborhoodRetrieveQueryKey = (
  countryCode: string,
  regionSlug: string,
  citySlug: string,
  neighborhoodSlug: string
) => [
  `/api/v7/frontend/internal-linking/${countryCode}/${regionSlug}/${citySlug}/${neighborhoodSlug}/`,
];

export type ApiFrontendInternalLinkingNeighborhoodRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendInternalLinkingNeighborhoodRetrieve>>
>;
export type ApiFrontendInternalLinkingNeighborhoodRetrieveQueryError = ErrorType<unknown>;

export const useApiFrontendInternalLinkingNeighborhoodRetrieve = <
  TData = Awaited<ReturnType<typeof apiFrontendInternalLinkingNeighborhoodRetrieve>>,
  TError = ErrorType<unknown>
>(
  countryCode: string,
  regionSlug: string,
  citySlug: string,
  neighborhoodSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendInternalLinkingNeighborhoodRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiFrontendInternalLinkingNeighborhoodRetrieveQueryKey(
      countryCode,
      regionSlug,
      citySlug,
      neighborhoodSlug
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFrontendInternalLinkingNeighborhoodRetrieve>>
  > = ({ signal }) =>
    apiFrontendInternalLinkingNeighborhoodRetrieve(
      countryCode,
      regionSlug,
      citySlug,
      neighborhoodSlug,
      signal
    );

  const query = useQuery<
    Awaited<ReturnType<typeof apiFrontendInternalLinkingNeighborhoodRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(countryCode && regionSlug && citySlug && neighborhoodSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFrontendRoutingRetrieve = (signal?: AbortSignal) => {
  return HTTP<Routing>({ url: `/api/v7/frontend/routing/`, method: 'get', signal });
};

export const getApiFrontendRoutingRetrieveQueryKey = () => [`/api/v7/frontend/routing/`];

export type ApiFrontendRoutingRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendRoutingRetrieve>>
>;
export type ApiFrontendRoutingRetrieveQueryError = ErrorType<unknown>;

export const useApiFrontendRoutingRetrieve = <
  TData = Awaited<ReturnType<typeof apiFrontendRoutingRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiFrontendRoutingRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFrontendRoutingRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFrontendRoutingRetrieve>>> = ({
    signal,
  }) => apiFrontendRoutingRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiFrontendRoutingRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFrontendRoverCardsMenuItemRetrieve = (viewerType: string, signal?: AbortSignal) => {
  return HTTP<RoverCardsMenuItem>({
    url: `/api/v7/frontend/rover-cards-menu-item/as-${viewerType}/`,
    method: 'get',
    signal,
  });
};

export const getApiFrontendRoverCardsMenuItemRetrieveQueryKey = (viewerType: string) => [
  `/api/v7/frontend/rover-cards-menu-item/as-${viewerType}/`,
];

export type ApiFrontendRoverCardsMenuItemRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendRoverCardsMenuItemRetrieve>>
>;
export type ApiFrontendRoverCardsMenuItemRetrieveQueryError = ErrorType<unknown>;

export const useApiFrontendRoverCardsMenuItemRetrieve = <
  TData = Awaited<ReturnType<typeof apiFrontendRoverCardsMenuItemRetrieve>>,
  TError = ErrorType<unknown>
>(
  viewerType: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendRoverCardsMenuItemRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiFrontendRoverCardsMenuItemRetrieveQueryKey(viewerType);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFrontendRoverCardsMenuItemRetrieve>>
  > = ({ signal }) => apiFrontendRoverCardsMenuItemRetrieve(viewerType, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFrontendRoverCardsMenuItemRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!viewerType,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFrontendServiceLandingCountryspecificRetrieve = (
  countryUrlPrefix: string,
  serviceLandingSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<LocalizedBrandService>({
    url: `/api/v7/frontend/service-landing/${countryUrlPrefix}/${serviceLandingSlug}/`,
    method: 'get',
    signal,
  });
};

export const getApiFrontendServiceLandingCountryspecificRetrieveQueryKey = (
  countryUrlPrefix: string,
  serviceLandingSlug: string
) => [`/api/v7/frontend/service-landing/${countryUrlPrefix}/${serviceLandingSlug}/`];

export type ApiFrontendServiceLandingCountryspecificRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendServiceLandingCountryspecificRetrieve>>
>;
export type ApiFrontendServiceLandingCountryspecificRetrieveQueryError = ErrorType<unknown>;

export const useApiFrontendServiceLandingCountryspecificRetrieve = <
  TData = Awaited<ReturnType<typeof apiFrontendServiceLandingCountryspecificRetrieve>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  serviceLandingSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendServiceLandingCountryspecificRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiFrontendServiceLandingCountryspecificRetrieveQueryKey(
      countryUrlPrefix,
      serviceLandingSlug
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFrontendServiceLandingCountryspecificRetrieve>>
  > = ({ signal }) =>
    apiFrontendServiceLandingCountryspecificRetrieve(countryUrlPrefix, serviceLandingSlug, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFrontendServiceLandingCountryspecificRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(countryUrlPrefix && serviceLandingSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFrontendServiceLandingRetrieve = (
  serviceLandingSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<LocalizedBrandService>({
    url: `/api/v7/frontend/service-landing/${serviceLandingSlug}/`,
    method: 'get',
    signal,
  });
};

export const getApiFrontendServiceLandingRetrieveQueryKey = (serviceLandingSlug: string) => [
  `/api/v7/frontend/service-landing/${serviceLandingSlug}/`,
];

export type ApiFrontendServiceLandingRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendServiceLandingRetrieve>>
>;
export type ApiFrontendServiceLandingRetrieveQueryError = ErrorType<unknown>;

export const useApiFrontendServiceLandingRetrieve = <
  TData = Awaited<ReturnType<typeof apiFrontendServiceLandingRetrieve>>,
  TError = ErrorType<unknown>
>(
  serviceLandingSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendServiceLandingRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiFrontendServiceLandingRetrieveQueryKey(serviceLandingSlug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFrontendServiceLandingRetrieve>>> = ({
    signal,
  }) => apiFrontendServiceLandingRetrieve(serviceLandingSlug, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFrontendServiceLandingRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!serviceLandingSlug,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiServiceLinksRetrieve = (signal?: AbortSignal) => {
  return HTTP<ApiServiceLinksRetrieve200>({
    url: `/api/v7/frontend/service-links/`,
    method: 'get',
    signal,
  });
};

export const getApiServiceLinksRetrieveQueryKey = () => [`/api/v7/frontend/service-links/`];

export type ApiServiceLinksRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceLinksRetrieve>>
>;
export type ApiServiceLinksRetrieveQueryError = ErrorType<unknown>;

export const useApiServiceLinksRetrieve = <
  TData = Awaited<ReturnType<typeof apiServiceLinksRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiServiceLinksRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiServiceLinksRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiServiceLinksRetrieve>>> = ({
    signal,
  }) => apiServiceLinksRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiServiceLinksRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiFrontendServiceTypesList = (
  params?: ApiFrontendServiceTypesListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedServiceTypeList>({
    url: `/api/v7/frontend/service-types/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiFrontendServiceTypesListQueryKey = (
  params?: ApiFrontendServiceTypesListParams
) => [`/api/v7/frontend/service-types/`, ...(params ? [params] : [])];

export type ApiFrontendServiceTypesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendServiceTypesList>>
>;
export type ApiFrontendServiceTypesListQueryError = ErrorType<unknown>;

export const useApiFrontendServiceTypesList = <
  TData = Awaited<ReturnType<typeof apiFrontendServiceTypesList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiFrontendServiceTypesListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiFrontendServiceTypesList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFrontendServiceTypesListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFrontendServiceTypesList>>> = ({
    signal,
  }) => apiFrontendServiceTypesList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiFrontendServiceTypesList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiFrontendUserPersonSummaryRetrieve = (signal?: AbortSignal) => {
  return HTTP<Me>({ url: `/api/v7/frontend/user-person-summary/`, method: 'get', signal });
};

export const getApiFrontendUserPersonSummaryRetrieveQueryKey = () => [
  `/api/v7/frontend/user-person-summary/`,
];

export type ApiFrontendUserPersonSummaryRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendUserPersonSummaryRetrieve>>
>;
export type ApiFrontendUserPersonSummaryRetrieveQueryError = ErrorType<unknown>;

export const useApiFrontendUserPersonSummaryRetrieve = <
  TData = Awaited<ReturnType<typeof apiFrontendUserPersonSummaryRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiFrontendUserPersonSummaryRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFrontendUserPersonSummaryRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFrontendUserPersonSummaryRetrieve>>
  > = ({ signal }) => apiFrontendUserPersonSummaryRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFrontendUserPersonSummaryRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiGenerateQrCodeRetrieve = (
  params: ApiGenerateQrCodeRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<ApiGenerateQrCodeRetrieve200>({
    url: `/api/v7/generate-qr-code/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiGenerateQrCodeRetrieveQueryKey = (params: ApiGenerateQrCodeRetrieveParams) => [
  `/api/v7/generate-qr-code/`,
  ...(params ? [params] : []),
];

export type ApiGenerateQrCodeRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiGenerateQrCodeRetrieve>>
>;
export type ApiGenerateQrCodeRetrieveQueryError = ErrorType<ApiGenerateQrCodeRetrieve400>;

export const useApiGenerateQrCodeRetrieve = <
  TData = Awaited<ReturnType<typeof apiGenerateQrCodeRetrieve>>,
  TError = ErrorType<ApiGenerateQrCodeRetrieve400>
>(
  params: ApiGenerateQrCodeRetrieveParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiGenerateQrCodeRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiGenerateQrCodeRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGenerateQrCodeRetrieve>>> = ({
    signal,
  }) => apiGenerateQrCodeRetrieve(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiGenerateQrCodeRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiCreateGenericConfirmationTokenPaymentIntentsCreate = (
  createGenericPIConfirmationTokenRequest: CreateGenericPIConfirmationTokenRequest
) => {
  return HTTP<CreateConfirmationTokenPaymentIntentResponse>({
    url: `/api/v7/generic-confirmation-token-payment-intents/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: createGenericPIConfirmationTokenRequest,
  });
};

export type ApiCreateGenericConfirmationTokenPaymentIntentsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiCreateGenericConfirmationTokenPaymentIntentsCreate>>
>;
export type ApiCreateGenericConfirmationTokenPaymentIntentsCreateMutationBody =
  CreateGenericPIConfirmationTokenRequest;
export type ApiCreateGenericConfirmationTokenPaymentIntentsCreateMutationError = ErrorType<unknown>;

export const useApiCreateGenericConfirmationTokenPaymentIntentsCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiCreateGenericConfirmationTokenPaymentIntentsCreate>>,
    TError,
    { data: CreateGenericPIConfirmationTokenRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiCreateGenericConfirmationTokenPaymentIntentsCreate>>,
    { data: CreateGenericPIConfirmationTokenRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiCreateGenericConfirmationTokenPaymentIntentsCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiCreateGenericConfirmationTokenPaymentIntentsCreate>>,
    TError,
    { data: CreateGenericPIConfirmationTokenRequest },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Create and authenticate a Stripe PaymentIntent.
Creates a PaymentIntent and linked Authorization,
associating the transaction with the seller StripeConnectAccount, or with Rover directly if no seller is provided.
In the case of 3DS this endpoint will return authentication credentials.

We created this separate and more generic payment intent API rather than modifying the existing API
because it's simpler than making a single API work for both legacy and new payment intent flows, and
we avoid having to version the old API.
Eventually, all flows can/will migrate to using this more generic API, at which point this class can
be merged with CreatePaymentIntentViewBase and CreatePaymentIntentView can be removed. This class
could also be renamed at that point.
 */
export const apiCreateGenericPaymentIntentsCreate = (
  createGenericPaymentIntentRequest: CreateGenericPaymentIntentRequest
) => {
  return HTTP<CreatePaymentIntentResponse>({
    url: `/api/v7/generic-payment-intents/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: createGenericPaymentIntentRequest,
  });
};

export type ApiCreateGenericPaymentIntentsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiCreateGenericPaymentIntentsCreate>>
>;
export type ApiCreateGenericPaymentIntentsCreateMutationBody = CreateGenericPaymentIntentRequest;
export type ApiCreateGenericPaymentIntentsCreateMutationError = ErrorType<unknown>;

export const useApiCreateGenericPaymentIntentsCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiCreateGenericPaymentIntentsCreate>>,
    TError,
    { data: CreateGenericPaymentIntentRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiCreateGenericPaymentIntentsCreate>>,
    { data: CreateGenericPaymentIntentRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiCreateGenericPaymentIntentsCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiCreateGenericPaymentIntentsCreate>>,
    TError,
    { data: CreateGenericPaymentIntentRequest },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiGeofenceList = (params?: ApiGeofenceListParams, signal?: AbortSignal) => {
  return HTTP<PaginatedGeofenceList>({ url: `/api/v7/geofences/`, method: 'get', params, signal });
};

export const getApiGeofenceListQueryKey = (params?: ApiGeofenceListParams) => [
  `/api/v7/geofences/`,
  ...(params ? [params] : []),
];

export type ApiGeofenceListQueryResult = NonNullable<Awaited<ReturnType<typeof apiGeofenceList>>>;
export type ApiGeofenceListQueryError = ErrorType<unknown>;

export const useApiGeofenceList = <
  TData = Awaited<ReturnType<typeof apiGeofenceList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiGeofenceListParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof apiGeofenceList>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiGeofenceListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGeofenceList>>> = ({ signal }) =>
    apiGeofenceList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiGeofenceList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiGoodpupReviewsSeoCityWithoutCountryList = (
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiGoodpupReviewsSeoCityWithoutCountryListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedSEOOwnerReviewList>({
    url: `/api/v7/goodpup-reviews/${city}--${regionSlug}--${seoSlug}/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiGoodpupReviewsSeoCityWithoutCountryListQueryKey = (
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiGoodpupReviewsSeoCityWithoutCountryListParams
) => [`/api/v7/goodpup-reviews/${city}--${regionSlug}--${seoSlug}/`, ...(params ? [params] : [])];

export type ApiGoodpupReviewsSeoCityWithoutCountryListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiGoodpupReviewsSeoCityWithoutCountryList>>
>;
export type ApiGoodpupReviewsSeoCityWithoutCountryListQueryError = ErrorType<unknown>;

export const useApiGoodpupReviewsSeoCityWithoutCountryList = <
  TData = Awaited<ReturnType<typeof apiGoodpupReviewsSeoCityWithoutCountryList>>,
  TError = ErrorType<unknown>
>(
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiGoodpupReviewsSeoCityWithoutCountryListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiGoodpupReviewsSeoCityWithoutCountryList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiGoodpupReviewsSeoCityWithoutCountryListQueryKey(city, regionSlug, seoSlug, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiGoodpupReviewsSeoCityWithoutCountryList>>
  > = ({ signal }) =>
    apiGoodpupReviewsSeoCityWithoutCountryList(city, regionSlug, seoSlug, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiGoodpupReviewsSeoCityWithoutCountryList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(city && regionSlug && seoSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiGoodpupReviewsSeoCityList = (
  countryUrlPrefix: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiGoodpupReviewsSeoCityListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedSEOOwnerReviewList>({
    url: `/api/v7/goodpup-reviews/${countryUrlPrefix}/${city}--${regionSlug}--${seoSlug}/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiGoodpupReviewsSeoCityListQueryKey = (
  countryUrlPrefix: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiGoodpupReviewsSeoCityListParams
) => [
  `/api/v7/goodpup-reviews/${countryUrlPrefix}/${city}--${regionSlug}--${seoSlug}/`,
  ...(params ? [params] : []),
];

export type ApiGoodpupReviewsSeoCityListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiGoodpupReviewsSeoCityList>>
>;
export type ApiGoodpupReviewsSeoCityListQueryError = ErrorType<unknown>;

export const useApiGoodpupReviewsSeoCityList = <
  TData = Awaited<ReturnType<typeof apiGoodpupReviewsSeoCityList>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiGoodpupReviewsSeoCityListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiGoodpupReviewsSeoCityList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiGoodpupReviewsSeoCityListQueryKey(countryUrlPrefix, city, regionSlug, seoSlug, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGoodpupReviewsSeoCityList>>> = ({
    signal,
  }) => apiGoodpupReviewsSeoCityList(countryUrlPrefix, city, regionSlug, seoSlug, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiGoodpupReviewsSeoCityList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!(countryUrlPrefix && city && regionSlug && seoSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * This is a hacky MVP view that we'll eventually switch over to elasticsearch queries
 */
export const apiGroomingSearchRetrieve = (signal?: AbortSignal) => {
  return HTTP<GroomingSearchResults>({ url: `/api/v7/grooming/search/`, method: 'get', signal });
};

export const getApiGroomingSearchRetrieveQueryKey = () => [`/api/v7/grooming/search/`];

export type ApiGroomingSearchRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiGroomingSearchRetrieve>>
>;
export type ApiGroomingSearchRetrieveQueryError = ErrorType<unknown>;

export const useApiGroomingSearchRetrieve = <
  TData = Awaited<ReturnType<typeof apiGroomingSearchRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiGroomingSearchRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiGroomingSearchRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGroomingSearchRetrieve>>> = ({
    signal,
  }) => apiGroomingSearchRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiGroomingSearchRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list/create views.
 */
export const apiHomeProfileList = (signal?: AbortSignal) => {
  return HTTP<HomeProfile[]>({ url: `/api/v7/home-profiles/`, method: 'get', signal });
};

export const getApiHomeProfileListQueryKey = () => [`/api/v7/home-profiles/`];

export type ApiHomeProfileListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiHomeProfileList>>
>;
export type ApiHomeProfileListQueryError = ErrorType<unknown>;

export const useApiHomeProfileList = <
  TData = Awaited<ReturnType<typeof apiHomeProfileList>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiHomeProfileList>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiHomeProfileListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiHomeProfileList>>> = ({ signal }) =>
    apiHomeProfileList(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiHomeProfileList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list/create views.
 */
export const apiHomeProfileListCreate = (homeProfile: HomeProfile) => {
  return HTTP<HomeProfile>({
    url: `/api/v7/home-profiles/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: homeProfile,
  });
};

export type ApiHomeProfileListCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiHomeProfileListCreate>>
>;
export type ApiHomeProfileListCreateMutationBody = HomeProfile;
export type ApiHomeProfileListCreateMutationError = ErrorType<unknown>;

export const useApiHomeProfileListCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiHomeProfileListCreate>>,
    TError,
    { data: HomeProfile },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiHomeProfileListCreate>>,
    { data: HomeProfile }
  > = (props) => {
    const { data } = props ?? {};

    return apiHomeProfileListCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiHomeProfileListCreate>>,
    TError,
    { data: HomeProfile },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiHomeProfileDetailRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<HomeProfile>({ url: `/api/v7/home-profiles/${opk}/`, method: 'get', signal });
};

export const getApiHomeProfileDetailRetrieveQueryKey = (opk: string) => [
  `/api/v7/home-profiles/${opk}/`,
];

export type ApiHomeProfileDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiHomeProfileDetailRetrieve>>
>;
export type ApiHomeProfileDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiHomeProfileDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiHomeProfileDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiHomeProfileDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiHomeProfileDetailRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiHomeProfileDetailRetrieve>>> = ({
    signal,
  }) => apiHomeProfileDetailRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiHomeProfileDetailRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiHomeProfileDetailUpdate = (opk: string, homeProfile: HomeProfile) => {
  return HTTP<HomeProfile>({
    url: `/api/v7/home-profiles/${opk}/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: homeProfile,
  });
};

export type ApiHomeProfileDetailUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiHomeProfileDetailUpdate>>
>;
export type ApiHomeProfileDetailUpdateMutationBody = HomeProfile;
export type ApiHomeProfileDetailUpdateMutationError = ErrorType<unknown>;

export const useApiHomeProfileDetailUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiHomeProfileDetailUpdate>>,
    TError,
    { opk: string; data: HomeProfile },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiHomeProfileDetailUpdate>>,
    { opk: string; data: HomeProfile }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiHomeProfileDetailUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiHomeProfileDetailUpdate>>,
    TError,
    { opk: string; data: HomeProfile },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiHomeProfileDetailPartialUpdate = (
  opk: string,
  patchedHomeProfile: PatchedHomeProfile
) => {
  return HTTP<HomeProfile>({
    url: `/api/v7/home-profiles/${opk}/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedHomeProfile,
  });
};

export type ApiHomeProfileDetailPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiHomeProfileDetailPartialUpdate>>
>;
export type ApiHomeProfileDetailPartialUpdateMutationBody = PatchedHomeProfile;
export type ApiHomeProfileDetailPartialUpdateMutationError = ErrorType<unknown>;

export const useApiHomeProfileDetailPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiHomeProfileDetailPartialUpdate>>,
    TError,
    { opk: string; data: PatchedHomeProfile },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiHomeProfileDetailPartialUpdate>>,
    { opk: string; data: PatchedHomeProfile }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiHomeProfileDetailPartialUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiHomeProfileDetailPartialUpdate>>,
    TError,
    { opk: string; data: PatchedHomeProfile },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiHomeProfileDetailDestroy = (opk: string) => {
  return HTTP<void>({ url: `/api/v7/home-profiles/${opk}/`, method: 'delete' });
};

export type ApiHomeProfileDetailDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiHomeProfileDetailDestroy>>
>;

export type ApiHomeProfileDetailDestroyMutationError = ErrorType<unknown>;

export const useApiHomeProfileDetailDestroy = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiHomeProfileDetailDestroy>>,
    TError,
    { opk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiHomeProfileDetailDestroy>>,
    { opk: string }
  > = (props) => {
    const { opk } = props ?? {};

    return apiHomeProfileDetailDestroy(opk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiHomeProfileDetailDestroy>>,
    TError,
    { opk: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Sets reasonable pagination defaults for all the API list/create views.
 */
export const apiHomeProfileDetailImagesList = (
  opk: string,
  params?: ApiHomeProfileDetailImagesListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedImageList>({
    url: `/api/v7/home-profiles/${opk}/images/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiHomeProfileDetailImagesListQueryKey = (
  opk: string,
  params?: ApiHomeProfileDetailImagesListParams
) => [`/api/v7/home-profiles/${opk}/images/`, ...(params ? [params] : [])];

export type ApiHomeProfileDetailImagesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiHomeProfileDetailImagesList>>
>;
export type ApiHomeProfileDetailImagesListQueryError = ErrorType<unknown>;

export const useApiHomeProfileDetailImagesList = <
  TData = Awaited<ReturnType<typeof apiHomeProfileDetailImagesList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiHomeProfileDetailImagesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiHomeProfileDetailImagesList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiHomeProfileDetailImagesListQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiHomeProfileDetailImagesList>>> = ({
    signal,
  }) => apiHomeProfileDetailImagesList(opk, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiHomeProfileDetailImagesList>>, TError, TData>(
    {
      queryKey,
      queryFn,
      enabled: !!opk,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      ...queryOptions,
    }
  ) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list/create views.
 */
export const apiHomeProfileDetailImagesCreate = (opk: string, image: Image) => {
  return HTTP<Image>({
    url: `/api/v7/home-profiles/${opk}/images/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: image,
  });
};

export type ApiHomeProfileDetailImagesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiHomeProfileDetailImagesCreate>>
>;
export type ApiHomeProfileDetailImagesCreateMutationBody = Image;
export type ApiHomeProfileDetailImagesCreateMutationError = ErrorType<unknown>;

export const useApiHomeProfileDetailImagesCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiHomeProfileDetailImagesCreate>>,
    TError,
    { opk: string; data: Image },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiHomeProfileDetailImagesCreate>>,
    { opk: string; data: Image }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiHomeProfileDetailImagesCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiHomeProfileDetailImagesCreate>>,
    TError,
    { opk: string; data: Image },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Save language code to person object if the user is authenticate and has preferred language.
 */
export const apiI18nSetLanguageCreate = (setLanguageRequest: SetLanguageRequest) => {
  return HTTP<void>({
    url: `/api/v7/i18n/set-language/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: setLanguageRequest,
  });
};

export type ApiI18nSetLanguageCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiI18nSetLanguageCreate>>
>;
export type ApiI18nSetLanguageCreateMutationBody = SetLanguageRequest;
export type ApiI18nSetLanguageCreateMutationError = ErrorType<unknown>;

export const useApiI18nSetLanguageCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiI18nSetLanguageCreate>>,
    TError,
    { data: SetLanguageRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiI18nSetLanguageCreate>>,
    { data: SetLanguageRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiI18nSetLanguageCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiI18nSetLanguageCreate>>,
    TError,
    { data: SetLanguageRequest },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiIdentityVerificationInformationRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<ApiIdentityVerificationInformationRetrieve200>({
    url: `/api/v7/identity-verification/${opk}/`,
    method: 'get',
    signal,
  });
};

export const getApiIdentityVerificationInformationRetrieveQueryKey = (opk: string) => [
  `/api/v7/identity-verification/${opk}/`,
];

export type ApiIdentityVerificationInformationRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiIdentityVerificationInformationRetrieve>>
>;
export type ApiIdentityVerificationInformationRetrieveQueryError = ErrorType<unknown>;

export const useApiIdentityVerificationInformationRetrieve = <
  TData = Awaited<ReturnType<typeof apiIdentityVerificationInformationRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiIdentityVerificationInformationRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiIdentityVerificationInformationRetrieveQueryKey(opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiIdentityVerificationInformationRetrieve>>
  > = ({ signal }) => apiIdentityVerificationInformationRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiIdentityVerificationInformationRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiIdentityVerificationCandidateUpdate = (
  opk: string,
  apiIdentityVerificationCandidateUpdateBody: ApiIdentityVerificationCandidateUpdateBody
) => {
  return HTTP<
    ApiIdentityVerificationCandidateUpdate200 | ApiIdentityVerificationCandidateUpdate201
  >({
    url: `/api/v7/identity-verification/${opk}/candidate/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiIdentityVerificationCandidateUpdateBody,
  });
};

export type ApiIdentityVerificationCandidateUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiIdentityVerificationCandidateUpdate>>
>;
export type ApiIdentityVerificationCandidateUpdateMutationBody =
  ApiIdentityVerificationCandidateUpdateBody;
export type ApiIdentityVerificationCandidateUpdateMutationError = ErrorType<void>;

export const useApiIdentityVerificationCandidateUpdate = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiIdentityVerificationCandidateUpdate>>,
    TError,
    { opk: string; data: ApiIdentityVerificationCandidateUpdateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiIdentityVerificationCandidateUpdate>>,
    { opk: string; data: ApiIdentityVerificationCandidateUpdateBody }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiIdentityVerificationCandidateUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiIdentityVerificationCandidateUpdate>>,
    TError,
    { opk: string; data: ApiIdentityVerificationCandidateUpdateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiIdentityVerificationCandidateSdkTokenRetrieve = (
  opk: string,
  signal?: AbortSignal
) => {
  return HTTP<ApiIdentityVerificationCandidateSdkTokenRetrieve200>({
    url: `/api/v7/identity-verification/${opk}/candidate/sdk-token/`,
    method: 'get',
    signal,
  });
};

export const getApiIdentityVerificationCandidateSdkTokenRetrieveQueryKey = (opk: string) => [
  `/api/v7/identity-verification/${opk}/candidate/sdk-token/`,
];

export type ApiIdentityVerificationCandidateSdkTokenRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiIdentityVerificationCandidateSdkTokenRetrieve>>
>;
export type ApiIdentityVerificationCandidateSdkTokenRetrieveQueryError = ErrorType<
  | ApiIdentityVerificationCandidateSdkTokenRetrieve400
  | ApiIdentityVerificationCandidateSdkTokenRetrieve404
>;

export const useApiIdentityVerificationCandidateSdkTokenRetrieve = <
  TData = Awaited<ReturnType<typeof apiIdentityVerificationCandidateSdkTokenRetrieve>>,
  TError = ErrorType<
    | ApiIdentityVerificationCandidateSdkTokenRetrieve400
    | ApiIdentityVerificationCandidateSdkTokenRetrieve404
  >
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiIdentityVerificationCandidateSdkTokenRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiIdentityVerificationCandidateSdkTokenRetrieveQueryKey(opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiIdentityVerificationCandidateSdkTokenRetrieve>>
  > = ({ signal }) => apiIdentityVerificationCandidateSdkTokenRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiIdentityVerificationCandidateSdkTokenRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiIdentityVerificationCandidateCheckRetrieve = (
  opk: string,
  signal?: AbortSignal
) => {
  return HTTP<ApiIdentityVerificationCandidateCheckRetrieve200>({
    url: `/api/v7/identity-verification/${opk}/check/`,
    method: 'get',
    signal,
  });
};

export const getApiIdentityVerificationCandidateCheckRetrieveQueryKey = (opk: string) => [
  `/api/v7/identity-verification/${opk}/check/`,
];

export type ApiIdentityVerificationCandidateCheckRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiIdentityVerificationCandidateCheckRetrieve>>
>;
export type ApiIdentityVerificationCandidateCheckRetrieveQueryError = ErrorType<void>;

export const useApiIdentityVerificationCandidateCheckRetrieve = <
  TData = Awaited<ReturnType<typeof apiIdentityVerificationCandidateCheckRetrieve>>,
  TError = ErrorType<void>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiIdentityVerificationCandidateCheckRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiIdentityVerificationCandidateCheckRetrieveQueryKey(opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiIdentityVerificationCandidateCheckRetrieve>>
  > = ({ signal }) => apiIdentityVerificationCandidateCheckRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiIdentityVerificationCandidateCheckRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiIdentityVerificationCandidateCheckCreate = (opk: string) => {
  return HTTP<void>({ url: `/api/v7/identity-verification/${opk}/check/`, method: 'post' });
};

export type ApiIdentityVerificationCandidateCheckCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiIdentityVerificationCandidateCheckCreate>>
>;

export type ApiIdentityVerificationCandidateCheckCreateMutationError = ErrorType<unknown>;

export const useApiIdentityVerificationCandidateCheckCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiIdentityVerificationCandidateCheckCreate>>,
    TError,
    { opk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiIdentityVerificationCandidateCheckCreate>>,
    { opk: string }
  > = (props) => {
    const { opk } = props ?? {};

    return apiIdentityVerificationCandidateCheckCreate(opk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiIdentityVerificationCandidateCheckCreate>>,
    TError,
    { opk: string },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiIdentityVerificationCandidateCheckBreakdownRetrieve = (
  opk: string,
  signal?: AbortSignal
) => {
  return HTTP<string[] | void>({
    url: `/api/v7/identity-verification/${opk}/check/breakdown/`,
    method: 'get',
    signal,
  });
};

export const getApiIdentityVerificationCandidateCheckBreakdownRetrieveQueryKey = (opk: string) => [
  `/api/v7/identity-verification/${opk}/check/breakdown/`,
];

export type ApiIdentityVerificationCandidateCheckBreakdownRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiIdentityVerificationCandidateCheckBreakdownRetrieve>>
>;
export type ApiIdentityVerificationCandidateCheckBreakdownRetrieveQueryError = ErrorType<unknown>;

export const useApiIdentityVerificationCandidateCheckBreakdownRetrieve = <
  TData = Awaited<ReturnType<typeof apiIdentityVerificationCandidateCheckBreakdownRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiIdentityVerificationCandidateCheckBreakdownRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiIdentityVerificationCandidateCheckBreakdownRetrieveQueryKey(opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiIdentityVerificationCandidateCheckBreakdownRetrieve>>
  > = ({ signal }) => apiIdentityVerificationCandidateCheckBreakdownRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiIdentityVerificationCandidateCheckBreakdownRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiImageDetailRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<Image>({ url: `/api/v7/images/${opk}/`, method: 'get', signal });
};

export const getApiImageDetailRetrieveQueryKey = (opk: string) => [`/api/v7/images/${opk}/`];

export type ApiImageDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiImageDetailRetrieve>>
>;
export type ApiImageDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiImageDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiImageDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiImageDetailRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiImageDetailRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiImageDetailRetrieve>>> = ({ signal }) =>
    apiImageDetailRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiImageDetailRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiImageDetailUpdate = (opk: string, image: Image) => {
  return HTTP<Image>({
    url: `/api/v7/images/${opk}/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: image,
  });
};

export type ApiImageDetailUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiImageDetailUpdate>>
>;
export type ApiImageDetailUpdateMutationBody = Image;
export type ApiImageDetailUpdateMutationError = ErrorType<unknown>;

export const useApiImageDetailUpdate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiImageDetailUpdate>>,
    TError,
    { opk: string; data: Image },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiImageDetailUpdate>>,
    { opk: string; data: Image }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiImageDetailUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiImageDetailUpdate>>,
    TError,
    { opk: string; data: Image },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiImageDetailDestroy = (opk: string) => {
  return HTTP<void>({ url: `/api/v7/images/${opk}/`, method: 'delete' });
};

export type ApiImageDetailDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiImageDetailDestroy>>
>;

export type ApiImageDetailDestroyMutationError = ErrorType<unknown>;

export const useApiImageDetailDestroy = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiImageDetailDestroy>>,
    TError,
    { opk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiImageDetailDestroy>>,
    { opk: string }
  > = (props) => {
    const { opk } = props ?? {};

    return apiImageDetailDestroy(opk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiImageDetailDestroy>>,
    TError,
    { opk: string },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiImageOrderingUpdate = (opk: string, imageOrdering: ImageOrdering) => {
  return HTTP<ImageOrdering>({
    url: `/api/v7/images/${opk}/ordering/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: imageOrdering,
  });
};

export type ApiImageOrderingUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiImageOrderingUpdate>>
>;
export type ApiImageOrderingUpdateMutationBody = ImageOrdering;
export type ApiImageOrderingUpdateMutationError = ErrorType<unknown>;

export const useApiImageOrderingUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiImageOrderingUpdate>>,
    TError,
    { opk: string; data: ImageOrdering },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiImageOrderingUpdate>>,
    { opk: string; data: ImageOrdering }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiImageOrderingUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiImageOrderingUpdate>>,
    TError,
    { opk: string; data: ImageOrdering },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiImagesUploadAuthorizeCreate = (s3Upload: S3Upload) => {
  return HTTP<ApiImagesUploadAuthorizeCreate201>({
    url: `/api/v7/images/upload/authorize/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: s3Upload,
  });
};

export type ApiImagesUploadAuthorizeCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiImagesUploadAuthorizeCreate>>
>;
export type ApiImagesUploadAuthorizeCreateMutationBody = S3Upload;
export type ApiImagesUploadAuthorizeCreateMutationError = ErrorType<
  ApiImagesUploadAuthorizeCreate400 | ApiImagesUploadAuthorizeCreate403 | void
>;

export const useApiImagesUploadAuthorizeCreate = <
  TError = ErrorType<ApiImagesUploadAuthorizeCreate400 | ApiImagesUploadAuthorizeCreate403 | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiImagesUploadAuthorizeCreate>>,
    TError,
    { data: S3Upload },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiImagesUploadAuthorizeCreate>>,
    { data: S3Upload }
  > = (props) => {
    const { data } = props ?? {};

    return apiImagesUploadAuthorizeCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiImagesUploadAuthorizeCreate>>,
    TError,
    { data: S3Upload },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Gets the serialized objects associated with the InboxListView

:param args:
:param kwargs:
:return: :class:`api.current.views.InboxListView`
 */
export const apiInboxList = (params?: ApiInboxListParams, signal?: AbortSignal) => {
  return HTTP<PaginatedInboxList>({ url: `/api/v7/inbox/`, method: 'get', params, signal });
};

export const getApiInboxListQueryKey = (params?: ApiInboxListParams) => [
  `/api/v7/inbox/`,
  ...(params ? [params] : []),
];

export type ApiInboxListQueryResult = NonNullable<Awaited<ReturnType<typeof apiInboxList>>>;
export type ApiInboxListQueryError = ErrorType<unknown>;

export const useApiInboxList = <
  TData = Awaited<ReturnType<typeof apiInboxList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiInboxListParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof apiInboxList>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInboxListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInboxList>>> = ({ signal }) =>
    apiInboxList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiInboxList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Mark all the messages in this inbox belonging to this user as read.
 */
export const apiInboxMarkAllReadUpdate = (inboxMarkAllAsReadRequest: InboxMarkAllAsReadRequest) => {
  return HTTP<void>({
    url: `/api/v7/inbox/mark-all-read/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: inboxMarkAllAsReadRequest,
  });
};

export type ApiInboxMarkAllReadUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInboxMarkAllReadUpdate>>
>;
export type ApiInboxMarkAllReadUpdateMutationBody = InboxMarkAllAsReadRequest;
export type ApiInboxMarkAllReadUpdateMutationError = ErrorType<unknown>;

export const useApiInboxMarkAllReadUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInboxMarkAllReadUpdate>>,
    TError,
    { data: InboxMarkAllAsReadRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInboxMarkAllReadUpdate>>,
    { data: InboxMarkAllAsReadRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiInboxMarkAllReadUpdate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiInboxMarkAllReadUpdate>>,
    TError,
    { data: InboxMarkAllAsReadRequest },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Helper class that provides a standard way to create an ABC using
inheritance.
 */
export const apiJobBoardMarkAsInterestedCreate = (opk: string) => {
  return HTTP<void>({ url: `/api/v7/job-board/${opk}/mark-as-interested/`, method: 'post' });
};

export type ApiJobBoardMarkAsInterestedCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiJobBoardMarkAsInterestedCreate>>
>;

export type ApiJobBoardMarkAsInterestedCreateMutationError = ErrorType<unknown>;

export const useApiJobBoardMarkAsInterestedCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiJobBoardMarkAsInterestedCreate>>,
    TError,
    { opk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiJobBoardMarkAsInterestedCreate>>,
    { opk: string }
  > = (props) => {
    const { opk } = props ?? {};

    return apiJobBoardMarkAsInterestedCreate(opk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiJobBoardMarkAsInterestedCreate>>,
    TError,
    { opk: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Helper class that provides a standard way to create an ABC using
inheritance.
 */
export const apiJobBoardMarkAsInterestedWithMessageCreate = (
  opk: string,
  providerInterestedWithMessageInput: ProviderInterestedWithMessageInput
) => {
  return HTTP<ProviderInterestedWithMessageInput>({
    url: `/api/v7/job-board/${opk}/mark-as-interested-with-message/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: providerInterestedWithMessageInput,
  });
};

export type ApiJobBoardMarkAsInterestedWithMessageCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiJobBoardMarkAsInterestedWithMessageCreate>>
>;
export type ApiJobBoardMarkAsInterestedWithMessageCreateMutationBody =
  ProviderInterestedWithMessageInput;
export type ApiJobBoardMarkAsInterestedWithMessageCreateMutationError = ErrorType<unknown>;

export const useApiJobBoardMarkAsInterestedWithMessageCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiJobBoardMarkAsInterestedWithMessageCreate>>,
    TError,
    { opk: string; data: ProviderInterestedWithMessageInput },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiJobBoardMarkAsInterestedWithMessageCreate>>,
    { opk: string; data: ProviderInterestedWithMessageInput }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiJobBoardMarkAsInterestedWithMessageCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiJobBoardMarkAsInterestedWithMessageCreate>>,
    TError,
    { opk: string; data: ProviderInterestedWithMessageInput },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Helper class that provides a standard way to create an ABC using
inheritance.
 */
export const apiJobBoardMarkAsNotInterestedCreate = (opk: string) => {
  return HTTP<void>({ url: `/api/v7/job-board/${opk}/mark-as-not-interested/`, method: 'post' });
};

export type ApiJobBoardMarkAsNotInterestedCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiJobBoardMarkAsNotInterestedCreate>>
>;

export type ApiJobBoardMarkAsNotInterestedCreateMutationError = ErrorType<unknown>;

export const useApiJobBoardMarkAsNotInterestedCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiJobBoardMarkAsNotInterestedCreate>>,
    TError,
    { opk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiJobBoardMarkAsNotInterestedCreate>>,
    { opk: string }
  > = (props) => {
    const { opk } = props ?? {};

    return apiJobBoardMarkAsNotInterestedCreate(opk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiJobBoardMarkAsNotInterestedCreate>>,
    TError,
    { opk: string },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiCheckDeactivationKetchCreate = (
  apiCheckDeactivationKetchCreateBody: ApiCheckDeactivationKetchCreateBody
) => {
  return HTTP<ApiCheckDeactivationKetchCreate200>({
    url: `/api/v7/ketch/check-deactivation/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiCheckDeactivationKetchCreateBody,
  });
};

export type ApiCheckDeactivationKetchCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiCheckDeactivationKetchCreate>>
>;
export type ApiCheckDeactivationKetchCreateMutationBody = ApiCheckDeactivationKetchCreateBody;
export type ApiCheckDeactivationKetchCreateMutationError = ErrorType<unknown>;

export const useApiCheckDeactivationKetchCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiCheckDeactivationKetchCreate>>,
    TError,
    { data: ApiCheckDeactivationKetchCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiCheckDeactivationKetchCreate>>,
    { data: ApiCheckDeactivationKetchCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiCheckDeactivationKetchCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiCheckDeactivationKetchCreate>>,
    TError,
    { data: ApiCheckDeactivationKetchCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiDeactivateKetchCreate = (
  apiDeactivateKetchCreateBody: ApiDeactivateKetchCreateBody
) => {
  return HTTP<ApiDeactivateKetchCreate200>({
    url: `/api/v7/ketch/deactivate-dsr/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiDeactivateKetchCreateBody,
  });
};

export type ApiDeactivateKetchCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiDeactivateKetchCreate>>
>;
export type ApiDeactivateKetchCreateMutationBody = ApiDeactivateKetchCreateBody;
export type ApiDeactivateKetchCreateMutationError = ErrorType<unknown>;

export const useApiDeactivateKetchCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDeactivateKetchCreate>>,
    TError,
    { data: ApiDeactivateKetchCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiDeactivateKetchCreate>>,
    { data: ApiDeactivateKetchCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiDeactivateKetchCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiDeactivateKetchCreate>>,
    TError,
    { data: ApiDeactivateKetchCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiPersonDataRedactionKetchCreate = (
  apiPersonDataRedactionKetchCreateBody: ApiPersonDataRedactionKetchCreateBody
) => {
  return HTTP<ApiPersonDataRedactionKetchCreate200>({
    url: `/api/v7/ketch/delete-user-data/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiPersonDataRedactionKetchCreateBody,
  });
};

export type ApiPersonDataRedactionKetchCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDataRedactionKetchCreate>>
>;
export type ApiPersonDataRedactionKetchCreateMutationBody = ApiPersonDataRedactionKetchCreateBody;
export type ApiPersonDataRedactionKetchCreateMutationError = ErrorType<unknown>;

export const useApiPersonDataRedactionKetchCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonDataRedactionKetchCreate>>,
    TError,
    { data: ApiPersonDataRedactionKetchCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonDataRedactionKetchCreate>>,
    { data: ApiPersonDataRedactionKetchCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiPersonDataRedactionKetchCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonDataRedactionKetchCreate>>,
    TError,
    { data: ApiPersonDataRedactionKetchCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiPersonDsrEligibilityKetchCreate = (
  apiPersonDsrEligibilityKetchCreateBody: ApiPersonDsrEligibilityKetchCreateBody
) => {
  return HTTP<ApiPersonDsrEligibilityKetchCreate200>({
    url: `/api/v7/ketch/person-dsr-eligibility/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiPersonDsrEligibilityKetchCreateBody,
  });
};

export type ApiPersonDsrEligibilityKetchCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDsrEligibilityKetchCreate>>
>;
export type ApiPersonDsrEligibilityKetchCreateMutationBody = ApiPersonDsrEligibilityKetchCreateBody;
export type ApiPersonDsrEligibilityKetchCreateMutationError = ErrorType<unknown>;

export const useApiPersonDsrEligibilityKetchCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonDsrEligibilityKetchCreate>>,
    TError,
    { data: ApiPersonDsrEligibilityKetchCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonDsrEligibilityKetchCreate>>,
    { data: ApiPersonDsrEligibilityKetchCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiPersonDsrEligibilityKetchCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonDsrEligibilityKetchCreate>>,
    TError,
    { data: ApiPersonDsrEligibilityKetchCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiUserStaffNotesDeletionApprovedKetchCreate = (
  apiUserStaffNotesDeletionApprovedKetchCreateBody: ApiUserStaffNotesDeletionApprovedKetchCreateBody
) => {
  return HTTP<ApiUserStaffNotesDeletionApprovedKetchCreate200>({
    url: `/api/v7/ketch/staff-notes-deletion-approved/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiUserStaffNotesDeletionApprovedKetchCreateBody,
  });
};

export type ApiUserStaffNotesDeletionApprovedKetchCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiUserStaffNotesDeletionApprovedKetchCreate>>
>;
export type ApiUserStaffNotesDeletionApprovedKetchCreateMutationBody =
  ApiUserStaffNotesDeletionApprovedKetchCreateBody;
export type ApiUserStaffNotesDeletionApprovedKetchCreateMutationError = ErrorType<unknown>;

export const useApiUserStaffNotesDeletionApprovedKetchCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiUserStaffNotesDeletionApprovedKetchCreate>>,
    TError,
    { data: ApiUserStaffNotesDeletionApprovedKetchCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiUserStaffNotesDeletionApprovedKetchCreate>>,
    { data: ApiUserStaffNotesDeletionApprovedKetchCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiUserStaffNotesDeletionApprovedKetchCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiUserStaffNotesDeletionApprovedKetchCreate>>,
    TError,
    { data: ApiUserStaffNotesDeletionApprovedKetchCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiUserStaffNotesDeletionDeniedKetchCreate = (
  apiUserStaffNotesDeletionDeniedKetchCreateBody: ApiUserStaffNotesDeletionDeniedKetchCreateBody
) => {
  return HTTP<ApiUserStaffNotesDeletionDeniedKetchCreate200>({
    url: `/api/v7/ketch/staff-notes-deletion-declined/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiUserStaffNotesDeletionDeniedKetchCreateBody,
  });
};

export type ApiUserStaffNotesDeletionDeniedKetchCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiUserStaffNotesDeletionDeniedKetchCreate>>
>;
export type ApiUserStaffNotesDeletionDeniedKetchCreateMutationBody =
  ApiUserStaffNotesDeletionDeniedKetchCreateBody;
export type ApiUserStaffNotesDeletionDeniedKetchCreateMutationError = ErrorType<unknown>;

export const useApiUserStaffNotesDeletionDeniedKetchCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiUserStaffNotesDeletionDeniedKetchCreate>>,
    TError,
    { data: ApiUserStaffNotesDeletionDeniedKetchCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiUserStaffNotesDeletionDeniedKetchCreate>>,
    { data: ApiUserStaffNotesDeletionDeniedKetchCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiUserStaffNotesDeletionDeniedKetchCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiUserStaffNotesDeletionDeniedKetchCreate>>,
    TError,
    { data: ApiUserStaffNotesDeletionDeniedKetchCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiUserStaffNotesSarApprovedKetchCreate = (
  apiUserStaffNotesSarApprovedKetchCreateBody: ApiUserStaffNotesSarApprovedKetchCreateBody
) => {
  return HTTP<ApiUserStaffNotesSarApprovedKetchCreate200>({
    url: `/api/v7/ketch/staff-notes-sar-approved/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiUserStaffNotesSarApprovedKetchCreateBody,
  });
};

export type ApiUserStaffNotesSarApprovedKetchCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiUserStaffNotesSarApprovedKetchCreate>>
>;
export type ApiUserStaffNotesSarApprovedKetchCreateMutationBody =
  ApiUserStaffNotesSarApprovedKetchCreateBody;
export type ApiUserStaffNotesSarApprovedKetchCreateMutationError = ErrorType<unknown>;

export const useApiUserStaffNotesSarApprovedKetchCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiUserStaffNotesSarApprovedKetchCreate>>,
    TError,
    { data: ApiUserStaffNotesSarApprovedKetchCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiUserStaffNotesSarApprovedKetchCreate>>,
    { data: ApiUserStaffNotesSarApprovedKetchCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiUserStaffNotesSarApprovedKetchCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiUserStaffNotesSarApprovedKetchCreate>>,
    TError,
    { data: ApiUserStaffNotesSarApprovedKetchCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiUserEmailExistsKetchCreate = (
  apiUserEmailExistsKetchCreateBody: ApiUserEmailExistsKetchCreateBody
) => {
  return HTTP<ApiUserEmailExistsKetchCreate200>({
    url: `/api/v7/ketch/user-email-exists/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiUserEmailExistsKetchCreateBody,
  });
};

export type ApiUserEmailExistsKetchCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiUserEmailExistsKetchCreate>>
>;
export type ApiUserEmailExistsKetchCreateMutationBody = ApiUserEmailExistsKetchCreateBody;
export type ApiUserEmailExistsKetchCreateMutationError = ErrorType<unknown>;

export const useApiUserEmailExistsKetchCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiUserEmailExistsKetchCreate>>,
    TError,
    { data: ApiUserEmailExistsKetchCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiUserEmailExistsKetchCreate>>,
    { data: ApiUserEmailExistsKetchCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiUserEmailExistsKetchCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiUserEmailExistsKetchCreate>>,
    TError,
    { data: ApiUserEmailExistsKetchCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiKnownPetsBucketingViewRetrieve = (
  params?: ApiKnownPetsBucketingViewRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<KnownPetsBucketing>({
    url: `/api/v7/known-pets-bucketing/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiKnownPetsBucketingViewRetrieveQueryKey = (
  params?: ApiKnownPetsBucketingViewRetrieveParams
) => [`/api/v7/known-pets-bucketing/`, ...(params ? [params] : [])];

export type ApiKnownPetsBucketingViewRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiKnownPetsBucketingViewRetrieve>>
>;
export type ApiKnownPetsBucketingViewRetrieveQueryError = ErrorType<unknown>;

export const useApiKnownPetsBucketingViewRetrieve = <
  TData = Awaited<ReturnType<typeof apiKnownPetsBucketingViewRetrieve>>,
  TError = ErrorType<unknown>
>(
  params?: ApiKnownPetsBucketingViewRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiKnownPetsBucketingViewRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiKnownPetsBucketingViewRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiKnownPetsBucketingViewRetrieve>>> = ({
    signal,
  }) => apiKnownPetsBucketingViewRetrieve(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiKnownPetsBucketingViewRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiLemonadePetInsuranceAvailabilityRetrieve = (signal?: AbortSignal) => {
  return HTTP<LemonadePetInsuranceAvailability>({
    url: `/api/v7/lemonade-pet-insurance-availability/`,
    method: 'get',
    signal,
  });
};

export const getApiLemonadePetInsuranceAvailabilityRetrieveQueryKey = () => [
  `/api/v7/lemonade-pet-insurance-availability/`,
];

export type ApiLemonadePetInsuranceAvailabilityRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiLemonadePetInsuranceAvailabilityRetrieve>>
>;
export type ApiLemonadePetInsuranceAvailabilityRetrieveQueryError = ErrorType<unknown>;

export const useApiLemonadePetInsuranceAvailabilityRetrieve = <
  TData = Awaited<ReturnType<typeof apiLemonadePetInsuranceAvailabilityRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiLemonadePetInsuranceAvailabilityRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiLemonadePetInsuranceAvailabilityRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiLemonadePetInsuranceAvailabilityRetrieve>>
  > = ({ signal }) => apiLemonadePetInsuranceAvailabilityRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiLemonadePetInsuranceAvailabilityRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiLemonadePetUserFormRetrieve = (signal?: AbortSignal) => {
  return HTTP<LemonadePetUserForm>({
    url: `/api/v7/lemonade-pet-user-form/`,
    method: 'get',
    signal,
  });
};

export const getApiLemonadePetUserFormRetrieveQueryKey = () => [`/api/v7/lemonade-pet-user-form/`];

export type ApiLemonadePetUserFormRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiLemonadePetUserFormRetrieve>>
>;
export type ApiLemonadePetUserFormRetrieveQueryError = ErrorType<unknown>;

export const useApiLemonadePetUserFormRetrieve = <
  TData = Awaited<ReturnType<typeof apiLemonadePetUserFormRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiLemonadePetUserFormRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiLemonadePetUserFormRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLemonadePetUserFormRetrieve>>> = ({
    signal,
  }) => apiLemonadePetUserFormRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiLemonadePetUserFormRetrieve>>, TError, TData>(
    { queryKey, queryFn, refetchOnMount: false, refetchOnWindowFocus: false, ...queryOptions }
  ) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiLemonadePetUserFormCreate = (
  lemonadePetUserFormSubmit: LemonadePetUserFormSubmit
) => {
  return HTTP<LemonadePetUserFormResponse>({
    url: `/api/v7/lemonade-pet-user-form/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: lemonadePetUserFormSubmit,
  });
};

export type ApiLemonadePetUserFormCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiLemonadePetUserFormCreate>>
>;
export type ApiLemonadePetUserFormCreateMutationBody = LemonadePetUserFormSubmit;
export type ApiLemonadePetUserFormCreateMutationError = ErrorType<Error>;

export const useApiLemonadePetUserFormCreate = <
  TError = ErrorType<Error>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiLemonadePetUserFormCreate>>,
    TError,
    { data: LemonadePetUserFormSubmit },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiLemonadePetUserFormCreate>>,
    { data: LemonadePetUserFormSubmit }
  > = (props) => {
    const { data } = props ?? {};

    return apiLemonadePetUserFormCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiLemonadePetUserFormCreate>>,
    TError,
    { data: LemonadePetUserFormSubmit },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiLocalizedLinkList = (slug: string, signal?: AbortSignal) => {
  return HTTP<LocalizedLinkURL[]>({
    url: `/api/v7/localized-links/${slug}/`,
    method: 'get',
    signal,
  });
};

export const getApiLocalizedLinkListQueryKey = (slug: string) => [
  `/api/v7/localized-links/${slug}/`,
];

export type ApiLocalizedLinkListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiLocalizedLinkList>>
>;
export type ApiLocalizedLinkListQueryError = ErrorType<unknown>;

export const useApiLocalizedLinkList = <
  TData = Awaited<ReturnType<typeof apiLocalizedLinkList>>,
  TError = ErrorType<unknown>
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiLocalizedLinkList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiLocalizedLinkListQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLocalizedLinkList>>> = ({ signal }) =>
    apiLocalizedLinkList(slug, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiLocalizedLinkList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!slug,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiLocalizedLinkDetailRetrieve = (
  slug: string,
  locale: string,
  signal?: AbortSignal
) => {
  return HTTP<LocalizedLinkURL>({
    url: `/api/v7/localized-links/${slug}/${locale}/`,
    method: 'get',
    signal,
  });
};

export const getApiLocalizedLinkDetailRetrieveQueryKey = (slug: string, locale: string) => [
  `/api/v7/localized-links/${slug}/${locale}/`,
];

export type ApiLocalizedLinkDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiLocalizedLinkDetailRetrieve>>
>;
export type ApiLocalizedLinkDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiLocalizedLinkDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiLocalizedLinkDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  slug: string,
  locale: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiLocalizedLinkDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiLocalizedLinkDetailRetrieveQueryKey(slug, locale);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLocalizedLinkDetailRetrieve>>> = ({
    signal,
  }) => apiLocalizedLinkDetailRetrieve(slug, locale, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiLocalizedLinkDetailRetrieve>>, TError, TData>(
    {
      queryKey,
      queryFn,
      enabled: !!(slug && locale),
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      ...queryOptions,
    }
  ) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiMultidimensionalReviewResponseDetailRetrieve = (
  mdreviewOpk: string,
  opk: string,
  signal?: AbortSignal
) => {
  return HTTP<MultiDimensionalReviewResponse>({
    url: `/api/v7/mdreviews/${mdreviewOpk}/responses/${opk}/`,
    method: 'get',
    signal,
  });
};

export const getApiMultidimensionalReviewResponseDetailRetrieveQueryKey = (
  mdreviewOpk: string,
  opk: string
) => [`/api/v7/mdreviews/${mdreviewOpk}/responses/${opk}/`];

export type ApiMultidimensionalReviewResponseDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMultidimensionalReviewResponseDetailRetrieve>>
>;
export type ApiMultidimensionalReviewResponseDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiMultidimensionalReviewResponseDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiMultidimensionalReviewResponseDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  mdreviewOpk: string,
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiMultidimensionalReviewResponseDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiMultidimensionalReviewResponseDetailRetrieveQueryKey(mdreviewOpk, opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiMultidimensionalReviewResponseDetailRetrieve>>
  > = ({ signal }) => apiMultidimensionalReviewResponseDetailRetrieve(mdreviewOpk, opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiMultidimensionalReviewResponseDetailRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(mdreviewOpk && opk),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiMultidimensionalReviewResponseDetailUpdate = (
  mdreviewOpk: string,
  opk: string,
  multiDimensionalReviewResponse: MultiDimensionalReviewResponse
) => {
  return HTTP<MultiDimensionalReviewResponse>({
    url: `/api/v7/mdreviews/${mdreviewOpk}/responses/${opk}/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: multiDimensionalReviewResponse,
  });
};

export type ApiMultidimensionalReviewResponseDetailUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiMultidimensionalReviewResponseDetailUpdate>>
>;
export type ApiMultidimensionalReviewResponseDetailUpdateMutationBody =
  MultiDimensionalReviewResponse;
export type ApiMultidimensionalReviewResponseDetailUpdateMutationError = ErrorType<unknown>;

export const useApiMultidimensionalReviewResponseDetailUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiMultidimensionalReviewResponseDetailUpdate>>,
    TError,
    { mdreviewOpk: string; opk: string; data: MultiDimensionalReviewResponse },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiMultidimensionalReviewResponseDetailUpdate>>,
    { mdreviewOpk: string; opk: string; data: MultiDimensionalReviewResponse }
  > = (props) => {
    const { mdreviewOpk, opk, data } = props ?? {};

    return apiMultidimensionalReviewResponseDetailUpdate(mdreviewOpk, opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiMultidimensionalReviewResponseDetailUpdate>>,
    TError,
    { mdreviewOpk: string; opk: string; data: MultiDimensionalReviewResponse },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiMultidimensionalReviewResponseDetailPartialUpdate = (
  mdreviewOpk: string,
  opk: string,
  patchedMultiDimensionalReviewResponse: PatchedMultiDimensionalReviewResponse
) => {
  return HTTP<MultiDimensionalReviewResponse>({
    url: `/api/v7/mdreviews/${mdreviewOpk}/responses/${opk}/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedMultiDimensionalReviewResponse,
  });
};

export type ApiMultidimensionalReviewResponseDetailPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiMultidimensionalReviewResponseDetailPartialUpdate>>
>;
export type ApiMultidimensionalReviewResponseDetailPartialUpdateMutationBody =
  PatchedMultiDimensionalReviewResponse;
export type ApiMultidimensionalReviewResponseDetailPartialUpdateMutationError = ErrorType<unknown>;

export const useApiMultidimensionalReviewResponseDetailPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiMultidimensionalReviewResponseDetailPartialUpdate>>,
    TError,
    { mdreviewOpk: string; opk: string; data: PatchedMultiDimensionalReviewResponse },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiMultidimensionalReviewResponseDetailPartialUpdate>>,
    { mdreviewOpk: string; opk: string; data: PatchedMultiDimensionalReviewResponse }
  > = (props) => {
    const { mdreviewOpk, opk, data } = props ?? {};

    return apiMultidimensionalReviewResponseDetailPartialUpdate(mdreviewOpk, opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiMultidimensionalReviewResponseDetailPartialUpdate>>,
    TError,
    { mdreviewOpk: string; opk: string; data: PatchedMultiDimensionalReviewResponse },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiMultidimensionalReviewDetailRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<MultiDimensionalReview>({ url: `/api/v7/mdreviews/${opk}/`, method: 'get', signal });
};

export const getApiMultidimensionalReviewDetailRetrieveQueryKey = (opk: string) => [
  `/api/v7/mdreviews/${opk}/`,
];

export type ApiMultidimensionalReviewDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMultidimensionalReviewDetailRetrieve>>
>;
export type ApiMultidimensionalReviewDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiMultidimensionalReviewDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiMultidimensionalReviewDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiMultidimensionalReviewDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiMultidimensionalReviewDetailRetrieveQueryKey(opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiMultidimensionalReviewDetailRetrieve>>
  > = ({ signal }) => apiMultidimensionalReviewDetailRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiMultidimensionalReviewDetailRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiMultidimensionalReviewDetailUpdate = (
  opk: string,
  multiDimensionalReview: MultiDimensionalReview
) => {
  return HTTP<MultiDimensionalReview>({
    url: `/api/v7/mdreviews/${opk}/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: multiDimensionalReview,
  });
};

export type ApiMultidimensionalReviewDetailUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiMultidimensionalReviewDetailUpdate>>
>;
export type ApiMultidimensionalReviewDetailUpdateMutationBody = MultiDimensionalReview;
export type ApiMultidimensionalReviewDetailUpdateMutationError = ErrorType<unknown>;

export const useApiMultidimensionalReviewDetailUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiMultidimensionalReviewDetailUpdate>>,
    TError,
    { opk: string; data: MultiDimensionalReview },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiMultidimensionalReviewDetailUpdate>>,
    { opk: string; data: MultiDimensionalReview }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiMultidimensionalReviewDetailUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiMultidimensionalReviewDetailUpdate>>,
    TError,
    { opk: string; data: MultiDimensionalReview },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiMultidimensionalReviewDetailPartialUpdate = (
  opk: string,
  patchedMultiDimensionalReview: PatchedMultiDimensionalReview
) => {
  return HTTP<MultiDimensionalReview>({
    url: `/api/v7/mdreviews/${opk}/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedMultiDimensionalReview,
  });
};

export type ApiMultidimensionalReviewDetailPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiMultidimensionalReviewDetailPartialUpdate>>
>;
export type ApiMultidimensionalReviewDetailPartialUpdateMutationBody =
  PatchedMultiDimensionalReview;
export type ApiMultidimensionalReviewDetailPartialUpdateMutationError = ErrorType<unknown>;

export const useApiMultidimensionalReviewDetailPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiMultidimensionalReviewDetailPartialUpdate>>,
    TError,
    { opk: string; data: PatchedMultiDimensionalReview },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiMultidimensionalReviewDetailPartialUpdate>>,
    { opk: string; data: PatchedMultiDimensionalReview }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiMultidimensionalReviewDetailPartialUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiMultidimensionalReviewDetailPartialUpdate>>,
    TError,
    { opk: string; data: PatchedMultiDimensionalReview },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiMeSummaryRetrieve = (signal?: AbortSignal) => {
  return HTTP<Me>({ url: `/api/v7/me/`, method: 'get', signal });
};

export const getApiMeSummaryRetrieveQueryKey = () => [`/api/v7/me/`];

export type ApiMeSummaryRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMeSummaryRetrieve>>
>;
export type ApiMeSummaryRetrieveQueryError = ErrorType<unknown>;

export const useApiMeSummaryRetrieve = <
  TData = Awaited<ReturnType<typeof apiMeSummaryRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiMeSummaryRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMeSummaryRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMeSummaryRetrieve>>> = ({ signal }) =>
    apiMeSummaryRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiMeSummaryRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiMeetAndGreetDetailRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<MeetAndGreet>({ url: `/api/v7/meet-and-greets/${opk}/`, method: 'get', signal });
};

export const getApiMeetAndGreetDetailRetrieveQueryKey = (opk: string) => [
  `/api/v7/meet-and-greets/${opk}/`,
];

export type ApiMeetAndGreetDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMeetAndGreetDetailRetrieve>>
>;
export type ApiMeetAndGreetDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiMeetAndGreetDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiMeetAndGreetDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiMeetAndGreetDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMeetAndGreetDetailRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMeetAndGreetDetailRetrieve>>> = ({
    signal,
  }) => apiMeetAndGreetDetailRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiMeetAndGreetDetailRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiMessageDetailRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<Message>({ url: `/api/v7/messages/${opk}/`, method: 'get', signal });
};

export const getApiMessageDetailRetrieveQueryKey = (opk: string) => [`/api/v7/messages/${opk}/`];

export type ApiMessageDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMessageDetailRetrieve>>
>;
export type ApiMessageDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiMessageDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiMessageDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiMessageDetailRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMessageDetailRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMessageDetailRetrieve>>> = ({
    signal,
  }) => apiMessageDetailRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiMessageDetailRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiMyPetsRetrieve = (signal?: AbortSignal) => {
  return HTTP<PersonPets>({ url: `/api/v7/my-pets/`, method: 'get', signal });
};

export const getApiMyPetsRetrieveQueryKey = () => [`/api/v7/my-pets/`];

export type ApiMyPetsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMyPetsRetrieve>>
>;
export type ApiMyPetsRetrieveQueryError = ErrorType<unknown>;

export const useApiMyPetsRetrieve = <
  TData = Awaited<ReturnType<typeof apiMyPetsRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiMyPetsRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMyPetsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMyPetsRetrieve>>> = ({ signal }) =>
    apiMyPetsRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiMyPetsRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiNewsletterSignupCreate = (newsletterSignup: NewsletterSignup) => {
  return HTTP<ApiNewsletterSignupCreate200>({
    url: `/api/v7/newsletter-signup/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: newsletterSignup,
  });
};

export type ApiNewsletterSignupCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiNewsletterSignupCreate>>
>;
export type ApiNewsletterSignupCreateMutationBody = NewsletterSignup;
export type ApiNewsletterSignupCreateMutationError = ErrorType<unknown>;

export const useApiNewsletterSignupCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiNewsletterSignupCreate>>,
    TError,
    { data: NewsletterSignup },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiNewsletterSignupCreate>>,
    { data: NewsletterSignup }
  > = (props) => {
    const { data } = props ?? {};

    return apiNewsletterSignupCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiNewsletterSignupCreate>>,
    TError,
    { data: NewsletterSignup },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiNotificationEventTrackingUpdate = (
  opk: string,
  notificationEventTracking: NotificationEventTracking
) => {
  return HTTP<NotificationEventTracking>({
    url: `/api/v7/notification-event-tracking/${opk}/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: notificationEventTracking,
  });
};

export type ApiNotificationEventTrackingUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiNotificationEventTrackingUpdate>>
>;
export type ApiNotificationEventTrackingUpdateMutationBody = NotificationEventTracking;
export type ApiNotificationEventTrackingUpdateMutationError = ErrorType<unknown>;

export const useApiNotificationEventTrackingUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiNotificationEventTrackingUpdate>>,
    TError,
    { opk: string; data: NotificationEventTracking },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiNotificationEventTrackingUpdate>>,
    { opk: string; data: NotificationEventTracking }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiNotificationEventTrackingUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiNotificationEventTrackingUpdate>>,
    TError,
    { opk: string; data: NotificationEventTracking },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiDeviceNotificationCallbackCreate = (
  deviceNotificationCallback: DeviceNotificationCallback
) => {
  return HTTP<DeviceNotificationCallback>({
    url: `/api/v7/notifications/callback/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: deviceNotificationCallback,
  });
};

export type ApiDeviceNotificationCallbackCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiDeviceNotificationCallbackCreate>>
>;
export type ApiDeviceNotificationCallbackCreateMutationBody = DeviceNotificationCallback;
export type ApiDeviceNotificationCallbackCreateMutationError = ErrorType<unknown>;

export const useApiDeviceNotificationCallbackCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDeviceNotificationCallbackCreate>>,
    TError,
    { data: DeviceNotificationCallback },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiDeviceNotificationCallbackCreate>>,
    { data: DeviceNotificationCallback }
  > = (props) => {
    const { data } = props ?? {};

    return apiDeviceNotificationCallbackCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiDeviceNotificationCallbackCreate>>,
    TError,
    { data: DeviceNotificationCallback },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiImportdUserOnboardingViewCreate = (
  importedUserOnboarding: ImportedUserOnboarding
) => {
  return HTTP<ClaimResponse>({
    url: `/api/v7/onboarding/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: importedUserOnboarding,
  });
};

export type ApiImportdUserOnboardingViewCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiImportdUserOnboardingViewCreate>>
>;
export type ApiImportdUserOnboardingViewCreateMutationBody = ImportedUserOnboarding;
export type ApiImportdUserOnboardingViewCreateMutationError = ErrorType<unknown>;

export const useApiImportdUserOnboardingViewCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiImportdUserOnboardingViewCreate>>,
    TError,
    { data: ImportedUserOnboarding },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiImportdUserOnboardingViewCreate>>,
    { data: ImportedUserOnboarding }
  > = (props) => {
    const { data } = props ?? {};

    return apiImportdUserOnboardingViewCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiImportdUserOnboardingViewCreate>>,
    TError,
    { data: ImportedUserOnboarding },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiImportedUserStatusViewRetrieve = (signal?: AbortSignal) => {
  return HTTP<ImportedUserStatus>({ url: `/api/v7/onboarding-status/`, method: 'get', signal });
};

export const getApiImportedUserStatusViewRetrieveQueryKey = () => [`/api/v7/onboarding-status/`];

export type ApiImportedUserStatusViewRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiImportedUserStatusViewRetrieve>>
>;
export type ApiImportedUserStatusViewRetrieveQueryError = ErrorType<unknown>;

export const useApiImportedUserStatusViewRetrieve = <
  TData = Awaited<ReturnType<typeof apiImportedUserStatusViewRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiImportedUserStatusViewRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiImportedUserStatusViewRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiImportedUserStatusViewRetrieve>>> = ({
    signal,
  }) => apiImportedUserStatusViewRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiImportedUserStatusViewRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiCommerceOrderAdminToolbarViewRetrieve = (
  opk: string,
  params?: ApiCommerceOrderAdminToolbarViewRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<OrderAdminToolbar>({
    url: `/api/v7/order/${opk}/admin-toolbar`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiCommerceOrderAdminToolbarViewRetrieveQueryKey = (
  opk: string,
  params?: ApiCommerceOrderAdminToolbarViewRetrieveParams
) => [`/api/v7/order/${opk}/admin-toolbar`, ...(params ? [params] : [])];

export type ApiCommerceOrderAdminToolbarViewRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiCommerceOrderAdminToolbarViewRetrieve>>
>;
export type ApiCommerceOrderAdminToolbarViewRetrieveQueryError = ErrorType<void>;

export const useApiCommerceOrderAdminToolbarViewRetrieve = <
  TData = Awaited<ReturnType<typeof apiCommerceOrderAdminToolbarViewRetrieve>>,
  TError = ErrorType<void>
>(
  opk: string,
  params?: ApiCommerceOrderAdminToolbarViewRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiCommerceOrderAdminToolbarViewRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiCommerceOrderAdminToolbarViewRetrieveQueryKey(opk, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiCommerceOrderAdminToolbarViewRetrieve>>
  > = ({ signal }) => apiCommerceOrderAdminToolbarViewRetrieve(opk, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiCommerceOrderAdminToolbarViewRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiCommerceOrderViewRetrieve = (orderOpk: string, signal?: AbortSignal) => {
  return HTTP<CommerceOrder>({ url: `/api/v7/order/${orderOpk}`, method: 'get', signal });
};

export const getApiCommerceOrderViewRetrieveQueryKey = (orderOpk: string) => [
  `/api/v7/order/${orderOpk}`,
];

export type ApiCommerceOrderViewRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiCommerceOrderViewRetrieve>>
>;
export type ApiCommerceOrderViewRetrieveQueryError = ErrorType<unknown>;

export const useApiCommerceOrderViewRetrieve = <
  TData = Awaited<ReturnType<typeof apiCommerceOrderViewRetrieve>>,
  TError = ErrorType<unknown>
>(
  orderOpk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiCommerceOrderViewRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiCommerceOrderViewRetrieveQueryKey(orderOpk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiCommerceOrderViewRetrieve>>> = ({
    signal,
  }) => apiCommerceOrderViewRetrieve(orderOpk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiCommerceOrderViewRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!orderOpk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiCreatePaymentIntentsCreate = (
  createPaymentIntentRequest: CreatePaymentIntentRequest
) => {
  return HTTP<CreatePaymentIntentResponse>({
    url: `/api/v7/payment-intents/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: createPaymentIntentRequest,
  });
};

export type ApiCreatePaymentIntentsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiCreatePaymentIntentsCreate>>
>;
export type ApiCreatePaymentIntentsCreateMutationBody = CreatePaymentIntentRequest;
export type ApiCreatePaymentIntentsCreateMutationError = ErrorType<unknown>;

export const useApiCreatePaymentIntentsCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiCreatePaymentIntentsCreate>>,
    TError,
    { data: CreatePaymentIntentRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiCreatePaymentIntentsCreate>>,
    { data: CreatePaymentIntentRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiCreatePaymentIntentsCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiCreatePaymentIntentsCreate>>,
    TError,
    { data: CreatePaymentIntentRequest },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiPaymentSheetCreate = (paymentSheetRequest: PaymentSheetRequest) => {
  return HTTP<PaymentSheetResponse>({
    url: `/api/v7/payment-sheet/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: paymentSheetRequest,
  });
};

export type ApiPaymentSheetCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentSheetCreate>>
>;
export type ApiPaymentSheetCreateMutationBody = PaymentSheetRequest;
export type ApiPaymentSheetCreateMutationError = ErrorType<unknown>;

export const useApiPaymentSheetCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPaymentSheetCreate>>,
    TError,
    { data: PaymentSheetRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPaymentSheetCreate>>,
    { data: PaymentSheetRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiPaymentSheetCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPaymentSheetCreate>>,
    TError,
    { data: PaymentSheetRequest },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiPersonList = (params?: ApiPersonListParams, signal?: AbortSignal) => {
  return HTTP<PaginatedPersonSummaryList>({
    url: `/api/v7/people/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPersonListQueryKey = (params?: ApiPersonListParams) => [
  `/api/v7/people/`,
  ...(params ? [params] : []),
];

export type ApiPersonListQueryResult = NonNullable<Awaited<ReturnType<typeof apiPersonList>>>;
export type ApiPersonListQueryError = ErrorType<unknown>;

export const useApiPersonList = <
  TData = Awaited<ReturnType<typeof apiPersonList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiPersonListParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof apiPersonList>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonList>>> = ({ signal }) =>
    apiPersonList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPersonList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiPersonDetailRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<Person>({ url: `/api/v7/people/${opk}/`, method: 'get', signal });
};

export const getApiPersonDetailRetrieveQueryKey = (opk: string) => [`/api/v7/people/${opk}/`];

export type ApiPersonDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDetailRetrieve>>
>;
export type ApiPersonDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiPersonDetailRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonDetailRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonDetailRetrieve>>> = ({
    signal,
  }) => apiPersonDetailRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPersonDetailRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiPersonAvailabilityViewRetrieve = (
  opk: string,
  serviceSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<ProviderProfileAvailabilityPreferences>({
    url: `/api/v7/people/${opk}/availability/${serviceSlug}/`,
    method: 'get',
    signal,
  });
};

export const getApiPersonAvailabilityViewRetrieveQueryKey = (opk: string, serviceSlug: string) => [
  `/api/v7/people/${opk}/availability/${serviceSlug}/`,
];

export type ApiPersonAvailabilityViewRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonAvailabilityViewRetrieve>>
>;
export type ApiPersonAvailabilityViewRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonAvailabilityViewRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonAvailabilityViewRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  serviceSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonAvailabilityViewRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiPersonAvailabilityViewRetrieveQueryKey(opk, serviceSlug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonAvailabilityViewRetrieve>>> = ({
    signal,
  }) => apiPersonAvailabilityViewRetrieve(opk, serviceSlug, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPersonAvailabilityViewRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(opk && serviceSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonBackgroundCheckRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<BackgroundCheckStatus>({
    url: `/api/v7/people/${opk}/background-check/`,
    method: 'get',
    signal,
  });
};

export const getApiPersonBackgroundCheckRetrieveQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/background-check/`,
];

export type ApiPersonBackgroundCheckRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonBackgroundCheckRetrieve>>
>;
export type ApiPersonBackgroundCheckRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonBackgroundCheckRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonBackgroundCheckRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonBackgroundCheckRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonBackgroundCheckRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonBackgroundCheckRetrieve>>> = ({
    signal,
  }) => apiPersonBackgroundCheckRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPersonBackgroundCheckRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * PrePurchase actions for PaymentIntent capable BackgroundChecks.
For the PaymentIntent enabled BackgroundCheck flow we initiate the process by finding a
BackgroundCheckRequest in the `prepurchase` state, creating an order, and finally invoicing
the order.
 */
export const apiPersonBackgroundCheckCandidateCreationCreate = (
  opk: string,
  sterlingCandidateCreation: SterlingCandidateCreation
) => {
  return HTTP<void>({
    url: `/api/v7/people/${opk}/background-check-candidate-creation/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: sterlingCandidateCreation,
  });
};

export type ApiPersonBackgroundCheckCandidateCreationCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonBackgroundCheckCandidateCreationCreate>>
>;
export type ApiPersonBackgroundCheckCandidateCreationCreateMutationBody = SterlingCandidateCreation;
export type ApiPersonBackgroundCheckCandidateCreationCreateMutationError = ErrorType<unknown>;

export const useApiPersonBackgroundCheckCandidateCreationCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonBackgroundCheckCandidateCreationCreate>>,
    TError,
    { opk: string; data: SterlingCandidateCreation },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonBackgroundCheckCandidateCreationCreate>>,
    { opk: string; data: SterlingCandidateCreation }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPersonBackgroundCheckCandidateCreationCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonBackgroundCheckCandidateCreationCreate>>,
    TError,
    { opk: string; data: SterlingCandidateCreation },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * PrePurchase actions for PaymentIntent capable BackgroundChecks.

For the PaymentIntent enabled BackgroundCheck flow we initiate the process by finding a
BackgroundCheckRequest in the `prepurchase` state, creating an order, and finally invoicing
the order.
 */
export const apiPersonBackgroundCheckOrderCreate = (
  opk: string,
  backgroundCheckOrderInvoice: BackgroundCheckOrderInvoice
) => {
  return HTTP<void>({
    url: `/api/v7/people/${opk}/background-check-order/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: backgroundCheckOrderInvoice,
  });
};

export type ApiPersonBackgroundCheckOrderCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonBackgroundCheckOrderCreate>>
>;
export type ApiPersonBackgroundCheckOrderCreateMutationBody = BackgroundCheckOrderInvoice;
export type ApiPersonBackgroundCheckOrderCreateMutationError = ErrorType<unknown>;

export const useApiPersonBackgroundCheckOrderCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonBackgroundCheckOrderCreate>>,
    TError,
    { opk: string; data: BackgroundCheckOrderInvoice },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonBackgroundCheckOrderCreate>>,
    { opk: string; data: BackgroundCheckOrderInvoice }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPersonBackgroundCheckOrderCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonBackgroundCheckOrderCreate>>,
    TError,
    { opk: string; data: BackgroundCheckOrderInvoice },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Complete the purchase of a PaymentIntent capable BackgroundCheck.
For the PaymentIntent BackgroundCheck flow, this is the final step before sending it to the 3rd
party. The BackgroundCheckRequest will have been associated with an order and invoiced.
 */
export const apiPersonBackgroundCheckOrderPartialUpdate = (
  opk: string,
  patchedBackgroundCheckOrderCompletePurchase: PatchedBackgroundCheckOrderCompletePurchase
) => {
  return HTTP<void>({
    url: `/api/v7/people/${opk}/background-check-order/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedBackgroundCheckOrderCompletePurchase,
  });
};

export type ApiPersonBackgroundCheckOrderPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonBackgroundCheckOrderPartialUpdate>>
>;
export type ApiPersonBackgroundCheckOrderPartialUpdateMutationBody =
  PatchedBackgroundCheckOrderCompletePurchase;
export type ApiPersonBackgroundCheckOrderPartialUpdateMutationError = ErrorType<unknown>;

export const useApiPersonBackgroundCheckOrderPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonBackgroundCheckOrderPartialUpdate>>,
    TError,
    { opk: string; data: PatchedBackgroundCheckOrderCompletePurchase },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonBackgroundCheckOrderPartialUpdate>>,
    { opk: string; data: PatchedBackgroundCheckOrderCompletePurchase }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPersonBackgroundCheckOrderPartialUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonBackgroundCheckOrderPartialUpdate>>,
    TError,
    { opk: string; data: PatchedBackgroundCheckOrderCompletePurchase },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Complete the purchase of a PaymentIntent capable BackgroundCheck.
For the PaymentIntent BackgroundCheck flow, this is the final step before sending it to the 3rd
party. The BackgroundCheckRequest will have been associated with an order and invoiced.
 */
export const apiPersonBackgroundCheckPaymentCreate = (opk: string) => {
  return HTTP<void>({ url: `/api/v7/people/${opk}/background-check-payment/`, method: 'post' });
};

export type ApiPersonBackgroundCheckPaymentCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonBackgroundCheckPaymentCreate>>
>;

export type ApiPersonBackgroundCheckPaymentCreateMutationError = ErrorType<unknown>;

export const useApiPersonBackgroundCheckPaymentCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonBackgroundCheckPaymentCreate>>,
    TError,
    { opk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonBackgroundCheckPaymentCreate>>,
    { opk: string }
  > = (props) => {
    const { opk } = props ?? {};

    return apiPersonBackgroundCheckPaymentCreate(opk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonBackgroundCheckPaymentCreate>>,
    TError,
    { opk: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonCalendarRetrieve = (
  opk: string,
  params?: ApiPersonCalendarRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<PersonCalendar>({
    url: `/api/v7/people/${opk}/calendar/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPersonCalendarRetrieveQueryKey = (
  opk: string,
  params?: ApiPersonCalendarRetrieveParams
) => [`/api/v7/people/${opk}/calendar/`, ...(params ? [params] : [])];

export type ApiPersonCalendarRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonCalendarRetrieve>>
>;
export type ApiPersonCalendarRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonCalendarRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonCalendarRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPersonCalendarRetrieveParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiPersonCalendarRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonCalendarRetrieveQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonCalendarRetrieve>>> = ({
    signal,
  }) => apiPersonCalendarRetrieve(opk, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPersonCalendarRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonCalendarUpdate = (
  opk: string,
  patchedPersonCalendar: PatchedPersonCalendar,
  params?: ApiPersonCalendarUpdateParams
) => {
  return HTTP<PersonCalendar>({
    url: `/api/v7/people/${opk}/calendar/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedPersonCalendar,
    params,
  });
};

export type ApiPersonCalendarUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonCalendarUpdate>>
>;
export type ApiPersonCalendarUpdateMutationBody = PatchedPersonCalendar;
export type ApiPersonCalendarUpdateMutationError = ErrorType<unknown>;

export const useApiPersonCalendarUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonCalendarUpdate>>,
    TError,
    { opk: string; data: PatchedPersonCalendar; params?: ApiPersonCalendarUpdateParams },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonCalendarUpdate>>,
    { opk: string; data: PatchedPersonCalendar; params?: ApiPersonCalendarUpdateParams }
  > = (props) => {
    const { opk, data, params } = props ?? {};

    return apiPersonCalendarUpdate(opk, data, params);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonCalendarUpdate>>,
    TError,
    { opk: string; data: PatchedPersonCalendar; params?: ApiPersonCalendarUpdateParams },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonCalendarPartialUpdate = (
  opk: string,
  patchedPersonCalendar: PatchedPersonCalendar,
  params?: ApiPersonCalendarPartialUpdateParams
) => {
  return HTTP<PersonCalendar>({
    url: `/api/v7/people/${opk}/calendar/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedPersonCalendar,
    params,
  });
};

export type ApiPersonCalendarPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonCalendarPartialUpdate>>
>;
export type ApiPersonCalendarPartialUpdateMutationBody = PatchedPersonCalendar;
export type ApiPersonCalendarPartialUpdateMutationError = ErrorType<unknown>;

export const useApiPersonCalendarPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonCalendarPartialUpdate>>,
    TError,
    { opk: string; data: PatchedPersonCalendar; params?: ApiPersonCalendarPartialUpdateParams },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonCalendarPartialUpdate>>,
    { opk: string; data: PatchedPersonCalendar; params?: ApiPersonCalendarPartialUpdateParams }
  > = (props) => {
    const { opk, data, params } = props ?? {};

    return apiPersonCalendarPartialUpdate(opk, data, params);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonCalendarPartialUpdate>>,
    TError,
    { opk: string; data: PatchedPersonCalendar; params?: ApiPersonCalendarPartialUpdateParams },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonCalendarPromptMessageRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<CalendarPromptMessageSerializerOrEmpty>({
    url: `/api/v7/people/${opk}/calendar-prompt/`,
    method: 'get',
    signal,
  });
};

export const getApiPersonCalendarPromptMessageRetrieveQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/calendar-prompt/`,
];

export type ApiPersonCalendarPromptMessageRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonCalendarPromptMessageRetrieve>>
>;
export type ApiPersonCalendarPromptMessageRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonCalendarPromptMessageRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonCalendarPromptMessageRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonCalendarPromptMessageRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonCalendarPromptMessageRetrieveQueryKey(opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiPersonCalendarPromptMessageRetrieve>>
  > = ({ signal }) => apiPersonCalendarPromptMessageRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPersonCalendarPromptMessageRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonCalendarSettingsList = (opk: string, signal?: AbortSignal) => {
  return HTTP<CalendarSettingsServiceSerializerListOrObject>({
    url: `/api/v7/people/${opk}/calendar/settings/`,
    method: 'get',
    signal,
  });
};

export const getApiPersonCalendarSettingsListQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/calendar/settings/`,
];

export type ApiPersonCalendarSettingsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonCalendarSettingsList>>
>;
export type ApiPersonCalendarSettingsListQueryError = ErrorType<unknown>;

export const useApiPersonCalendarSettingsList = <
  TData = Awaited<ReturnType<typeof apiPersonCalendarSettingsList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonCalendarSettingsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonCalendarSettingsListQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonCalendarSettingsList>>> = ({
    signal,
  }) => apiPersonCalendarSettingsList(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPersonCalendarSettingsList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonCalendarSettingsDetailRetrieve = (
  opk: string,
  serviceSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<CalendarSettingsService>({
    url: `/api/v7/people/${opk}/calendar/settings/services/${serviceSlug}`,
    method: 'get',
    signal,
  });
};

export const getApiPersonCalendarSettingsDetailRetrieveQueryKey = (
  opk: string,
  serviceSlug: string
) => [`/api/v7/people/${opk}/calendar/settings/services/${serviceSlug}`];

export type ApiPersonCalendarSettingsDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonCalendarSettingsDetailRetrieve>>
>;
export type ApiPersonCalendarSettingsDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonCalendarSettingsDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonCalendarSettingsDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  serviceSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonCalendarSettingsDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiPersonCalendarSettingsDetailRetrieveQueryKey(opk, serviceSlug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiPersonCalendarSettingsDetailRetrieve>>
  > = ({ signal }) => apiPersonCalendarSettingsDetailRetrieve(opk, serviceSlug, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPersonCalendarSettingsDetailRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(opk && serviceSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonCalendarSettingsDetailUpdate = (
  opk: string,
  serviceSlug: string,
  calendarSettingsService: CalendarSettingsService
) => {
  return HTTP<CalendarSettingsService>({
    url: `/api/v7/people/${opk}/calendar/settings/services/${serviceSlug}`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: calendarSettingsService,
  });
};

export type ApiPersonCalendarSettingsDetailUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonCalendarSettingsDetailUpdate>>
>;
export type ApiPersonCalendarSettingsDetailUpdateMutationBody = CalendarSettingsService;
export type ApiPersonCalendarSettingsDetailUpdateMutationError = ErrorType<unknown>;

export const useApiPersonCalendarSettingsDetailUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonCalendarSettingsDetailUpdate>>,
    TError,
    { opk: string; serviceSlug: string; data: CalendarSettingsService },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonCalendarSettingsDetailUpdate>>,
    { opk: string; serviceSlug: string; data: CalendarSettingsService }
  > = (props) => {
    const { opk, serviceSlug, data } = props ?? {};

    return apiPersonCalendarSettingsDetailUpdate(opk, serviceSlug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonCalendarSettingsDetailUpdate>>,
    TError,
    { opk: string; serviceSlug: string; data: CalendarSettingsService },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonCalendarSettingsDetailPartialUpdate = (
  opk: string,
  serviceSlug: string,
  patchedCalendarSettingsService: PatchedCalendarSettingsService
) => {
  return HTTP<CalendarSettingsService>({
    url: `/api/v7/people/${opk}/calendar/settings/services/${serviceSlug}`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedCalendarSettingsService,
  });
};

export type ApiPersonCalendarSettingsDetailPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonCalendarSettingsDetailPartialUpdate>>
>;
export type ApiPersonCalendarSettingsDetailPartialUpdateMutationBody =
  PatchedCalendarSettingsService;
export type ApiPersonCalendarSettingsDetailPartialUpdateMutationError = ErrorType<unknown>;

export const useApiPersonCalendarSettingsDetailPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonCalendarSettingsDetailPartialUpdate>>,
    TError,
    { opk: string; serviceSlug: string; data: PatchedCalendarSettingsService },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonCalendarSettingsDetailPartialUpdate>>,
    { opk: string; serviceSlug: string; data: PatchedCalendarSettingsService }
  > = (props) => {
    const { opk, serviceSlug, data } = props ?? {};

    return apiPersonCalendarSettingsDetailPartialUpdate(opk, serviceSlug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonCalendarSettingsDetailPartialUpdate>>,
    TError,
    { opk: string; serviceSlug: string; data: PatchedCalendarSettingsService },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiCheckPaymentCompletionRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<PersonCheckOrderResponse>({
    url: `/api/v7/people/${opk}/check-payment-completion/`,
    method: 'get',
    signal,
  });
};

export const getApiCheckPaymentCompletionRetrieveQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/check-payment-completion/`,
];

export type ApiCheckPaymentCompletionRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiCheckPaymentCompletionRetrieve>>
>;
export type ApiCheckPaymentCompletionRetrieveQueryError = ErrorType<unknown>;

export const useApiCheckPaymentCompletionRetrieve = <
  TData = Awaited<ReturnType<typeof apiCheckPaymentCompletionRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiCheckPaymentCompletionRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiCheckPaymentCompletionRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiCheckPaymentCompletionRetrieve>>> = ({
    signal,
  }) => apiCheckPaymentCompletionRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiCheckPaymentCompletionRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiCheckPaymentCompletionPartialUpdate = (opk: string) => {
  return HTTP<void>({ url: `/api/v7/people/${opk}/check-payment-completion/`, method: 'patch' });
};

export type ApiCheckPaymentCompletionPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiCheckPaymentCompletionPartialUpdate>>
>;

export type ApiCheckPaymentCompletionPartialUpdateMutationError = ErrorType<unknown>;

export const useApiCheckPaymentCompletionPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiCheckPaymentCompletionPartialUpdate>>,
    TError,
    { opk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiCheckPaymentCompletionPartialUpdate>>,
    { opk: string }
  > = (props) => {
    const { opk } = props ?? {};

    return apiCheckPaymentCompletionPartialUpdate(opk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiCheckPaymentCompletionPartialUpdate>>,
    TError,
    { opk: string },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiPersonProfileCitySeoRetrieve = (
  opk: string,
  params?: ApiPersonProfileCitySeoRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<CitySEO>({ url: `/api/v7/people/${opk}/city-seo/`, method: 'get', params, signal });
};

export const getApiPersonProfileCitySeoRetrieveQueryKey = (
  opk: string,
  params?: ApiPersonProfileCitySeoRetrieveParams
) => [`/api/v7/people/${opk}/city-seo/`, ...(params ? [params] : [])];

export type ApiPersonProfileCitySeoRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonProfileCitySeoRetrieve>>
>;
export type ApiPersonProfileCitySeoRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonProfileCitySeoRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonProfileCitySeoRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPersonProfileCitySeoRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonProfileCitySeoRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiPersonProfileCitySeoRetrieveQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonProfileCitySeoRetrieve>>> = ({
    signal,
  }) => apiPersonProfileCitySeoRetrieve(opk, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPersonProfileCitySeoRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiConfirmedAvailabilityRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<PersonConfirmedAvailabilityCalendar>({
    url: `/api/v7/people/${opk}/confirmed-availability/`,
    method: 'get',
    signal,
  });
};

export const getApiConfirmedAvailabilityRetrieveQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/confirmed-availability/`,
];

export type ApiConfirmedAvailabilityRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConfirmedAvailabilityRetrieve>>
>;
export type ApiConfirmedAvailabilityRetrieveQueryError = ErrorType<unknown>;

export const useApiConfirmedAvailabilityRetrieve = <
  TData = Awaited<ReturnType<typeof apiConfirmedAvailabilityRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiConfirmedAvailabilityRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiConfirmedAvailabilityRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiConfirmedAvailabilityRetrieve>>> = ({
    signal,
  }) => apiConfirmedAvailabilityRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiConfirmedAvailabilityRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiConfirmedAvailabilityUpdate = (
  opk: string,
  personConfirmedAvailabilityCalendar: PersonConfirmedAvailabilityCalendar
) => {
  return HTTP<PersonConfirmedAvailabilityCalendar>({
    url: `/api/v7/people/${opk}/confirmed-availability/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: personConfirmedAvailabilityCalendar,
  });
};

export type ApiConfirmedAvailabilityUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiConfirmedAvailabilityUpdate>>
>;
export type ApiConfirmedAvailabilityUpdateMutationBody = PersonConfirmedAvailabilityCalendar;
export type ApiConfirmedAvailabilityUpdateMutationError = ErrorType<unknown>;

export const useApiConfirmedAvailabilityUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiConfirmedAvailabilityUpdate>>,
    TError,
    { opk: string; data: PersonConfirmedAvailabilityCalendar },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiConfirmedAvailabilityUpdate>>,
    { opk: string; data: PersonConfirmedAvailabilityCalendar }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiConfirmedAvailabilityUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiConfirmedAvailabilityUpdate>>,
    TError,
    { opk: string; data: PersonConfirmedAvailabilityCalendar },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiConfirmedAvailabilityPartialUpdate = (
  opk: string,
  patchedPersonConfirmedAvailabilityCalendar: PatchedPersonConfirmedAvailabilityCalendar
) => {
  return HTTP<PersonConfirmedAvailabilityCalendar>({
    url: `/api/v7/people/${opk}/confirmed-availability/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedPersonConfirmedAvailabilityCalendar,
  });
};

export type ApiConfirmedAvailabilityPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiConfirmedAvailabilityPartialUpdate>>
>;
export type ApiConfirmedAvailabilityPartialUpdateMutationBody =
  PatchedPersonConfirmedAvailabilityCalendar;
export type ApiConfirmedAvailabilityPartialUpdateMutationError = ErrorType<unknown>;

export const useApiConfirmedAvailabilityPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiConfirmedAvailabilityPartialUpdate>>,
    TError,
    { opk: string; data: PatchedPersonConfirmedAvailabilityCalendar },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiConfirmedAvailabilityPartialUpdate>>,
    { opk: string; data: PatchedPersonConfirmedAvailabilityCalendar }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiConfirmedAvailabilityPartialUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiConfirmedAvailabilityPartialUpdate>>,
    TError,
    { opk: string; data: PatchedPersonConfirmedAvailabilityCalendar },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonEnhancedAddOnsList = (
  opk: string,
  params?: ApiPersonEnhancedAddOnsListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedEnhancedAddOnsList>({
    url: `/api/v7/people/${opk}/enhanced-add-ons/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPersonEnhancedAddOnsListQueryKey = (
  opk: string,
  params?: ApiPersonEnhancedAddOnsListParams
) => [`/api/v7/people/${opk}/enhanced-add-ons/`, ...(params ? [params] : [])];

export type ApiPersonEnhancedAddOnsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonEnhancedAddOnsList>>
>;
export type ApiPersonEnhancedAddOnsListQueryError = ErrorType<unknown>;

export const useApiPersonEnhancedAddOnsList = <
  TData = Awaited<ReturnType<typeof apiPersonEnhancedAddOnsList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPersonEnhancedAddOnsListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiPersonEnhancedAddOnsList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonEnhancedAddOnsListQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonEnhancedAddOnsList>>> = ({
    signal,
  }) => apiPersonEnhancedAddOnsList(opk, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPersonEnhancedAddOnsList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonHolidayAvailabilitySurveyList = (opk: string, signal?: AbortSignal) => {
  return HTTP<PaginatedHolidayList>({
    url: `/api/v7/people/${opk}/holiday-availability/survey/`,
    method: 'get',
    signal,
  });
};

export const getApiPersonHolidayAvailabilitySurveyListQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/holiday-availability/survey/`,
];

export type ApiPersonHolidayAvailabilitySurveyListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonHolidayAvailabilitySurveyList>>
>;
export type ApiPersonHolidayAvailabilitySurveyListQueryError = ErrorType<unknown>;

export const useApiPersonHolidayAvailabilitySurveyList = <
  TData = Awaited<ReturnType<typeof apiPersonHolidayAvailabilitySurveyList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonHolidayAvailabilitySurveyList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonHolidayAvailabilitySurveyListQueryKey(opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiPersonHolidayAvailabilitySurveyList>>
  > = ({ signal }) => apiPersonHolidayAvailabilitySurveyList(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPersonHolidayAvailabilitySurveyList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonHolidayAvailabilitySurveyDetailRetrieve = (
  opk: string,
  holidaySlug: string,
  signal?: AbortSignal
) => {
  return HTTP<HolidaySerializerOrEmpty>({
    url: `/api/v7/people/${opk}/holiday-availability/survey/${holidaySlug}/`,
    method: 'get',
    signal,
  });
};

export const getApiPersonHolidayAvailabilitySurveyDetailRetrieveQueryKey = (
  opk: string,
  holidaySlug: string
) => [`/api/v7/people/${opk}/holiday-availability/survey/${holidaySlug}/`];

export type ApiPersonHolidayAvailabilitySurveyDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonHolidayAvailabilitySurveyDetailRetrieve>>
>;
export type ApiPersonHolidayAvailabilitySurveyDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonHolidayAvailabilitySurveyDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonHolidayAvailabilitySurveyDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  holidaySlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonHolidayAvailabilitySurveyDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiPersonHolidayAvailabilitySurveyDetailRetrieveQueryKey(opk, holidaySlug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiPersonHolidayAvailabilitySurveyDetailRetrieve>>
  > = ({ signal }) => apiPersonHolidayAvailabilitySurveyDetailRetrieve(opk, holidaySlug, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPersonHolidayAvailabilitySurveyDetailRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(opk && holidaySlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonHolidayAvailabilitySurveyDetailUpdate = (
  opk: string,
  holidaySlug: string,
  holidayAvailabilitySurveyDetailViewPutRequest: HolidayAvailabilitySurveyDetailViewPutRequest
) => {
  return HTTP<HolidayAvailabilitySurveyDetailViewPutResponse>({
    url: `/api/v7/people/${opk}/holiday-availability/survey/${holidaySlug}/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: holidayAvailabilitySurveyDetailViewPutRequest,
  });
};

export type ApiPersonHolidayAvailabilitySurveyDetailUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonHolidayAvailabilitySurveyDetailUpdate>>
>;
export type ApiPersonHolidayAvailabilitySurveyDetailUpdateMutationBody =
  HolidayAvailabilitySurveyDetailViewPutRequest;
export type ApiPersonHolidayAvailabilitySurveyDetailUpdateMutationError = ErrorType<unknown>;

export const useApiPersonHolidayAvailabilitySurveyDetailUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonHolidayAvailabilitySurveyDetailUpdate>>,
    TError,
    { opk: string; holidaySlug: string; data: HolidayAvailabilitySurveyDetailViewPutRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonHolidayAvailabilitySurveyDetailUpdate>>,
    { opk: string; holidaySlug: string; data: HolidayAvailabilitySurveyDetailViewPutRequest }
  > = (props) => {
    const { opk, holidaySlug, data } = props ?? {};

    return apiPersonHolidayAvailabilitySurveyDetailUpdate(opk, holidaySlug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonHolidayAvailabilitySurveyDetailUpdate>>,
    TError,
    { opk: string; holidaySlug: string; data: HolidayAvailabilitySurveyDetailViewPutRequest },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonDetailHomeRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<PersonLocation>({ url: `/api/v7/people/${opk}/home/`, method: 'get', signal });
};

export const getApiPersonDetailHomeRetrieveQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/home/`,
];

export type ApiPersonDetailHomeRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDetailHomeRetrieve>>
>;
export type ApiPersonDetailHomeRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonDetailHomeRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonDetailHomeRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiPersonDetailHomeRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonDetailHomeRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonDetailHomeRetrieve>>> = ({
    signal,
  }) => apiPersonDetailHomeRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPersonDetailHomeRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonDetailHomeCreate = (opk: string, personLocation: PersonLocation) => {
  return HTTP<PersonLocation>({
    url: `/api/v7/people/${opk}/home/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: personLocation,
  });
};

export type ApiPersonDetailHomeCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDetailHomeCreate>>
>;
export type ApiPersonDetailHomeCreateMutationBody = PersonLocation;
export type ApiPersonDetailHomeCreateMutationError = ErrorType<unknown>;

export const useApiPersonDetailHomeCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonDetailHomeCreate>>,
    TError,
    { opk: string; data: PersonLocation },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonDetailHomeCreate>>,
    { opk: string; data: PersonLocation }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPersonDetailHomeCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonDetailHomeCreate>>,
    TError,
    { opk: string; data: PersonLocation },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonDetailImagesList = (
  opk: string,
  params?: ApiPersonDetailImagesListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedImageList>({
    url: `/api/v7/people/${opk}/images/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPersonDetailImagesListQueryKey = (
  opk: string,
  params?: ApiPersonDetailImagesListParams
) => [`/api/v7/people/${opk}/images/`, ...(params ? [params] : [])];

export type ApiPersonDetailImagesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDetailImagesList>>
>;
export type ApiPersonDetailImagesListQueryError = ErrorType<unknown>;

export const useApiPersonDetailImagesList = <
  TData = Awaited<ReturnType<typeof apiPersonDetailImagesList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPersonDetailImagesListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiPersonDetailImagesList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonDetailImagesListQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonDetailImagesList>>> = ({
    signal,
  }) => apiPersonDetailImagesList(opk, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPersonDetailImagesList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonDetailImagesCreate = (opk: string, image: Image) => {
  return HTTP<Image>({
    url: `/api/v7/people/${opk}/images/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: image,
  });
};

export type ApiPersonDetailImagesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDetailImagesCreate>>
>;
export type ApiPersonDetailImagesCreateMutationBody = Image;
export type ApiPersonDetailImagesCreateMutationError = ErrorType<unknown>;

export const useApiPersonDetailImagesCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonDetailImagesCreate>>,
    TError,
    { opk: string; data: Image },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonDetailImagesCreate>>,
    { opk: string; data: Image }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPersonDetailImagesCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonDetailImagesCreate>>,
    TError,
    { opk: string; data: Image },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonDetailImagesProfilePhotoRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<Image>({ url: `/api/v7/people/${opk}/images/profile/`, method: 'get', signal });
};

export const getApiPersonDetailImagesProfilePhotoRetrieveQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/images/profile/`,
];

export type ApiPersonDetailImagesProfilePhotoRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDetailImagesProfilePhotoRetrieve>>
>;
export type ApiPersonDetailImagesProfilePhotoRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonDetailImagesProfilePhotoRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonDetailImagesProfilePhotoRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonDetailImagesProfilePhotoRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiPersonDetailImagesProfilePhotoRetrieveQueryKey(opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiPersonDetailImagesProfilePhotoRetrieve>>
  > = ({ signal }) => apiPersonDetailImagesProfilePhotoRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPersonDetailImagesProfilePhotoRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonDetailImagesProfilePhotoUpdate = (opk: string, image: Image) => {
  return HTTP<Image>({
    url: `/api/v7/people/${opk}/images/profile/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: image,
  });
};

export type ApiPersonDetailImagesProfilePhotoUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDetailImagesProfilePhotoUpdate>>
>;
export type ApiPersonDetailImagesProfilePhotoUpdateMutationBody = Image;
export type ApiPersonDetailImagesProfilePhotoUpdateMutationError = ErrorType<unknown>;

export const useApiPersonDetailImagesProfilePhotoUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonDetailImagesProfilePhotoUpdate>>,
    TError,
    { opk: string; data: Image },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonDetailImagesProfilePhotoUpdate>>,
    { opk: string; data: Image }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPersonDetailImagesProfilePhotoUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonDetailImagesProfilePhotoUpdate>>,
    TError,
    { opk: string; data: Image },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiInsightsProviderRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<ProviderInsightsViewResult>({
    url: `/api/v7/people/${opk}/insights/`,
    method: 'get',
    signal,
  });
};

export const getApiInsightsProviderRetrieveQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/insights/`,
];

export type ApiInsightsProviderRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInsightsProviderRetrieve>>
>;
export type ApiInsightsProviderRetrieveQueryError = ErrorType<unknown>;

export const useApiInsightsProviderRetrieve = <
  TData = Awaited<ReturnType<typeof apiInsightsProviderRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiInsightsProviderRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInsightsProviderRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInsightsProviderRetrieve>>> = ({
    signal,
  }) => apiInsightsProviderRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiInsightsProviderRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonLanguageRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<PersonLocalization>({
    url: `/api/v7/people/${opk}/language/`,
    method: 'get',
    signal,
  });
};

export const getApiPersonLanguageRetrieveQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/language/`,
];

export type ApiPersonLanguageRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonLanguageRetrieve>>
>;
export type ApiPersonLanguageRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonLanguageRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonLanguageRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiPersonLanguageRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonLanguageRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonLanguageRetrieve>>> = ({
    signal,
  }) => apiPersonLanguageRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPersonLanguageRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonLanguageUpdate = (opk: string, personLocalization: PersonLocalization) => {
  return HTTP<PersonLocalization>({
    url: `/api/v7/people/${opk}/language/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: personLocalization,
  });
};

export type ApiPersonLanguageUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonLanguageUpdate>>
>;
export type ApiPersonLanguageUpdateMutationBody = PersonLocalization;
export type ApiPersonLanguageUpdateMutationError = ErrorType<unknown>;

export const useApiPersonLanguageUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonLanguageUpdate>>,
    TError,
    { opk: string; data: PersonLocalization },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonLanguageUpdate>>,
    { opk: string; data: PersonLocalization }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPersonLanguageUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonLanguageUpdate>>,
    TError,
    { opk: string; data: PersonLocalization },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonLanguagePartialUpdate = (
  opk: string,
  patchedPersonLocalization: PatchedPersonLocalization
) => {
  return HTTP<PersonLocalization>({
    url: `/api/v7/people/${opk}/language/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedPersonLocalization,
  });
};

export type ApiPersonLanguagePartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonLanguagePartialUpdate>>
>;
export type ApiPersonLanguagePartialUpdateMutationBody = PatchedPersonLocalization;
export type ApiPersonLanguagePartialUpdateMutationError = ErrorType<unknown>;

export const useApiPersonLanguagePartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonLanguagePartialUpdate>>,
    TError,
    { opk: string; data: PatchedPersonLocalization },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonLanguagePartialUpdate>>,
    { opk: string; data: PatchedPersonLocalization }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPersonLanguagePartialUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonLanguagePartialUpdate>>,
    TError,
    { opk: string; data: PatchedPersonLocalization },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonLockboxCreate = (opk: string, lockbox: Lockbox) => {
  return HTTP<Lockbox>({
    url: `/api/v7/people/${opk}/lockbox/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: lockbox,
  });
};

export type ApiPersonLockboxCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonLockboxCreate>>
>;
export type ApiPersonLockboxCreateMutationBody = Lockbox;
export type ApiPersonLockboxCreateMutationError = ErrorType<unknown>;

export const useApiPersonLockboxCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonLockboxCreate>>,
    TError,
    { opk: string; data: Lockbox },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonLockboxCreate>>,
    { opk: string; data: Lockbox }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPersonLockboxCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonLockboxCreate>>,
    TError,
    { opk: string; data: Lockbox },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiOwnerDetailRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<OwnerDetail>({ url: `/api/v7/people/${opk}/owner-detail/`, method: 'get', signal });
};

export const getApiOwnerDetailRetrieveQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/owner-detail/`,
];

export type ApiOwnerDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiOwnerDetailRetrieve>>
>;
export type ApiOwnerDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiOwnerDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiOwnerDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiOwnerDetailRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiOwnerDetailRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiOwnerDetailRetrieve>>> = ({ signal }) =>
    apiOwnerDetailRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiOwnerDetailRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Check if the user needs to pay for IDV and return the amount.
 */
export const apiPersonIdvOrderRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<PersonIDVOrderResponse>({
    url: `/api/v7/people/${opk}/person-idv-order/`,
    method: 'get',
    signal,
  });
};

export const getApiPersonIdvOrderRetrieveQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/person-idv-order/`,
];

export type ApiPersonIdvOrderRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonIdvOrderRetrieve>>
>;
export type ApiPersonIdvOrderRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonIdvOrderRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonIdvOrderRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiPersonIdvOrderRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonIdvOrderRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonIdvOrderRetrieve>>> = ({
    signal,
  }) => apiPersonIdvOrderRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPersonIdvOrderRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonIdvOrderPartialUpdate = (opk: string) => {
  return HTTP<void>({ url: `/api/v7/people/${opk}/person-idv-order/`, method: 'patch' });
};

export type ApiPersonIdvOrderPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonIdvOrderPartialUpdate>>
>;

export type ApiPersonIdvOrderPartialUpdateMutationError = ErrorType<unknown>;

export const useApiPersonIdvOrderPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonIdvOrderPartialUpdate>>,
    TError,
    { opk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonIdvOrderPartialUpdate>>,
    { opk: string }
  > = (props) => {
    const { opk } = props ?? {};

    return apiPersonIdvOrderPartialUpdate(opk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonIdvOrderPartialUpdate>>,
    TError,
    { opk: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonPreferencesRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<PersonPreferences>({
    url: `/api/v7/people/${opk}/preferences/`,
    method: 'get',
    signal,
  });
};

export const getApiPersonPreferencesRetrieveQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/preferences/`,
];

export type ApiPersonPreferencesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonPreferencesRetrieve>>
>;
export type ApiPersonPreferencesRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonPreferencesRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonPreferencesRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonPreferencesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonPreferencesRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonPreferencesRetrieve>>> = ({
    signal,
  }) => apiPersonPreferencesRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPersonPreferencesRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiServiceAreaPreferencesRetrieve = (
  opk: string,
  serviceSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<ServiceAreaPreferences>({
    url: `/api/v7/people/${opk}/preferences/${serviceSlug}/service-area-preferences/`,
    method: 'get',
    signal,
  });
};

export const getApiServiceAreaPreferencesRetrieveQueryKey = (opk: string, serviceSlug: string) => [
  `/api/v7/people/${opk}/preferences/${serviceSlug}/service-area-preferences/`,
];

export type ApiServiceAreaPreferencesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceAreaPreferencesRetrieve>>
>;
export type ApiServiceAreaPreferencesRetrieveQueryError = ErrorType<unknown>;

export const useApiServiceAreaPreferencesRetrieve = <
  TData = Awaited<ReturnType<typeof apiServiceAreaPreferencesRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  serviceSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiServiceAreaPreferencesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiServiceAreaPreferencesRetrieveQueryKey(opk, serviceSlug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiServiceAreaPreferencesRetrieve>>> = ({
    signal,
  }) => apiServiceAreaPreferencesRetrieve(opk, serviceSlug, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiServiceAreaPreferencesRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(opk && serviceSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiServiceAreaPreferencesUpdate = (
  opk: string,
  serviceSlug: string,
  serviceAreaPreferences: ServiceAreaPreferences
) => {
  return HTTP<ServiceAreaPreferences>({
    url: `/api/v7/people/${opk}/preferences/${serviceSlug}/service-area-preferences/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: serviceAreaPreferences,
  });
};

export type ApiServiceAreaPreferencesUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceAreaPreferencesUpdate>>
>;
export type ApiServiceAreaPreferencesUpdateMutationBody = ServiceAreaPreferences;
export type ApiServiceAreaPreferencesUpdateMutationError = ErrorType<unknown>;

export const useApiServiceAreaPreferencesUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiServiceAreaPreferencesUpdate>>,
    TError,
    { opk: string; serviceSlug: string; data: ServiceAreaPreferences },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiServiceAreaPreferencesUpdate>>,
    { opk: string; serviceSlug: string; data: ServiceAreaPreferences }
  > = (props) => {
    const { opk, serviceSlug, data } = props ?? {};

    return apiServiceAreaPreferencesUpdate(opk, serviceSlug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiServiceAreaPreferencesUpdate>>,
    TError,
    { opk: string; serviceSlug: string; data: ServiceAreaPreferences },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiServiceAreaPreferencesPartialUpdate = (
  opk: string,
  serviceSlug: string,
  patchedServiceAreaPreferences: PatchedServiceAreaPreferences
) => {
  return HTTP<ServiceAreaPreferences>({
    url: `/api/v7/people/${opk}/preferences/${serviceSlug}/service-area-preferences/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedServiceAreaPreferences,
  });
};

export type ApiServiceAreaPreferencesPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceAreaPreferencesPartialUpdate>>
>;
export type ApiServiceAreaPreferencesPartialUpdateMutationBody = PatchedServiceAreaPreferences;
export type ApiServiceAreaPreferencesPartialUpdateMutationError = ErrorType<unknown>;

export const useApiServiceAreaPreferencesPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiServiceAreaPreferencesPartialUpdate>>,
    TError,
    { opk: string; serviceSlug: string; data: PatchedServiceAreaPreferences },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiServiceAreaPreferencesPartialUpdate>>,
    { opk: string; serviceSlug: string; data: PatchedServiceAreaPreferences }
  > = (props) => {
    const { opk, serviceSlug, data } = props ?? {};

    return apiServiceAreaPreferencesPartialUpdate(opk, serviceSlug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiServiceAreaPreferencesPartialUpdate>>,
    TError,
    { opk: string; serviceSlug: string; data: PatchedServiceAreaPreferences },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiServiceHostingPreferencesRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<HostingServicePreferences>({
    url: `/api/v7/people/${opk}/preferences/hosting/`,
    method: 'get',
    signal,
  });
};

export const getApiServiceHostingPreferencesRetrieveQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/preferences/hosting/`,
];

export type ApiServiceHostingPreferencesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceHostingPreferencesRetrieve>>
>;
export type ApiServiceHostingPreferencesRetrieveQueryError = ErrorType<unknown>;

export const useApiServiceHostingPreferencesRetrieve = <
  TData = Awaited<ReturnType<typeof apiServiceHostingPreferencesRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiServiceHostingPreferencesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiServiceHostingPreferencesRetrieveQueryKey(opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiServiceHostingPreferencesRetrieve>>
  > = ({ signal }) => apiServiceHostingPreferencesRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiServiceHostingPreferencesRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiServiceHostingPreferencesUpdate = (
  opk: string,
  hostingServicePreferences: HostingServicePreferences
) => {
  return HTTP<HostingServicePreferences>({
    url: `/api/v7/people/${opk}/preferences/hosting/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: hostingServicePreferences,
  });
};

export type ApiServiceHostingPreferencesUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceHostingPreferencesUpdate>>
>;
export type ApiServiceHostingPreferencesUpdateMutationBody = HostingServicePreferences;
export type ApiServiceHostingPreferencesUpdateMutationError = ErrorType<unknown>;

export const useApiServiceHostingPreferencesUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiServiceHostingPreferencesUpdate>>,
    TError,
    { opk: string; data: HostingServicePreferences },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiServiceHostingPreferencesUpdate>>,
    { opk: string; data: HostingServicePreferences }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiServiceHostingPreferencesUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiServiceHostingPreferencesUpdate>>,
    TError,
    { opk: string; data: HostingServicePreferences },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiServiceHostingPreferencesPartialUpdate = (
  opk: string,
  patchedHostingServicePreferences: PatchedHostingServicePreferences
) => {
  return HTTP<HostingServicePreferences>({
    url: `/api/v7/people/${opk}/preferences/hosting/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedHostingServicePreferences,
  });
};

export type ApiServiceHostingPreferencesPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceHostingPreferencesPartialUpdate>>
>;
export type ApiServiceHostingPreferencesPartialUpdateMutationBody =
  PatchedHostingServicePreferences;
export type ApiServiceHostingPreferencesPartialUpdateMutationError = ErrorType<unknown>;

export const useApiServiceHostingPreferencesPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiServiceHostingPreferencesPartialUpdate>>,
    TError,
    { opk: string; data: PatchedHostingServicePreferences },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiServiceHostingPreferencesPartialUpdate>>,
    { opk: string; data: PatchedHostingServicePreferences }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiServiceHostingPreferencesPartialUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiServiceHostingPreferencesPartialUpdate>>,
    TError,
    { opk: string; data: PatchedHostingServicePreferences },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiServiceTravelingPreferencesRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<TravelingServicePreferences>({
    url: `/api/v7/people/${opk}/preferences/traveling/`,
    method: 'get',
    signal,
  });
};

export const getApiServiceTravelingPreferencesRetrieveQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/preferences/traveling/`,
];

export type ApiServiceTravelingPreferencesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceTravelingPreferencesRetrieve>>
>;
export type ApiServiceTravelingPreferencesRetrieveQueryError = ErrorType<unknown>;

export const useApiServiceTravelingPreferencesRetrieve = <
  TData = Awaited<ReturnType<typeof apiServiceTravelingPreferencesRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiServiceTravelingPreferencesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiServiceTravelingPreferencesRetrieveQueryKey(opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiServiceTravelingPreferencesRetrieve>>
  > = ({ signal }) => apiServiceTravelingPreferencesRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiServiceTravelingPreferencesRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiServiceTravelingPreferencesUpdate = (
  opk: string,
  travelingServicePreferences: TravelingServicePreferences
) => {
  return HTTP<TravelingServicePreferences>({
    url: `/api/v7/people/${opk}/preferences/traveling/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: travelingServicePreferences,
  });
};

export type ApiServiceTravelingPreferencesUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceTravelingPreferencesUpdate>>
>;
export type ApiServiceTravelingPreferencesUpdateMutationBody = TravelingServicePreferences;
export type ApiServiceTravelingPreferencesUpdateMutationError = ErrorType<unknown>;

export const useApiServiceTravelingPreferencesUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiServiceTravelingPreferencesUpdate>>,
    TError,
    { opk: string; data: TravelingServicePreferences },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiServiceTravelingPreferencesUpdate>>,
    { opk: string; data: TravelingServicePreferences }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiServiceTravelingPreferencesUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiServiceTravelingPreferencesUpdate>>,
    TError,
    { opk: string; data: TravelingServicePreferences },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiServiceTravelingPreferencesPartialUpdate = (
  opk: string,
  patchedTravelingServicePreferences: PatchedTravelingServicePreferences
) => {
  return HTTP<TravelingServicePreferences>({
    url: `/api/v7/people/${opk}/preferences/traveling/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedTravelingServicePreferences,
  });
};

export type ApiServiceTravelingPreferencesPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceTravelingPreferencesPartialUpdate>>
>;
export type ApiServiceTravelingPreferencesPartialUpdateMutationBody =
  PatchedTravelingServicePreferences;
export type ApiServiceTravelingPreferencesPartialUpdateMutationError = ErrorType<unknown>;

export const useApiServiceTravelingPreferencesPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiServiceTravelingPreferencesPartialUpdate>>,
    TError,
    { opk: string; data: PatchedTravelingServicePreferences },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiServiceTravelingPreferencesPartialUpdate>>,
    { opk: string; data: PatchedTravelingServicePreferences }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiServiceTravelingPreferencesPartialUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiServiceTravelingPreferencesPartialUpdate>>,
    TError,
    { opk: string; data: PatchedTravelingServicePreferences },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonDetailPrivateDataRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<PersonPrivateData>({ url: `/api/v7/people/${opk}/private/`, method: 'get', signal });
};

export const getApiPersonDetailPrivateDataRetrieveQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/private/`,
];

export type ApiPersonDetailPrivateDataRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDetailPrivateDataRetrieve>>
>;
export type ApiPersonDetailPrivateDataRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonDetailPrivateDataRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonDetailPrivateDataRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonDetailPrivateDataRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonDetailPrivateDataRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonDetailPrivateDataRetrieve>>> = ({
    signal,
  }) => apiPersonDetailPrivateDataRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPersonDetailPrivateDataRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonDetailPrivateDataUpdate = (
  opk: string,
  personPrivateData: PersonPrivateData
) => {
  return HTTP<PersonPrivateData>({
    url: `/api/v7/people/${opk}/private/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: personPrivateData,
  });
};

export type ApiPersonDetailPrivateDataUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDetailPrivateDataUpdate>>
>;
export type ApiPersonDetailPrivateDataUpdateMutationBody = PersonPrivateData;
export type ApiPersonDetailPrivateDataUpdateMutationError = ErrorType<unknown>;

export const useApiPersonDetailPrivateDataUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonDetailPrivateDataUpdate>>,
    TError,
    { opk: string; data: PersonPrivateData },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonDetailPrivateDataUpdate>>,
    { opk: string; data: PersonPrivateData }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPersonDetailPrivateDataUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonDetailPrivateDataUpdate>>,
    TError,
    { opk: string; data: PersonPrivateData },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonDetailPrivateDataPartialUpdate = (
  opk: string,
  patchedPersonPrivateData: PatchedPersonPrivateData
) => {
  return HTTP<PersonPrivateData>({
    url: `/api/v7/people/${opk}/private/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedPersonPrivateData,
  });
};

export type ApiPersonDetailPrivateDataPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDetailPrivateDataPartialUpdate>>
>;
export type ApiPersonDetailPrivateDataPartialUpdateMutationBody = PatchedPersonPrivateData;
export type ApiPersonDetailPrivateDataPartialUpdateMutationError = ErrorType<unknown>;

export const useApiPersonDetailPrivateDataPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonDetailPrivateDataPartialUpdate>>,
    TError,
    { opk: string; data: PatchedPersonPrivateData },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonDetailPrivateDataPartialUpdate>>,
    { opk: string; data: PatchedPersonPrivateData }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPersonDetailPrivateDataPartialUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonDetailPrivateDataPartialUpdate>>,
    TError,
    { opk: string; data: PatchedPersonPrivateData },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiDogbuddyMigrationStatusRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<DogbuddyMigrationStatus>({
    url: `/api/v7/people/${opk}/private/migration-status/`,
    method: 'get',
    signal,
  });
};

export const getApiDogbuddyMigrationStatusRetrieveQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/private/migration-status/`,
];

export type ApiDogbuddyMigrationStatusRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiDogbuddyMigrationStatusRetrieve>>
>;
export type ApiDogbuddyMigrationStatusRetrieveQueryError = ErrorType<unknown>;

export const useApiDogbuddyMigrationStatusRetrieve = <
  TData = Awaited<ReturnType<typeof apiDogbuddyMigrationStatusRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiDogbuddyMigrationStatusRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiDogbuddyMigrationStatusRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDogbuddyMigrationStatusRetrieve>>> = ({
    signal,
  }) => apiDogbuddyMigrationStatusRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiDogbuddyMigrationStatusRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiDogbuddyMigrationStatusUpdate = (
  opk: string,
  dogbuddyMigrationStatus: DogbuddyMigrationStatus
) => {
  return HTTP<DogbuddyMigrationStatus>({
    url: `/api/v7/people/${opk}/private/migration-status/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: dogbuddyMigrationStatus,
  });
};

export type ApiDogbuddyMigrationStatusUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiDogbuddyMigrationStatusUpdate>>
>;
export type ApiDogbuddyMigrationStatusUpdateMutationBody = DogbuddyMigrationStatus;
export type ApiDogbuddyMigrationStatusUpdateMutationError = ErrorType<unknown>;

export const useApiDogbuddyMigrationStatusUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDogbuddyMigrationStatusUpdate>>,
    TError,
    { opk: string; data: DogbuddyMigrationStatus },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiDogbuddyMigrationStatusUpdate>>,
    { opk: string; data: DogbuddyMigrationStatus }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiDogbuddyMigrationStatusUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiDogbuddyMigrationStatusUpdate>>,
    TError,
    { opk: string; data: DogbuddyMigrationStatus },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiDogbuddyMigrationStatusPartialUpdate = (
  opk: string,
  patchedDogbuddyMigrationStatus: PatchedDogbuddyMigrationStatus
) => {
  return HTTP<DogbuddyMigrationStatus>({
    url: `/api/v7/people/${opk}/private/migration-status/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedDogbuddyMigrationStatus,
  });
};

export type ApiDogbuddyMigrationStatusPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiDogbuddyMigrationStatusPartialUpdate>>
>;
export type ApiDogbuddyMigrationStatusPartialUpdateMutationBody = PatchedDogbuddyMigrationStatus;
export type ApiDogbuddyMigrationStatusPartialUpdateMutationError = ErrorType<unknown>;

export const useApiDogbuddyMigrationStatusPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiDogbuddyMigrationStatusPartialUpdate>>,
    TError,
    { opk: string; data: PatchedDogbuddyMigrationStatus },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiDogbuddyMigrationStatusPartialUpdate>>,
    { opk: string; data: PatchedDogbuddyMigrationStatus }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiDogbuddyMigrationStatusPartialUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiDogbuddyMigrationStatusPartialUpdate>>,
    TError,
    { opk: string; data: PatchedDogbuddyMigrationStatus },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonDetailPromotionAndReferralUrlsRetrieve = (
  opk: string,
  signal?: AbortSignal
) => {
  return HTTP<PersonPromotionAndReferral>({
    url: `/api/v7/people/${opk}/promotion-and-referral-urls/`,
    method: 'get',
    signal,
  });
};

export const getApiPersonDetailPromotionAndReferralUrlsRetrieveQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/promotion-and-referral-urls/`,
];

export type ApiPersonDetailPromotionAndReferralUrlsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDetailPromotionAndReferralUrlsRetrieve>>
>;
export type ApiPersonDetailPromotionAndReferralUrlsRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonDetailPromotionAndReferralUrlsRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonDetailPromotionAndReferralUrlsRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonDetailPromotionAndReferralUrlsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiPersonDetailPromotionAndReferralUrlsRetrieveQueryKey(opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiPersonDetailPromotionAndReferralUrlsRetrieve>>
  > = ({ signal }) => apiPersonDetailPromotionAndReferralUrlsRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPersonDetailPromotionAndReferralUrlsRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonPublicCalendarRetrieve = (
  opk: string,
  params?: ApiPersonPublicCalendarRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<PersonCalendar>({
    url: `/api/v7/people/${opk}/public-calendar/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPersonPublicCalendarRetrieveQueryKey = (
  opk: string,
  params?: ApiPersonPublicCalendarRetrieveParams
) => [`/api/v7/people/${opk}/public-calendar/`, ...(params ? [params] : [])];

export type ApiPersonPublicCalendarRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonPublicCalendarRetrieve>>
>;
export type ApiPersonPublicCalendarRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonPublicCalendarRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonPublicCalendarRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPersonPublicCalendarRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonPublicCalendarRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiPersonPublicCalendarRetrieveQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonPublicCalendarRetrieve>>> = ({
    signal,
  }) => apiPersonPublicCalendarRetrieve(opk, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPersonPublicCalendarRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonDetailReferralUrlRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<PersonReferralUrl>({
    url: `/api/v7/people/${opk}/referral-url/`,
    method: 'get',
    signal,
  });
};

export const getApiPersonDetailReferralUrlRetrieveQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/referral-url/`,
];

export type ApiPersonDetailReferralUrlRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDetailReferralUrlRetrieve>>
>;
export type ApiPersonDetailReferralUrlRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonDetailReferralUrlRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonDetailReferralUrlRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonDetailReferralUrlRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonDetailReferralUrlRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonDetailReferralUrlRetrieve>>> = ({
    signal,
  }) => apiPersonDetailReferralUrlRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPersonDetailReferralUrlRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiPersonRelatedProvidersList = (
  opk: string,
  params?: ApiPersonRelatedProvidersListParams,
  signal?: AbortSignal
) => {
  return HTTP<RelatedProviders[]>({
    url: `/api/v7/people/${opk}/related-providers/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPersonRelatedProvidersListQueryKey = (
  opk: string,
  params?: ApiPersonRelatedProvidersListParams
) => [`/api/v7/people/${opk}/related-providers/`, ...(params ? [params] : [])];

export type ApiPersonRelatedProvidersListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonRelatedProvidersList>>
>;
export type ApiPersonRelatedProvidersListQueryError = ErrorType<unknown>;

export const useApiPersonRelatedProvidersList = <
  TData = Awaited<ReturnType<typeof apiPersonRelatedProvidersList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPersonRelatedProvidersListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonRelatedProvidersList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonRelatedProvidersListQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonRelatedProvidersList>>> = ({
    signal,
  }) => apiPersonRelatedProvidersList(opk, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPersonRelatedProvidersList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonDetailReviewsList = (
  opk: string,
  params?: ApiPersonDetailReviewsListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedReviewDispatchList>({
    url: `/api/v7/people/${opk}/reviews/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPersonDetailReviewsListQueryKey = (
  opk: string,
  params?: ApiPersonDetailReviewsListParams
) => [`/api/v7/people/${opk}/reviews/`, ...(params ? [params] : [])];

export type ApiPersonDetailReviewsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDetailReviewsList>>
>;
export type ApiPersonDetailReviewsListQueryError = ErrorType<unknown>;

export const useApiPersonDetailReviewsList = <
  TData = Awaited<ReturnType<typeof apiPersonDetailReviewsList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPersonDetailReviewsListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiPersonDetailReviewsList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonDetailReviewsListQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonDetailReviewsList>>> = ({
    signal,
  }) => apiPersonDetailReviewsList(opk, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPersonDetailReviewsList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonDetailServicesList = (opk: string, signal?: AbortSignal) => {
  return HTTP<Service[]>({ url: `/api/v7/people/${opk}/services/`, method: 'get', signal });
};

export const getApiPersonDetailServicesListQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/services/`,
];

export type ApiPersonDetailServicesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDetailServicesList>>
>;
export type ApiPersonDetailServicesListQueryError = ErrorType<unknown>;

export const useApiPersonDetailServicesList = <
  TData = Awaited<ReturnType<typeof apiPersonDetailServicesList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiPersonDetailServicesList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonDetailServicesListQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonDetailServicesList>>> = ({
    signal,
  }) => apiPersonDetailServicesList(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPersonDetailServicesList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonDetailServicesCreate = (opk: string, service: Service) => {
  return HTTP<Service>({
    url: `/api/v7/people/${opk}/services/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: service,
  });
};

export type ApiPersonDetailServicesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDetailServicesCreate>>
>;
export type ApiPersonDetailServicesCreateMutationBody = Service;
export type ApiPersonDetailServicesCreateMutationError = ErrorType<unknown>;

export const useApiPersonDetailServicesCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonDetailServicesCreate>>,
    TError,
    { opk: string; data: Service },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonDetailServicesCreate>>,
    { opk: string; data: Service }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPersonDetailServicesCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonDetailServicesCreate>>,
    TError,
    { opk: string; data: Service },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiServiceDetailRetrieve = (
  opk: string,
  serviceSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<Service>({
    url: `/api/v7/people/${opk}/services/${serviceSlug}/`,
    method: 'get',
    signal,
  });
};

export const getApiServiceDetailRetrieveQueryKey = (opk: string, serviceSlug: string) => [
  `/api/v7/people/${opk}/services/${serviceSlug}/`,
];

export type ApiServiceDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceDetailRetrieve>>
>;
export type ApiServiceDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiServiceDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiServiceDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  serviceSlug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiServiceDetailRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiServiceDetailRetrieveQueryKey(opk, serviceSlug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiServiceDetailRetrieve>>> = ({
    signal,
  }) => apiServiceDetailRetrieve(opk, serviceSlug, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiServiceDetailRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!(opk && serviceSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiServiceDetailUpdate = (opk: string, serviceSlug: string, service: Service) => {
  return HTTP<Service>({
    url: `/api/v7/people/${opk}/services/${serviceSlug}/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: service,
  });
};

export type ApiServiceDetailUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceDetailUpdate>>
>;
export type ApiServiceDetailUpdateMutationBody = Service;
export type ApiServiceDetailUpdateMutationError = ErrorType<unknown>;

export const useApiServiceDetailUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiServiceDetailUpdate>>,
    TError,
    { opk: string; serviceSlug: string; data: Service },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiServiceDetailUpdate>>,
    { opk: string; serviceSlug: string; data: Service }
  > = (props) => {
    const { opk, serviceSlug, data } = props ?? {};

    return apiServiceDetailUpdate(opk, serviceSlug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiServiceDetailUpdate>>,
    TError,
    { opk: string; serviceSlug: string; data: Service },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiServiceDetailPartialUpdate = (
  opk: string,
  serviceSlug: string,
  patchedService: PatchedService
) => {
  return HTTP<Service>({
    url: `/api/v7/people/${opk}/services/${serviceSlug}/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedService,
  });
};

export type ApiServiceDetailPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceDetailPartialUpdate>>
>;
export type ApiServiceDetailPartialUpdateMutationBody = PatchedService;
export type ApiServiceDetailPartialUpdateMutationError = ErrorType<unknown>;

export const useApiServiceDetailPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiServiceDetailPartialUpdate>>,
    TError,
    { opk: string; serviceSlug: string; data: PatchedService },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiServiceDetailPartialUpdate>>,
    { opk: string; serviceSlug: string; data: PatchedService }
  > = (props) => {
    const { opk, serviceSlug, data } = props ?? {};

    return apiServiceDetailPartialUpdate(opk, serviceSlug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiServiceDetailPartialUpdate>>,
    TError,
    { opk: string; serviceSlug: string; data: PatchedService },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiServiceDetailCalendarRetrieve = (
  opk: string,
  serviceSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<ApiServiceDetailCalendarRetrieve200>({
    url: `/api/v7/people/${opk}/services/${serviceSlug}/calendar/`,
    method: 'get',
    signal,
  });
};

export const getApiServiceDetailCalendarRetrieveQueryKey = (opk: string, serviceSlug: string) => [
  `/api/v7/people/${opk}/services/${serviceSlug}/calendar/`,
];

export type ApiServiceDetailCalendarRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceDetailCalendarRetrieve>>
>;
export type ApiServiceDetailCalendarRetrieveQueryError = ErrorType<unknown>;

export const useApiServiceDetailCalendarRetrieve = <
  TData = Awaited<ReturnType<typeof apiServiceDetailCalendarRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  serviceSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiServiceDetailCalendarRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiServiceDetailCalendarRetrieveQueryKey(opk, serviceSlug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiServiceDetailCalendarRetrieve>>> = ({
    signal,
  }) => apiServiceDetailCalendarRetrieve(opk, serviceSlug, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiServiceDetailCalendarRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(opk && serviceSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiServiceDetailCalendarCreate = (
  opk: string,
  serviceSlug: string,
  apiServiceDetailCalendarCreateBody: ApiServiceDetailCalendarCreateBody
) => {
  return HTTP<void>({
    url: `/api/v7/people/${opk}/services/${serviceSlug}/calendar/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiServiceDetailCalendarCreateBody,
  });
};

export type ApiServiceDetailCalendarCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceDetailCalendarCreate>>
>;
export type ApiServiceDetailCalendarCreateMutationBody = ApiServiceDetailCalendarCreateBody;
export type ApiServiceDetailCalendarCreateMutationError = ErrorType<unknown>;

export const useApiServiceDetailCalendarCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiServiceDetailCalendarCreate>>,
    TError,
    { opk: string; serviceSlug: string; data: ApiServiceDetailCalendarCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiServiceDetailCalendarCreate>>,
    { opk: string; serviceSlug: string; data: ApiServiceDetailCalendarCreateBody }
  > = (props) => {
    const { opk, serviceSlug, data } = props ?? {};

    return apiServiceDetailCalendarCreate(opk, serviceSlug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiServiceDetailCalendarCreate>>,
    TError,
    { opk: string; serviceSlug: string; data: ApiServiceDetailCalendarCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiServiceDetailCalendarSettingsRetrieve = (
  opk: string,
  serviceSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<ServiceCalendarSettings>({
    url: `/api/v7/people/${opk}/services/${serviceSlug}/calendar/settings/`,
    method: 'get',
    signal,
  });
};

export const getApiServiceDetailCalendarSettingsRetrieveQueryKey = (
  opk: string,
  serviceSlug: string
) => [`/api/v7/people/${opk}/services/${serviceSlug}/calendar/settings/`];

export type ApiServiceDetailCalendarSettingsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceDetailCalendarSettingsRetrieve>>
>;
export type ApiServiceDetailCalendarSettingsRetrieveQueryError = ErrorType<unknown>;

export const useApiServiceDetailCalendarSettingsRetrieve = <
  TData = Awaited<ReturnType<typeof apiServiceDetailCalendarSettingsRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  serviceSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiServiceDetailCalendarSettingsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiServiceDetailCalendarSettingsRetrieveQueryKey(opk, serviceSlug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiServiceDetailCalendarSettingsRetrieve>>
  > = ({ signal }) => apiServiceDetailCalendarSettingsRetrieve(opk, serviceSlug, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiServiceDetailCalendarSettingsRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(opk && serviceSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiServiceDetailCalendarSettingsUpdate = (
  opk: string,
  serviceSlug: string,
  serviceCalendarSettings: ServiceCalendarSettings
) => {
  return HTTP<ServiceCalendarSettings>({
    url: `/api/v7/people/${opk}/services/${serviceSlug}/calendar/settings/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: serviceCalendarSettings,
  });
};

export type ApiServiceDetailCalendarSettingsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceDetailCalendarSettingsUpdate>>
>;
export type ApiServiceDetailCalendarSettingsUpdateMutationBody = ServiceCalendarSettings;
export type ApiServiceDetailCalendarSettingsUpdateMutationError = ErrorType<unknown>;

export const useApiServiceDetailCalendarSettingsUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiServiceDetailCalendarSettingsUpdate>>,
    TError,
    { opk: string; serviceSlug: string; data: ServiceCalendarSettings },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiServiceDetailCalendarSettingsUpdate>>,
    { opk: string; serviceSlug: string; data: ServiceCalendarSettings }
  > = (props) => {
    const { opk, serviceSlug, data } = props ?? {};

    return apiServiceDetailCalendarSettingsUpdate(opk, serviceSlug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiServiceDetailCalendarSettingsUpdate>>,
    TError,
    { opk: string; serviceSlug: string; data: ServiceCalendarSettings },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiServiceDetailCalendarSettingsPartialUpdate = (
  opk: string,
  serviceSlug: string,
  patchedServiceCalendarSettings: PatchedServiceCalendarSettings
) => {
  return HTTP<ServiceCalendarSettings>({
    url: `/api/v7/people/${opk}/services/${serviceSlug}/calendar/settings/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedServiceCalendarSettings,
  });
};

export type ApiServiceDetailCalendarSettingsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceDetailCalendarSettingsPartialUpdate>>
>;
export type ApiServiceDetailCalendarSettingsPartialUpdateMutationBody =
  PatchedServiceCalendarSettings;
export type ApiServiceDetailCalendarSettingsPartialUpdateMutationError = ErrorType<unknown>;

export const useApiServiceDetailCalendarSettingsPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiServiceDetailCalendarSettingsPartialUpdate>>,
    TError,
    { opk: string; serviceSlug: string; data: PatchedServiceCalendarSettings },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiServiceDetailCalendarSettingsPartialUpdate>>,
    { opk: string; serviceSlug: string; data: PatchedServiceCalendarSettings }
  > = (props) => {
    const { opk, serviceSlug, data } = props ?? {};

    return apiServiceDetailCalendarSettingsPartialUpdate(opk, serviceSlug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiServiceDetailCalendarSettingsPartialUpdate>>,
    TError,
    { opk: string; serviceSlug: string; data: PatchedServiceCalendarSettings },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiServiceContactabilityCreate = (
  opk: string,
  serviceSlug: string,
  serviceContactability: ServiceContactability
) => {
  return HTTP<ApiServiceContactabilityCreate200>({
    url: `/api/v7/people/${opk}/services/${serviceSlug}/contactability/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: serviceContactability,
  });
};

export type ApiServiceContactabilityCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceContactabilityCreate>>
>;
export type ApiServiceContactabilityCreateMutationBody = ServiceContactability;
export type ApiServiceContactabilityCreateMutationError = ErrorType<unknown>;

export const useApiServiceContactabilityCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiServiceContactabilityCreate>>,
    TError,
    { opk: string; serviceSlug: string; data: ServiceContactability },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiServiceContactabilityCreate>>,
    { opk: string; serviceSlug: string; data: ServiceContactability }
  > = (props) => {
    const { opk, serviceSlug, data } = props ?? {};

    return apiServiceContactabilityCreate(opk, serviceSlug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiServiceContactabilityCreate>>,
    TError,
    { opk: string; serviceSlug: string; data: ServiceContactability },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Checks whether the service specified in the URL uses the holiday rates in the date range
specified by the start_date and end_date parameters.
 */
export const apiServiceHolidayRateCheckRetrieve = (
  opk: string,
  serviceSlug: string,
  params?: ApiServiceHolidayRateCheckRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<HolidayRateResponse>({
    url: `/api/v7/people/${opk}/services/${serviceSlug}/holiday-rate-check/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiServiceHolidayRateCheckRetrieveQueryKey = (
  opk: string,
  serviceSlug: string,
  params?: ApiServiceHolidayRateCheckRetrieveParams
) => [
  `/api/v7/people/${opk}/services/${serviceSlug}/holiday-rate-check/`,
  ...(params ? [params] : []),
];

export type ApiServiceHolidayRateCheckRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceHolidayRateCheckRetrieve>>
>;
export type ApiServiceHolidayRateCheckRetrieveQueryError = ErrorType<unknown>;

export const useApiServiceHolidayRateCheckRetrieve = <
  TData = Awaited<ReturnType<typeof apiServiceHolidayRateCheckRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  serviceSlug: string,
  params?: ApiServiceHolidayRateCheckRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiServiceHolidayRateCheckRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiServiceHolidayRateCheckRetrieveQueryKey(opk, serviceSlug, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiServiceHolidayRateCheckRetrieve>>> = ({
    signal,
  }) => apiServiceHolidayRateCheckRetrieve(opk, serviceSlug, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiServiceHolidayRateCheckRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(opk && serviceSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiRelatedServicesList = (
  opk: string,
  serviceSlug: string,
  params?: ApiRelatedServicesListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedServiceList>({
    url: `/api/v7/people/${opk}/services/${serviceSlug}/related/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiRelatedServicesListQueryKey = (
  opk: string,
  serviceSlug: string,
  params?: ApiRelatedServicesListParams
) => [`/api/v7/people/${opk}/services/${serviceSlug}/related/`, ...(params ? [params] : [])];

export type ApiRelatedServicesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiRelatedServicesList>>
>;
export type ApiRelatedServicesListQueryError = ErrorType<unknown>;

export const useApiRelatedServicesList = <
  TData = Awaited<ReturnType<typeof apiRelatedServicesList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  serviceSlug: string,
  params?: ApiRelatedServicesListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiRelatedServicesList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiRelatedServicesListQueryKey(opk, serviceSlug, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiRelatedServicesList>>> = ({ signal }) =>
    apiRelatedServicesList(opk, serviceSlug, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiRelatedServicesList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!(opk && serviceSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiPersonSitterProfileRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<PersonSitterProfile>({
    url: `/api/v7/people/${opk}/sitter-profile/`,
    method: 'get',
    signal,
  });
};

export const getApiPersonSitterProfileRetrieveQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/sitter-profile/`,
];

export type ApiPersonSitterProfileRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonSitterProfileRetrieve>>
>;
export type ApiPersonSitterProfileRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonSitterProfileRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonSitterProfileRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonSitterProfileRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonSitterProfileRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonSitterProfileRetrieve>>> = ({
    signal,
  }) => apiPersonSitterProfileRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPersonSitterProfileRetrieve>>, TError, TData>(
    {
      queryKey,
      queryFn,
      enabled: !!opk,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      ...queryOptions,
    }
  ) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonDetailStayMediaList = (
  opk: string,
  params?: ApiPersonDetailStayMediaListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedMediaList>({
    url: `/api/v7/people/${opk}/stay-media/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPersonDetailStayMediaListQueryKey = (
  opk: string,
  params?: ApiPersonDetailStayMediaListParams
) => [`/api/v7/people/${opk}/stay-media/`, ...(params ? [params] : [])];

export type ApiPersonDetailStayMediaListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDetailStayMediaList>>
>;
export type ApiPersonDetailStayMediaListQueryError = ErrorType<unknown>;

export const useApiPersonDetailStayMediaList = <
  TData = Awaited<ReturnType<typeof apiPersonDetailStayMediaList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPersonDetailStayMediaListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonDetailStayMediaList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonDetailStayMediaListQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonDetailStayMediaList>>> = ({
    signal,
  }) => apiPersonDetailStayMediaList(opk, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPersonDetailStayMediaList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiPersonDetailSummaryRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<PersonSummaryDetail>({
    url: `/api/v7/people/${opk}/summary/`,
    method: 'get',
    signal,
  });
};

export const getApiPersonDetailSummaryRetrieveQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/summary/`,
];

export type ApiPersonDetailSummaryRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDetailSummaryRetrieve>>
>;
export type ApiPersonDetailSummaryRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonDetailSummaryRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonDetailSummaryRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonDetailSummaryRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonDetailSummaryRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonDetailSummaryRetrieve>>> = ({
    signal,
  }) => apiPersonDetailSummaryRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPersonDetailSummaryRetrieve>>, TError, TData>(
    {
      queryKey,
      queryFn,
      enabled: !!opk,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      ...queryOptions,
    }
  ) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list/create views.
 */
export const apiPersonDetailVideosList = (
  opk: string,
  params?: ApiPersonDetailVideosListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedVideoList>({
    url: `/api/v7/people/${opk}/videos/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPersonDetailVideosListQueryKey = (
  opk: string,
  params?: ApiPersonDetailVideosListParams
) => [`/api/v7/people/${opk}/videos/`, ...(params ? [params] : [])];

export type ApiPersonDetailVideosListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDetailVideosList>>
>;
export type ApiPersonDetailVideosListQueryError = ErrorType<unknown>;

export const useApiPersonDetailVideosList = <
  TData = Awaited<ReturnType<typeof apiPersonDetailVideosList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPersonDetailVideosListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiPersonDetailVideosList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonDetailVideosListQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonDetailVideosList>>> = ({
    signal,
  }) => apiPersonDetailVideosList(opk, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPersonDetailVideosList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list/create views.
 */
export const apiPersonDetailVideosCreate = (opk: string, video: Video) => {
  return HTTP<Video>({
    url: `/api/v7/people/${opk}/videos/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: video,
  });
};

export type ApiPersonDetailVideosCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDetailVideosCreate>>
>;
export type ApiPersonDetailVideosCreateMutationBody = Video;
export type ApiPersonDetailVideosCreateMutationError = ErrorType<unknown>;

export const useApiPersonDetailVideosCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonDetailVideosCreate>>,
    TError,
    { opk: string; data: Video },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonDetailVideosCreate>>,
    { opk: string; data: Video }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPersonDetailVideosCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonDetailVideosCreate>>,
    TError,
    { opk: string; data: Video },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * This is ugly but necessary to support both list and detail views for
the per-type filtered payment method endpoints.
 */
export const apiPaymentMethodList = (
  opk: string,
  params?: ApiPaymentMethodListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaymentDispatch[]>({
    url: `/api/v7/people/${opk}/wallet/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPaymentMethodListQueryKey = (
  opk: string,
  params?: ApiPaymentMethodListParams
) => [`/api/v7/people/${opk}/wallet/`, ...(params ? [params] : [])];

export type ApiPaymentMethodListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodList>>
>;
export type ApiPaymentMethodListQueryError = ErrorType<unknown>;

export const useApiPaymentMethodList = <
  TData = Awaited<ReturnType<typeof apiPaymentMethodList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPaymentMethodListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiPaymentMethodList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPaymentMethodListQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPaymentMethodList>>> = ({ signal }) =>
    apiPaymentMethodList(opk, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPaymentMethodList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * This is ugly but necessary to support both list and detail views for
the per-type filtered payment method endpoints.
 */
export const apiPaymentMethodCreditcardList = (
  opk: string,
  params?: ApiPaymentMethodCreditcardListParams,
  signal?: AbortSignal
) => {
  return HTTP<CreditCardMethodSerializerListOrObject>({
    url: `/api/v7/people/${opk}/wallet/creditcard/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPaymentMethodCreditcardListQueryKey = (
  opk: string,
  params?: ApiPaymentMethodCreditcardListParams
) => [`/api/v7/people/${opk}/wallet/creditcard/`, ...(params ? [params] : [])];

export type ApiPaymentMethodCreditcardListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodCreditcardList>>
>;
export type ApiPaymentMethodCreditcardListQueryError = ErrorType<unknown>;

export const useApiPaymentMethodCreditcardList = <
  TData = Awaited<ReturnType<typeof apiPaymentMethodCreditcardList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPaymentMethodCreditcardListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPaymentMethodCreditcardList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPaymentMethodCreditcardListQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPaymentMethodCreditcardList>>> = ({
    signal,
  }) => apiPaymentMethodCreditcardList(opk, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPaymentMethodCreditcardList>>, TError, TData>(
    {
      queryKey,
      queryFn,
      enabled: !!opk,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      ...queryOptions,
    }
  ) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPaymentMethodCreditcardCreate = (
  opk: string,
  createCreditCardMethod: CreateCreditCardMethod
) => {
  return HTTP<ApiPaymentMethodCreditcardCreate200 | ApiPaymentMethodCreditcardCreate201>({
    url: `/api/v7/people/${opk}/wallet/creditcard/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: createCreditCardMethod,
  });
};

export type ApiPaymentMethodCreditcardCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodCreditcardCreate>>
>;
export type ApiPaymentMethodCreditcardCreateMutationBody = CreateCreditCardMethod;
export type ApiPaymentMethodCreditcardCreateMutationError = ErrorType<unknown>;

export const useApiPaymentMethodCreditcardCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPaymentMethodCreditcardCreate>>,
    TError,
    { opk: string; data: CreateCreditCardMethod },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPaymentMethodCreditcardCreate>>,
    { opk: string; data: CreateCreditCardMethod }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPaymentMethodCreditcardCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPaymentMethodCreditcardCreate>>,
    TError,
    { opk: string; data: CreateCreditCardMethod },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPaymentMethodCreditcardPartialUpdate = (
  opk: string,
  patchedUpdateCreditCardMethod: PatchedUpdateCreditCardMethod
) => {
  return HTTP<void>({
    url: `/api/v7/people/${opk}/wallet/creditcard/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedUpdateCreditCardMethod,
  });
};

export type ApiPaymentMethodCreditcardPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodCreditcardPartialUpdate>>
>;
export type ApiPaymentMethodCreditcardPartialUpdateMutationBody = PatchedUpdateCreditCardMethod;
export type ApiPaymentMethodCreditcardPartialUpdateMutationError = ErrorType<unknown>;

export const useApiPaymentMethodCreditcardPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPaymentMethodCreditcardPartialUpdate>>,
    TError,
    { opk: string; data: PatchedUpdateCreditCardMethod },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPaymentMethodCreditcardPartialUpdate>>,
    { opk: string; data: PatchedUpdateCreditCardMethod }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPaymentMethodCreditcardPartialUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPaymentMethodCreditcardPartialUpdate>>,
    TError,
    { opk: string; data: PatchedUpdateCreditCardMethod },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPaymentMethodCreditcardDestroy = (opk: string) => {
  return HTTP<void>({ url: `/api/v7/people/${opk}/wallet/creditcard/`, method: 'delete' });
};

export type ApiPaymentMethodCreditcardDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodCreditcardDestroy>>
>;

export type ApiPaymentMethodCreditcardDestroyMutationError = ErrorType<unknown>;

export const useApiPaymentMethodCreditcardDestroy = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPaymentMethodCreditcardDestroy>>,
    TError,
    { opk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPaymentMethodCreditcardDestroy>>,
    { opk: string }
  > = (props) => {
    const { opk } = props ?? {};

    return apiPaymentMethodCreditcardDestroy(opk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPaymentMethodCreditcardDestroy>>,
    TError,
    { opk: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * This is ugly but necessary to support both list and detail views for
the per-type filtered payment method endpoints.
 */
export const apiPaymentMethodDetailCreditcardList = (
  opk: string,
  methodOpk: string,
  params?: ApiPaymentMethodDetailCreditcardListParams,
  signal?: AbortSignal
) => {
  return HTTP<CreditCardMethodSerializerListOrObject>({
    url: `/api/v7/people/${opk}/wallet/creditcard/${methodOpk}/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPaymentMethodDetailCreditcardListQueryKey = (
  opk: string,
  methodOpk: string,
  params?: ApiPaymentMethodDetailCreditcardListParams
) => [`/api/v7/people/${opk}/wallet/creditcard/${methodOpk}/`, ...(params ? [params] : [])];

export type ApiPaymentMethodDetailCreditcardListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodDetailCreditcardList>>
>;
export type ApiPaymentMethodDetailCreditcardListQueryError = ErrorType<unknown>;

export const useApiPaymentMethodDetailCreditcardList = <
  TData = Awaited<ReturnType<typeof apiPaymentMethodDetailCreditcardList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  methodOpk: string,
  params?: ApiPaymentMethodDetailCreditcardListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPaymentMethodDetailCreditcardList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiPaymentMethodDetailCreditcardListQueryKey(opk, methodOpk, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiPaymentMethodDetailCreditcardList>>
  > = ({ signal }) => apiPaymentMethodDetailCreditcardList(opk, methodOpk, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPaymentMethodDetailCreditcardList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(opk && methodOpk),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPaymentMethodDetailCreditcardCreate = (
  opk: string,
  methodOpk: string,
  createCreditCardMethod: CreateCreditCardMethod
) => {
  return HTTP<
    ApiPaymentMethodDetailCreditcardCreate200 | ApiPaymentMethodDetailCreditcardCreate201
  >({
    url: `/api/v7/people/${opk}/wallet/creditcard/${methodOpk}/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: createCreditCardMethod,
  });
};

export type ApiPaymentMethodDetailCreditcardCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodDetailCreditcardCreate>>
>;
export type ApiPaymentMethodDetailCreditcardCreateMutationBody = CreateCreditCardMethod;
export type ApiPaymentMethodDetailCreditcardCreateMutationError = ErrorType<unknown>;

export const useApiPaymentMethodDetailCreditcardCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPaymentMethodDetailCreditcardCreate>>,
    TError,
    { opk: string; methodOpk: string; data: CreateCreditCardMethod },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPaymentMethodDetailCreditcardCreate>>,
    { opk: string; methodOpk: string; data: CreateCreditCardMethod }
  > = (props) => {
    const { opk, methodOpk, data } = props ?? {};

    return apiPaymentMethodDetailCreditcardCreate(opk, methodOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPaymentMethodDetailCreditcardCreate>>,
    TError,
    { opk: string; methodOpk: string; data: CreateCreditCardMethod },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPaymentMethodDetailCreditcardPartialUpdate = (
  opk: string,
  methodOpk: string,
  patchedUpdateCreditCardMethod: PatchedUpdateCreditCardMethod
) => {
  return HTTP<void>({
    url: `/api/v7/people/${opk}/wallet/creditcard/${methodOpk}/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedUpdateCreditCardMethod,
  });
};

export type ApiPaymentMethodDetailCreditcardPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodDetailCreditcardPartialUpdate>>
>;
export type ApiPaymentMethodDetailCreditcardPartialUpdateMutationBody =
  PatchedUpdateCreditCardMethod;
export type ApiPaymentMethodDetailCreditcardPartialUpdateMutationError = ErrorType<unknown>;

export const useApiPaymentMethodDetailCreditcardPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPaymentMethodDetailCreditcardPartialUpdate>>,
    TError,
    { opk: string; methodOpk: string; data: PatchedUpdateCreditCardMethod },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPaymentMethodDetailCreditcardPartialUpdate>>,
    { opk: string; methodOpk: string; data: PatchedUpdateCreditCardMethod }
  > = (props) => {
    const { opk, methodOpk, data } = props ?? {};

    return apiPaymentMethodDetailCreditcardPartialUpdate(opk, methodOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPaymentMethodDetailCreditcardPartialUpdate>>,
    TError,
    { opk: string; methodOpk: string; data: PatchedUpdateCreditCardMethod },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPaymentMethodDetailCreditcardDestroy = (opk: string, methodOpk: string) => {
  return HTTP<void>({
    url: `/api/v7/people/${opk}/wallet/creditcard/${methodOpk}/`,
    method: 'delete',
  });
};

export type ApiPaymentMethodDetailCreditcardDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodDetailCreditcardDestroy>>
>;

export type ApiPaymentMethodDetailCreditcardDestroyMutationError = ErrorType<unknown>;

export const useApiPaymentMethodDetailCreditcardDestroy = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPaymentMethodDetailCreditcardDestroy>>,
    TError,
    { opk: string; methodOpk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPaymentMethodDetailCreditcardDestroy>>,
    { opk: string; methodOpk: string }
  > = (props) => {
    const { opk, methodOpk } = props ?? {};

    return apiPaymentMethodDetailCreditcardDestroy(opk, methodOpk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPaymentMethodDetailCreditcardDestroy>>,
    TError,
    { opk: string; methodOpk: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * This is ugly but necessary to support both list and detail views for
the per-type filtered payment method endpoints.
 */
export const apiPaymentMethodCreditunitmethodList = (
  opk: string,
  params?: ApiPaymentMethodCreditunitmethodListParams,
  signal?: AbortSignal
) => {
  return HTTP<CreditUnitMethodSerializerListOrObject>({
    url: `/api/v7/people/${opk}/wallet/creditunitmethod/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPaymentMethodCreditunitmethodListQueryKey = (
  opk: string,
  params?: ApiPaymentMethodCreditunitmethodListParams
) => [`/api/v7/people/${opk}/wallet/creditunitmethod/`, ...(params ? [params] : [])];

export type ApiPaymentMethodCreditunitmethodListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodCreditunitmethodList>>
>;
export type ApiPaymentMethodCreditunitmethodListQueryError = ErrorType<unknown>;

export const useApiPaymentMethodCreditunitmethodList = <
  TData = Awaited<ReturnType<typeof apiPaymentMethodCreditunitmethodList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPaymentMethodCreditunitmethodListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPaymentMethodCreditunitmethodList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiPaymentMethodCreditunitmethodListQueryKey(opk, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiPaymentMethodCreditunitmethodList>>
  > = ({ signal }) => apiPaymentMethodCreditunitmethodList(opk, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPaymentMethodCreditunitmethodList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * This is ugly but necessary to support both list and detail views for
the per-type filtered payment method endpoints.
 */
export const apiPaymentMethodDetailCreditunitmethodList = (
  opk: string,
  methodOpk: string,
  params?: ApiPaymentMethodDetailCreditunitmethodListParams,
  signal?: AbortSignal
) => {
  return HTTP<CreditUnitMethodSerializerListOrObject>({
    url: `/api/v7/people/${opk}/wallet/creditunitmethod/${methodOpk}/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPaymentMethodDetailCreditunitmethodListQueryKey = (
  opk: string,
  methodOpk: string,
  params?: ApiPaymentMethodDetailCreditunitmethodListParams
) => [`/api/v7/people/${opk}/wallet/creditunitmethod/${methodOpk}/`, ...(params ? [params] : [])];

export type ApiPaymentMethodDetailCreditunitmethodListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodDetailCreditunitmethodList>>
>;
export type ApiPaymentMethodDetailCreditunitmethodListQueryError = ErrorType<unknown>;

export const useApiPaymentMethodDetailCreditunitmethodList = <
  TData = Awaited<ReturnType<typeof apiPaymentMethodDetailCreditunitmethodList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  methodOpk: string,
  params?: ApiPaymentMethodDetailCreditunitmethodListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPaymentMethodDetailCreditunitmethodList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiPaymentMethodDetailCreditunitmethodListQueryKey(opk, methodOpk, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiPaymentMethodDetailCreditunitmethodList>>
  > = ({ signal }) => apiPaymentMethodDetailCreditunitmethodList(opk, methodOpk, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPaymentMethodDetailCreditunitmethodList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(opk && methodOpk),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Get the current default payment method
 */
export const apiPaymentMethodDefaultPaymentList = (opk: string, signal?: AbortSignal) => {
  return HTTP<PaymentMethodDefaultViewSchema | void>({
    url: `/api/v7/people/${opk}/wallet/default-payment/`,
    method: 'get',
    signal,
  });
};

export const getApiPaymentMethodDefaultPaymentListQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/wallet/default-payment/`,
];

export type ApiPaymentMethodDefaultPaymentListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodDefaultPaymentList>>
>;
export type ApiPaymentMethodDefaultPaymentListQueryError = ErrorType<unknown>;

export const useApiPaymentMethodDefaultPaymentList = <
  TData = Awaited<ReturnType<typeof apiPaymentMethodDefaultPaymentList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPaymentMethodDefaultPaymentList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPaymentMethodDefaultPaymentListQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPaymentMethodDefaultPaymentList>>> = ({
    signal,
  }) => apiPaymentMethodDefaultPaymentList(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPaymentMethodDefaultPaymentList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Create a new default payment method
 */
export const apiPaymentMethodDefaultPaymentUpdate = (
  opk: string,
  paymentMethodDefaultViewPutRequest: PaymentMethodDefaultViewPutRequest
) => {
  return HTTP<PaymentDispatch>({
    url: `/api/v7/people/${opk}/wallet/default-payment/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: paymentMethodDefaultViewPutRequest,
  });
};

export type ApiPaymentMethodDefaultPaymentUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodDefaultPaymentUpdate>>
>;
export type ApiPaymentMethodDefaultPaymentUpdateMutationBody = PaymentMethodDefaultViewPutRequest;
export type ApiPaymentMethodDefaultPaymentUpdateMutationError = ErrorType<unknown>;

export const useApiPaymentMethodDefaultPaymentUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPaymentMethodDefaultPaymentUpdate>>,
    TError,
    { opk: string; data: PaymentMethodDefaultViewPutRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPaymentMethodDefaultPaymentUpdate>>,
    { opk: string; data: PaymentMethodDefaultViewPutRequest }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPaymentMethodDefaultPaymentUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPaymentMethodDefaultPaymentUpdate>>,
    TError,
    { opk: string; data: PaymentMethodDefaultViewPutRequest },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * This is ugly but necessary to support both list and detail views for
the per-type filtered payment method endpoints.
 */
export const apiPaymentMethodGenericpaymentmethodList = (
  opk: string,
  params?: ApiPaymentMethodGenericpaymentmethodListParams,
  signal?: AbortSignal
) => {
  return HTTP<GenericPaymentMethodSerializerListOrObject>({
    url: `/api/v7/people/${opk}/wallet/genericpaymentmethod/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPaymentMethodGenericpaymentmethodListQueryKey = (
  opk: string,
  params?: ApiPaymentMethodGenericpaymentmethodListParams
) => [`/api/v7/people/${opk}/wallet/genericpaymentmethod/`, ...(params ? [params] : [])];

export type ApiPaymentMethodGenericpaymentmethodListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodGenericpaymentmethodList>>
>;
export type ApiPaymentMethodGenericpaymentmethodListQueryError = ErrorType<unknown>;

export const useApiPaymentMethodGenericpaymentmethodList = <
  TData = Awaited<ReturnType<typeof apiPaymentMethodGenericpaymentmethodList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPaymentMethodGenericpaymentmethodListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPaymentMethodGenericpaymentmethodList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiPaymentMethodGenericpaymentmethodListQueryKey(opk, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiPaymentMethodGenericpaymentmethodList>>
  > = ({ signal }) => apiPaymentMethodGenericpaymentmethodList(opk, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPaymentMethodGenericpaymentmethodList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPaymentMethodGenericpaymentmethodDestroy = (opk: string) => {
  return HTTP<void>({
    url: `/api/v7/people/${opk}/wallet/genericpaymentmethod/`,
    method: 'delete',
  });
};

export type ApiPaymentMethodGenericpaymentmethodDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodGenericpaymentmethodDestroy>>
>;

export type ApiPaymentMethodGenericpaymentmethodDestroyMutationError = ErrorType<unknown>;

export const useApiPaymentMethodGenericpaymentmethodDestroy = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPaymentMethodGenericpaymentmethodDestroy>>,
    TError,
    { opk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPaymentMethodGenericpaymentmethodDestroy>>,
    { opk: string }
  > = (props) => {
    const { opk } = props ?? {};

    return apiPaymentMethodGenericpaymentmethodDestroy(opk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPaymentMethodGenericpaymentmethodDestroy>>,
    TError,
    { opk: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * This is ugly but necessary to support both list and detail views for
the per-type filtered payment method endpoints.
 */
export const apiPaymentMethodDetailGenericpaymentmethodList = (
  opk: string,
  methodOpk: string,
  params?: ApiPaymentMethodDetailGenericpaymentmethodListParams,
  signal?: AbortSignal
) => {
  return HTTP<GenericPaymentMethodSerializerListOrObject>({
    url: `/api/v7/people/${opk}/wallet/genericpaymentmethod/${methodOpk}/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPaymentMethodDetailGenericpaymentmethodListQueryKey = (
  opk: string,
  methodOpk: string,
  params?: ApiPaymentMethodDetailGenericpaymentmethodListParams
) => [
  `/api/v7/people/${opk}/wallet/genericpaymentmethod/${methodOpk}/`,
  ...(params ? [params] : []),
];

export type ApiPaymentMethodDetailGenericpaymentmethodListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodDetailGenericpaymentmethodList>>
>;
export type ApiPaymentMethodDetailGenericpaymentmethodListQueryError = ErrorType<unknown>;

export const useApiPaymentMethodDetailGenericpaymentmethodList = <
  TData = Awaited<ReturnType<typeof apiPaymentMethodDetailGenericpaymentmethodList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  methodOpk: string,
  params?: ApiPaymentMethodDetailGenericpaymentmethodListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPaymentMethodDetailGenericpaymentmethodList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiPaymentMethodDetailGenericpaymentmethodListQueryKey(opk, methodOpk, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiPaymentMethodDetailGenericpaymentmethodList>>
  > = ({ signal }) =>
    apiPaymentMethodDetailGenericpaymentmethodList(opk, methodOpk, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPaymentMethodDetailGenericpaymentmethodList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(opk && methodOpk),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPaymentMethodDetailGenericpaymentmethodDestroy = (
  opk: string,
  methodOpk: string
) => {
  return HTTP<void>({
    url: `/api/v7/people/${opk}/wallet/genericpaymentmethod/${methodOpk}/`,
    method: 'delete',
  });
};

export type ApiPaymentMethodDetailGenericpaymentmethodDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodDetailGenericpaymentmethodDestroy>>
>;

export type ApiPaymentMethodDetailGenericpaymentmethodDestroyMutationError = ErrorType<unknown>;

export const useApiPaymentMethodDetailGenericpaymentmethodDestroy = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPaymentMethodDetailGenericpaymentmethodDestroy>>,
    TError,
    { opk: string; methodOpk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPaymentMethodDetailGenericpaymentmethodDestroy>>,
    { opk: string; methodOpk: string }
  > = (props) => {
    const { opk, methodOpk } = props ?? {};

    return apiPaymentMethodDetailGenericpaymentmethodDestroy(opk, methodOpk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPaymentMethodDetailGenericpaymentmethodDestroy>>,
    TError,
    { opk: string; methodOpk: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * This is ugly but necessary to support both list and detail views for
the per-type filtered payment method endpoints.
 */
export const apiPaymentMethodWalletList = (
  opk: string,
  params?: ApiPaymentMethodWalletListParams,
  signal?: AbortSignal
) => {
  return HTTP<WalletMethodSerializerListOrObject>({
    url: `/api/v7/people/${opk}/wallet/method/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPaymentMethodWalletListQueryKey = (
  opk: string,
  params?: ApiPaymentMethodWalletListParams
) => [`/api/v7/people/${opk}/wallet/method/`, ...(params ? [params] : [])];

export type ApiPaymentMethodWalletListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodWalletList>>
>;
export type ApiPaymentMethodWalletListQueryError = ErrorType<unknown>;

export const useApiPaymentMethodWalletList = <
  TData = Awaited<ReturnType<typeof apiPaymentMethodWalletList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPaymentMethodWalletListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiPaymentMethodWalletList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPaymentMethodWalletListQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPaymentMethodWalletList>>> = ({
    signal,
  }) => apiPaymentMethodWalletList(opk, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPaymentMethodWalletList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * This is ugly but necessary to support both list and detail views for
the per-type filtered payment method endpoints.
 */
export const apiPaymentMethodDetailWalletList = (
  opk: string,
  methodOpk: string,
  params?: ApiPaymentMethodDetailWalletListParams,
  signal?: AbortSignal
) => {
  return HTTP<WalletMethodSerializerListOrObject>({
    url: `/api/v7/people/${opk}/wallet/method/${methodOpk}/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPaymentMethodDetailWalletListQueryKey = (
  opk: string,
  methodOpk: string,
  params?: ApiPaymentMethodDetailWalletListParams
) => [`/api/v7/people/${opk}/wallet/method/${methodOpk}/`, ...(params ? [params] : [])];

export type ApiPaymentMethodDetailWalletListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodDetailWalletList>>
>;
export type ApiPaymentMethodDetailWalletListQueryError = ErrorType<unknown>;

export const useApiPaymentMethodDetailWalletList = <
  TData = Awaited<ReturnType<typeof apiPaymentMethodDetailWalletList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  methodOpk: string,
  params?: ApiPaymentMethodDetailWalletListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPaymentMethodDetailWalletList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiPaymentMethodDetailWalletListQueryKey(opk, methodOpk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPaymentMethodDetailWalletList>>> = ({
    signal,
  }) => apiPaymentMethodDetailWalletList(opk, methodOpk, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPaymentMethodDetailWalletList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(opk && methodOpk),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * This is ugly but necessary to support both list and detail views for
the per-type filtered payment method endpoints.
 */
export const apiPaymentMethodPayoutbankaccountList = (
  opk: string,
  params?: ApiPaymentMethodPayoutbankaccountListParams,
  signal?: AbortSignal
) => {
  return HTTP<PayoutBankAccountMethodSerializerListOrObject>({
    url: `/api/v7/people/${opk}/wallet/payoutbankaccount/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPaymentMethodPayoutbankaccountListQueryKey = (
  opk: string,
  params?: ApiPaymentMethodPayoutbankaccountListParams
) => [`/api/v7/people/${opk}/wallet/payoutbankaccount/`, ...(params ? [params] : [])];

export type ApiPaymentMethodPayoutbankaccountListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodPayoutbankaccountList>>
>;
export type ApiPaymentMethodPayoutbankaccountListQueryError = ErrorType<unknown>;

export const useApiPaymentMethodPayoutbankaccountList = <
  TData = Awaited<ReturnType<typeof apiPaymentMethodPayoutbankaccountList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPaymentMethodPayoutbankaccountListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPaymentMethodPayoutbankaccountList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiPaymentMethodPayoutbankaccountListQueryKey(opk, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiPaymentMethodPayoutbankaccountList>>
  > = ({ signal }) => apiPaymentMethodPayoutbankaccountList(opk, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPaymentMethodPayoutbankaccountList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPaymentMethodPayoutbankaccountCreate = (
  opk: string,
  createPayoutBankAccountMethod: CreatePayoutBankAccountMethod
) => {
  return HTTP<ApiPaymentMethodPayoutbankaccountCreate201>({
    url: `/api/v7/people/${opk}/wallet/payoutbankaccount/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: createPayoutBankAccountMethod,
  });
};

export type ApiPaymentMethodPayoutbankaccountCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodPayoutbankaccountCreate>>
>;
export type ApiPaymentMethodPayoutbankaccountCreateMutationBody = CreatePayoutBankAccountMethod;
export type ApiPaymentMethodPayoutbankaccountCreateMutationError = ErrorType<unknown>;

export const useApiPaymentMethodPayoutbankaccountCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPaymentMethodPayoutbankaccountCreate>>,
    TError,
    { opk: string; data: CreatePayoutBankAccountMethod },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPaymentMethodPayoutbankaccountCreate>>,
    { opk: string; data: CreatePayoutBankAccountMethod }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPaymentMethodPayoutbankaccountCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPaymentMethodPayoutbankaccountCreate>>,
    TError,
    { opk: string; data: CreatePayoutBankAccountMethod },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * This is ugly but necessary to support both list and detail views for
the per-type filtered payment method endpoints.
 */
export const apiPaymentMethodDetailPayoutbankaccountList = (
  opk: string,
  methodOpk: string,
  params?: ApiPaymentMethodDetailPayoutbankaccountListParams,
  signal?: AbortSignal
) => {
  return HTTP<PayoutBankAccountMethodSerializerListOrObject>({
    url: `/api/v7/people/${opk}/wallet/payoutbankaccount/${methodOpk}/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPaymentMethodDetailPayoutbankaccountListQueryKey = (
  opk: string,
  methodOpk: string,
  params?: ApiPaymentMethodDetailPayoutbankaccountListParams
) => [`/api/v7/people/${opk}/wallet/payoutbankaccount/${methodOpk}/`, ...(params ? [params] : [])];

export type ApiPaymentMethodDetailPayoutbankaccountListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodDetailPayoutbankaccountList>>
>;
export type ApiPaymentMethodDetailPayoutbankaccountListQueryError = ErrorType<unknown>;

export const useApiPaymentMethodDetailPayoutbankaccountList = <
  TData = Awaited<ReturnType<typeof apiPaymentMethodDetailPayoutbankaccountList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  methodOpk: string,
  params?: ApiPaymentMethodDetailPayoutbankaccountListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPaymentMethodDetailPayoutbankaccountList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiPaymentMethodDetailPayoutbankaccountListQueryKey(opk, methodOpk, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiPaymentMethodDetailPayoutbankaccountList>>
  > = ({ signal }) => apiPaymentMethodDetailPayoutbankaccountList(opk, methodOpk, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPaymentMethodDetailPayoutbankaccountList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(opk && methodOpk),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPaymentMethodDetailPayoutbankaccountCreate = (
  opk: string,
  methodOpk: string,
  createPayoutBankAccountMethod: CreatePayoutBankAccountMethod
) => {
  return HTTP<ApiPaymentMethodDetailPayoutbankaccountCreate201>({
    url: `/api/v7/people/${opk}/wallet/payoutbankaccount/${methodOpk}/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: createPayoutBankAccountMethod,
  });
};

export type ApiPaymentMethodDetailPayoutbankaccountCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodDetailPayoutbankaccountCreate>>
>;
export type ApiPaymentMethodDetailPayoutbankaccountCreateMutationBody =
  CreatePayoutBankAccountMethod;
export type ApiPaymentMethodDetailPayoutbankaccountCreateMutationError = ErrorType<unknown>;

export const useApiPaymentMethodDetailPayoutbankaccountCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPaymentMethodDetailPayoutbankaccountCreate>>,
    TError,
    { opk: string; methodOpk: string; data: CreatePayoutBankAccountMethod },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPaymentMethodDetailPayoutbankaccountCreate>>,
    { opk: string; methodOpk: string; data: CreatePayoutBankAccountMethod }
  > = (props) => {
    const { opk, methodOpk, data } = props ?? {};

    return apiPaymentMethodDetailPayoutbankaccountCreate(opk, methodOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPaymentMethodDetailPayoutbankaccountCreate>>,
    TError,
    { opk: string; methodOpk: string; data: CreatePayoutBankAccountMethod },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * This is ugly but necessary to support both list and detail views for
the per-type filtered payment method endpoints.
 */
export const apiPaymentMethodPromoList = (
  opk: string,
  params?: ApiPaymentMethodPromoListParams,
  signal?: AbortSignal
) => {
  return HTTP<InternalCreditMethodSerializerListOrObject>({
    url: `/api/v7/people/${opk}/wallet/promo/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPaymentMethodPromoListQueryKey = (
  opk: string,
  params?: ApiPaymentMethodPromoListParams
) => [`/api/v7/people/${opk}/wallet/promo/`, ...(params ? [params] : [])];

export type ApiPaymentMethodPromoListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodPromoList>>
>;
export type ApiPaymentMethodPromoListQueryError = ErrorType<unknown>;

export const useApiPaymentMethodPromoList = <
  TData = Awaited<ReturnType<typeof apiPaymentMethodPromoList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPaymentMethodPromoListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiPaymentMethodPromoList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPaymentMethodPromoListQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPaymentMethodPromoList>>> = ({
    signal,
  }) => apiPaymentMethodPromoList(opk, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPaymentMethodPromoList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * This is ugly but necessary to support both list and detail views for
the per-type filtered payment method endpoints.
 */
export const apiPaymentMethodDetailPromoList = (
  opk: string,
  methodOpk: string,
  params?: ApiPaymentMethodDetailPromoListParams,
  signal?: AbortSignal
) => {
  return HTTP<InternalCreditMethodSerializerListOrObject>({
    url: `/api/v7/people/${opk}/wallet/promo/${methodOpk}/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPaymentMethodDetailPromoListQueryKey = (
  opk: string,
  methodOpk: string,
  params?: ApiPaymentMethodDetailPromoListParams
) => [`/api/v7/people/${opk}/wallet/promo/${methodOpk}/`, ...(params ? [params] : [])];

export type ApiPaymentMethodDetailPromoListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPaymentMethodDetailPromoList>>
>;
export type ApiPaymentMethodDetailPromoListQueryError = ErrorType<unknown>;

export const useApiPaymentMethodDetailPromoList = <
  TData = Awaited<ReturnType<typeof apiPaymentMethodDetailPromoList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  methodOpk: string,
  params?: ApiPaymentMethodDetailPromoListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPaymentMethodDetailPromoList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiPaymentMethodDetailPromoListQueryKey(opk, methodOpk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPaymentMethodDetailPromoList>>> = ({
    signal,
  }) => apiPaymentMethodDetailPromoList(opk, methodOpk, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPaymentMethodDetailPromoList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(opk && methodOpk),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for list and create views that provides functionality to merge
querysets in order to return paginated results.
 */
export const apiWalletRedemptionList = (
  opk: string,
  params?: ApiWalletRedemptionListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedRedemptionSerializerBaseList>({
    url: `/api/v7/people/${opk}/wallet/promos/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiWalletRedemptionListQueryKey = (
  opk: string,
  params?: ApiWalletRedemptionListParams
) => [`/api/v7/people/${opk}/wallet/promos/`, ...(params ? [params] : [])];

export type ApiWalletRedemptionListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiWalletRedemptionList>>
>;
export type ApiWalletRedemptionListQueryError = ErrorType<unknown>;

export const useApiWalletRedemptionList = <
  TData = Awaited<ReturnType<typeof apiWalletRedemptionList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiWalletRedemptionListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiWalletRedemptionList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiWalletRedemptionListQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiWalletRedemptionList>>> = ({
    signal,
  }) => apiWalletRedemptionList(opk, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiWalletRedemptionList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for list and create views that provides functionality to merge
querysets in order to return paginated results.
 */
export const apiWalletRedemptionListCreate = (
  opk: string,
  apiWalletRedemptionListCreateBody: ApiWalletRedemptionListCreateBody
) => {
  return HTTP<RedemptionSerializerBase | Error>({
    url: `/api/v7/people/${opk}/wallet/promos/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiWalletRedemptionListCreateBody,
  });
};

export type ApiWalletRedemptionListCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiWalletRedemptionListCreate>>
>;
export type ApiWalletRedemptionListCreateMutationBody = ApiWalletRedemptionListCreateBody;
export type ApiWalletRedemptionListCreateMutationError = ErrorType<unknown>;

export const useApiWalletRedemptionListCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiWalletRedemptionListCreate>>,
    TError,
    { opk: string; data: ApiWalletRedemptionListCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiWalletRedemptionListCreate>>,
    { opk: string; data: ApiWalletRedemptionListCreateBody }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiWalletRedemptionListCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiWalletRedemptionListCreate>>,
    TError,
    { opk: string; data: ApiWalletRedemptionListCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiWalletRedemptionCouponList = (
  opk: string,
  params?: ApiWalletRedemptionCouponListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedCouponRedemptionList>({
    url: `/api/v7/people/${opk}/wallet/promos/coupons/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiWalletRedemptionCouponListQueryKey = (
  opk: string,
  params?: ApiWalletRedemptionCouponListParams
) => [`/api/v7/people/${opk}/wallet/promos/coupons/`, ...(params ? [params] : [])];

export type ApiWalletRedemptionCouponListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiWalletRedemptionCouponList>>
>;
export type ApiWalletRedemptionCouponListQueryError = ErrorType<unknown>;

export const useApiWalletRedemptionCouponList = <
  TData = Awaited<ReturnType<typeof apiWalletRedemptionCouponList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiWalletRedemptionCouponListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiWalletRedemptionCouponList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiWalletRedemptionCouponListQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiWalletRedemptionCouponList>>> = ({
    signal,
  }) => apiWalletRedemptionCouponList(opk, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiWalletRedemptionCouponList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiWalletRedemptionCouponDetailRetrieve = (
  opk: string,
  redemptionOpk: string,
  signal?: AbortSignal
) => {
  return HTTP<CouponRedemption>({
    url: `/api/v7/people/${opk}/wallet/promos/coupons/${redemptionOpk}/`,
    method: 'get',
    signal,
  });
};

export const getApiWalletRedemptionCouponDetailRetrieveQueryKey = (
  opk: string,
  redemptionOpk: string
) => [`/api/v7/people/${opk}/wallet/promos/coupons/${redemptionOpk}/`];

export type ApiWalletRedemptionCouponDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiWalletRedemptionCouponDetailRetrieve>>
>;
export type ApiWalletRedemptionCouponDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiWalletRedemptionCouponDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiWalletRedemptionCouponDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  redemptionOpk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiWalletRedemptionCouponDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiWalletRedemptionCouponDetailRetrieveQueryKey(opk, redemptionOpk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiWalletRedemptionCouponDetailRetrieve>>
  > = ({ signal }) => apiWalletRedemptionCouponDetailRetrieve(opk, redemptionOpk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiWalletRedemptionCouponDetailRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(opk && redemptionOpk),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiWalletRedemptionGiftCardDetailRetrieve = (
  opk: string,
  redemptionOpk: string,
  signal?: AbortSignal
) => {
  return HTTP<GiftCardRedemption>({
    url: `/api/v7/people/${opk}/wallet/promos/gift-cards/${redemptionOpk}/`,
    method: 'get',
    signal,
  });
};

export const getApiWalletRedemptionGiftCardDetailRetrieveQueryKey = (
  opk: string,
  redemptionOpk: string
) => [`/api/v7/people/${opk}/wallet/promos/gift-cards/${redemptionOpk}/`];

export type ApiWalletRedemptionGiftCardDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiWalletRedemptionGiftCardDetailRetrieve>>
>;
export type ApiWalletRedemptionGiftCardDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiWalletRedemptionGiftCardDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiWalletRedemptionGiftCardDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  redemptionOpk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiWalletRedemptionGiftCardDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiWalletRedemptionGiftCardDetailRetrieveQueryKey(opk, redemptionOpk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiWalletRedemptionGiftCardDetailRetrieve>>
  > = ({ signal }) => apiWalletRedemptionGiftCardDetailRetrieve(opk, redemptionOpk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiWalletRedemptionGiftCardDetailRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(opk && redemptionOpk),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonWeekendAvailabilityRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<WeekendAvailability>({
    url: `/api/v7/people/${opk}/weekend-availability/`,
    method: 'get',
    signal,
  });
};

export const getApiPersonWeekendAvailabilityRetrieveQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/weekend-availability/`,
];

export type ApiPersonWeekendAvailabilityRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonWeekendAvailabilityRetrieve>>
>;
export type ApiPersonWeekendAvailabilityRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonWeekendAvailabilityRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonWeekendAvailabilityRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonWeekendAvailabilityRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonWeekendAvailabilityRetrieveQueryKey(opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiPersonWeekendAvailabilityRetrieve>>
  > = ({ signal }) => apiPersonWeekendAvailabilityRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPersonWeekendAvailabilityRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonWeekendAvailabilityUpdate = (
  opk: string,
  weekendAvailability: WeekendAvailability
) => {
  return HTTP<WeekendAvailability>({
    url: `/api/v7/people/${opk}/weekend-availability/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: weekendAvailability,
  });
};

export type ApiPersonWeekendAvailabilityUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonWeekendAvailabilityUpdate>>
>;
export type ApiPersonWeekendAvailabilityUpdateMutationBody = WeekendAvailability;
export type ApiPersonWeekendAvailabilityUpdateMutationError = ErrorType<unknown>;

export const useApiPersonWeekendAvailabilityUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonWeekendAvailabilityUpdate>>,
    TError,
    { opk: string; data: WeekendAvailability },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonWeekendAvailabilityUpdate>>,
    { opk: string; data: WeekendAvailability }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPersonWeekendAvailabilityUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonWeekendAvailabilityUpdate>>,
    TError,
    { opk: string; data: WeekendAvailability },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonWeekendAvailabilityPartialUpdate = (
  opk: string,
  patchedWeekendAvailability: PatchedWeekendAvailability
) => {
  return HTTP<WeekendAvailability>({
    url: `/api/v7/people/${opk}/weekend-availability/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedWeekendAvailability,
  });
};

export type ApiPersonWeekendAvailabilityPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonWeekendAvailabilityPartialUpdate>>
>;
export type ApiPersonWeekendAvailabilityPartialUpdateMutationBody = PatchedWeekendAvailability;
export type ApiPersonWeekendAvailabilityPartialUpdateMutationError = ErrorType<unknown>;

export const useApiPersonWeekendAvailabilityPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonWeekendAvailabilityPartialUpdate>>,
    TError,
    { opk: string; data: PatchedWeekendAvailability },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonWeekendAvailabilityPartialUpdate>>,
    { opk: string; data: PatchedWeekendAvailability }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPersonWeekendAvailabilityPartialUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonWeekendAvailabilityPartialUpdate>>,
    TError,
    { opk: string; data: PatchedWeekendAvailability },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonZipCodeRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<ZipLocation>({ url: `/api/v7/people/${opk}/zip_code/`, method: 'get', signal });
};

export const getApiPersonZipCodeRetrieveQueryKey = (opk: string) => [
  `/api/v7/people/${opk}/zip_code/`,
];

export type ApiPersonZipCodeRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonZipCodeRetrieve>>
>;
export type ApiPersonZipCodeRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonZipCodeRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonZipCodeRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiPersonZipCodeRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonZipCodeRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonZipCodeRetrieve>>> = ({
    signal,
  }) => apiPersonZipCodeRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPersonZipCodeRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonZipCodeCreate = (opk: string, zipLocation: ZipLocation) => {
  return HTTP<Me>({
    url: `/api/v7/people/${opk}/zip_code/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: zipLocation,
  });
};

export type ApiPersonZipCodeCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonZipCodeCreate>>
>;
export type ApiPersonZipCodeCreateMutationBody = ZipLocation;
export type ApiPersonZipCodeCreateMutationError = ErrorType<unknown>;

export const useApiPersonZipCodeCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPersonZipCodeCreate>>,
    TError,
    { opk: string; data: ZipLocation },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPersonZipCodeCreate>>,
    { opk: string; data: ZipLocation }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPersonZipCodeCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPersonZipCodeCreate>>,
    TError,
    { opk: string; data: ZipLocation },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiPersonEuSitterRequirementRetrieve = (signal?: AbortSignal) => {
  return HTTP<EUSitterRequirement>({
    url: `/api/v7/people/eu-sitter-requirement/`,
    method: 'get',
    signal,
  });
};

export const getApiPersonEuSitterRequirementRetrieveQueryKey = () => [
  `/api/v7/people/eu-sitter-requirement/`,
];

export type ApiPersonEuSitterRequirementRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonEuSitterRequirementRetrieve>>
>;
export type ApiPersonEuSitterRequirementRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonEuSitterRequirementRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonEuSitterRequirementRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiPersonEuSitterRequirementRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonEuSitterRequirementRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiPersonEuSitterRequirementRetrieve>>
  > = ({ signal }) => apiPersonEuSitterRequirementRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPersonEuSitterRequirementRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiPersonFullSitterProfileRetrieve = (
  params: ApiPersonFullSitterProfileRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<EnhancedPersonSitterProfile>({
    url: `/api/v7/people/full-sitter-profile/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPersonFullSitterProfileRetrieveQueryKey = (
  params: ApiPersonFullSitterProfileRetrieveParams
) => [`/api/v7/people/full-sitter-profile/`, ...(params ? [params] : [])];

export type ApiPersonFullSitterProfileRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonFullSitterProfileRetrieve>>
>;
export type ApiPersonFullSitterProfileRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonFullSitterProfileRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonFullSitterProfileRetrieve>>,
  TError = ErrorType<unknown>
>(
  params: ApiPersonFullSitterProfileRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonFullSitterProfileRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonFullSitterProfileRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonFullSitterProfileRetrieve>>> = ({
    signal,
  }) => apiPersonFullSitterProfileRetrieve(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPersonFullSitterProfileRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiPersonCorePetProfileListRetrieve = (ownerSlug: string, signal?: AbortSignal) => {
  return HTTP<PetSelector>({ url: `/api/v7/person/${ownerSlug}/pets/`, method: 'get', signal });
};

export const getApiPersonCorePetProfileListRetrieveQueryKey = (ownerSlug: string) => [
  `/api/v7/person/${ownerSlug}/pets/`,
];

export type ApiPersonCorePetProfileListRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonCorePetProfileListRetrieve>>
>;
export type ApiPersonCorePetProfileListRetrieveQueryError = ErrorType<unknown>;

export const useApiPersonCorePetProfileListRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonCorePetProfileListRetrieve>>,
  TError = ErrorType<unknown>
>(
  ownerSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonCorePetProfileListRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiPersonCorePetProfileListRetrieveQueryKey(ownerSlug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonCorePetProfileListRetrieve>>> = ({
    signal,
  }) => apiPersonCorePetProfileListRetrieve(ownerSlug, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPersonCorePetProfileListRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!ownerSlug,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiPetListCreate = (pet: Pet) => {
  return HTTP<Pet>({
    url: `/api/v7/pets/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: pet,
  });
};

export type ApiPetListCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPetListCreate>>
>;
export type ApiPetListCreateMutationBody = Pet;
export type ApiPetListCreateMutationError = ErrorType<unknown>;

export const useApiPetListCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPetListCreate>>,
    TError,
    { data: Pet },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPetListCreate>>,
    { data: Pet }
  > = (props) => {
    const { data } = props ?? {};

    return apiPetListCreate(data);
  };

  return useMutation<Awaited<ReturnType<typeof apiPetListCreate>>, TError, { data: Pet }, TContext>(
    mutationFn,
    mutationOptions
  );
};

export const apiPetDetailRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<PetWithProfileCompletion>({ url: `/api/v7/pets/${opk}/`, method: 'get', signal });
};

export const getApiPetDetailRetrieveQueryKey = (opk: string) => [`/api/v7/pets/${opk}/`];

export type ApiPetDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPetDetailRetrieve>>
>;
export type ApiPetDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiPetDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiPetDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiPetDetailRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPetDetailRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPetDetailRetrieve>>> = ({ signal }) =>
    apiPetDetailRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPetDetailRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiPetDetailUpdate = (
  opk: string,
  petWithProfileCompletion: PetWithProfileCompletion
) => {
  return HTTP<PetWithProfileCompletion>({
    url: `/api/v7/pets/${opk}/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: petWithProfileCompletion,
  });
};

export type ApiPetDetailUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPetDetailUpdate>>
>;
export type ApiPetDetailUpdateMutationBody = PetWithProfileCompletion;
export type ApiPetDetailUpdateMutationError = ErrorType<unknown>;

export const useApiPetDetailUpdate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPetDetailUpdate>>,
    TError,
    { opk: string; data: PetWithProfileCompletion },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPetDetailUpdate>>,
    { opk: string; data: PetWithProfileCompletion }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPetDetailUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPetDetailUpdate>>,
    TError,
    { opk: string; data: PetWithProfileCompletion },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiPetDetailPartialUpdate = (
  opk: string,
  patchedPetWithProfileCompletion: PatchedPetWithProfileCompletion
) => {
  return HTTP<PetWithProfileCompletion>({
    url: `/api/v7/pets/${opk}/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedPetWithProfileCompletion,
  });
};

export type ApiPetDetailPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPetDetailPartialUpdate>>
>;
export type ApiPetDetailPartialUpdateMutationBody = PatchedPetWithProfileCompletion;
export type ApiPetDetailPartialUpdateMutationError = ErrorType<unknown>;

export const useApiPetDetailPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPetDetailPartialUpdate>>,
    TError,
    { opk: string; data: PatchedPetWithProfileCompletion },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPetDetailPartialUpdate>>,
    { opk: string; data: PatchedPetWithProfileCompletion }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPetDetailPartialUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPetDetailPartialUpdate>>,
    TError,
    { opk: string; data: PatchedPetWithProfileCompletion },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiPetDetailDestroy = (opk: string) => {
  return HTTP<void>({ url: `/api/v7/pets/${opk}/`, method: 'delete' });
};

export type ApiPetDetailDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPetDetailDestroy>>
>;

export type ApiPetDetailDestroyMutationError = ErrorType<unknown>;

export const useApiPetDetailDestroy = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPetDetailDestroy>>,
    TError,
    { opk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPetDetailDestroy>>,
    { opk: string }
  > = (props) => {
    const { opk } = props ?? {};

    return apiPetDetailDestroy(opk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPetDetailDestroy>>,
    TError,
    { opk: string },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Sets reasonable pagination defaults for all the API list/create views.
 */
export const apiPetDetailImagesList = (
  opk: string,
  params?: ApiPetDetailImagesListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedImageList>({
    url: `/api/v7/pets/${opk}/images/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPetDetailImagesListQueryKey = (
  opk: string,
  params?: ApiPetDetailImagesListParams
) => [`/api/v7/pets/${opk}/images/`, ...(params ? [params] : [])];

export type ApiPetDetailImagesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPetDetailImagesList>>
>;
export type ApiPetDetailImagesListQueryError = ErrorType<unknown>;

export const useApiPetDetailImagesList = <
  TData = Awaited<ReturnType<typeof apiPetDetailImagesList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPetDetailImagesListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiPetDetailImagesList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPetDetailImagesListQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPetDetailImagesList>>> = ({ signal }) =>
    apiPetDetailImagesList(opk, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPetDetailImagesList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list/create views.
 */
export const apiPetDetailImagesCreate = (opk: string, image: Image) => {
  return HTTP<Image>({
    url: `/api/v7/pets/${opk}/images/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: image,
  });
};

export type ApiPetDetailImagesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPetDetailImagesCreate>>
>;
export type ApiPetDetailImagesCreateMutationBody = Image;
export type ApiPetDetailImagesCreateMutationError = ErrorType<unknown>;

export const useApiPetDetailImagesCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPetDetailImagesCreate>>,
    TError,
    { opk: string; data: Image },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPetDetailImagesCreate>>,
    { opk: string; data: Image }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPetDetailImagesCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPetDetailImagesCreate>>,
    TError,
    { opk: string; data: Image },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Optimized version of PetImageListView for known pets.
 */
export const apiPetDetailImagesCachedList = (
  opk: string,
  params?: ApiPetDetailImagesCachedListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedImageList>({
    url: `/api/v7/pets/${opk}/images-cached/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPetDetailImagesCachedListQueryKey = (
  opk: string,
  params?: ApiPetDetailImagesCachedListParams
) => [`/api/v7/pets/${opk}/images-cached/`, ...(params ? [params] : [])];

export type ApiPetDetailImagesCachedListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPetDetailImagesCachedList>>
>;
export type ApiPetDetailImagesCachedListQueryError = ErrorType<unknown>;

export const useApiPetDetailImagesCachedList = <
  TData = Awaited<ReturnType<typeof apiPetDetailImagesCachedList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPetDetailImagesCachedListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPetDetailImagesCachedList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPetDetailImagesCachedListQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPetDetailImagesCachedList>>> = ({
    signal,
  }) => apiPetDetailImagesCachedList(opk, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPetDetailImagesCachedList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Optimized version of PetImageListView for known pets.
 */
export const apiPetDetailImagesCachedCreate = (opk: string, image: Image) => {
  return HTTP<Image>({
    url: `/api/v7/pets/${opk}/images-cached/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: image,
  });
};

export type ApiPetDetailImagesCachedCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPetDetailImagesCachedCreate>>
>;
export type ApiPetDetailImagesCachedCreateMutationBody = Image;
export type ApiPetDetailImagesCachedCreateMutationError = ErrorType<unknown>;

export const useApiPetDetailImagesCachedCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPetDetailImagesCachedCreate>>,
    TError,
    { opk: string; data: Image },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPetDetailImagesCachedCreate>>,
    { opk: string; data: Image }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPetDetailImagesCachedCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPetDetailImagesCachedCreate>>,
    TError,
    { opk: string; data: Image },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiPetReviewsSummaryList = (
  petOpk: string,
  params?: ApiPetReviewsSummaryListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedPetReviewSummaryList>({
    url: `/api/v7/pets/${petOpk}/reviews/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPetReviewsSummaryListQueryKey = (
  petOpk: string,
  params?: ApiPetReviewsSummaryListParams
) => [`/api/v7/pets/${petOpk}/reviews/`, ...(params ? [params] : [])];

export type ApiPetReviewsSummaryListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPetReviewsSummaryList>>
>;
export type ApiPetReviewsSummaryListQueryError = ErrorType<unknown>;

export const useApiPetReviewsSummaryList = <
  TData = Awaited<ReturnType<typeof apiPetReviewsSummaryList>>,
  TError = ErrorType<unknown>
>(
  petOpk: string,
  params?: ApiPetReviewsSummaryListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiPetReviewsSummaryList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPetReviewsSummaryListQueryKey(petOpk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPetReviewsSummaryList>>> = ({
    signal,
  }) => apiPetReviewsSummaryList(petOpk, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPetReviewsSummaryList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!petOpk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiPetReviewResponseCreate = (
  petOpk: string,
  reviewOpk: string,
  petReviewResponse: PetReviewResponse
) => {
  return HTTP<PetReviewResponse>({
    url: `/api/v7/pets/${petOpk}/reviews/${reviewOpk}/response`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: petReviewResponse,
  });
};

export type ApiPetReviewResponseCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPetReviewResponseCreate>>
>;
export type ApiPetReviewResponseCreateMutationBody = PetReviewResponse;
export type ApiPetReviewResponseCreateMutationError = ErrorType<unknown>;

export const useApiPetReviewResponseCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPetReviewResponseCreate>>,
    TError,
    { petOpk: string; reviewOpk: string; data: PetReviewResponse },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPetReviewResponseCreate>>,
    { petOpk: string; reviewOpk: string; data: PetReviewResponse }
  > = (props) => {
    const { petOpk, reviewOpk, data } = props ?? {};

    return apiPetReviewResponseCreate(petOpk, reviewOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPetReviewResponseCreate>>,
    TError,
    { petOpk: string; reviewOpk: string; data: PetReviewResponse },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiPetReviewResponseDestroy = (petOpk: string, reviewOpk: string) => {
  return HTTP<void>({
    url: `/api/v7/pets/${petOpk}/reviews/${reviewOpk}/response`,
    method: 'delete',
  });
};

export type ApiPetReviewResponseDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPetReviewResponseDestroy>>
>;

export type ApiPetReviewResponseDestroyMutationError = ErrorType<unknown>;

export const useApiPetReviewResponseDestroy = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPetReviewResponseDestroy>>,
    TError,
    { petOpk: string; reviewOpk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPetReviewResponseDestroy>>,
    { petOpk: string; reviewOpk: string }
  > = (props) => {
    const { petOpk, reviewOpk } = props ?? {};

    return apiPetReviewResponseDestroy(petOpk, reviewOpk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPetReviewResponseDestroy>>,
    TError,
    { petOpk: string; reviewOpk: string },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiLostPetFlyerRetrieve = (lostPetActionOpk: string, signal?: AbortSignal) => {
  return HTTP<void>({
    url: `/api/v7/pets/lost-pet-flier/${lostPetActionOpk}/`,
    method: 'get',
    signal,
  });
};

export const getApiLostPetFlyerRetrieveQueryKey = (lostPetActionOpk: string) => [
  `/api/v7/pets/lost-pet-flier/${lostPetActionOpk}/`,
];

export type ApiLostPetFlyerRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiLostPetFlyerRetrieve>>
>;
export type ApiLostPetFlyerRetrieveQueryError = ErrorType<unknown>;

export const useApiLostPetFlyerRetrieve = <
  TData = Awaited<ReturnType<typeof apiLostPetFlyerRetrieve>>,
  TError = ErrorType<unknown>
>(
  lostPetActionOpk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiLostPetFlyerRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiLostPetFlyerRetrieveQueryKey(lostPetActionOpk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLostPetFlyerRetrieve>>> = ({
    signal,
  }) => apiLostPetFlyerRetrieve(lostPetActionOpk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiLostPetFlyerRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!lostPetActionOpk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiPhoneList = (params?: ApiPhoneListParams, signal?: AbortSignal) => {
  return HTTP<PaginatedPhoneList>({ url: `/api/v7/phones/`, method: 'get', params, signal });
};

export const getApiPhoneListQueryKey = (params?: ApiPhoneListParams) => [
  `/api/v7/phones/`,
  ...(params ? [params] : []),
];

export type ApiPhoneListQueryResult = NonNullable<Awaited<ReturnType<typeof apiPhoneList>>>;
export type ApiPhoneListQueryError = ErrorType<unknown>;

export const useApiPhoneList = <
  TData = Awaited<ReturnType<typeof apiPhoneList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiPhoneListParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof apiPhoneList>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPhoneListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPhoneList>>> = ({ signal }) =>
    apiPhoneList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPhoneList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Create the phone and return a 201 response.
If the same person already associated with the phone,
return a 201 immediately since it is unknown if the clients
are setup to support a 200 response. If the phone is in use by
a different person a 409 response is returned.


Note there is a potential race condition
when the payload's ``phone_number`` exactly matches that
stored in the DB. Since ``class:~people.models.Phone`` has
``phone_number`` set to unique, the DRF fields run_validation will
attempt to query for it and raise a 400 if a match is found before the
serializer's ``create`` is called. If a duplicate http request
inserted the record between the view check and the field validation
the client will see the 400.
 */
export const apiPhoneListCreate = (createPhone: CreatePhone) => {
  return HTTP<Phone>({
    url: `/api/v7/phones/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: createPhone,
  });
};

export type ApiPhoneListCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPhoneListCreate>>
>;
export type ApiPhoneListCreateMutationBody = CreatePhone;
export type ApiPhoneListCreateMutationError = ErrorType<unknown>;

export const useApiPhoneListCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPhoneListCreate>>,
    TError,
    { data: CreatePhone },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPhoneListCreate>>,
    { data: CreatePhone }
  > = (props) => {
    const { data } = props ?? {};

    return apiPhoneListCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPhoneListCreate>>,
    TError,
    { data: CreatePhone },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiPhoneDetailRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<Phone>({ url: `/api/v7/phones/${opk}/`, method: 'get', signal });
};

export const getApiPhoneDetailRetrieveQueryKey = (opk: string) => [`/api/v7/phones/${opk}/`];

export type ApiPhoneDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPhoneDetailRetrieve>>
>;
export type ApiPhoneDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiPhoneDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiPhoneDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiPhoneDetailRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPhoneDetailRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPhoneDetailRetrieve>>> = ({ signal }) =>
    apiPhoneDetailRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPhoneDetailRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiPhoneDetailDestroy = (opk: string) => {
  return HTTP<void>({ url: `/api/v7/phones/${opk}/`, method: 'delete' });
};

export type ApiPhoneDetailDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPhoneDetailDestroy>>
>;

export type ApiPhoneDetailDestroyMutationError = ErrorType<unknown>;

export const useApiPhoneDetailDestroy = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPhoneDetailDestroy>>,
    TError,
    { opk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPhoneDetailDestroy>>,
    { opk: string }
  > = (props) => {
    const { opk } = props ?? {};

    return apiPhoneDetailDestroy(opk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPhoneDetailDestroy>>,
    TError,
    { opk: string },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiPhoneDetailMakeDefaultUpdate = (
  opk: string,
  apiPhoneDetailMakeDefaultUpdateBody: ApiPhoneDetailMakeDefaultUpdateBody
) => {
  return HTTP<Phone>({
    url: `/api/v7/phones/${opk}/make-default/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiPhoneDetailMakeDefaultUpdateBody,
  });
};

export type ApiPhoneDetailMakeDefaultUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPhoneDetailMakeDefaultUpdate>>
>;
export type ApiPhoneDetailMakeDefaultUpdateMutationBody = ApiPhoneDetailMakeDefaultUpdateBody;
export type ApiPhoneDetailMakeDefaultUpdateMutationError = ErrorType<unknown>;

export const useApiPhoneDetailMakeDefaultUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPhoneDetailMakeDefaultUpdate>>,
    TError,
    { opk: string; data: ApiPhoneDetailMakeDefaultUpdateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPhoneDetailMakeDefaultUpdate>>,
    { opk: string; data: ApiPhoneDetailMakeDefaultUpdateBody }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPhoneDetailMakeDefaultUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPhoneDetailMakeDefaultUpdate>>,
    TError,
    { opk: string; data: ApiPhoneDetailMakeDefaultUpdateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiPhoneDetailRequestVerificationTokenCreate = (
  opk: string,
  phoneVerificationMethod: PhoneVerificationMethod
) => {
  return HTTP<Phone>({
    url: `/api/v7/phones/${opk}/request-verification-token/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: phoneVerificationMethod,
  });
};

export type ApiPhoneDetailRequestVerificationTokenCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPhoneDetailRequestVerificationTokenCreate>>
>;
export type ApiPhoneDetailRequestVerificationTokenCreateMutationBody = PhoneVerificationMethod;
export type ApiPhoneDetailRequestVerificationTokenCreateMutationError = ErrorType<Error>;

export const useApiPhoneDetailRequestVerificationTokenCreate = <
  TError = ErrorType<Error>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPhoneDetailRequestVerificationTokenCreate>>,
    TError,
    { opk: string; data: PhoneVerificationMethod },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPhoneDetailRequestVerificationTokenCreate>>,
    { opk: string; data: PhoneVerificationMethod }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPhoneDetailRequestVerificationTokenCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPhoneDetailRequestVerificationTokenCreate>>,
    TError,
    { opk: string; data: PhoneVerificationMethod },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiPhoneDetailVerifyUpdate = (
  opk: string,
  apiPhoneDetailVerifyUpdateBody: ApiPhoneDetailVerifyUpdateBody
) => {
  return HTTP<Phone>({
    url: `/api/v7/phones/${opk}/verify/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiPhoneDetailVerifyUpdateBody,
  });
};

export type ApiPhoneDetailVerifyUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPhoneDetailVerifyUpdate>>
>;
export type ApiPhoneDetailVerifyUpdateMutationBody = ApiPhoneDetailVerifyUpdateBody;
export type ApiPhoneDetailVerifyUpdateMutationError = ErrorType<unknown>;

export const useApiPhoneDetailVerifyUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPhoneDetailVerifyUpdate>>,
    TError,
    { opk: string; data: ApiPhoneDetailVerifyUpdateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPhoneDetailVerifyUpdate>>,
    { opk: string; data: ApiPhoneDetailVerifyUpdateBody }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiPhoneDetailVerifyUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPhoneDetailVerifyUpdate>>,
    TError,
    { opk: string; data: ApiPhoneDetailVerifyUpdateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiPhysicalArtifactsViewRetrieve = (
  flyerName: string,
  params?: ApiPhysicalArtifactsViewRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<unknown>({
    url: `/api/v7/physical-artifacts/${flyerName}/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiPhysicalArtifactsViewRetrieveQueryKey = (
  flyerName: string,
  params?: ApiPhysicalArtifactsViewRetrieveParams
) => [`/api/v7/physical-artifacts/${flyerName}/`, ...(params ? [params] : [])];

export type ApiPhysicalArtifactsViewRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPhysicalArtifactsViewRetrieve>>
>;
export type ApiPhysicalArtifactsViewRetrieveQueryError = ErrorType<unknown>;

export const useApiPhysicalArtifactsViewRetrieve = <
  TData = Awaited<ReturnType<typeof apiPhysicalArtifactsViewRetrieve>>,
  TError = ErrorType<unknown>
>(
  flyerName: string,
  params?: ApiPhysicalArtifactsViewRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPhysicalArtifactsViewRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiPhysicalArtifactsViewRetrieveQueryKey(flyerName, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPhysicalArtifactsViewRetrieve>>> = ({
    signal,
  }) => apiPhysicalArtifactsViewRetrieve(flyerName, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPhysicalArtifactsViewRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!flyerName,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiPlatformTaxReportingLoginRetrieve = (signal?: AbortSignal) => {
  return HTTP<PlatformTaxReporting>({
    url: `/api/v7/platform-tax-reporting-login/`,
    method: 'get',
    signal,
  });
};

export const getApiPlatformTaxReportingLoginRetrieveQueryKey = () => [
  `/api/v7/platform-tax-reporting-login/`,
];

export type ApiPlatformTaxReportingLoginRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPlatformTaxReportingLoginRetrieve>>
>;
export type ApiPlatformTaxReportingLoginRetrieveQueryError = ErrorType<
  ErrorResponsePlatformTaxReportingLogin400 | ErrorResponsePlatformTaxReportingLogin500
>;

export const useApiPlatformTaxReportingLoginRetrieve = <
  TData = Awaited<ReturnType<typeof apiPlatformTaxReportingLoginRetrieve>>,
  TError = ErrorType<
    ErrorResponsePlatformTaxReportingLogin400 | ErrorResponsePlatformTaxReportingLogin500
  >
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiPlatformTaxReportingLoginRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPlatformTaxReportingLoginRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiPlatformTaxReportingLoginRetrieve>>
  > = ({ signal }) => apiPlatformTaxReportingLoginRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPlatformTaxReportingLoginRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiPromoPartnersCareGiftCardCreate = (partnerGiftCardInput: PartnerGiftCardInput) => {
  return HTTP<PartnerGiftCardOutput>({
    url: `/api/v7/promos/partners/care/gift-card/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: partnerGiftCardInput,
  });
};

export type ApiPromoPartnersCareGiftCardCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPromoPartnersCareGiftCardCreate>>
>;
export type ApiPromoPartnersCareGiftCardCreateMutationBody = PartnerGiftCardInput;
export type ApiPromoPartnersCareGiftCardCreateMutationError = ErrorType<Error>;

export const useApiPromoPartnersCareGiftCardCreate = <
  TError = ErrorType<Error>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPromoPartnersCareGiftCardCreate>>,
    TError,
    { data: PartnerGiftCardInput },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPromoPartnersCareGiftCardCreate>>,
    { data: PartnerGiftCardInput }
  > = (props) => {
    const { data } = props ?? {};

    return apiPromoPartnersCareGiftCardCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPromoPartnersCareGiftCardCreate>>,
    TError,
    { data: PartnerGiftCardInput },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiSspArtifactsBucketingViewRetrieve = (
  params?: ApiSspArtifactsBucketingViewRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<SSPArtifactsBucketing>({
    url: `/api/v7/promos/ssp-artifacts-bucketing/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiSspArtifactsBucketingViewRetrieveQueryKey = (
  params?: ApiSspArtifactsBucketingViewRetrieveParams
) => [`/api/v7/promos/ssp-artifacts-bucketing/`, ...(params ? [params] : [])];

export type ApiSspArtifactsBucketingViewRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSspArtifactsBucketingViewRetrieve>>
>;
export type ApiSspArtifactsBucketingViewRetrieveQueryError = ErrorType<unknown>;

export const useApiSspArtifactsBucketingViewRetrieve = <
  TData = Awaited<ReturnType<typeof apiSspArtifactsBucketingViewRetrieve>>,
  TError = ErrorType<unknown>
>(
  params?: ApiSspArtifactsBucketingViewRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSspArtifactsBucketingViewRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiSspArtifactsBucketingViewRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiSspArtifactsBucketingViewRetrieve>>
  > = ({ signal }) => apiSspArtifactsBucketingViewRetrieve(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiSspArtifactsBucketingViewRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiSspBucketingViewRetrieve = (signal?: AbortSignal) => {
  return HTTP<SSPBucketing>({ url: `/api/v7/promos/ssp-bucketing/`, method: 'get', signal });
};

export const getApiSspBucketingViewRetrieveQueryKey = () => [`/api/v7/promos/ssp-bucketing/`];

export type ApiSspBucketingViewRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSspBucketingViewRetrieve>>
>;
export type ApiSspBucketingViewRetrieveQueryError = ErrorType<unknown>;

export const useApiSspBucketingViewRetrieve = <
  TData = Awaited<ReturnType<typeof apiSspBucketingViewRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiSspBucketingViewRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSspBucketingViewRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSspBucketingViewRetrieve>>> = ({
    signal,
  }) => apiSspBucketingViewRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiSspBucketingViewRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiCatProviderProfileRetrieve = (signal?: AbortSignal) => {
  return HTTP<RetrieveCatProviderProfile | void>({
    url: `/api/v7/provider-profile/cat-profile/`,
    method: 'get',
    signal,
  });
};

export const getApiCatProviderProfileRetrieveQueryKey = () => [
  `/api/v7/provider-profile/cat-profile/`,
];

export type ApiCatProviderProfileRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiCatProviderProfileRetrieve>>
>;
export type ApiCatProviderProfileRetrieveQueryError = ErrorType<unknown>;

export const useApiCatProviderProfileRetrieve = <
  TData = Awaited<ReturnType<typeof apiCatProviderProfileRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiCatProviderProfileRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiCatProviderProfileRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiCatProviderProfileRetrieve>>> = ({
    signal,
  }) => apiCatProviderProfileRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiCatProviderProfileRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiCatProviderProfileCreate = (catProviderProfile: CatProviderProfile) => {
  return HTTP<RetrieveCatProviderProfile | void>({
    url: `/api/v7/provider-profile/cat-profile/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: catProviderProfile,
  });
};

export type ApiCatProviderProfileCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiCatProviderProfileCreate>>
>;
export type ApiCatProviderProfileCreateMutationBody = CatProviderProfile;
export type ApiCatProviderProfileCreateMutationError = ErrorType<unknown>;

export const useApiCatProviderProfileCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiCatProviderProfileCreate>>,
    TError,
    { data: CatProviderProfile },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiCatProviderProfileCreate>>,
    { data: CatProviderProfile }
  > = (props) => {
    const { data } = props ?? {};

    return apiCatProviderProfileCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiCatProviderProfileCreate>>,
    TError,
    { data: CatProviderProfile },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiCatProviderProfileUpdate = (catProviderProfile: CatProviderProfile) => {
  return HTTP<RetrieveCatProviderProfile>({
    url: `/api/v7/provider-profile/cat-profile/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: catProviderProfile,
  });
};

export type ApiCatProviderProfileUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiCatProviderProfileUpdate>>
>;
export type ApiCatProviderProfileUpdateMutationBody = CatProviderProfile;
export type ApiCatProviderProfileUpdateMutationError = ErrorType<ApiCatProviderProfileUpdate404>;

export const useApiCatProviderProfileUpdate = <
  TError = ErrorType<ApiCatProviderProfileUpdate404>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiCatProviderProfileUpdate>>,
    TError,
    { data: CatProviderProfile },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiCatProviderProfileUpdate>>,
    { data: CatProviderProfile }
  > = (props) => {
    const { data } = props ?? {};

    return apiCatProviderProfileUpdate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiCatProviderProfileUpdate>>,
    TError,
    { data: CatProviderProfile },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiGroomingSignUpHubRetrieve = (signal?: AbortSignal) => {
  return HTTP<HubResponse>({
    url: `/api/v7/provider-profile/grooming-profile/hub/`,
    method: 'get',
    signal,
  });
};

export const getApiGroomingSignUpHubRetrieveQueryKey = () => [
  `/api/v7/provider-profile/grooming-profile/hub/`,
];

export type ApiGroomingSignUpHubRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiGroomingSignUpHubRetrieve>>
>;
export type ApiGroomingSignUpHubRetrieveQueryError = ErrorType<unknown>;

export const useApiGroomingSignUpHubRetrieve = <
  TData = Awaited<ReturnType<typeof apiGroomingSignUpHubRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiGroomingSignUpHubRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiGroomingSignUpHubRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGroomingSignUpHubRetrieve>>> = ({
    signal,
  }) => apiGroomingSignUpHubRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiGroomingSignUpHubRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Retrieve a list of chapters for user and user state to inform display on
hub. Chapters contain modules/accordions, their states, and types. This
view also conditionally updates provider state and reloads the response.
 */
export const apiProviderProfileHubRetrieve = (signal?: AbortSignal) => {
  return HTTP<HubResponse>({ url: `/api/v7/provider-profile/hub/`, method: 'get', signal });
};

export const getApiProviderProfileHubRetrieveQueryKey = () => [`/api/v7/provider-profile/hub/`];

export type ApiProviderProfileHubRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfileHubRetrieve>>
>;
export type ApiProviderProfileHubRetrieveQueryError = ErrorType<unknown>;

export const useApiProviderProfileHubRetrieve = <
  TData = Awaited<ReturnType<typeof apiProviderProfileHubRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiProviderProfileHubRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiProviderProfileHubRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiProviderProfileHubRetrieve>>> = ({
    signal,
  }) => apiProviderProfileHubRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiProviderProfileHubRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiProviderProfileModuleRetrieve = (moduleSlug: string, signal?: AbortSignal) => {
  return HTTP<ModuleGetResponse>({
    url: `/api/v7/provider-profile/module/${moduleSlug}/`,
    method: 'get',
    signal,
  });
};

export const getApiProviderProfileModuleRetrieveQueryKey = (moduleSlug: string) => [
  `/api/v7/provider-profile/module/${moduleSlug}/`,
];

export type ApiProviderProfileModuleRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfileModuleRetrieve>>
>;
export type ApiProviderProfileModuleRetrieveQueryError = ErrorType<unknown>;

export const useApiProviderProfileModuleRetrieve = <
  TData = Awaited<ReturnType<typeof apiProviderProfileModuleRetrieve>>,
  TError = ErrorType<unknown>
>(
  moduleSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiProviderProfileModuleRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiProviderProfileModuleRetrieveQueryKey(moduleSlug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiProviderProfileModuleRetrieve>>> = ({
    signal,
  }) => apiProviderProfileModuleRetrieve(moduleSlug, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiProviderProfileModuleRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!moduleSlug,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiProviderProfileModuleCreate = (
  moduleSlug: string,
  modulePostBody: ModulePostBody
) => {
  return HTTP<ModulePostResponse>({
    url: `/api/v7/provider-profile/module/${moduleSlug}/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: modulePostBody,
  });
};

export type ApiProviderProfileModuleCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfileModuleCreate>>
>;
export type ApiProviderProfileModuleCreateMutationBody = ModulePostBody;
export type ApiProviderProfileModuleCreateMutationError = ErrorType<unknown>;

export const useApiProviderProfileModuleCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiProviderProfileModuleCreate>>,
    TError,
    { moduleSlug: string; data: ModulePostBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiProviderProfileModuleCreate>>,
    { moduleSlug: string; data: ModulePostBody }
  > = (props) => {
    const { moduleSlug, data } = props ?? {};

    return apiProviderProfileModuleCreate(moduleSlug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiProviderProfileModuleCreate>>,
    TError,
    { moduleSlug: string; data: ModulePostBody },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Update HubModuleUserState based on the request data and the user's
current ProviderState.

Request Data has 3 keys, started, completed, and optional_fields_set
all of which have boolean values.

Only the keys with values of True are updated, such that modules do not
get un-started / un-completed.
 */
export const apiProviderProfileModuleStateCreate = (
  moduleSlug: string,
  moduleStateRequest: ModuleStateRequest
) => {
  return HTTP<void>({
    url: `/api/v7/provider-profile/module/${moduleSlug}/state/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: moduleStateRequest,
  });
};

export type ApiProviderProfileModuleStateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfileModuleStateCreate>>
>;
export type ApiProviderProfileModuleStateCreateMutationBody = ModuleStateRequest;
export type ApiProviderProfileModuleStateCreateMutationError = ErrorType<unknown>;

export const useApiProviderProfileModuleStateCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiProviderProfileModuleStateCreate>>,
    TError,
    { moduleSlug: string; data: ModuleStateRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiProviderProfileModuleStateCreate>>,
    { moduleSlug: string; data: ModuleStateRequest }
  > = (props) => {
    const { moduleSlug, data } = props ?? {};

    return apiProviderProfileModuleStateCreate(moduleSlug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiProviderProfileModuleStateCreate>>,
    TError,
    { moduleSlug: string; data: ModuleStateRequest },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Uncompletes a module, as in sets the module's completed field to False.
Note that uncompleting service modules is currently not supported.
 */
export const apiProviderProfileModuleStateUncompleteCreate = (moduleSlug: string) => {
  return HTTP<void>({
    url: `/api/v7/provider-profile/module/${moduleSlug}/state-uncomplete/`,
    method: 'post',
  });
};

export type ApiProviderProfileModuleStateUncompleteCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfileModuleStateUncompleteCreate>>
>;

export type ApiProviderProfileModuleStateUncompleteCreateMutationError = ErrorType<unknown>;

export const useApiProviderProfileModuleStateUncompleteCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiProviderProfileModuleStateUncompleteCreate>>,
    TError,
    { moduleSlug: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiProviderProfileModuleStateUncompleteCreate>>,
    { moduleSlug: string }
  > = (props) => {
    const { moduleSlug } = props ?? {};

    return apiProviderProfileModuleStateUncompleteCreate(moduleSlug);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiProviderProfileModuleStateUncompleteCreate>>,
    TError,
    { moduleSlug: string },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiProviderProfilePersonServicePreferencesRetrieve = (
  servicePreferencesSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<ServicePreferencesContent>({
    url: `/api/v7/provider-profile/person/${servicePreferencesSlug}/`,
    method: 'get',
    signal,
  });
};

export const getApiProviderProfilePersonServicePreferencesRetrieveQueryKey = (
  servicePreferencesSlug: string
) => [`/api/v7/provider-profile/person/${servicePreferencesSlug}/`];

export type ApiProviderProfilePersonServicePreferencesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfilePersonServicePreferencesRetrieve>>
>;
export type ApiProviderProfilePersonServicePreferencesRetrieveQueryError = ErrorType<unknown>;

export const useApiProviderProfilePersonServicePreferencesRetrieve = <
  TData = Awaited<ReturnType<typeof apiProviderProfilePersonServicePreferencesRetrieve>>,
  TError = ErrorType<unknown>
>(
  servicePreferencesSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiProviderProfilePersonServicePreferencesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiProviderProfilePersonServicePreferencesRetrieveQueryKey(servicePreferencesSlug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiProviderProfilePersonServicePreferencesRetrieve>>
  > = ({ signal }) =>
    apiProviderProfilePersonServicePreferencesRetrieve(servicePreferencesSlug, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiProviderProfilePersonServicePreferencesRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!servicePreferencesSlug,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiProviderProfilePersonServicePreferencesUpdate = (
  servicePreferencesSlug: string,
  servicePreferencesContent: ServicePreferencesContent
) => {
  return HTTP<ServicePreferencesContent>({
    url: `/api/v7/provider-profile/person/${servicePreferencesSlug}/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: servicePreferencesContent,
  });
};

export type ApiProviderProfilePersonServicePreferencesUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfilePersonServicePreferencesUpdate>>
>;
export type ApiProviderProfilePersonServicePreferencesUpdateMutationBody =
  ServicePreferencesContent;
export type ApiProviderProfilePersonServicePreferencesUpdateMutationError = ErrorType<unknown>;

export const useApiProviderProfilePersonServicePreferencesUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiProviderProfilePersonServicePreferencesUpdate>>,
    TError,
    { servicePreferencesSlug: string; data: ServicePreferencesContent },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiProviderProfilePersonServicePreferencesUpdate>>,
    { servicePreferencesSlug: string; data: ServicePreferencesContent }
  > = (props) => {
    const { servicePreferencesSlug, data } = props ?? {};

    return apiProviderProfilePersonServicePreferencesUpdate(servicePreferencesSlug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiProviderProfilePersonServicePreferencesUpdate>>,
    TError,
    { servicePreferencesSlug: string; data: ServicePreferencesContent },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiProviderProfilePersonServicePreferencesPartialUpdate = (
  servicePreferencesSlug: string,
  patchedServicePreferencesContent: PatchedServicePreferencesContent
) => {
  return HTTP<ServicePreferencesContent>({
    url: `/api/v7/provider-profile/person/${servicePreferencesSlug}/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedServicePreferencesContent,
  });
};

export type ApiProviderProfilePersonServicePreferencesPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfilePersonServicePreferencesPartialUpdate>>
>;
export type ApiProviderProfilePersonServicePreferencesPartialUpdateMutationBody =
  PatchedServicePreferencesContent;
export type ApiProviderProfilePersonServicePreferencesPartialUpdateMutationError =
  ErrorType<unknown>;

export const useApiProviderProfilePersonServicePreferencesPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiProviderProfilePersonServicePreferencesPartialUpdate>>,
    TError,
    { servicePreferencesSlug: string; data: PatchedServicePreferencesContent },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiProviderProfilePersonServicePreferencesPartialUpdate>>,
    { servicePreferencesSlug: string; data: PatchedServicePreferencesContent }
  > = (props) => {
    const { servicePreferencesSlug, data } = props ?? {};

    return apiProviderProfilePersonServicePreferencesPartialUpdate(servicePreferencesSlug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiProviderProfilePersonServicePreferencesPartialUpdate>>,
    TError,
    { servicePreferencesSlug: string; data: PatchedServicePreferencesContent },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Create or delete objects that use DogTrainingServicePreferences in a ForeignKey relationship
 */
export const apiProviderProfilePersonDogTrainingBehaviorsList = (signal?: AbortSignal) => {
  return HTTP<DogTrainingBehavior[]>({
    url: `/api/v7/provider-profile/person/dog-training/behaviors/`,
    method: 'get',
    signal,
  });
};

export const getApiProviderProfilePersonDogTrainingBehaviorsListQueryKey = () => [
  `/api/v7/provider-profile/person/dog-training/behaviors/`,
];

export type ApiProviderProfilePersonDogTrainingBehaviorsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfilePersonDogTrainingBehaviorsList>>
>;
export type ApiProviderProfilePersonDogTrainingBehaviorsListQueryError = ErrorType<unknown>;

export const useApiProviderProfilePersonDogTrainingBehaviorsList = <
  TData = Awaited<ReturnType<typeof apiProviderProfilePersonDogTrainingBehaviorsList>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiProviderProfilePersonDogTrainingBehaviorsList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiProviderProfilePersonDogTrainingBehaviorsListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiProviderProfilePersonDogTrainingBehaviorsList>>
  > = ({ signal }) => apiProviderProfilePersonDogTrainingBehaviorsList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiProviderProfilePersonDogTrainingBehaviorsList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Create or delete objects that use DogTrainingServicePreferences in a ForeignKey relationship
 */
export const apiProviderProfilePersonDogTrainingBehaviorsUpdate = (
  dogTrainingBehavior: DogTrainingBehavior[]
) => {
  return HTTP<DogTrainingResponse[]>({
    url: `/api/v7/provider-profile/person/dog-training/behaviors/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: dogTrainingBehavior,
  });
};

export type ApiProviderProfilePersonDogTrainingBehaviorsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfilePersonDogTrainingBehaviorsUpdate>>
>;
export type ApiProviderProfilePersonDogTrainingBehaviorsUpdateMutationBody = DogTrainingBehavior[];
export type ApiProviderProfilePersonDogTrainingBehaviorsUpdateMutationError = ErrorType<unknown>;

export const useApiProviderProfilePersonDogTrainingBehaviorsUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiProviderProfilePersonDogTrainingBehaviorsUpdate>>,
    TError,
    { data: DogTrainingBehavior[] },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiProviderProfilePersonDogTrainingBehaviorsUpdate>>,
    { data: DogTrainingBehavior[] }
  > = (props) => {
    const { data } = props ?? {};

    return apiProviderProfilePersonDogTrainingBehaviorsUpdate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiProviderProfilePersonDogTrainingBehaviorsUpdate>>,
    TError,
    { data: DogTrainingBehavior[] },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Create or delete objects that use DogTrainingServicePreferences in a ForeignKey relationship
 */
export const apiProviderProfilePersonDogTrainingToolsList = (signal?: AbortSignal) => {
  return HTTP<DogTrainingTool[]>({
    url: `/api/v7/provider-profile/person/dog-training/tools/`,
    method: 'get',
    signal,
  });
};

export const getApiProviderProfilePersonDogTrainingToolsListQueryKey = () => [
  `/api/v7/provider-profile/person/dog-training/tools/`,
];

export type ApiProviderProfilePersonDogTrainingToolsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfilePersonDogTrainingToolsList>>
>;
export type ApiProviderProfilePersonDogTrainingToolsListQueryError = ErrorType<unknown>;

export const useApiProviderProfilePersonDogTrainingToolsList = <
  TData = Awaited<ReturnType<typeof apiProviderProfilePersonDogTrainingToolsList>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiProviderProfilePersonDogTrainingToolsList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiProviderProfilePersonDogTrainingToolsListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiProviderProfilePersonDogTrainingToolsList>>
  > = ({ signal }) => apiProviderProfilePersonDogTrainingToolsList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiProviderProfilePersonDogTrainingToolsList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Create or delete objects that use DogTrainingServicePreferences in a ForeignKey relationship
 */
export const apiProviderProfilePersonDogTrainingToolsUpdate = (
  dogTrainingTool: DogTrainingTool[]
) => {
  return HTTP<DogTrainingResponse[]>({
    url: `/api/v7/provider-profile/person/dog-training/tools/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: dogTrainingTool,
  });
};

export type ApiProviderProfilePersonDogTrainingToolsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfilePersonDogTrainingToolsUpdate>>
>;
export type ApiProviderProfilePersonDogTrainingToolsUpdateMutationBody = DogTrainingTool[];
export type ApiProviderProfilePersonDogTrainingToolsUpdateMutationError = ErrorType<unknown>;

export const useApiProviderProfilePersonDogTrainingToolsUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiProviderProfilePersonDogTrainingToolsUpdate>>,
    TError,
    { data: DogTrainingTool[] },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiProviderProfilePersonDogTrainingToolsUpdate>>,
    { data: DogTrainingTool[] }
  > = (props) => {
    const { data } = props ?? {};

    return apiProviderProfilePersonDogTrainingToolsUpdate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiProviderProfilePersonDogTrainingToolsUpdate>>,
    TError,
    { data: DogTrainingTool[] },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Return the list of service types available for selection on the
ServiceTypeSelectorPage.
 */
export const apiProviderProfileServiceTypesList = (signal?: AbortSignal) => {
  return HTTP<ProviderProfileServiceType[]>({
    url: `/api/v7/provider-profile/service-types/`,
    method: 'get',
    signal,
  });
};

export const getApiProviderProfileServiceTypesListQueryKey = () => [
  `/api/v7/provider-profile/service-types/`,
];

export type ApiProviderProfileServiceTypesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfileServiceTypesList>>
>;
export type ApiProviderProfileServiceTypesListQueryError = ErrorType<unknown>;

export const useApiProviderProfileServiceTypesList = <
  TData = Awaited<ReturnType<typeof apiProviderProfileServiceTypesList>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiProviderProfileServiceTypesList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiProviderProfileServiceTypesListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiProviderProfileServiceTypesList>>> = ({
    signal,
  }) => apiProviderProfileServiceTypesList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiProviderProfileServiceTypesList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiProviderProfileServiceAvailabilityRetrieve = (
  serviceOpk: string,
  signal?: AbortSignal
) => {
  return HTTP<ProviderProfileAvailabilityPreferences>({
    url: `/api/v7/provider-profile/services/${serviceOpk}/availability/`,
    method: 'get',
    signal,
  });
};

export const getApiProviderProfileServiceAvailabilityRetrieveQueryKey = (serviceOpk: string) => [
  `/api/v7/provider-profile/services/${serviceOpk}/availability/`,
];

export type ApiProviderProfileServiceAvailabilityRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfileServiceAvailabilityRetrieve>>
>;
export type ApiProviderProfileServiceAvailabilityRetrieveQueryError = ErrorType<unknown>;

export const useApiProviderProfileServiceAvailabilityRetrieve = <
  TData = Awaited<ReturnType<typeof apiProviderProfileServiceAvailabilityRetrieve>>,
  TError = ErrorType<unknown>
>(
  serviceOpk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiProviderProfileServiceAvailabilityRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiProviderProfileServiceAvailabilityRetrieveQueryKey(serviceOpk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiProviderProfileServiceAvailabilityRetrieve>>
  > = ({ signal }) => apiProviderProfileServiceAvailabilityRetrieve(serviceOpk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiProviderProfileServiceAvailabilityRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!serviceOpk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiProviderProfileServiceAvailabilityUpdate = (
  serviceOpk: string,
  providerProfileAvailabilityPreferences: ProviderProfileAvailabilityPreferences
) => {
  return HTTP<ProviderProfileAvailabilityPreferences>({
    url: `/api/v7/provider-profile/services/${serviceOpk}/availability/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: providerProfileAvailabilityPreferences,
  });
};

export type ApiProviderProfileServiceAvailabilityUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfileServiceAvailabilityUpdate>>
>;
export type ApiProviderProfileServiceAvailabilityUpdateMutationBody =
  ProviderProfileAvailabilityPreferences;
export type ApiProviderProfileServiceAvailabilityUpdateMutationError = ErrorType<unknown>;

export const useApiProviderProfileServiceAvailabilityUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiProviderProfileServiceAvailabilityUpdate>>,
    TError,
    { serviceOpk: string; data: ProviderProfileAvailabilityPreferences },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiProviderProfileServiceAvailabilityUpdate>>,
    { serviceOpk: string; data: ProviderProfileAvailabilityPreferences }
  > = (props) => {
    const { serviceOpk, data } = props ?? {};

    return apiProviderProfileServiceAvailabilityUpdate(serviceOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiProviderProfileServiceAvailabilityUpdate>>,
    TError,
    { serviceOpk: string; data: ProviderProfileAvailabilityPreferences },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiProviderProfileServicePetPreferencesRetrieve = (
  serviceOpk: string,
  signal?: AbortSignal
) => {
  return HTTP<PetPreferences>({
    url: `/api/v7/provider-profile/services/${serviceOpk}/pet-preferences/`,
    method: 'get',
    signal,
  });
};

export const getApiProviderProfileServicePetPreferencesRetrieveQueryKey = (serviceOpk: string) => [
  `/api/v7/provider-profile/services/${serviceOpk}/pet-preferences/`,
];

export type ApiProviderProfileServicePetPreferencesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfileServicePetPreferencesRetrieve>>
>;
export type ApiProviderProfileServicePetPreferencesRetrieveQueryError = ErrorType<unknown>;

export const useApiProviderProfileServicePetPreferencesRetrieve = <
  TData = Awaited<ReturnType<typeof apiProviderProfileServicePetPreferencesRetrieve>>,
  TError = ErrorType<unknown>
>(
  serviceOpk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiProviderProfileServicePetPreferencesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiProviderProfileServicePetPreferencesRetrieveQueryKey(serviceOpk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiProviderProfileServicePetPreferencesRetrieve>>
  > = ({ signal }) => apiProviderProfileServicePetPreferencesRetrieve(serviceOpk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiProviderProfileServicePetPreferencesRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!serviceOpk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiProviderProfileServicePetPreferencesUpdate = (
  serviceOpk: string,
  petPreferences: PetPreferences
) => {
  return HTTP<PetPreferences>({
    url: `/api/v7/provider-profile/services/${serviceOpk}/pet-preferences/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: petPreferences,
  });
};

export type ApiProviderProfileServicePetPreferencesUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfileServicePetPreferencesUpdate>>
>;
export type ApiProviderProfileServicePetPreferencesUpdateMutationBody = PetPreferences;
export type ApiProviderProfileServicePetPreferencesUpdateMutationError = ErrorType<unknown>;

export const useApiProviderProfileServicePetPreferencesUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiProviderProfileServicePetPreferencesUpdate>>,
    TError,
    { serviceOpk: string; data: PetPreferences },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiProviderProfileServicePetPreferencesUpdate>>,
    { serviceOpk: string; data: PetPreferences }
  > = (props) => {
    const { serviceOpk, data } = props ?? {};

    return apiProviderProfileServicePetPreferencesUpdate(serviceOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiProviderProfileServicePetPreferencesUpdate>>,
    TError,
    { serviceOpk: string; data: PetPreferences },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiProviderProfileServicePetPreferencesPartialUpdate = (
  serviceOpk: string,
  patchedPetPreferences: PatchedPetPreferences
) => {
  return HTTP<PetPreferences>({
    url: `/api/v7/provider-profile/services/${serviceOpk}/pet-preferences/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedPetPreferences,
  });
};

export type ApiProviderProfileServicePetPreferencesPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfileServicePetPreferencesPartialUpdate>>
>;
export type ApiProviderProfileServicePetPreferencesPartialUpdateMutationBody =
  PatchedPetPreferences;
export type ApiProviderProfileServicePetPreferencesPartialUpdateMutationError = ErrorType<unknown>;

export const useApiProviderProfileServicePetPreferencesPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiProviderProfileServicePetPreferencesPartialUpdate>>,
    TError,
    { serviceOpk: string; data: PatchedPetPreferences },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiProviderProfileServicePetPreferencesPartialUpdate>>,
    { serviceOpk: string; data: PatchedPetPreferences }
  > = (props) => {
    const { serviceOpk, data } = props ?? {};

    return apiProviderProfileServicePetPreferencesPartialUpdate(serviceOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiProviderProfileServicePetPreferencesPartialUpdate>>,
    TError,
    { serviceOpk: string; data: PatchedPetPreferences },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiProviderProfileServiceRatesList = (serviceOpk: string, signal?: AbortSignal) => {
  return HTTP<ProfileServiceAddOn[]>({
    url: `/api/v7/provider-profile/services/${serviceOpk}/rates/`,
    method: 'get',
    signal,
  });
};

export const getApiProviderProfileServiceRatesListQueryKey = (serviceOpk: string) => [
  `/api/v7/provider-profile/services/${serviceOpk}/rates/`,
];

export type ApiProviderProfileServiceRatesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfileServiceRatesList>>
>;
export type ApiProviderProfileServiceRatesListQueryError = ErrorType<unknown>;

export const useApiProviderProfileServiceRatesList = <
  TData = Awaited<ReturnType<typeof apiProviderProfileServiceRatesList>>,
  TError = ErrorType<unknown>
>(
  serviceOpk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiProviderProfileServiceRatesList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiProviderProfileServiceRatesListQueryKey(serviceOpk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiProviderProfileServiceRatesList>>> = ({
    signal,
  }) => apiProviderProfileServiceRatesList(serviceOpk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiProviderProfileServiceRatesList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!serviceOpk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Allows updates on standard rate when user is applicant and all other
rates minus cost adjustment when user is provider.
 */
export const apiProviderProfileServiceRatesUpdate = (
  serviceOpk: string,
  servicesRates: ServicesRates
) => {
  return HTTP<ServiceRatesResponse[]>({
    url: `/api/v7/provider-profile/services/${serviceOpk}/rates/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: servicesRates,
  });
};

export type ApiProviderProfileServiceRatesUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfileServiceRatesUpdate>>
>;
export type ApiProviderProfileServiceRatesUpdateMutationBody = ServicesRates;
export type ApiProviderProfileServiceRatesUpdateMutationError = ErrorType<unknown>;

export const useApiProviderProfileServiceRatesUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiProviderProfileServiceRatesUpdate>>,
    TError,
    { serviceOpk: string; data: ServicesRates },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiProviderProfileServiceRatesUpdate>>,
    { serviceOpk: string; data: ServicesRates }
  > = (props) => {
    const { serviceOpk, data } = props ?? {};

    return apiProviderProfileServiceRatesUpdate(serviceOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiProviderProfileServiceRatesUpdate>>,
    TError,
    { serviceOpk: string; data: ServicesRates },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiProviderProfileRecommendedRatesCalculatorList = (
  serviceOpk: string,
  params: ApiProviderProfileRecommendedRatesCalculatorListParams,
  signal?: AbortSignal
) => {
  return HTTP<RecommendedRatesCalculator[]>({
    url: `/api/v7/provider-profile/services/${serviceOpk}/recommended-rates/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiProviderProfileRecommendedRatesCalculatorListQueryKey = (
  serviceOpk: string,
  params: ApiProviderProfileRecommendedRatesCalculatorListParams
) => [
  `/api/v7/provider-profile/services/${serviceOpk}/recommended-rates/`,
  ...(params ? [params] : []),
];

export type ApiProviderProfileRecommendedRatesCalculatorListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfileRecommendedRatesCalculatorList>>
>;
export type ApiProviderProfileRecommendedRatesCalculatorListQueryError = ErrorType<unknown>;

export const useApiProviderProfileRecommendedRatesCalculatorList = <
  TData = Awaited<ReturnType<typeof apiProviderProfileRecommendedRatesCalculatorList>>,
  TError = ErrorType<unknown>
>(
  serviceOpk: string,
  params: ApiProviderProfileRecommendedRatesCalculatorListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiProviderProfileRecommendedRatesCalculatorList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiProviderProfileRecommendedRatesCalculatorListQueryKey(serviceOpk, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiProviderProfileRecommendedRatesCalculatorList>>
  > = ({ signal }) => apiProviderProfileRecommendedRatesCalculatorList(serviceOpk, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiProviderProfileRecommendedRatesCalculatorList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!serviceOpk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiProviderProfileServiceRetrieve = (serviceSlug: string, signal?: AbortSignal) => {
  return HTTP<ProfileService>({
    url: `/api/v7/provider-profile/services/${serviceSlug}/`,
    method: 'get',
    signal,
  });
};

export const getApiProviderProfileServiceRetrieveQueryKey = (serviceSlug: string) => [
  `/api/v7/provider-profile/services/${serviceSlug}/`,
];

export type ApiProviderProfileServiceRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfileServiceRetrieve>>
>;
export type ApiProviderProfileServiceRetrieveQueryError = ErrorType<unknown>;

export const useApiProviderProfileServiceRetrieve = <
  TData = Awaited<ReturnType<typeof apiProviderProfileServiceRetrieve>>,
  TError = ErrorType<unknown>
>(
  serviceSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiProviderProfileServiceRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiProviderProfileServiceRetrieveQueryKey(serviceSlug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiProviderProfileServiceRetrieve>>> = ({
    signal,
  }) => apiProviderProfileServiceRetrieve(serviceSlug, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiProviderProfileServiceRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!serviceSlug,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiProviderProfileServiceCreate = (
  serviceSlug: string,
  profileService: ProfileService
) => {
  return HTTP<ProfileService>({
    url: `/api/v7/provider-profile/services/${serviceSlug}/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: profileService,
  });
};

export type ApiProviderProfileServiceCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfileServiceCreate>>
>;
export type ApiProviderProfileServiceCreateMutationBody = ProfileService;
export type ApiProviderProfileServiceCreateMutationError = ErrorType<unknown>;

export const useApiProviderProfileServiceCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiProviderProfileServiceCreate>>,
    TError,
    { serviceSlug: string; data: ProfileService },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiProviderProfileServiceCreate>>,
    { serviceSlug: string; data: ProfileService }
  > = (props) => {
    const { serviceSlug, data } = props ?? {};

    return apiProviderProfileServiceCreate(serviceSlug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiProviderProfileServiceCreate>>,
    TError,
    { serviceSlug: string; data: ProfileService },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiProviderProfileServiceUpdate = (
  serviceSlug: string,
  profileService: ProfileService
) => {
  return HTTP<ProfileService>({
    url: `/api/v7/provider-profile/services/${serviceSlug}/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: profileService,
  });
};

export type ApiProviderProfileServiceUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfileServiceUpdate>>
>;
export type ApiProviderProfileServiceUpdateMutationBody = ProfileService;
export type ApiProviderProfileServiceUpdateMutationError = ErrorType<unknown>;

export const useApiProviderProfileServiceUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiProviderProfileServiceUpdate>>,
    TError,
    { serviceSlug: string; data: ProfileService },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiProviderProfileServiceUpdate>>,
    { serviceSlug: string; data: ProfileService }
  > = (props) => {
    const { serviceSlug, data } = props ?? {};

    return apiProviderProfileServiceUpdate(serviceSlug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiProviderProfileServiceUpdate>>,
    TError,
    { serviceSlug: string; data: ProfileService },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiProviderProfileServicePartialUpdate = (
  serviceSlug: string,
  patchedProfileService: PatchedProfileService
) => {
  return HTTP<ProfileService>({
    url: `/api/v7/provider-profile/services/${serviceSlug}/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedProfileService,
  });
};

export type ApiProviderProfileServicePartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfileServicePartialUpdate>>
>;
export type ApiProviderProfileServicePartialUpdateMutationBody = PatchedProfileService;
export type ApiProviderProfileServicePartialUpdateMutationError = ErrorType<unknown>;

export const useApiProviderProfileServicePartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiProviderProfileServicePartialUpdate>>,
    TError,
    { serviceSlug: string; data: PatchedProfileService },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiProviderProfileServicePartialUpdate>>,
    { serviceSlug: string; data: PatchedProfileService }
  > = (props) => {
    const { serviceSlug, data } = props ?? {};

    return apiProviderProfileServicePartialUpdate(serviceSlug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiProviderProfileServicePartialUpdate>>,
    TError,
    { serviceSlug: string; data: PatchedProfileService },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Sets reasonable pagination defaults for all the API list/create views.
 */
export const apiProviderProfileCreateServicesList = (signal?: AbortSignal) => {
  return HTTP<ProfileService[]>({
    url: `/api/v7/provider-profile/services/list/`,
    method: 'get',
    signal,
  });
};

export const getApiProviderProfileCreateServicesListQueryKey = () => [
  `/api/v7/provider-profile/services/list/`,
];

export type ApiProviderProfileCreateServicesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfileCreateServicesList>>
>;
export type ApiProviderProfileCreateServicesListQueryError = ErrorType<unknown>;

export const useApiProviderProfileCreateServicesList = <
  TData = Awaited<ReturnType<typeof apiProviderProfileCreateServicesList>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiProviderProfileCreateServicesList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiProviderProfileCreateServicesListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiProviderProfileCreateServicesList>>
  > = ({ signal }) => apiProviderProfileCreateServicesList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiProviderProfileCreateServicesList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list/create views.
 */
export const apiProviderProfileCreateServicesCreate = (
  serviceListViewRequest: ServiceListViewRequest
) => {
  return HTTP<ProfileService[]>({
    url: `/api/v7/provider-profile/services/list/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: serviceListViewRequest,
  });
};

export type ApiProviderProfileCreateServicesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfileCreateServicesCreate>>
>;
export type ApiProviderProfileCreateServicesCreateMutationBody = ServiceListViewRequest;
export type ApiProviderProfileCreateServicesCreateMutationError = ErrorType<unknown>;

export const useApiProviderProfileCreateServicesCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiProviderProfileCreateServicesCreate>>,
    TError,
    { data: ServiceListViewRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiProviderProfileCreateServicesCreate>>,
    { data: ServiceListViewRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiProviderProfileCreateServicesCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiProviderProfileCreateServicesCreate>>,
    TError,
    { data: ServiceListViewRequest },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Retrieve a list of chapters for user and user state to inform display on
training sign up hub. Chapters contain modules/accordions, their states,
and types. This is a separate view because existing trainers who otherwise
see the management hub still need to be able to see this hub if they are
signing up as sitters. This view also conditionally updates provider state
and reloads the response.
 */
export const apiExistingTrainerSitterSignUpHubViewRetrieve = (
  serviceSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<HubResponse>({
    url: `/api/v7/provider-profile/trainer-sitter-sign-up/${serviceSlug}/`,
    method: 'get',
    signal,
  });
};

export const getApiExistingTrainerSitterSignUpHubViewRetrieveQueryKey = (serviceSlug: string) => [
  `/api/v7/provider-profile/trainer-sitter-sign-up/${serviceSlug}/`,
];

export type ApiExistingTrainerSitterSignUpHubViewRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiExistingTrainerSitterSignUpHubViewRetrieve>>
>;
export type ApiExistingTrainerSitterSignUpHubViewRetrieveQueryError = ErrorType<unknown>;

export const useApiExistingTrainerSitterSignUpHubViewRetrieve = <
  TData = Awaited<ReturnType<typeof apiExistingTrainerSitterSignUpHubViewRetrieve>>,
  TError = ErrorType<unknown>
>(
  serviceSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiExistingTrainerSitterSignUpHubViewRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiExistingTrainerSitterSignUpHubViewRetrieveQueryKey(serviceSlug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiExistingTrainerSitterSignUpHubViewRetrieve>>
  > = ({ signal }) => apiExistingTrainerSitterSignUpHubViewRetrieve(serviceSlug, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiExistingTrainerSitterSignUpHubViewRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!serviceSlug,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiProviderProfileWindowingRetrieve = (signal?: AbortSignal) => {
  return HTTP<ServiceSelector>({
    url: `/api/v7/provider-profile/windowing/`,
    method: 'get',
    signal,
  });
};

export const getApiProviderProfileWindowingRetrieveQueryKey = () => [
  `/api/v7/provider-profile/windowing/`,
];

export type ApiProviderProfileWindowingRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfileWindowingRetrieve>>
>;
export type ApiProviderProfileWindowingRetrieveQueryError = ErrorType<unknown>;

export const useApiProviderProfileWindowingRetrieve = <
  TData = Awaited<ReturnType<typeof apiProviderProfileWindowingRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiProviderProfileWindowingRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiProviderProfileWindowingRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiProviderProfileWindowingRetrieve>>> = ({
    signal,
  }) => apiProviderProfileWindowingRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiProviderProfileWindowingRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiRecap2025ViewRetrieve = (signal?: AbortSignal) => {
  return HTTP<Recap2025>({ url: `/api/v7/recap-2025/`, method: 'get', signal });
};

export const getApiRecap2025ViewRetrieveQueryKey = () => [`/api/v7/recap-2025/`];

export type ApiRecap2025ViewRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiRecap2025ViewRetrieve>>
>;
export type ApiRecap2025ViewRetrieveQueryError = ErrorType<unknown>;

export const useApiRecap2025ViewRetrieve = <
  TData = Awaited<ReturnType<typeof apiRecap2025ViewRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiRecap2025ViewRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiRecap2025ViewRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiRecap2025ViewRetrieve>>> = ({
    signal,
  }) => apiRecap2025ViewRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiRecap2025ViewRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list/create views.
 */
export const apiRecurringBillingList = (
  params?: ApiRecurringBillingListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedRecurringBillingRelationshipList>({
    url: `/api/v7/recurring-relationships/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiRecurringBillingListQueryKey = (params?: ApiRecurringBillingListParams) => [
  `/api/v7/recurring-relationships/`,
  ...(params ? [params] : []),
];

export type ApiRecurringBillingListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiRecurringBillingList>>
>;
export type ApiRecurringBillingListQueryError = ErrorType<unknown>;

export const useApiRecurringBillingList = <
  TData = Awaited<ReturnType<typeof apiRecurringBillingList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiRecurringBillingListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiRecurringBillingList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiRecurringBillingListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiRecurringBillingList>>> = ({
    signal,
  }) => apiRecurringBillingList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiRecurringBillingList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list/create views.
 */
export const apiRecurringBillingListCreate = (
  recurringBillingRelationshipCreation: RecurringBillingRelationshipCreation
) => {
  return HTTP<RecurringBillingRelationship>({
    url: `/api/v7/recurring-relationships/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: recurringBillingRelationshipCreation,
  });
};

export type ApiRecurringBillingListCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiRecurringBillingListCreate>>
>;
export type ApiRecurringBillingListCreateMutationBody = RecurringBillingRelationshipCreation;
export type ApiRecurringBillingListCreateMutationError = ErrorType<unknown>;

export const useApiRecurringBillingListCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiRecurringBillingListCreate>>,
    TError,
    { data: RecurringBillingRelationshipCreation },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiRecurringBillingListCreate>>,
    { data: RecurringBillingRelationshipCreation }
  > = (props) => {
    const { data } = props ?? {};

    return apiRecurringBillingListCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiRecurringBillingListCreate>>,
    TError,
    { data: RecurringBillingRelationshipCreation },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiRecurringBillingDetailRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<RecurringBillingRelationship>({
    url: `/api/v7/recurring-relationships/${opk}/`,
    method: 'get',
    signal,
  });
};

export const getApiRecurringBillingDetailRetrieveQueryKey = (opk: string) => [
  `/api/v7/recurring-relationships/${opk}/`,
];

export type ApiRecurringBillingDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiRecurringBillingDetailRetrieve>>
>;
export type ApiRecurringBillingDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiRecurringBillingDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiRecurringBillingDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiRecurringBillingDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiRecurringBillingDetailRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiRecurringBillingDetailRetrieve>>> = ({
    signal,
  }) => apiRecurringBillingDetailRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiRecurringBillingDetailRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiRecurringBillingDetailUpdate = (
  opk: string,
  recurringBillingRelationshipDetailRequest: RecurringBillingRelationshipDetailRequest
) => {
  return HTTP<RecurringBillingRelationship>({
    url: `/api/v7/recurring-relationships/${opk}/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: recurringBillingRelationshipDetailRequest,
  });
};

export type ApiRecurringBillingDetailUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiRecurringBillingDetailUpdate>>
>;
export type ApiRecurringBillingDetailUpdateMutationBody = RecurringBillingRelationshipDetailRequest;
export type ApiRecurringBillingDetailUpdateMutationError = ErrorType<unknown>;

export const useApiRecurringBillingDetailUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiRecurringBillingDetailUpdate>>,
    TError,
    { opk: string; data: RecurringBillingRelationshipDetailRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiRecurringBillingDetailUpdate>>,
    { opk: string; data: RecurringBillingRelationshipDetailRequest }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiRecurringBillingDetailUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiRecurringBillingDetailUpdate>>,
    TError,
    { opk: string; data: RecurringBillingRelationshipDetailRequest },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiRecurringBillingCancelCreate = (
  opk: string,
  recurringBillingRelationshipCancel: RecurringBillingRelationshipCancel
) => {
  return HTTP<void>({
    url: `/api/v7/recurring-relationships/${opk}/cancel/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: recurringBillingRelationshipCancel,
  });
};

export type ApiRecurringBillingCancelCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiRecurringBillingCancelCreate>>
>;
export type ApiRecurringBillingCancelCreateMutationBody = RecurringBillingRelationshipCancel;
export type ApiRecurringBillingCancelCreateMutationError = ErrorType<unknown>;

export const useApiRecurringBillingCancelCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiRecurringBillingCancelCreate>>,
    TError,
    { opk: string; data: RecurringBillingRelationshipCancel },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiRecurringBillingCancelCreate>>,
    { opk: string; data: RecurringBillingRelationshipCancel }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiRecurringBillingCancelCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiRecurringBillingCancelCreate>>,
    TError,
    { opk: string; data: RecurringBillingRelationshipCancel },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiRecurringBillingPricingCreate = (
  opk: string,
  conversationVersion: string,
  recurringPricing: RecurringPricing
) => {
  return HTTP<RecurringBillingPricingListResponse>({
    url: `/api/v7/recurring-relationships/${opk}/pricing/${conversationVersion}/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: recurringPricing,
  });
};

export type ApiRecurringBillingPricingCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiRecurringBillingPricingCreate>>
>;
export type ApiRecurringBillingPricingCreateMutationBody = RecurringPricing;
export type ApiRecurringBillingPricingCreateMutationError = ErrorType<unknown>;

export const useApiRecurringBillingPricingCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiRecurringBillingPricingCreate>>,
    TError,
    { opk: string; conversationVersion: string; data: RecurringPricing },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiRecurringBillingPricingCreate>>,
    { opk: string; conversationVersion: string; data: RecurringPricing }
  > = (props) => {
    const { opk, conversationVersion, data } = props ?? {};

    return apiRecurringBillingPricingCreate(opk, conversationVersion, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiRecurringBillingPricingCreate>>,
    TError,
    { opk: string; conversationVersion: string; data: RecurringPricing },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiRecurringScheduleWeeklyTemplatesRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<RecurringScheduleWeeklyTemplates>({
    url: `/api/v7/recurring-relationships/${opk}/schedule/`,
    method: 'get',
    signal,
  });
};

export const getApiRecurringScheduleWeeklyTemplatesRetrieveQueryKey = (opk: string) => [
  `/api/v7/recurring-relationships/${opk}/schedule/`,
];

export type ApiRecurringScheduleWeeklyTemplatesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiRecurringScheduleWeeklyTemplatesRetrieve>>
>;
export type ApiRecurringScheduleWeeklyTemplatesRetrieveQueryError = ErrorType<unknown>;

export const useApiRecurringScheduleWeeklyTemplatesRetrieve = <
  TData = Awaited<ReturnType<typeof apiRecurringScheduleWeeklyTemplatesRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiRecurringScheduleWeeklyTemplatesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiRecurringScheduleWeeklyTemplatesRetrieveQueryKey(opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiRecurringScheduleWeeklyTemplatesRetrieve>>
  > = ({ signal }) => apiRecurringScheduleWeeklyTemplatesRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiRecurringScheduleWeeklyTemplatesRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiRecurringScheduleWeeklyTemplatesUpdate = (
  opk: string,
  recurringScheduleWeeklyTemplates: RecurringScheduleWeeklyTemplates
) => {
  return HTTP<void>({
    url: `/api/v7/recurring-relationships/${opk}/schedule/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: recurringScheduleWeeklyTemplates,
  });
};

export type ApiRecurringScheduleWeeklyTemplatesUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiRecurringScheduleWeeklyTemplatesUpdate>>
>;
export type ApiRecurringScheduleWeeklyTemplatesUpdateMutationBody =
  RecurringScheduleWeeklyTemplates;
export type ApiRecurringScheduleWeeklyTemplatesUpdateMutationError = ErrorType<unknown>;

export const useApiRecurringScheduleWeeklyTemplatesUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiRecurringScheduleWeeklyTemplatesUpdate>>,
    TError,
    { opk: string; data: RecurringScheduleWeeklyTemplates },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiRecurringScheduleWeeklyTemplatesUpdate>>,
    { opk: string; data: RecurringScheduleWeeklyTemplates }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiRecurringScheduleWeeklyTemplatesUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiRecurringScheduleWeeklyTemplatesUpdate>>,
    TError,
    { opk: string; data: RecurringScheduleWeeklyTemplates },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiRecurringScheduleUnitsRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<UpcomingWeeklyUnits>({
    url: `/api/v7/recurring-relationships/${opk}/schedule-units/`,
    method: 'get',
    signal,
  });
};

export const getApiRecurringScheduleUnitsRetrieveQueryKey = (opk: string) => [
  `/api/v7/recurring-relationships/${opk}/schedule-units/`,
];

export type ApiRecurringScheduleUnitsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiRecurringScheduleUnitsRetrieve>>
>;
export type ApiRecurringScheduleUnitsRetrieveQueryError = ErrorType<unknown>;

export const useApiRecurringScheduleUnitsRetrieve = <
  TData = Awaited<ReturnType<typeof apiRecurringScheduleUnitsRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiRecurringScheduleUnitsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiRecurringScheduleUnitsRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiRecurringScheduleUnitsRetrieve>>> = ({
    signal,
  }) => apiRecurringScheduleUnitsRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiRecurringScheduleUnitsRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiRecurringScheduleUnitsCreate = (
  opk: string,
  dateWithTimeRanges: DateWithTimeRanges
) => {
  return HTTP<RecurringScheduleUnit>({
    url: `/api/v7/recurring-relationships/${opk}/schedule-units/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: dateWithTimeRanges,
  });
};

export type ApiRecurringScheduleUnitsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiRecurringScheduleUnitsCreate>>
>;
export type ApiRecurringScheduleUnitsCreateMutationBody = DateWithTimeRanges;
export type ApiRecurringScheduleUnitsCreateMutationError = ErrorType<unknown>;

export const useApiRecurringScheduleUnitsCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiRecurringScheduleUnitsCreate>>,
    TError,
    { opk: string; data: DateWithTimeRanges },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiRecurringScheduleUnitsCreate>>,
    { opk: string; data: DateWithTimeRanges }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiRecurringScheduleUnitsCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiRecurringScheduleUnitsCreate>>,
    TError,
    { opk: string; data: DateWithTimeRanges },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiRecurringScheduleUnitDetailUpdate = (
  opk: string,
  unitOpk: string,
  dateWithTimeRanges: DateWithTimeRanges
) => {
  return HTTP<void>({
    url: `/api/v7/recurring-relationships/${opk}/schedule-units/${unitOpk}/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: dateWithTimeRanges,
  });
};

export type ApiRecurringScheduleUnitDetailUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiRecurringScheduleUnitDetailUpdate>>
>;
export type ApiRecurringScheduleUnitDetailUpdateMutationBody = DateWithTimeRanges;
export type ApiRecurringScheduleUnitDetailUpdateMutationError = ErrorType<unknown>;

export const useApiRecurringScheduleUnitDetailUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiRecurringScheduleUnitDetailUpdate>>,
    TError,
    { opk: string; unitOpk: string; data: DateWithTimeRanges },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiRecurringScheduleUnitDetailUpdate>>,
    { opk: string; unitOpk: string; data: DateWithTimeRanges }
  > = (props) => {
    const { opk, unitOpk, data } = props ?? {};

    return apiRecurringScheduleUnitDetailUpdate(opk, unitOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiRecurringScheduleUnitDetailUpdate>>,
    TError,
    { opk: string; unitOpk: string; data: DateWithTimeRanges },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiRecurringScheduleUnitDetailDestroy = (opk: string, unitOpk: string) => {
  return HTTP<void>({
    url: `/api/v7/recurring-relationships/${opk}/schedule-units/${unitOpk}/`,
    method: 'delete',
  });
};

export type ApiRecurringScheduleUnitDetailDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiRecurringScheduleUnitDetailDestroy>>
>;

export type ApiRecurringScheduleUnitDetailDestroyMutationError = ErrorType<unknown>;

export const useApiRecurringScheduleUnitDetailDestroy = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiRecurringScheduleUnitDetailDestroy>>,
    TError,
    { opk: string; unitOpk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiRecurringScheduleUnitDetailDestroy>>,
    { opk: string; unitOpk: string }
  > = (props) => {
    const { opk, unitOpk } = props ?? {};

    return apiRecurringScheduleUnitDetailDestroy(opk, unitOpk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiRecurringScheduleUnitDetailDestroy>>,
    TError,
    { opk: string; unitOpk: string },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiRecurringSwitchToOneTimeCreate = (
  opk: string,
  apiRecurringSwitchToOneTimeCreateBody: ApiRecurringSwitchToOneTimeCreateBody
) => {
  return HTTP<Conversation>({
    url: `/api/v7/recurring-relationships/${opk}/to-one-time/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiRecurringSwitchToOneTimeCreateBody,
  });
};

export type ApiRecurringSwitchToOneTimeCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiRecurringSwitchToOneTimeCreate>>
>;
export type ApiRecurringSwitchToOneTimeCreateMutationBody = ApiRecurringSwitchToOneTimeCreateBody;
export type ApiRecurringSwitchToOneTimeCreateMutationError = ErrorType<unknown>;

export const useApiRecurringSwitchToOneTimeCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiRecurringSwitchToOneTimeCreate>>,
    TError,
    { opk: string; data: ApiRecurringSwitchToOneTimeCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiRecurringSwitchToOneTimeCreate>>,
    { opk: string; data: ApiRecurringSwitchToOneTimeCreateBody }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiRecurringSwitchToOneTimeCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiRecurringSwitchToOneTimeCreate>>,
    TError,
    { opk: string; data: ApiRecurringSwitchToOneTimeCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiReferEmailCreate = (referEmail: ReferEmail) => {
  return HTTP<ReferEmail>({
    url: `/api/v7/refer/email/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: referEmail,
  });
};

export type ApiReferEmailCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiReferEmailCreate>>
>;
export type ApiReferEmailCreateMutationBody = ReferEmail;
export type ApiReferEmailCreateMutationError = ErrorType<unknown>;

export const useApiReferEmailCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiReferEmailCreate>>,
    TError,
    { data: ReferEmail },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiReferEmailCreate>>,
    { data: ReferEmail }
  > = (props) => {
    const { data } = props ?? {};

    return apiReferEmailCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiReferEmailCreate>>,
    TError,
    { data: ReferEmail },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiReferralSourceChoicesRetrieve = (signal?: AbortSignal) => {
  return HTTP<Choices>({ url: `/api/v7/referral-source-choices/`, method: 'get', signal });
};

export const getApiReferralSourceChoicesRetrieveQueryKey = () => [
  `/api/v7/referral-source-choices/`,
];

export type ApiReferralSourceChoicesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiReferralSourceChoicesRetrieve>>
>;
export type ApiReferralSourceChoicesRetrieveQueryError = ErrorType<unknown>;

export const useApiReferralSourceChoicesRetrieve = <
  TData = Awaited<ReturnType<typeof apiReferralSourceChoicesRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiReferralSourceChoicesRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiReferralSourceChoicesRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiReferralSourceChoicesRetrieve>>> = ({
    signal,
  }) => apiReferralSourceChoicesRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiReferralSourceChoicesRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiPersonDetailsFromShortIdentifierRetrieve = (
  personShortIdentifier: string,
  signal?: AbortSignal
) => {
  return HTTP<PersonDetailsShortIdentifier>({
    url: `/api/v7/referral/${personShortIdentifier}/details/`,
    method: 'get',
    signal,
  });
};

export const getApiPersonDetailsFromShortIdentifierRetrieveQueryKey = (
  personShortIdentifier: string
) => [`/api/v7/referral/${personShortIdentifier}/details/`];

export type ApiPersonDetailsFromShortIdentifierRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonDetailsFromShortIdentifierRetrieve>>
>;
export type ApiPersonDetailsFromShortIdentifierRetrieveQueryError = ErrorType<Error | void>;

export const useApiPersonDetailsFromShortIdentifierRetrieve = <
  TData = Awaited<ReturnType<typeof apiPersonDetailsFromShortIdentifierRetrieve>>,
  TError = ErrorType<Error | void>
>(
  personShortIdentifier: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonDetailsFromShortIdentifierRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiPersonDetailsFromShortIdentifierRetrieveQueryKey(personShortIdentifier);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiPersonDetailsFromShortIdentifierRetrieve>>
  > = ({ signal }) => apiPersonDetailsFromShortIdentifierRetrieve(personShortIdentifier, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPersonDetailsFromShortIdentifierRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!personShortIdentifier,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiRelationshipList = (params?: ApiRelationshipListParams, signal?: AbortSignal) => {
  return HTTP<PaginatedRelationshipList>({
    url: `/api/v7/relationships/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiRelationshipListQueryKey = (params?: ApiRelationshipListParams) => [
  `/api/v7/relationships/`,
  ...(params ? [params] : []),
];

export type ApiRelationshipListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiRelationshipList>>
>;
export type ApiRelationshipListQueryError = ErrorType<unknown>;

export const useApiRelationshipList = <
  TData = Awaited<ReturnType<typeof apiRelationshipList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiRelationshipListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiRelationshipList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiRelationshipListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiRelationshipList>>> = ({ signal }) =>
    apiRelationshipList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiRelationshipList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiRelationshipDetailRetrieve = (
  viewerType: string,
  opk: string,
  params?: ApiRelationshipDetailRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<Relationship>({
    url: `/api/v7/relationships/as-${viewerType}/${opk}/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiRelationshipDetailRetrieveQueryKey = (
  viewerType: string,
  opk: string,
  params?: ApiRelationshipDetailRetrieveParams
) => [`/api/v7/relationships/as-${viewerType}/${opk}/`, ...(params ? [params] : [])];

export type ApiRelationshipDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiRelationshipDetailRetrieve>>
>;
export type ApiRelationshipDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiRelationshipDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiRelationshipDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  viewerType: string,
  opk: string,
  params?: ApiRelationshipDetailRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiRelationshipDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiRelationshipDetailRetrieveQueryKey(viewerType, opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiRelationshipDetailRetrieve>>> = ({
    signal,
  }) => apiRelationshipDetailRetrieve(viewerType, opk, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiRelationshipDetailRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!(viewerType && opk),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiRelationshipDetailUpdate = (
  viewerType: string,
  opk: string,
  relationshipDetailBody: RelationshipDetailBody
) => {
  return HTTP<Relationship>({
    url: `/api/v7/relationships/as-${viewerType}/${opk}/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: relationshipDetailBody,
  });
};

export type ApiRelationshipDetailUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiRelationshipDetailUpdate>>
>;
export type ApiRelationshipDetailUpdateMutationBody = RelationshipDetailBody;
export type ApiRelationshipDetailUpdateMutationError = ErrorType<unknown>;

export const useApiRelationshipDetailUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiRelationshipDetailUpdate>>,
    TError,
    { viewerType: string; opk: string; data: RelationshipDetailBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiRelationshipDetailUpdate>>,
    { viewerType: string; opk: string; data: RelationshipDetailBody }
  > = (props) => {
    const { viewerType, opk, data } = props ?? {};

    return apiRelationshipDetailUpdate(viewerType, opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiRelationshipDetailUpdate>>,
    TError,
    { viewerType: string; opk: string; data: RelationshipDetailBody },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiRelationshipCallPreferenceChoicesList = (
  viewerType: string,
  opk: string,
  params?: ApiRelationshipCallPreferenceChoicesListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedRelationshipCallPreferenceList>({
    url: `/api/v7/relationships/as-${viewerType}/${opk}/call-preference-choices/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiRelationshipCallPreferenceChoicesListQueryKey = (
  viewerType: string,
  opk: string,
  params?: ApiRelationshipCallPreferenceChoicesListParams
) => [
  `/api/v7/relationships/as-${viewerType}/${opk}/call-preference-choices/`,
  ...(params ? [params] : []),
];

export type ApiRelationshipCallPreferenceChoicesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiRelationshipCallPreferenceChoicesList>>
>;
export type ApiRelationshipCallPreferenceChoicesListQueryError = ErrorType<unknown>;

export const useApiRelationshipCallPreferenceChoicesList = <
  TData = Awaited<ReturnType<typeof apiRelationshipCallPreferenceChoicesList>>,
  TError = ErrorType<unknown>
>(
  viewerType: string,
  opk: string,
  params?: ApiRelationshipCallPreferenceChoicesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiRelationshipCallPreferenceChoicesList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiRelationshipCallPreferenceChoicesListQueryKey(viewerType, opk, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiRelationshipCallPreferenceChoicesList>>
  > = ({ signal }) => apiRelationshipCallPreferenceChoicesList(viewerType, opk, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiRelationshipCallPreferenceChoicesList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(viewerType && opk),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiRelationshipVcardRetrieve = (
  viewerType: string,
  opk: string,
  signal?: AbortSignal
) => {
  return HTTP<void>({
    url: `/api/v7/relationships/as-${viewerType}/${opk}/vcard/`,
    method: 'get',
    signal,
  });
};

export const getApiRelationshipVcardRetrieveQueryKey = (viewerType: string, opk: string) => [
  `/api/v7/relationships/as-${viewerType}/${opk}/vcard/`,
];

export type ApiRelationshipVcardRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiRelationshipVcardRetrieve>>
>;
export type ApiRelationshipVcardRetrieveQueryError = ErrorType<unknown>;

export const useApiRelationshipVcardRetrieve = <
  TData = Awaited<ReturnType<typeof apiRelationshipVcardRetrieve>>,
  TError = ErrorType<unknown>
>(
  viewerType: string,
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiRelationshipVcardRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiRelationshipVcardRetrieveQueryKey(viewerType, opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiRelationshipVcardRetrieve>>> = ({
    signal,
  }) => apiRelationshipVcardRetrieve(viewerType, opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiRelationshipVcardRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!(viewerType && opk),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiLockedServiceAddOnRetrieve = (
  ownerOpk: string,
  serviceSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<LockedServiceAddOnsForRelationship>({
    url: `/api/v7/relationships/as-provider/${ownerOpk}/rates/${serviceSlug}/`,
    method: 'get',
    signal,
  });
};

export const getApiLockedServiceAddOnRetrieveQueryKey = (ownerOpk: string, serviceSlug: string) => [
  `/api/v7/relationships/as-provider/${ownerOpk}/rates/${serviceSlug}/`,
];

export type ApiLockedServiceAddOnRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiLockedServiceAddOnRetrieve>>
>;
export type ApiLockedServiceAddOnRetrieveQueryError = ErrorType<void>;

export const useApiLockedServiceAddOnRetrieve = <
  TData = Awaited<ReturnType<typeof apiLockedServiceAddOnRetrieve>>,
  TError = ErrorType<void>
>(
  ownerOpk: string,
  serviceSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiLockedServiceAddOnRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiLockedServiceAddOnRetrieveQueryKey(ownerOpk, serviceSlug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLockedServiceAddOnRetrieve>>> = ({
    signal,
  }) => apiLockedServiceAddOnRetrieve(ownerOpk, serviceSlug, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiLockedServiceAddOnRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!(ownerOpk && serviceSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * @deprecated
 */
export const apiLockedServiceAddOnCreate = (
  ownerOpk: string,
  serviceSlug: string,
  lockedServiceAddOnRequest: LockedServiceAddOnRequest
) => {
  return HTTP<LockedServiceAddOn[]>({
    url: `/api/v7/relationships/as-provider/${ownerOpk}/rates/${serviceSlug}/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: lockedServiceAddOnRequest,
  });
};

export type ApiLockedServiceAddOnCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiLockedServiceAddOnCreate>>
>;
export type ApiLockedServiceAddOnCreateMutationBody = LockedServiceAddOnRequest;
export type ApiLockedServiceAddOnCreateMutationError = ErrorType<void>;

export const useApiLockedServiceAddOnCreate = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiLockedServiceAddOnCreate>>,
    TError,
    { ownerOpk: string; serviceSlug: string; data: LockedServiceAddOnRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiLockedServiceAddOnCreate>>,
    { ownerOpk: string; serviceSlug: string; data: LockedServiceAddOnRequest }
  > = (props) => {
    const { ownerOpk, serviceSlug, data } = props ?? {};

    return apiLockedServiceAddOnCreate(ownerOpk, serviceSlug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiLockedServiceAddOnCreate>>,
    TError,
    { ownerOpk: string; serviceSlug: string; data: LockedServiceAddOnRequest },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiLockedServiceAddOnDestroy = (ownerOpk: string, serviceSlug: string) => {
  return HTTP<void>({
    url: `/api/v7/relationships/as-provider/${ownerOpk}/rates/${serviceSlug}/`,
    method: 'delete',
  });
};

export type ApiLockedServiceAddOnDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiLockedServiceAddOnDestroy>>
>;

export type ApiLockedServiceAddOnDestroyMutationError = ErrorType<unknown>;

export const useApiLockedServiceAddOnDestroy = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiLockedServiceAddOnDestroy>>,
    TError,
    { ownerOpk: string; serviceSlug: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiLockedServiceAddOnDestroy>>,
    { ownerOpk: string; serviceSlug: string }
  > = (props) => {
    const { ownerOpk, serviceSlug } = props ?? {};

    return apiLockedServiceAddOnDestroy(ownerOpk, serviceSlug);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiLockedServiceAddOnDestroy>>,
    TError,
    { ownerOpk: string; serviceSlug: string },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiLockedServiceAddOnCalculatorCreate = (
  ownerOpk: string,
  serviceSlug: string,
  calculatedLockedServiceAddOns: CalculatedLockedServiceAddOns
) => {
  return HTTP<CalculatedLockedServiceAddOns>({
    url: `/api/v7/relationships/as-provider/${ownerOpk}/rates/${serviceSlug}/calculator/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: calculatedLockedServiceAddOns,
  });
};

export type ApiLockedServiceAddOnCalculatorCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiLockedServiceAddOnCalculatorCreate>>
>;
export type ApiLockedServiceAddOnCalculatorCreateMutationBody = CalculatedLockedServiceAddOns;
export type ApiLockedServiceAddOnCalculatorCreateMutationError = ErrorType<void>;

export const useApiLockedServiceAddOnCalculatorCreate = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiLockedServiceAddOnCalculatorCreate>>,
    TError,
    { ownerOpk: string; serviceSlug: string; data: CalculatedLockedServiceAddOns },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiLockedServiceAddOnCalculatorCreate>>,
    { ownerOpk: string; serviceSlug: string; data: CalculatedLockedServiceAddOns }
  > = (props) => {
    const { ownerOpk, serviceSlug, data } = props ?? {};

    return apiLockedServiceAddOnCalculatorCreate(ownerOpk, serviceSlug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiLockedServiceAddOnCalculatorCreate>>,
    TError,
    { ownerOpk: string; serviceSlug: string; data: CalculatedLockedServiceAddOns },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiFavoriteSittersList = (
  params?: ApiFavoriteSittersListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedFavoriteSitterList>({
    url: `/api/v7/relationships/favorites/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiFavoriteSittersListQueryKey = (params?: ApiFavoriteSittersListParams) => [
  `/api/v7/relationships/favorites/`,
  ...(params ? [params] : []),
];

export type ApiFavoriteSittersListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFavoriteSittersList>>
>;
export type ApiFavoriteSittersListQueryError = ErrorType<unknown>;

export const useApiFavoriteSittersList = <
  TData = Awaited<ReturnType<typeof apiFavoriteSittersList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiFavoriteSittersListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiFavoriteSittersList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFavoriteSittersListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFavoriteSittersList>>> = ({ signal }) =>
    apiFavoriteSittersList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiFavoriteSittersList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiReportProviderRatingCreate = (objectOpk: string, report: Report) => {
  return HTTP<ReportResponse>({
    url: `/api/v7/report-provider-rating/${objectOpk}/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: report,
  });
};

export type ApiReportProviderRatingCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiReportProviderRatingCreate>>
>;
export type ApiReportProviderRatingCreateMutationBody = Report;
export type ApiReportProviderRatingCreateMutationError = ErrorType<unknown>;

export const useApiReportProviderRatingCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiReportProviderRatingCreate>>,
    TError,
    { objectOpk: string; data: Report },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiReportProviderRatingCreate>>,
    { objectOpk: string; data: Report }
  > = (props) => {
    const { objectOpk, data } = props ?? {};

    return apiReportProviderRatingCreate(objectOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiReportProviderRatingCreate>>,
    TError,
    { objectOpk: string; data: Report },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiReportRequesterReviewCreate = (objectOpk: string, report: Report) => {
  return HTTP<ReportResponse>({
    url: `/api/v7/report-requester-review/${objectOpk}/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: report,
  });
};

export type ApiReportRequesterReviewCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiReportRequesterReviewCreate>>
>;
export type ApiReportRequesterReviewCreateMutationBody = Report;
export type ApiReportRequesterReviewCreateMutationError = ErrorType<unknown>;

export const useApiReportRequesterReviewCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiReportRequesterReviewCreate>>,
    TError,
    { objectOpk: string; data: Report },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiReportRequesterReviewCreate>>,
    { objectOpk: string; data: Report }
  > = (props) => {
    const { objectOpk, data } = props ?? {};

    return apiReportRequesterReviewCreate(objectOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiReportRequesterReviewCreate>>,
    TError,
    { objectOpk: string; data: Report },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiReportCreate = (sourceType: string, objectOpk: string, report: Report) => {
  return HTTP<ReportResponse>({
    url: `/api/v7/report/${sourceType}/${objectOpk}/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: report,
  });
};

export type ApiReportCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiReportCreate>>
>;
export type ApiReportCreateMutationBody = Report;
export type ApiReportCreateMutationError = ErrorType<unknown>;

export const useApiReportCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiReportCreate>>,
    TError,
    { sourceType: string; objectOpk: string; data: Report },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiReportCreate>>,
    { sourceType: string; objectOpk: string; data: Report }
  > = (props) => {
    const { sourceType, objectOpk, data } = props ?? {};

    return apiReportCreate(sourceType, objectOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiReportCreate>>,
    TError,
    { sourceType: string; objectOpk: string; data: Report },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiReportConversationSubreasonsRetrieve = (
  objectOpk: string,
  signal?: AbortSignal
) => {
  return HTTP<ReportSubreasonsResponse>({
    url: `/api/v7/report/conversation/${objectOpk}/reasons/`,
    method: 'get',
    signal,
  });
};

export const getApiReportConversationSubreasonsRetrieveQueryKey = (objectOpk: string) => [
  `/api/v7/report/conversation/${objectOpk}/reasons/`,
];

export type ApiReportConversationSubreasonsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiReportConversationSubreasonsRetrieve>>
>;
export type ApiReportConversationSubreasonsRetrieveQueryError = ErrorType<unknown>;

export const useApiReportConversationSubreasonsRetrieve = <
  TData = Awaited<ReturnType<typeof apiReportConversationSubreasonsRetrieve>>,
  TError = ErrorType<unknown>
>(
  objectOpk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiReportConversationSubreasonsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiReportConversationSubreasonsRetrieveQueryKey(objectOpk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiReportConversationSubreasonsRetrieve>>
  > = ({ signal }) => apiReportConversationSubreasonsRetrieve(objectOpk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiReportConversationSubreasonsRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!objectOpk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiReportProviderRatingSubreasonsRetrieve = (
  objectOpk: string,
  signal?: AbortSignal
) => {
  return HTTP<ReportSubreasonsResponse>({
    url: `/api/v7/report/provider_rating/${objectOpk}/reasons/`,
    method: 'get',
    signal,
  });
};

export const getApiReportProviderRatingSubreasonsRetrieveQueryKey = (objectOpk: string) => [
  `/api/v7/report/provider_rating/${objectOpk}/reasons/`,
];

export type ApiReportProviderRatingSubreasonsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiReportProviderRatingSubreasonsRetrieve>>
>;
export type ApiReportProviderRatingSubreasonsRetrieveQueryError = ErrorType<unknown>;

export const useApiReportProviderRatingSubreasonsRetrieve = <
  TData = Awaited<ReturnType<typeof apiReportProviderRatingSubreasonsRetrieve>>,
  TError = ErrorType<unknown>
>(
  objectOpk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiReportProviderRatingSubreasonsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiReportProviderRatingSubreasonsRetrieveQueryKey(objectOpk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiReportProviderRatingSubreasonsRetrieve>>
  > = ({ signal }) => apiReportProviderRatingSubreasonsRetrieve(objectOpk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiReportProviderRatingSubreasonsRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!objectOpk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiReportReasonsList = (signal?: AbortSignal) => {
  return HTTP<ReportReasonsResponse[]>({ url: `/api/v7/report/reasons/`, method: 'get', signal });
};

export const getApiReportReasonsListQueryKey = () => [`/api/v7/report/reasons/`];

export type ApiReportReasonsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiReportReasonsList>>
>;
export type ApiReportReasonsListQueryError = ErrorType<unknown>;

export const useApiReportReasonsList = <
  TData = Awaited<ReturnType<typeof apiReportReasonsList>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiReportReasonsList>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiReportReasonsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiReportReasonsList>>> = ({ signal }) =>
    apiReportReasonsList(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiReportReasonsList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiReportRequesterReviewSubreasonsRetrieve = (
  objectOpk: string,
  signal?: AbortSignal
) => {
  return HTTP<ReportSubreasonsResponse>({
    url: `/api/v7/report/requester_review/${objectOpk}/reasons/`,
    method: 'get',
    signal,
  });
};

export const getApiReportRequesterReviewSubreasonsRetrieveQueryKey = (objectOpk: string) => [
  `/api/v7/report/requester_review/${objectOpk}/reasons/`,
];

export type ApiReportRequesterReviewSubreasonsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiReportRequesterReviewSubreasonsRetrieve>>
>;
export type ApiReportRequesterReviewSubreasonsRetrieveQueryError = ErrorType<unknown>;

export const useApiReportRequesterReviewSubreasonsRetrieve = <
  TData = Awaited<ReturnType<typeof apiReportRequesterReviewSubreasonsRetrieve>>,
  TError = ErrorType<unknown>
>(
  objectOpk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiReportRequesterReviewSubreasonsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiReportRequesterReviewSubreasonsRetrieveQueryKey(objectOpk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiReportRequesterReviewSubreasonsRetrieve>>
  > = ({ signal }) => apiReportRequesterReviewSubreasonsRetrieve(objectOpk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiReportRequesterReviewSubreasonsRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!objectOpk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiRequestDetailViewRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<RequestDetail>({ url: `/api/v7/requests/${opk}/`, method: 'get', signal });
};

export const getApiRequestDetailViewRetrieveQueryKey = (opk: string) => [
  `/api/v7/requests/${opk}/`,
];

export type ApiRequestDetailViewRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiRequestDetailViewRetrieve>>
>;
export type ApiRequestDetailViewRetrieveQueryError = ErrorType<unknown>;

export const useApiRequestDetailViewRetrieve = <
  TData = Awaited<ReturnType<typeof apiRequestDetailViewRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiRequestDetailViewRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiRequestDetailViewRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiRequestDetailViewRetrieve>>> = ({
    signal,
  }) => apiRequestDetailViewRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiRequestDetailViewRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiReviewsAutomaticrecordDetailRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<ReviewDispatch>({ url: `/api/v7/reviews/automatic/${opk}/`, method: 'get', signal });
};

export const getApiReviewsAutomaticrecordDetailRetrieveQueryKey = (opk: string) => [
  `/api/v7/reviews/automatic/${opk}/`,
];

export type ApiReviewsAutomaticrecordDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiReviewsAutomaticrecordDetailRetrieve>>
>;
export type ApiReviewsAutomaticrecordDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiReviewsAutomaticrecordDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiReviewsAutomaticrecordDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiReviewsAutomaticrecordDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiReviewsAutomaticrecordDetailRetrieveQueryKey(opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiReviewsAutomaticrecordDetailRetrieve>>
  > = ({ signal }) => apiReviewsAutomaticrecordDetailRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiReviewsAutomaticrecordDetailRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiReviewsAutomaticrecordresponseDetailRetrieve = (
  reviewOpk: string,
  signal?: AbortSignal
) => {
  return HTTP<AutomaticRecordResponse>({
    url: `/api/v7/reviews/automatic/${reviewOpk}/response/`,
    method: 'get',
    signal,
  });
};

export const getApiReviewsAutomaticrecordresponseDetailRetrieveQueryKey = (reviewOpk: string) => [
  `/api/v7/reviews/automatic/${reviewOpk}/response/`,
];

export type ApiReviewsAutomaticrecordresponseDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiReviewsAutomaticrecordresponseDetailRetrieve>>
>;
export type ApiReviewsAutomaticrecordresponseDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiReviewsAutomaticrecordresponseDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiReviewsAutomaticrecordresponseDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  reviewOpk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiReviewsAutomaticrecordresponseDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiReviewsAutomaticrecordresponseDetailRetrieveQueryKey(reviewOpk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiReviewsAutomaticrecordresponseDetailRetrieve>>
  > = ({ signal }) => apiReviewsAutomaticrecordresponseDetailRetrieve(reviewOpk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiReviewsAutomaticrecordresponseDetailRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!reviewOpk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiReviewsAutomaticrecordresponseDetailCreate = (
  reviewOpk: string,
  automaticRecordResponse: AutomaticRecordResponse
) => {
  return HTTP<AutomaticRecordResponse>({
    url: `/api/v7/reviews/automatic/${reviewOpk}/response/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: automaticRecordResponse,
  });
};

export type ApiReviewsAutomaticrecordresponseDetailCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiReviewsAutomaticrecordresponseDetailCreate>>
>;
export type ApiReviewsAutomaticrecordresponseDetailCreateMutationBody = AutomaticRecordResponse;
export type ApiReviewsAutomaticrecordresponseDetailCreateMutationError = ErrorType<unknown>;

export const useApiReviewsAutomaticrecordresponseDetailCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiReviewsAutomaticrecordresponseDetailCreate>>,
    TError,
    { reviewOpk: string; data: AutomaticRecordResponse },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiReviewsAutomaticrecordresponseDetailCreate>>,
    { reviewOpk: string; data: AutomaticRecordResponse }
  > = (props) => {
    const { reviewOpk, data } = props ?? {};

    return apiReviewsAutomaticrecordresponseDetailCreate(reviewOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiReviewsAutomaticrecordresponseDetailCreate>>,
    TError,
    { reviewOpk: string; data: AutomaticRecordResponse },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiReviewsAutomaticrecordresponseDetailDestroy = (reviewOpk: string) => {
  return HTTP<void>({ url: `/api/v7/reviews/automatic/${reviewOpk}/response/`, method: 'delete' });
};

export type ApiReviewsAutomaticrecordresponseDetailDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiReviewsAutomaticrecordresponseDetailDestroy>>
>;

export type ApiReviewsAutomaticrecordresponseDetailDestroyMutationError = ErrorType<unknown>;

export const useApiReviewsAutomaticrecordresponseDetailDestroy = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiReviewsAutomaticrecordresponseDetailDestroy>>,
    TError,
    { reviewOpk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiReviewsAutomaticrecordresponseDetailDestroy>>,
    { reviewOpk: string }
  > = (props) => {
    const { reviewOpk } = props ?? {};

    return apiReviewsAutomaticrecordresponseDetailDestroy(reviewOpk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiReviewsAutomaticrecordresponseDetailDestroy>>,
    TError,
    { reviewOpk: string },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiReviewsExternalreviewDetailRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<ExternalReview>({
    url: `/api/v7/reviews/externalreview/${opk}/`,
    method: 'get',
    signal,
  });
};

export const getApiReviewsExternalreviewDetailRetrieveQueryKey = (opk: string) => [
  `/api/v7/reviews/externalreview/${opk}/`,
];

export type ApiReviewsExternalreviewDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiReviewsExternalreviewDetailRetrieve>>
>;
export type ApiReviewsExternalreviewDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiReviewsExternalreviewDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiReviewsExternalreviewDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiReviewsExternalreviewDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiReviewsExternalreviewDetailRetrieveQueryKey(opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiReviewsExternalreviewDetailRetrieve>>
  > = ({ signal }) => apiReviewsExternalreviewDetailRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiReviewsExternalreviewDetailRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiReviewsFacilityList = (opk: string, signal?: AbortSignal) => {
  return HTTP<FacilityReview[]>({ url: `/api/v7/reviews/facility/${opk}/`, method: 'get', signal });
};

export const getApiReviewsFacilityListQueryKey = (opk: string) => [
  `/api/v7/reviews/facility/${opk}/`,
];

export type ApiReviewsFacilityListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiReviewsFacilityList>>
>;
export type ApiReviewsFacilityListQueryError = ErrorType<unknown>;

export const useApiReviewsFacilityList = <
  TData = Awaited<ReturnType<typeof apiReviewsFacilityList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiReviewsFacilityList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiReviewsFacilityListQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiReviewsFacilityList>>> = ({ signal }) =>
    apiReviewsFacilityList(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiReviewsFacilityList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiPendingReviewsRetrieve = (conversationOpk: string, signal?: AbortSignal) => {
  return HTTP<PendingReviews>({
    url: `/api/v7/reviews/pending/${conversationOpk}/`,
    method: 'get',
    signal,
  });
};

export const getApiPendingReviewsRetrieveQueryKey = (conversationOpk: string) => [
  `/api/v7/reviews/pending/${conversationOpk}/`,
];

export type ApiPendingReviewsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPendingReviewsRetrieve>>
>;
export type ApiPendingReviewsRetrieveQueryError = ErrorType<unknown>;

export const useApiPendingReviewsRetrieve = <
  TData = Awaited<ReturnType<typeof apiPendingReviewsRetrieve>>,
  TError = ErrorType<unknown>
>(
  conversationOpk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiPendingReviewsRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPendingReviewsRetrieveQueryKey(conversationOpk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPendingReviewsRetrieve>>> = ({
    signal,
  }) => apiPendingReviewsRetrieve(conversationOpk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPendingReviewsRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!conversationOpk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * View that returns the questions and answer choices for the new pet reviews
 */
export const apiReviewsPetDetailsOptionsList = (signal?: AbortSignal) => {
  return HTTP<PetReviewDefinition[]>({ url: `/api/v7/reviews/pet-review/`, method: 'get', signal });
};

export const getApiReviewsPetDetailsOptionsListQueryKey = () => [`/api/v7/reviews/pet-review/`];

export type ApiReviewsPetDetailsOptionsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiReviewsPetDetailsOptionsList>>
>;
export type ApiReviewsPetDetailsOptionsListQueryError = ErrorType<unknown>;

export const useApiReviewsPetDetailsOptionsList = <
  TData = Awaited<ReturnType<typeof apiReviewsPetDetailsOptionsList>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiReviewsPetDetailsOptionsList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiReviewsPetDetailsOptionsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiReviewsPetDetailsOptionsList>>> = ({
    signal,
  }) => apiReviewsPetDetailsOptionsList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiReviewsPetDetailsOptionsList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiReviewsPetDetailsCreateCreate = (conversationOpk: string, petReview: PetReview) => {
  return HTTP<void>({
    url: `/api/v7/reviews/pet-review/${conversationOpk}/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: petReview,
  });
};

export type ApiReviewsPetDetailsCreateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiReviewsPetDetailsCreateCreate>>
>;
export type ApiReviewsPetDetailsCreateCreateMutationBody = PetReview;
export type ApiReviewsPetDetailsCreateCreateMutationError = ErrorType<unknown>;

export const useApiReviewsPetDetailsCreateCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiReviewsPetDetailsCreateCreate>>,
    TError,
    { conversationOpk: string; data: PetReview },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiReviewsPetDetailsCreateCreate>>,
    { conversationOpk: string; data: PetReview }
  > = (props) => {
    const { conversationOpk, data } = props ?? {};

    return apiReviewsPetDetailsCreateCreate(conversationOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiReviewsPetDetailsCreateCreate>>,
    TError,
    { conversationOpk: string; data: PetReview },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiReviewsPetCreateCreate = (
  conversationOpk: string,
  petRatingURLReversal: PetRatingURLReversal[]
) => {
  return HTTP<ApiReviewsPetCreateCreate201>({
    url: `/api/v7/reviews/pet/${conversationOpk}/create`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: petRatingURLReversal,
  });
};

export type ApiReviewsPetCreateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiReviewsPetCreateCreate>>
>;
export type ApiReviewsPetCreateCreateMutationBody = PetRatingURLReversal[];
export type ApiReviewsPetCreateCreateMutationError = ErrorType<unknown>;

export const useApiReviewsPetCreateCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiReviewsPetCreateCreate>>,
    TError,
    { conversationOpk: string; data: PetRatingURLReversal[] },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiReviewsPetCreateCreate>>,
    { conversationOpk: string; data: PetRatingURLReversal[] }
  > = (props) => {
    const { conversationOpk, data } = props ?? {};

    return apiReviewsPetCreateCreate(conversationOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiReviewsPetCreateCreate>>,
    TError,
    { conversationOpk: string; data: PetRatingURLReversal[] },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiReviewsPetDetailRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<ReviewDispatch>({ url: `/api/v7/reviews/pet/${opk}/`, method: 'get', signal });
};

export const getApiReviewsPetDetailRetrieveQueryKey = (opk: string) => [
  `/api/v7/reviews/pet/${opk}/`,
];

export type ApiReviewsPetDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiReviewsPetDetailRetrieve>>
>;
export type ApiReviewsPetDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiReviewsPetDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiReviewsPetDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiReviewsPetDetailRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiReviewsPetDetailRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiReviewsPetDetailRetrieve>>> = ({
    signal,
  }) => apiReviewsPetDetailRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiReviewsPetDetailRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiReviewsRatingDetailRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<ReviewDispatch>({ url: `/api/v7/reviews/provider/${opk}/`, method: 'get', signal });
};

export const getApiReviewsRatingDetailRetrieveQueryKey = (opk: string) => [
  `/api/v7/reviews/provider/${opk}/`,
];

export type ApiReviewsRatingDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiReviewsRatingDetailRetrieve>>
>;
export type ApiReviewsRatingDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiReviewsRatingDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiReviewsRatingDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiReviewsRatingDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiReviewsRatingDetailRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiReviewsRatingDetailRetrieve>>> = ({
    signal,
  }) => apiReviewsRatingDetailRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiReviewsRatingDetailRetrieve>>, TError, TData>(
    {
      queryKey,
      queryFn,
      enabled: !!opk,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      ...queryOptions,
    }
  ) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiReviewsRatingresponseDetailRetrieve = (reviewOpk: string, signal?: AbortSignal) => {
  return HTTP<RatingResponse>({
    url: `/api/v7/reviews/provider/${reviewOpk}/response/`,
    method: 'get',
    signal,
  });
};

export const getApiReviewsRatingresponseDetailRetrieveQueryKey = (reviewOpk: string) => [
  `/api/v7/reviews/provider/${reviewOpk}/response/`,
];

export type ApiReviewsRatingresponseDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiReviewsRatingresponseDetailRetrieve>>
>;
export type ApiReviewsRatingresponseDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiReviewsRatingresponseDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiReviewsRatingresponseDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  reviewOpk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiReviewsRatingresponseDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiReviewsRatingresponseDetailRetrieveQueryKey(reviewOpk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiReviewsRatingresponseDetailRetrieve>>
  > = ({ signal }) => apiReviewsRatingresponseDetailRetrieve(reviewOpk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiReviewsRatingresponseDetailRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!reviewOpk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiReviewsRatingresponseDetailCreate = (
  reviewOpk: string,
  ratingResponse: RatingResponse
) => {
  return HTTP<RatingResponse>({
    url: `/api/v7/reviews/provider/${reviewOpk}/response/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: ratingResponse,
  });
};

export type ApiReviewsRatingresponseDetailCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiReviewsRatingresponseDetailCreate>>
>;
export type ApiReviewsRatingresponseDetailCreateMutationBody = RatingResponse;
export type ApiReviewsRatingresponseDetailCreateMutationError = ErrorType<unknown>;

export const useApiReviewsRatingresponseDetailCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiReviewsRatingresponseDetailCreate>>,
    TError,
    { reviewOpk: string; data: RatingResponse },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiReviewsRatingresponseDetailCreate>>,
    { reviewOpk: string; data: RatingResponse }
  > = (props) => {
    const { reviewOpk, data } = props ?? {};

    return apiReviewsRatingresponseDetailCreate(reviewOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiReviewsRatingresponseDetailCreate>>,
    TError,
    { reviewOpk: string; data: RatingResponse },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiReviewsRatingresponseDetailUpdate = (
  reviewOpk: string,
  ratingResponse: RatingResponse
) => {
  return HTTP<RatingResponse>({
    url: `/api/v7/reviews/provider/${reviewOpk}/response/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: ratingResponse,
  });
};

export type ApiReviewsRatingresponseDetailUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiReviewsRatingresponseDetailUpdate>>
>;
export type ApiReviewsRatingresponseDetailUpdateMutationBody = RatingResponse;
export type ApiReviewsRatingresponseDetailUpdateMutationError = ErrorType<unknown>;

export const useApiReviewsRatingresponseDetailUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiReviewsRatingresponseDetailUpdate>>,
    TError,
    { reviewOpk: string; data: RatingResponse },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiReviewsRatingresponseDetailUpdate>>,
    { reviewOpk: string; data: RatingResponse }
  > = (props) => {
    const { reviewOpk, data } = props ?? {};

    return apiReviewsRatingresponseDetailUpdate(reviewOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiReviewsRatingresponseDetailUpdate>>,
    TError,
    { reviewOpk: string; data: RatingResponse },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiReviewsRatingresponseDetailPartialUpdate = (
  reviewOpk: string,
  patchedRatingResponse: PatchedRatingResponse
) => {
  return HTTP<RatingResponse>({
    url: `/api/v7/reviews/provider/${reviewOpk}/response/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedRatingResponse,
  });
};

export type ApiReviewsRatingresponseDetailPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiReviewsRatingresponseDetailPartialUpdate>>
>;
export type ApiReviewsRatingresponseDetailPartialUpdateMutationBody = PatchedRatingResponse;
export type ApiReviewsRatingresponseDetailPartialUpdateMutationError = ErrorType<unknown>;

export const useApiReviewsRatingresponseDetailPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiReviewsRatingresponseDetailPartialUpdate>>,
    TError,
    { reviewOpk: string; data: PatchedRatingResponse },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiReviewsRatingresponseDetailPartialUpdate>>,
    { reviewOpk: string; data: PatchedRatingResponse }
  > = (props) => {
    const { reviewOpk, data } = props ?? {};

    return apiReviewsRatingresponseDetailPartialUpdate(reviewOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiReviewsRatingresponseDetailPartialUpdate>>,
    TError,
    { reviewOpk: string; data: PatchedRatingResponse },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiReviewsRatingresponseDetailDestroy = (reviewOpk: string) => {
  return HTTP<void>({ url: `/api/v7/reviews/provider/${reviewOpk}/response/`, method: 'delete' });
};

export type ApiReviewsRatingresponseDetailDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiReviewsRatingresponseDetailDestroy>>
>;

export type ApiReviewsRatingresponseDetailDestroyMutationError = ErrorType<unknown>;

export const useApiReviewsRatingresponseDetailDestroy = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiReviewsRatingresponseDetailDestroy>>,
    TError,
    { reviewOpk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiReviewsRatingresponseDetailDestroy>>,
    { reviewOpk: string }
  > = (props) => {
    const { reviewOpk } = props ?? {};

    return apiReviewsRatingresponseDetailDestroy(reviewOpk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiReviewsRatingresponseDetailDestroy>>,
    TError,
    { reviewOpk: string },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiReportableReviewRetrieve = (conversationOpk: string, signal?: AbortSignal) => {
  return HTTP<ReportableReview>({
    url: `/api/v7/reviews/reportable/${conversationOpk}/`,
    method: 'get',
    signal,
  });
};

export const getApiReportableReviewRetrieveQueryKey = (conversationOpk: string) => [
  `/api/v7/reviews/reportable/${conversationOpk}/`,
];

export type ApiReportableReviewRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiReportableReviewRetrieve>>
>;
export type ApiReportableReviewRetrieveQueryError = ErrorType<unknown>;

export const useApiReportableReviewRetrieve = <
  TData = Awaited<ReturnType<typeof apiReportableReviewRetrieve>>,
  TError = ErrorType<unknown>
>(
  conversationOpk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiReportableReviewRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiReportableReviewRetrieveQueryKey(conversationOpk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiReportableReviewRetrieve>>> = ({
    signal,
  }) => apiReportableReviewRetrieve(conversationOpk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiReportableReviewRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!conversationOpk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiRequesterReviewCreate = (
  conversationOpk: string,
  requesterReview: RequesterReview
) => {
  return HTTP<RequesterReviewApi>({
    url: `/api/v7/reviews/requester-review/${conversationOpk}/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: requesterReview,
  });
};

export type ApiRequesterReviewCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiRequesterReviewCreate>>
>;
export type ApiRequesterReviewCreateMutationBody = RequesterReview;
export type ApiRequesterReviewCreateMutationError = ErrorType<unknown>;

export const useApiRequesterReviewCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiRequesterReviewCreate>>,
    TError,
    { conversationOpk: string; data: RequesterReview },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiRequesterReviewCreate>>,
    { conversationOpk: string; data: RequesterReview }
  > = (props) => {
    const { conversationOpk, data } = props ?? {};

    return apiRequesterReviewCreate(conversationOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiRequesterReviewCreate>>,
    TError,
    { conversationOpk: string; data: RequesterReview },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiReviewsTestimonialDetailRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<ReviewDispatch>({
    url: `/api/v7/reviews/testimonial/${opk}/`,
    method: 'get',
    signal,
  });
};

export const getApiReviewsTestimonialDetailRetrieveQueryKey = (opk: string) => [
  `/api/v7/reviews/testimonial/${opk}/`,
];

export type ApiReviewsTestimonialDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiReviewsTestimonialDetailRetrieve>>
>;
export type ApiReviewsTestimonialDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiReviewsTestimonialDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiReviewsTestimonialDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiReviewsTestimonialDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiReviewsTestimonialDetailRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiReviewsTestimonialDetailRetrieve>>> = ({
    signal,
  }) => apiReviewsTestimonialDetailRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiReviewsTestimonialDetailRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiReviewsTrainerReviewsCreate = (trainerReviewWrite: TrainerReviewWrite) => {
  return HTTP<void>({
    url: `/api/v7/reviews/trainer-reviews/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: trainerReviewWrite,
  });
};

export type ApiReviewsTrainerReviewsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiReviewsTrainerReviewsCreate>>
>;
export type ApiReviewsTrainerReviewsCreateMutationBody = TrainerReviewWrite;
export type ApiReviewsTrainerReviewsCreateMutationError = ErrorType<unknown>;

export const useApiReviewsTrainerReviewsCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiReviewsTrainerReviewsCreate>>,
    TError,
    { data: TrainerReviewWrite },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiReviewsTrainerReviewsCreate>>,
    { data: TrainerReviewWrite }
  > = (props) => {
    const { data } = props ?? {};

    return apiReviewsTrainerReviewsCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiReviewsTrainerReviewsCreate>>,
    TError,
    { data: TrainerReviewWrite },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * List and create TrainerTestimonialRequests.
 */
export const apiReviewsTrainerTestimonialRequestsList = (signal?: AbortSignal) => {
  return HTTP<SerializedTrainerTestimonialRequest[]>({
    url: `/api/v7/reviews/trainer-testimonial-requests/`,
    method: 'get',
    signal,
  });
};

export const getApiReviewsTrainerTestimonialRequestsListQueryKey = () => [
  `/api/v7/reviews/trainer-testimonial-requests/`,
];

export type ApiReviewsTrainerTestimonialRequestsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiReviewsTrainerTestimonialRequestsList>>
>;
export type ApiReviewsTrainerTestimonialRequestsListQueryError = ErrorType<unknown>;

export const useApiReviewsTrainerTestimonialRequestsList = <
  TData = Awaited<ReturnType<typeof apiReviewsTrainerTestimonialRequestsList>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiReviewsTrainerTestimonialRequestsList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiReviewsTrainerTestimonialRequestsListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiReviewsTrainerTestimonialRequestsList>>
  > = ({ signal }) => apiReviewsTrainerTestimonialRequestsList(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiReviewsTrainerTestimonialRequestsList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * List and create TrainerTestimonialRequests.
 */
export const apiReviewsTrainerTestimonialRequestsCreate = (
  trainerTestimonialRequestCreateAPIInput: TrainerTestimonialRequestCreateAPIInput
) => {
  return HTTP<TrainerTestimonialRequestCreateResponse>({
    url: `/api/v7/reviews/trainer-testimonial-requests/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: trainerTestimonialRequestCreateAPIInput,
  });
};

export type ApiReviewsTrainerTestimonialRequestsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiReviewsTrainerTestimonialRequestsCreate>>
>;
export type ApiReviewsTrainerTestimonialRequestsCreateMutationBody =
  TrainerTestimonialRequestCreateAPIInput;
export type ApiReviewsTrainerTestimonialRequestsCreateMutationError = ErrorType<unknown>;

export const useApiReviewsTrainerTestimonialRequestsCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiReviewsTrainerTestimonialRequestsCreate>>,
    TError,
    { data: TrainerTestimonialRequestCreateAPIInput },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiReviewsTrainerTestimonialRequestsCreate>>,
    { data: TrainerTestimonialRequestCreateAPIInput }
  > = (props) => {
    const { data } = props ?? {};

    return apiReviewsTrainerTestimonialRequestsCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiReviewsTrainerTestimonialRequestsCreate>>,
    TError,
    { data: TrainerTestimonialRequestCreateAPIInput },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Retrieves details about a TrainerTestimonialRequest.
 */
export const apiReviewsTrainerTestimonialRequestDetailRetrieve = (
  token: string,
  signal?: AbortSignal
) => {
  return HTTP<SerializedTrainerTestimonialRequest>({
    url: `/api/v7/reviews/trainer-testimonial-requests/${token}/`,
    method: 'get',
    signal,
  });
};

export const getApiReviewsTrainerTestimonialRequestDetailRetrieveQueryKey = (token: string) => [
  `/api/v7/reviews/trainer-testimonial-requests/${token}/`,
];

export type ApiReviewsTrainerTestimonialRequestDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiReviewsTrainerTestimonialRequestDetailRetrieve>>
>;
export type ApiReviewsTrainerTestimonialRequestDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiReviewsTrainerTestimonialRequestDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiReviewsTrainerTestimonialRequestDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiReviewsTrainerTestimonialRequestDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiReviewsTrainerTestimonialRequestDetailRetrieveQueryKey(token);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiReviewsTrainerTestimonialRequestDetailRetrieve>>
  > = ({ signal }) => apiReviewsTrainerTestimonialRequestDetailRetrieve(token, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiReviewsTrainerTestimonialRequestDetailRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!token,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Creates a new testimonial for a trainer.
 */
export const apiReviewsTrainerTestimonialsCreate = (
  trainerTestimonialCreateAPIInput: TrainerTestimonialCreateAPIInput
) => {
  return HTTP<ApiReviewsTrainerTestimonialsCreate201>({
    url: `/api/v7/reviews/trainer-testimonials/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: trainerTestimonialCreateAPIInput,
  });
};

export type ApiReviewsTrainerTestimonialsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiReviewsTrainerTestimonialsCreate>>
>;
export type ApiReviewsTrainerTestimonialsCreateMutationBody = TrainerTestimonialCreateAPIInput;
export type ApiReviewsTrainerTestimonialsCreateMutationError = ErrorType<unknown>;

export const useApiReviewsTrainerTestimonialsCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiReviewsTrainerTestimonialsCreate>>,
    TError,
    { data: TrainerTestimonialCreateAPIInput },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiReviewsTrainerTestimonialsCreate>>,
    { data: TrainerTestimonialCreateAPIInput }
  > = (props) => {
    const { data } = props ?? {};

    return apiReviewsTrainerTestimonialsCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiReviewsTrainerTestimonialsCreate>>,
    TError,
    { data: TrainerTestimonialCreateAPIInput },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiQuizResponseCreate = (quizResponse: QuizResponse) => {
  return HTTP<ApiQuizResponseCreate201>({
    url: `/api/v7/safety/quiz-response/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: quizResponse,
  });
};

export type ApiQuizResponseCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiQuizResponseCreate>>
>;
export type ApiQuizResponseCreateMutationBody = QuizResponse;
export type ApiQuizResponseCreateMutationError = ErrorType<unknown>;

export const useApiQuizResponseCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiQuizResponseCreate>>,
    TError,
    { data: QuizResponse },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiQuizResponseCreate>>,
    { data: QuizResponse }
  > = (props) => {
    const { data } = props ?? {};

    return apiQuizResponseCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiQuizResponseCreate>>,
    TError,
    { data: QuizResponse },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiSafetySafetyAcknowledgementCreate = (
  safetyAcknowledgement: SafetyAcknowledgement
) => {
  return HTTP<SafetyAcknowledgement>({
    url: `/api/v7/safety/safety-acknowledgement/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: safetyAcknowledgement,
  });
};

export type ApiSafetySafetyAcknowledgementCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSafetySafetyAcknowledgementCreate>>
>;
export type ApiSafetySafetyAcknowledgementCreateMutationBody = SafetyAcknowledgement;
export type ApiSafetySafetyAcknowledgementCreateMutationError = ErrorType<unknown>;

export const useApiSafetySafetyAcknowledgementCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSafetySafetyAcknowledgementCreate>>,
    TError,
    { data: SafetyAcknowledgement },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSafetySafetyAcknowledgementCreate>>,
    { data: SafetyAcknowledgement }
  > = (props) => {
    const { data } = props ?? {};

    return apiSafetySafetyAcknowledgementCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiSafetySafetyAcknowledgementCreate>>,
    TError,
    { data: SafetyAcknowledgement },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiSafetyQuizQuestionsRetrieve = (signal?: AbortSignal) => {
  return HTTP<ApiSafetyQuizQuestionsRetrieve200>({
    url: `/api/v7/safety/safety-quiz/`,
    method: 'get',
    signal,
  });
};

export const getApiSafetyQuizQuestionsRetrieveQueryKey = () => [`/api/v7/safety/safety-quiz/`];

export type ApiSafetyQuizQuestionsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSafetyQuizQuestionsRetrieve>>
>;
export type ApiSafetyQuizQuestionsRetrieveQueryError = ErrorType<unknown>;

export const useApiSafetyQuizQuestionsRetrieve = <
  TData = Awaited<ReturnType<typeof apiSafetyQuizQuestionsRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiSafetyQuizQuestionsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSafetyQuizQuestionsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSafetyQuizQuestionsRetrieve>>> = ({
    signal,
  }) => apiSafetyQuizQuestionsRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiSafetyQuizQuestionsRetrieve>>, TError, TData>(
    { queryKey, queryFn, refetchOnMount: false, refetchOnWindowFocus: false, ...queryOptions }
  ) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * OpenApi3 schema for this API. Format can be selected via content negotiation.

- YAML: application/vnd.oai.openapi
- JSON: application/vnd.oai.openapi+json
 */
export const apiSchemaRetrieve = (params?: ApiSchemaRetrieveParams, signal?: AbortSignal) => {
  return HTTP<ApiSchemaRetrieve200One | ApiSchemaRetrieve200Two>({
    url: `/api/v7/schema/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiSchemaRetrieveQueryKey = (params?: ApiSchemaRetrieveParams) => [
  `/api/v7/schema/`,
  ...(params ? [params] : []),
];

export type ApiSchemaRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSchemaRetrieve>>
>;
export type ApiSchemaRetrieveQueryError = ErrorType<unknown>;

export const useApiSchemaRetrieve = <
  TData = Awaited<ReturnType<typeof apiSchemaRetrieve>>,
  TError = ErrorType<unknown>
>(
  params?: ApiSchemaRetrieveParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiSchemaRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSchemaRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSchemaRetrieve>>> = ({ signal }) =>
    apiSchemaRetrieve(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiSchemaRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiBrightHorizonsHubScreenRetrieve = (signal?: AbortSignal) => {
  return HTTP<BrightHorizonsHubConfiguration>({
    url: `/api/v7/screens/bright-horizons/hub/`,
    method: 'get',
    signal,
  });
};

export const getApiBrightHorizonsHubScreenRetrieveQueryKey = () => [
  `/api/v7/screens/bright-horizons/hub/`,
];

export type ApiBrightHorizonsHubScreenRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiBrightHorizonsHubScreenRetrieve>>
>;
export type ApiBrightHorizonsHubScreenRetrieveQueryError = ErrorType<unknown>;

export const useApiBrightHorizonsHubScreenRetrieve = <
  TData = Awaited<ReturnType<typeof apiBrightHorizonsHubScreenRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiBrightHorizonsHubScreenRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiBrightHorizonsHubScreenRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiBrightHorizonsHubScreenRetrieve>>> = ({
    signal,
  }) => apiBrightHorizonsHubScreenRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiBrightHorizonsHubScreenRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiCancelPagePricerCreate = (cancelPagePricerRequest: CancelPagePricerRequest) => {
  return HTTP<CreditLedgerResponse>({
    url: `/api/v7/screens/cancel-page-pricer/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: cancelPagePricerRequest,
  });
};

export type ApiCancelPagePricerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiCancelPagePricerCreate>>
>;
export type ApiCancelPagePricerCreateMutationBody = CancelPagePricerRequest;
export type ApiCancelPagePricerCreateMutationError = ErrorType<unknown>;

export const useApiCancelPagePricerCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiCancelPagePricerCreate>>,
    TError,
    { data: CancelPagePricerRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiCancelPagePricerCreate>>,
    { data: CancelPagePricerRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiCancelPagePricerCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiCancelPagePricerCreate>>,
    TError,
    { data: CancelPagePricerRequest },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiContactPagePricerCreate = (contactPricerRequest: ContactPricerRequest) => {
  return HTTP<CreditLedgerResponse>({
    url: `/api/v7/screens/contact-page-pricer/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: contactPricerRequest,
  });
};

export type ApiContactPagePricerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiContactPagePricerCreate>>
>;
export type ApiContactPagePricerCreateMutationBody = ContactPricerRequest;
export type ApiContactPagePricerCreateMutationError = ErrorType<unknown>;

export const useApiContactPagePricerCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiContactPagePricerCreate>>,
    TError,
    { data: ContactPricerRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiContactPagePricerCreate>>,
    { data: ContactPricerRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiContactPagePricerCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiContactPagePricerCreate>>,
    TError,
    { data: ContactPricerRequest },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiModifyRequestPricerCreate = (
  convOpk: string,
  contactPricerRequest: ContactPricerRequest
) => {
  return HTTP<CreditLedgerResponse>({
    url: `/api/v7/screens/conversations/${convOpk}/modify-request-pricer/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: contactPricerRequest,
  });
};

export type ApiModifyRequestPricerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiModifyRequestPricerCreate>>
>;
export type ApiModifyRequestPricerCreateMutationBody = ContactPricerRequest;
export type ApiModifyRequestPricerCreateMutationError = ErrorType<unknown>;

export const useApiModifyRequestPricerCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiModifyRequestPricerCreate>>,
    TError,
    { convOpk: string; data: ContactPricerRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiModifyRequestPricerCreate>>,
    { convOpk: string; data: ContactPricerRequest }
  > = (props) => {
    const { convOpk, data } = props ?? {};

    return apiModifyRequestPricerCreate(convOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiModifyRequestPricerCreate>>,
    TError,
    { convOpk: string; data: ContactPricerRequest },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiConversationScreenRetrieve = (
  opk: string,
  params?: ApiConversationScreenRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<ConversationScreen>({
    url: `/api/v7/screens/conversations/${opk}/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiConversationScreenRetrieveQueryKey = (
  opk: string,
  params?: ApiConversationScreenRetrieveParams
) => [`/api/v7/screens/conversations/${opk}/`, ...(params ? [params] : [])];

export type ApiConversationScreenRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationScreenRetrieve>>
>;
export type ApiConversationScreenRetrieveQueryError = ErrorType<unknown>;

export const useApiConversationScreenRetrieve = <
  TData = Awaited<ReturnType<typeof apiConversationScreenRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiConversationScreenRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiConversationScreenRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiConversationScreenRetrieveQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiConversationScreenRetrieve>>> = ({
    signal,
  }) => apiConversationScreenRetrieve(opk, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiConversationScreenRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiConversationImagesList = (opk: string, signal?: AbortSignal) => {
  return HTTP<ConversationImages[]>({
    url: `/api/v7/screens/conversations/${opk}/images/`,
    method: 'get',
    signal,
  });
};

export const getApiConversationImagesListQueryKey = (opk: string) => [
  `/api/v7/screens/conversations/${opk}/images/`,
];

export type ApiConversationImagesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationImagesList>>
>;
export type ApiConversationImagesListQueryError = ErrorType<unknown>;

export const useApiConversationImagesList = <
  TData = Awaited<ReturnType<typeof apiConversationImagesList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiConversationImagesList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiConversationImagesListQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiConversationImagesList>>> = ({
    signal,
  }) => apiConversationImagesList(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiConversationImagesList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiInboxScreenRetrieve = (signal?: AbortSignal) => {
  return HTTP<InboxScreen>({ url: `/api/v7/screens/inbox/`, method: 'get', signal });
};

export const getApiInboxScreenRetrieveQueryKey = () => [`/api/v7/screens/inbox/`];

export type ApiInboxScreenRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInboxScreenRetrieve>>
>;
export type ApiInboxScreenRetrieveQueryError = ErrorType<unknown>;

export const useApiInboxScreenRetrieve = <
  TData = Awaited<ReturnType<typeof apiInboxScreenRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiInboxScreenRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInboxScreenRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInboxScreenRetrieve>>> = ({ signal }) =>
    apiInboxScreenRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiInboxScreenRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiInboxSectionScreenRetrieve = (
  slug:
    | 'all'
    | 'all-conversations'
    | 'archived'
    | 'current'
    | 'past'
    | 'primary'
    | 'requests'
    | 'unread'
    | 'upcoming',
  params?: ApiInboxSectionScreenRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<InboxSectionContent>({
    url: `/api/v7/screens/inbox/${slug}/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiInboxSectionScreenRetrieveQueryKey = (
  slug:
    | 'all'
    | 'all-conversations'
    | 'archived'
    | 'current'
    | 'past'
    | 'primary'
    | 'requests'
    | 'unread'
    | 'upcoming',
  params?: ApiInboxSectionScreenRetrieveParams
) => [`/api/v7/screens/inbox/${slug}/`, ...(params ? [params] : [])];

export type ApiInboxSectionScreenRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInboxSectionScreenRetrieve>>
>;
export type ApiInboxSectionScreenRetrieveQueryError = ErrorType<unknown>;

export const useApiInboxSectionScreenRetrieve = <
  TData = Awaited<ReturnType<typeof apiInboxSectionScreenRetrieve>>,
  TError = ErrorType<unknown>
>(
  slug:
    | 'all'
    | 'all-conversations'
    | 'archived'
    | 'current'
    | 'past'
    | 'primary'
    | 'requests'
    | 'unread'
    | 'upcoming',
  params?: ApiInboxSectionScreenRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiInboxSectionScreenRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInboxSectionScreenRetrieveQueryKey(slug, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInboxSectionScreenRetrieve>>> = ({
    signal,
  }) => apiInboxSectionScreenRetrieve(slug, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiInboxSectionScreenRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!slug,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiInboxSectionMarkAsReadCreate = (
  slug:
    | 'all'
    | 'all-conversations'
    | 'archived'
    | 'current'
    | 'past'
    | 'primary'
    | 'requests'
    | 'unread'
    | 'upcoming'
) => {
  return HTTP<void>({ url: `/api/v7/screens/inbox/${slug}/mark-as-read/`, method: 'post' });
};

export type ApiInboxSectionMarkAsReadCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiInboxSectionMarkAsReadCreate>>
>;

export type ApiInboxSectionMarkAsReadCreateMutationError = ErrorType<unknown>;

export const useApiInboxSectionMarkAsReadCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiInboxSectionMarkAsReadCreate>>,
    TError,
    {
      slug:
        | 'all'
        | 'all-conversations'
        | 'archived'
        | 'current'
        | 'past'
        | 'primary'
        | 'requests'
        | 'unread'
        | 'upcoming';
    },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiInboxSectionMarkAsReadCreate>>,
    {
      slug:
        | 'all'
        | 'all-conversations'
        | 'archived'
        | 'current'
        | 'past'
        | 'primary'
        | 'requests'
        | 'unread'
        | 'upcoming';
    }
  > = (props) => {
    const { slug } = props ?? {};

    return apiInboxSectionMarkAsReadCreate(slug);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiInboxSectionMarkAsReadCreate>>,
    TError,
    {
      slug:
        | 'all'
        | 'all-conversations'
        | 'archived'
        | 'current'
        | 'past'
        | 'primary'
        | 'requests'
        | 'unread'
        | 'upcoming';
    },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiInboxMetadataScreenRetrieve = (signal?: AbortSignal) => {
  return HTTP<InboxMetadata>({ url: `/api/v7/screens/inbox/metadata/`, method: 'get', signal });
};

export const getApiInboxMetadataScreenRetrieveQueryKey = () => [`/api/v7/screens/inbox/metadata/`];

export type ApiInboxMetadataScreenRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiInboxMetadataScreenRetrieve>>
>;
export type ApiInboxMetadataScreenRetrieveQueryError = ErrorType<unknown>;

export const useApiInboxMetadataScreenRetrieve = <
  TData = Awaited<ReturnType<typeof apiInboxMetadataScreenRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiInboxMetadataScreenRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiInboxMetadataScreenRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInboxMetadataScreenRetrieve>>> = ({
    signal,
  }) => apiInboxMetadataScreenRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiInboxMetadataScreenRetrieve>>, TError, TData>(
    { queryKey, queryFn, refetchOnMount: false, refetchOnWindowFocus: false, ...queryOptions }
  ) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiJobBoardDetailRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<JobBoardDetail>({
    url: `/api/v7/screens/job-board-detail/${opk}/`,
    method: 'get',
    signal,
  });
};

export const getApiJobBoardDetailRetrieveQueryKey = (opk: string) => [
  `/api/v7/screens/job-board-detail/${opk}/`,
];

export type ApiJobBoardDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiJobBoardDetailRetrieve>>
>;
export type ApiJobBoardDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiJobBoardDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiJobBoardDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiJobBoardDetailRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiJobBoardDetailRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiJobBoardDetailRetrieve>>> = ({
    signal,
  }) => apiJobBoardDetailRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiJobBoardDetailRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiJobBoardListingRetrieve = (
  params?: ApiJobBoardListingRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<JobBoardListingView>({
    url: `/api/v7/screens/job-board-listing/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiJobBoardListingRetrieveQueryKey = (
  params?: ApiJobBoardListingRetrieveParams
) => [`/api/v7/screens/job-board-listing/`, ...(params ? [params] : [])];

export type ApiJobBoardListingRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiJobBoardListingRetrieve>>
>;
export type ApiJobBoardListingRetrieveQueryError = ErrorType<unknown>;

export const useApiJobBoardListingRetrieve = <
  TData = Awaited<ReturnType<typeof apiJobBoardListingRetrieve>>,
  TError = ErrorType<unknown>
>(
  params?: ApiJobBoardListingRetrieveParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiJobBoardListingRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiJobBoardListingRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiJobBoardListingRetrieve>>> = ({
    signal,
  }) => apiJobBoardListingRetrieve(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiJobBoardListingRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiJobBoardListingAvailablePostingsRetrieve = (
  params?: ApiJobBoardListingAvailablePostingsRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<PostingsPage>({
    url: `/api/v7/screens/job-board-listing/available-postings/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiJobBoardListingAvailablePostingsRetrieveQueryKey = (
  params?: ApiJobBoardListingAvailablePostingsRetrieveParams
) => [`/api/v7/screens/job-board-listing/available-postings/`, ...(params ? [params] : [])];

export type ApiJobBoardListingAvailablePostingsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiJobBoardListingAvailablePostingsRetrieve>>
>;
export type ApiJobBoardListingAvailablePostingsRetrieveQueryError = ErrorType<unknown>;

export const useApiJobBoardListingAvailablePostingsRetrieve = <
  TData = Awaited<ReturnType<typeof apiJobBoardListingAvailablePostingsRetrieve>>,
  TError = ErrorType<unknown>
>(
  params?: ApiJobBoardListingAvailablePostingsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiJobBoardListingAvailablePostingsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiJobBoardListingAvailablePostingsRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiJobBoardListingAvailablePostingsRetrieve>>
  > = ({ signal }) => apiJobBoardListingAvailablePostingsRetrieve(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiJobBoardListingAvailablePostingsRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * In order to decrease payload size and improve performance in frontend search api clients,
OptimizedSearchView extends SearchView, and hides any fields not used by the SSR React
Search client.

This duplicate endpoint is step one in a longer term process to migrate all search clients to
use a single reduced-payload API, which will then become *the* search endpoint in a future
API version; at that point the /search-optimized/ route will be removed.
 */
export const apiMobileSearchRetrieve = (
  params?: ApiMobileSearchRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<MobileSearchResponse>({
    url: `/api/v7/screens/mobile-search/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiMobileSearchRetrieveQueryKey = (params?: ApiMobileSearchRetrieveParams) => [
  `/api/v7/screens/mobile-search/`,
  ...(params ? [params] : []),
];

export type ApiMobileSearchRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMobileSearchRetrieve>>
>;
export type ApiMobileSearchRetrieveQueryError = ErrorType<unknown>;

export const useApiMobileSearchRetrieve = <
  TData = Awaited<ReturnType<typeof apiMobileSearchRetrieve>>,
  TError = ErrorType<unknown>
>(
  params?: ApiMobileSearchRetrieveParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiMobileSearchRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMobileSearchRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMobileSearchRetrieve>>> = ({
    signal,
  }) => apiMobileSearchRetrieve(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiMobileSearchRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiSearchWithTextCreate = (
  apiSearchWithTextCreateBody: ApiSearchWithTextCreateBody
) => {
  return HTTP<unknown>({
    url: `/api/v7/screens/search-with-text/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiSearchWithTextCreateBody,
  });
};

export type ApiSearchWithTextCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSearchWithTextCreate>>
>;
export type ApiSearchWithTextCreateMutationBody = ApiSearchWithTextCreateBody;
export type ApiSearchWithTextCreateMutationError = ErrorType<ApiSearchWithTextCreate400>;

export const useApiSearchWithTextCreate = <
  TError = ErrorType<ApiSearchWithTextCreate400>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSearchWithTextCreate>>,
    TError,
    { data: ApiSearchWithTextCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSearchWithTextCreate>>,
    { data: ApiSearchWithTextCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiSearchWithTextCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiSearchWithTextCreate>>,
    TError,
    { data: ApiSearchWithTextCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiServiceSelectorRetrieve = (signal?: AbortSignal) => {
  return HTTP<ServiceSelectorView>({
    url: `/api/v7/screens/service-selector/`,
    method: 'get',
    signal,
  });
};

export const getApiServiceSelectorRetrieveQueryKey = () => [`/api/v7/screens/service-selector/`];

export type ApiServiceSelectorRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceSelectorRetrieve>>
>;
export type ApiServiceSelectorRetrieveQueryError = ErrorType<unknown>;

export const useApiServiceSelectorRetrieve = <
  TData = Awaited<ReturnType<typeof apiServiceSelectorRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiServiceSelectorRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiServiceSelectorRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiServiceSelectorRetrieve>>> = ({
    signal,
  }) => apiServiceSelectorRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiServiceSelectorRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiStarSitterDashboardRetrieve = (signal?: AbortSignal) => {
  return HTTP<StarSitterRolling>({
    url: `/api/v7/screens/star-sitter-dashboard/`,
    method: 'get',
    signal,
  });
};

export const getApiStarSitterDashboardRetrieveQueryKey = () => [
  `/api/v7/screens/star-sitter-dashboard/`,
];

export type ApiStarSitterDashboardRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiStarSitterDashboardRetrieve>>
>;
export type ApiStarSitterDashboardRetrieveQueryError = ErrorType<unknown>;

export const useApiStarSitterDashboardRetrieve = <
  TData = Awaited<ReturnType<typeof apiStarSitterDashboardRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiStarSitterDashboardRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiStarSitterDashboardRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiStarSitterDashboardRetrieve>>> = ({
    signal,
  }) => apiStarSitterDashboardRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiStarSitterDashboardRetrieve>>, TError, TData>(
    { queryKey, queryFn, refetchOnMount: false, refetchOnWindowFocus: false, ...queryOptions }
  ) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiStarSitterInsightsRetrieve = (signal?: AbortSignal) => {
  return HTTP<StarSitterInsights>({
    url: `/api/v7/screens/star-sitter-insights/`,
    method: 'get',
    signal,
  });
};

export const getApiStarSitterInsightsRetrieveQueryKey = () => [
  `/api/v7/screens/star-sitter-insights/`,
];

export type ApiStarSitterInsightsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiStarSitterInsightsRetrieve>>
>;
export type ApiStarSitterInsightsRetrieveQueryError = ErrorType<unknown>;

export const useApiStarSitterInsightsRetrieve = <
  TData = Awaited<ReturnType<typeof apiStarSitterInsightsRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiStarSitterInsightsRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiStarSitterInsightsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiStarSitterInsightsRetrieve>>> = ({
    signal,
  }) => apiStarSitterInsightsRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiStarSitterInsightsRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Search view
 */
export const apiSearchRetrieve = (params?: ApiSearchRetrieveParams, signal?: AbortSignal) => {
  return HTTP<SearchResponse>({ url: `/api/v7/search/`, method: 'get', params, signal });
};

export const getApiSearchRetrieveQueryKey = (params?: ApiSearchRetrieveParams) => [
  `/api/v7/search/`,
  ...(params ? [params] : []),
];

export type ApiSearchRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSearchRetrieve>>
>;
export type ApiSearchRetrieveQueryError = ErrorType<unknown>;

export const useApiSearchRetrieve = <
  TData = Awaited<ReturnType<typeof apiSearchRetrieve>>,
  TError = ErrorType<unknown>
>(
  params?: ApiSearchRetrieveParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiSearchRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSearchRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSearchRetrieve>>> = ({ signal }) =>
    apiSearchRetrieve(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiSearchRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiSearchEndpointsRetrieve = (signal?: AbortSignal) => {
  return HTTP<ApiSearchEndpointsRetrieve200>({
    url: `/api/v7/search-endpoints/`,
    method: 'get',
    signal,
  });
};

export const getApiSearchEndpointsRetrieveQueryKey = () => [`/api/v7/search-endpoints/`];

export type ApiSearchEndpointsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSearchEndpointsRetrieve>>
>;
export type ApiSearchEndpointsRetrieveQueryError = ErrorType<unknown>;

export const useApiSearchEndpointsRetrieve = <
  TData = Awaited<ReturnType<typeof apiSearchEndpointsRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiSearchEndpointsRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSearchEndpointsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSearchEndpointsRetrieve>>> = ({
    signal,
  }) => apiSearchEndpointsRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiSearchEndpointsRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * In order to decrease payload size and improve performance in frontend search api clients,
OptimizedSearchView extends SearchView, and hides any fields not used by the SSR React
Search client.

This duplicate endpoint is step one in a longer term process to migrate all search clients to
use a single reduced-payload API, which will then become *the* search endpoint in a future
API version; at that point the /search-optimized/ route will be removed.
 */
export const apiSearchOptimizedRetrieve = (
  params?: ApiSearchOptimizedRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<OptimizedSearchResponse>({
    url: `/api/v7/search-optimized/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiSearchOptimizedRetrieveQueryKey = (
  params?: ApiSearchOptimizedRetrieveParams
) => [`/api/v7/search-optimized/`, ...(params ? [params] : [])];

export type ApiSearchOptimizedRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSearchOptimizedRetrieve>>
>;
export type ApiSearchOptimizedRetrieveQueryError = ErrorType<unknown>;

export const useApiSearchOptimizedRetrieve = <
  TData = Awaited<ReturnType<typeof apiSearchOptimizedRetrieve>>,
  TError = ErrorType<unknown>
>(
  params?: ApiSearchOptimizedRetrieveParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiSearchOptimizedRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSearchOptimizedRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSearchOptimizedRetrieve>>> = ({
    signal,
  }) => apiSearchOptimizedRetrieve(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiSearchOptimizedRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Add the service_type from the url as a query parameter to regular Search
 */
export const apiSearchServiceTypeRetrieve = (
  serviceType: string,
  params?: ApiSearchServiceTypeRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<SearchResponse>({
    url: `/api/v7/search/${serviceType}/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiSearchServiceTypeRetrieveQueryKey = (
  serviceType: string,
  params?: ApiSearchServiceTypeRetrieveParams
) => [`/api/v7/search/${serviceType}/`, ...(params ? [params] : [])];

export type ApiSearchServiceTypeRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSearchServiceTypeRetrieve>>
>;
export type ApiSearchServiceTypeRetrieveQueryError = ErrorType<unknown>;

export const useApiSearchServiceTypeRetrieve = <
  TData = Awaited<ReturnType<typeof apiSearchServiceTypeRetrieve>>,
  TError = ErrorType<unknown>
>(
  serviceType: string,
  params?: ApiSearchServiceTypeRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSearchServiceTypeRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiSearchServiceTypeRetrieveQueryKey(serviceType, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSearchServiceTypeRetrieve>>> = ({
    signal,
  }) => apiSearchServiceTypeRetrieve(serviceType, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiSearchServiceTypeRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!serviceType,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiReplicateSearchEventCreate = (
  replicateSearchEventRequest: ReplicateSearchEventRequest
) => {
  return HTTP<void>({
    url: `/api/v7/search/replicate-event/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: replicateSearchEventRequest,
  });
};

export type ApiReplicateSearchEventCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiReplicateSearchEventCreate>>
>;
export type ApiReplicateSearchEventCreateMutationBody = ReplicateSearchEventRequest;
export type ApiReplicateSearchEventCreateMutationError = ErrorType<unknown>;

export const useApiReplicateSearchEventCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiReplicateSearchEventCreate>>,
    TError,
    { data: ReplicateSearchEventRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiReplicateSearchEventCreate>>,
    { data: ReplicateSearchEventRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiReplicateSearchEventCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiReplicateSearchEventCreate>>,
    TError,
    { data: ReplicateSearchEventRequest },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiSearchSeoCityWithoutCountryRetrieve = (
  city: string,
  regionSlug: string,
  seoSlug: string,
  extra: string,
  signal?: AbortSignal
) => {
  return HTTP<SeoLocationSchema>({
    url: `/api/v7/seo-location/${city}--${regionSlug}--${seoSlug}/${extra}`,
    method: 'get',
    signal,
  });
};

export const getApiSearchSeoCityWithoutCountryRetrieveQueryKey = (
  city: string,
  regionSlug: string,
  seoSlug: string,
  extra: string
) => [`/api/v7/seo-location/${city}--${regionSlug}--${seoSlug}/${extra}`];

export type ApiSearchSeoCityWithoutCountryRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSearchSeoCityWithoutCountryRetrieve>>
>;
export type ApiSearchSeoCityWithoutCountryRetrieveQueryError = ErrorType<unknown>;

export const useApiSearchSeoCityWithoutCountryRetrieve = <
  TData = Awaited<ReturnType<typeof apiSearchSeoCityWithoutCountryRetrieve>>,
  TError = ErrorType<unknown>
>(
  city: string,
  regionSlug: string,
  seoSlug: string,
  extra: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSearchSeoCityWithoutCountryRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiSearchSeoCityWithoutCountryRetrieveQueryKey(city, regionSlug, seoSlug, extra);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiSearchSeoCityWithoutCountryRetrieve>>
  > = ({ signal }) =>
    apiSearchSeoCityWithoutCountryRetrieve(city, regionSlug, seoSlug, extra, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiSearchSeoCityWithoutCountryRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(city && regionSlug && seoSlug && extra),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiSearchSeoCityWithoutCountryReviewsList = (
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiSearchSeoCityWithoutCountryReviewsListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedProviderRatingList>({
    url: `/api/v7/seo-location/${city}--${regionSlug}--${seoSlug}/reviews/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiSearchSeoCityWithoutCountryReviewsListQueryKey = (
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiSearchSeoCityWithoutCountryReviewsListParams
) => [
  `/api/v7/seo-location/${city}--${regionSlug}--${seoSlug}/reviews/`,
  ...(params ? [params] : []),
];

export type ApiSearchSeoCityWithoutCountryReviewsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSearchSeoCityWithoutCountryReviewsList>>
>;
export type ApiSearchSeoCityWithoutCountryReviewsListQueryError = ErrorType<unknown>;

export const useApiSearchSeoCityWithoutCountryReviewsList = <
  TData = Awaited<ReturnType<typeof apiSearchSeoCityWithoutCountryReviewsList>>,
  TError = ErrorType<unknown>
>(
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiSearchSeoCityWithoutCountryReviewsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSearchSeoCityWithoutCountryReviewsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiSearchSeoCityWithoutCountryReviewsListQueryKey(city, regionSlug, seoSlug, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiSearchSeoCityWithoutCountryReviewsList>>
  > = ({ signal }) =>
    apiSearchSeoCityWithoutCountryReviewsList(city, regionSlug, seoSlug, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiSearchSeoCityWithoutCountryReviewsList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(city && regionSlug && seoSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiSearchSeoCityRetrieve = (
  countryUrlPrefix: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  extra: string,
  signal?: AbortSignal
) => {
  return HTTP<SeoLocationSchema>({
    url: `/api/v7/seo-location/${countryUrlPrefix}/${city}--${regionSlug}--${seoSlug}/${extra}`,
    method: 'get',
    signal,
  });
};

export const getApiSearchSeoCityRetrieveQueryKey = (
  countryUrlPrefix: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  extra: string
) => [`/api/v7/seo-location/${countryUrlPrefix}/${city}--${regionSlug}--${seoSlug}/${extra}`];

export type ApiSearchSeoCityRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSearchSeoCityRetrieve>>
>;
export type ApiSearchSeoCityRetrieveQueryError = ErrorType<unknown>;

export const useApiSearchSeoCityRetrieve = <
  TData = Awaited<ReturnType<typeof apiSearchSeoCityRetrieve>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  extra: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiSearchSeoCityRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiSearchSeoCityRetrieveQueryKey(countryUrlPrefix, city, regionSlug, seoSlug, extra);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSearchSeoCityRetrieve>>> = ({
    signal,
  }) => apiSearchSeoCityRetrieve(countryUrlPrefix, city, regionSlug, seoSlug, extra, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiSearchSeoCityRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!(countryUrlPrefix && city && regionSlug && seoSlug && extra),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiSearchSeoCityReviewsList = (
  countryUrlPrefix: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiSearchSeoCityReviewsListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedProviderRatingList>({
    url: `/api/v7/seo-location/${countryUrlPrefix}/${city}--${regionSlug}--${seoSlug}/reviews/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiSearchSeoCityReviewsListQueryKey = (
  countryUrlPrefix: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiSearchSeoCityReviewsListParams
) => [
  `/api/v7/seo-location/${countryUrlPrefix}/${city}--${regionSlug}--${seoSlug}/reviews/`,
  ...(params ? [params] : []),
];

export type ApiSearchSeoCityReviewsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSearchSeoCityReviewsList>>
>;
export type ApiSearchSeoCityReviewsListQueryError = ErrorType<unknown>;

export const useApiSearchSeoCityReviewsList = <
  TData = Awaited<ReturnType<typeof apiSearchSeoCityReviewsList>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiSearchSeoCityReviewsListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiSearchSeoCityReviewsList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiSearchSeoCityReviewsListQueryKey(countryUrlPrefix, city, regionSlug, seoSlug, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSearchSeoCityReviewsList>>> = ({
    signal,
  }) => apiSearchSeoCityReviewsList(countryUrlPrefix, city, regionSlug, seoSlug, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiSearchSeoCityReviewsList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!(countryUrlPrefix && city && regionSlug && seoSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiSearchSeoNeighborhoodRetrieve = (
  countryUrlPrefix: string,
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  extra: string,
  signal?: AbortSignal
) => {
  return HTTP<SeoLocationSchema>({
    url: `/api/v7/seo-location/${countryUrlPrefix}/${neighborhood}--${city}--${regionSlug}--${seoSlug}/${extra}`,
    method: 'get',
    signal,
  });
};

export const getApiSearchSeoNeighborhoodRetrieveQueryKey = (
  countryUrlPrefix: string,
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  extra: string
) => [
  `/api/v7/seo-location/${countryUrlPrefix}/${neighborhood}--${city}--${regionSlug}--${seoSlug}/${extra}`,
];

export type ApiSearchSeoNeighborhoodRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSearchSeoNeighborhoodRetrieve>>
>;
export type ApiSearchSeoNeighborhoodRetrieveQueryError = ErrorType<unknown>;

export const useApiSearchSeoNeighborhoodRetrieve = <
  TData = Awaited<ReturnType<typeof apiSearchSeoNeighborhoodRetrieve>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  extra: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSearchSeoNeighborhoodRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiSearchSeoNeighborhoodRetrieveQueryKey(
      countryUrlPrefix,
      neighborhood,
      city,
      regionSlug,
      seoSlug,
      extra
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSearchSeoNeighborhoodRetrieve>>> = ({
    signal,
  }) =>
    apiSearchSeoNeighborhoodRetrieve(
      countryUrlPrefix,
      neighborhood,
      city,
      regionSlug,
      seoSlug,
      extra,
      signal
    );

  const query = useQuery<
    Awaited<ReturnType<typeof apiSearchSeoNeighborhoodRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(countryUrlPrefix && neighborhood && city && regionSlug && seoSlug && extra),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiSearchSeoNeighborhoodReviewsList = (
  countryUrlPrefix: string,
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiSearchSeoNeighborhoodReviewsListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedProviderRatingList>({
    url: `/api/v7/seo-location/${countryUrlPrefix}/${neighborhood}--${city}--${regionSlug}--${seoSlug}/reviews/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiSearchSeoNeighborhoodReviewsListQueryKey = (
  countryUrlPrefix: string,
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiSearchSeoNeighborhoodReviewsListParams
) => [
  `/api/v7/seo-location/${countryUrlPrefix}/${neighborhood}--${city}--${regionSlug}--${seoSlug}/reviews/`,
  ...(params ? [params] : []),
];

export type ApiSearchSeoNeighborhoodReviewsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSearchSeoNeighborhoodReviewsList>>
>;
export type ApiSearchSeoNeighborhoodReviewsListQueryError = ErrorType<unknown>;

export const useApiSearchSeoNeighborhoodReviewsList = <
  TData = Awaited<ReturnType<typeof apiSearchSeoNeighborhoodReviewsList>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiSearchSeoNeighborhoodReviewsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSearchSeoNeighborhoodReviewsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiSearchSeoNeighborhoodReviewsListQueryKey(
      countryUrlPrefix,
      neighborhood,
      city,
      regionSlug,
      seoSlug,
      params
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSearchSeoNeighborhoodReviewsList>>> = ({
    signal,
  }) =>
    apiSearchSeoNeighborhoodReviewsList(
      countryUrlPrefix,
      neighborhood,
      city,
      regionSlug,
      seoSlug,
      params,
      signal
    );

  const query = useQuery<
    Awaited<ReturnType<typeof apiSearchSeoNeighborhoodReviewsList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(countryUrlPrefix && neighborhood && city && regionSlug && seoSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiSearchSeoNeighborhoodWithoutCountryRetrieve = (
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  extra: string,
  signal?: AbortSignal
) => {
  return HTTP<SeoLocationSchema>({
    url: `/api/v7/seo-location/${neighborhood}--${city}--${regionSlug}--${seoSlug}/${extra}`,
    method: 'get',
    signal,
  });
};

export const getApiSearchSeoNeighborhoodWithoutCountryRetrieveQueryKey = (
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  extra: string
) => [`/api/v7/seo-location/${neighborhood}--${city}--${regionSlug}--${seoSlug}/${extra}`];

export type ApiSearchSeoNeighborhoodWithoutCountryRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSearchSeoNeighborhoodWithoutCountryRetrieve>>
>;
export type ApiSearchSeoNeighborhoodWithoutCountryRetrieveQueryError = ErrorType<unknown>;

export const useApiSearchSeoNeighborhoodWithoutCountryRetrieve = <
  TData = Awaited<ReturnType<typeof apiSearchSeoNeighborhoodWithoutCountryRetrieve>>,
  TError = ErrorType<unknown>
>(
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  extra: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSearchSeoNeighborhoodWithoutCountryRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiSearchSeoNeighborhoodWithoutCountryRetrieveQueryKey(
      neighborhood,
      city,
      regionSlug,
      seoSlug,
      extra
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiSearchSeoNeighborhoodWithoutCountryRetrieve>>
  > = ({ signal }) =>
    apiSearchSeoNeighborhoodWithoutCountryRetrieve(
      neighborhood,
      city,
      regionSlug,
      seoSlug,
      extra,
      signal
    );

  const query = useQuery<
    Awaited<ReturnType<typeof apiSearchSeoNeighborhoodWithoutCountryRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(neighborhood && city && regionSlug && seoSlug && extra),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiSearchSeoNeighborhoodWithoutCountryReviewsList = (
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiSearchSeoNeighborhoodWithoutCountryReviewsListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedProviderRatingList>({
    url: `/api/v7/seo-location/${neighborhood}--${city}--${regionSlug}--${seoSlug}/reviews/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiSearchSeoNeighborhoodWithoutCountryReviewsListQueryKey = (
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiSearchSeoNeighborhoodWithoutCountryReviewsListParams
) => [
  `/api/v7/seo-location/${neighborhood}--${city}--${regionSlug}--${seoSlug}/reviews/`,
  ...(params ? [params] : []),
];

export type ApiSearchSeoNeighborhoodWithoutCountryReviewsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSearchSeoNeighborhoodWithoutCountryReviewsList>>
>;
export type ApiSearchSeoNeighborhoodWithoutCountryReviewsListQueryError = ErrorType<unknown>;

export const useApiSearchSeoNeighborhoodWithoutCountryReviewsList = <
  TData = Awaited<ReturnType<typeof apiSearchSeoNeighborhoodWithoutCountryReviewsList>>,
  TError = ErrorType<unknown>
>(
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiSearchSeoNeighborhoodWithoutCountryReviewsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSearchSeoNeighborhoodWithoutCountryReviewsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiSearchSeoNeighborhoodWithoutCountryReviewsListQueryKey(
      neighborhood,
      city,
      regionSlug,
      seoSlug,
      params
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiSearchSeoNeighborhoodWithoutCountryReviewsList>>
  > = ({ signal }) =>
    apiSearchSeoNeighborhoodWithoutCountryReviewsList(
      neighborhood,
      city,
      regionSlug,
      seoSlug,
      params,
      signal
    );

  const query = useQuery<
    Awaited<ReturnType<typeof apiSearchSeoNeighborhoodWithoutCountryReviewsList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(neighborhood && city && regionSlug && seoSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiServiceAreaIsochroneCreate = (serviceAreaIsochrone: ServiceAreaIsochrone) => {
  return HTTP<ApiServiceAreaIsochroneCreate200>({
    url: `/api/v7/service-area-isochrone/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: serviceAreaIsochrone,
  });
};

export type ApiServiceAreaIsochroneCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceAreaIsochroneCreate>>
>;
export type ApiServiceAreaIsochroneCreateMutationBody = ServiceAreaIsochrone;
export type ApiServiceAreaIsochroneCreateMutationError = ErrorType<unknown>;

export const useApiServiceAreaIsochroneCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiServiceAreaIsochroneCreate>>,
    TError,
    { data: ServiceAreaIsochrone },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiServiceAreaIsochroneCreate>>,
    { data: ServiceAreaIsochrone }
  > = (props) => {
    const { data } = props ?? {};

    return apiServiceAreaIsochroneCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiServiceAreaIsochroneCreate>>,
    TError,
    { data: ServiceAreaIsochrone },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Sets reasonable pagination defaults for all the API list/create views.
 */
export const apiServiceDeliveryList = (
  params?: ApiServiceDeliveryListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedServiceDeliveryList>({
    url: `/api/v7/service-deliveries/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiServiceDeliveryListQueryKey = (params?: ApiServiceDeliveryListParams) => [
  `/api/v7/service-deliveries/`,
  ...(params ? [params] : []),
];

export type ApiServiceDeliveryListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceDeliveryList>>
>;
export type ApiServiceDeliveryListQueryError = ErrorType<unknown>;

export const useApiServiceDeliveryList = <
  TData = Awaited<ReturnType<typeof apiServiceDeliveryList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiServiceDeliveryListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiServiceDeliveryList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiServiceDeliveryListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiServiceDeliveryList>>> = ({ signal }) =>
    apiServiceDeliveryList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiServiceDeliveryList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list/create views.
 */
export const apiServiceDeliveryListCreate = (serviceDelivery: ServiceDelivery) => {
  return HTTP<ServiceDelivery>({
    url: `/api/v7/service-deliveries/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: serviceDelivery,
  });
};

export type ApiServiceDeliveryListCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceDeliveryListCreate>>
>;
export type ApiServiceDeliveryListCreateMutationBody = ServiceDelivery;
export type ApiServiceDeliveryListCreateMutationError = ErrorType<unknown>;

export const useApiServiceDeliveryListCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiServiceDeliveryListCreate>>,
    TError,
    { data: ServiceDelivery },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiServiceDeliveryListCreate>>,
    { data: ServiceDelivery }
  > = (props) => {
    const { data } = props ?? {};

    return apiServiceDeliveryListCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiServiceDeliveryListCreate>>,
    TError,
    { data: ServiceDelivery },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiServiceDeliveryDetailRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<ServiceDelivery>({
    url: `/api/v7/service-deliveries/${opk}/`,
    method: 'get',
    signal,
  });
};

export const getApiServiceDeliveryDetailRetrieveQueryKey = (opk: string) => [
  `/api/v7/service-deliveries/${opk}/`,
];

export type ApiServiceDeliveryDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceDeliveryDetailRetrieve>>
>;
export type ApiServiceDeliveryDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiServiceDeliveryDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiServiceDeliveryDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiServiceDeliveryDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiServiceDeliveryDetailRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiServiceDeliveryDetailRetrieve>>> = ({
    signal,
  }) => apiServiceDeliveryDetailRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiServiceDeliveryDetailRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiServiceDeliveryDetailUpdate = (opk: string, serviceDelivery: ServiceDelivery) => {
  return HTTP<ServiceDelivery>({
    url: `/api/v7/service-deliveries/${opk}/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: serviceDelivery,
  });
};

export type ApiServiceDeliveryDetailUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceDeliveryDetailUpdate>>
>;
export type ApiServiceDeliveryDetailUpdateMutationBody = ServiceDelivery;
export type ApiServiceDeliveryDetailUpdateMutationError = ErrorType<unknown>;

export const useApiServiceDeliveryDetailUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiServiceDeliveryDetailUpdate>>,
    TError,
    { opk: string; data: ServiceDelivery },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiServiceDeliveryDetailUpdate>>,
    { opk: string; data: ServiceDelivery }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiServiceDeliveryDetailUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiServiceDeliveryDetailUpdate>>,
    TError,
    { opk: string; data: ServiceDelivery },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiServiceDeliveryDetailPartialUpdate = (
  opk: string,
  patchedServiceDelivery: PatchedServiceDelivery
) => {
  return HTTP<ServiceDelivery>({
    url: `/api/v7/service-deliveries/${opk}/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedServiceDelivery,
  });
};

export type ApiServiceDeliveryDetailPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceDeliveryDetailPartialUpdate>>
>;
export type ApiServiceDeliveryDetailPartialUpdateMutationBody = PatchedServiceDelivery;
export type ApiServiceDeliveryDetailPartialUpdateMutationError = ErrorType<unknown>;

export const useApiServiceDeliveryDetailPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiServiceDeliveryDetailPartialUpdate>>,
    TError,
    { opk: string; data: PatchedServiceDelivery },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiServiceDeliveryDetailPartialUpdate>>,
    { opk: string; data: PatchedServiceDelivery }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiServiceDeliveryDetailPartialUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiServiceDeliveryDetailPartialUpdate>>,
    TError,
    { opk: string; data: PatchedServiceDelivery },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Base class for all Service Delivery subresource views that need a service
delivery PK in the URL kwargs
 */
export const apiServiceDeliveryDetailImagesList = (
  opk: string,
  params?: ApiServiceDeliveryDetailImagesListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedImageList>({
    url: `/api/v7/service-deliveries/${opk}/images/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiServiceDeliveryDetailImagesListQueryKey = (
  opk: string,
  params?: ApiServiceDeliveryDetailImagesListParams
) => [`/api/v7/service-deliveries/${opk}/images/`, ...(params ? [params] : [])];

export type ApiServiceDeliveryDetailImagesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceDeliveryDetailImagesList>>
>;
export type ApiServiceDeliveryDetailImagesListQueryError = ErrorType<unknown>;

export const useApiServiceDeliveryDetailImagesList = <
  TData = Awaited<ReturnType<typeof apiServiceDeliveryDetailImagesList>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiServiceDeliveryDetailImagesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiServiceDeliveryDetailImagesList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiServiceDeliveryDetailImagesListQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiServiceDeliveryDetailImagesList>>> = ({
    signal,
  }) => apiServiceDeliveryDetailImagesList(opk, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiServiceDeliveryDetailImagesList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Base class for all Service Delivery subresource views that need a service
delivery PK in the URL kwargs
 */
export const apiServiceDeliveryDetailImagesCreate = (opk: string, image: Image) => {
  return HTTP<Image>({
    url: `/api/v7/service-deliveries/${opk}/images/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: image,
  });
};

export type ApiServiceDeliveryDetailImagesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceDeliveryDetailImagesCreate>>
>;
export type ApiServiceDeliveryDetailImagesCreateMutationBody = Image;
export type ApiServiceDeliveryDetailImagesCreateMutationError = ErrorType<unknown>;

export const useApiServiceDeliveryDetailImagesCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiServiceDeliveryDetailImagesCreate>>,
    TError,
    { opk: string; data: Image },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiServiceDeliveryDetailImagesCreate>>,
    { opk: string; data: Image }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiServiceDeliveryDetailImagesCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiServiceDeliveryDetailImagesCreate>>,
    TError,
    { opk: string; data: Image },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiServiceDeliveryDetailWalksCreate = (opk: string, walk: Walk) => {
  return HTTP<Walk>({
    url: `/api/v7/service-deliveries/${opk}/walks/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: walk,
  });
};

export type ApiServiceDeliveryDetailWalksCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceDeliveryDetailWalksCreate>>
>;
export type ApiServiceDeliveryDetailWalksCreateMutationBody = Walk;
export type ApiServiceDeliveryDetailWalksCreateMutationError = ErrorType<unknown>;

export const useApiServiceDeliveryDetailWalksCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiServiceDeliveryDetailWalksCreate>>,
    TError,
    { opk: string; data: Walk },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiServiceDeliveryDetailWalksCreate>>,
    { opk: string; data: Walk }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiServiceDeliveryDetailWalksCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiServiceDeliveryDetailWalksCreate>>,
    TError,
    { opk: string; data: Walk },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiServiceExperienceRetrieve = (signal?: AbortSignal) => {
  return HTTP<ServiceExperience>({ url: `/api/v7/service-experience/`, method: 'get', signal });
};

export const getApiServiceExperienceRetrieveQueryKey = () => [`/api/v7/service-experience/`];

export type ApiServiceExperienceRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceExperienceRetrieve>>
>;
export type ApiServiceExperienceRetrieveQueryError = ErrorType<unknown>;

export const useApiServiceExperienceRetrieve = <
  TData = Awaited<ReturnType<typeof apiServiceExperienceRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiServiceExperienceRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiServiceExperienceRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiServiceExperienceRetrieve>>> = ({
    signal,
  }) => apiServiceExperienceRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiServiceExperienceRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiServiceTypesList = (params?: ApiServiceTypesListParams, signal?: AbortSignal) => {
  return HTTP<PaginatedServiceTypeList>({
    url: `/api/v7/service-types/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiServiceTypesListQueryKey = (params?: ApiServiceTypesListParams) => [
  `/api/v7/service-types/`,
  ...(params ? [params] : []),
];

export type ApiServiceTypesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceTypesList>>
>;
export type ApiServiceTypesListQueryError = ErrorType<unknown>;

export const useApiServiceTypesList = <
  TData = Awaited<ReturnType<typeof apiServiceTypesList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiServiceTypesListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiServiceTypesList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiServiceTypesListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiServiceTypesList>>> = ({ signal }) =>
    apiServiceTypesList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiServiceTypesList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * This API allows the toggle privacy function for Owner for pet profile images (Images attached to Pet
instances), or either conversation party to toggle Stay photos (Images attached to Messages or SDVs).
Both types of photos are on the Pet Profile page's photo gallery.
 */
export const apiSetPetProfileImageVisibilityUpdate = (
  setImageVisibilityRequest: SetImageVisibilityRequest
) => {
  return HTTP<void>({
    url: `/api/v7/set-pet-profile-image-visibility/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: setImageVisibilityRequest,
  });
};

export type ApiSetPetProfileImageVisibilityUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSetPetProfileImageVisibilityUpdate>>
>;
export type ApiSetPetProfileImageVisibilityUpdateMutationBody = SetImageVisibilityRequest;
export type ApiSetPetProfileImageVisibilityUpdateMutationError = ErrorType<Error>;

export const useApiSetPetProfileImageVisibilityUpdate = <
  TError = ErrorType<Error>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSetPetProfileImageVisibilityUpdate>>,
    TError,
    { data: SetImageVisibilityRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSetPetProfileImageVisibilityUpdate>>,
    { data: SetImageVisibilityRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiSetPetProfileImageVisibilityUpdate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiSetPetProfileImageVisibilityUpdate>>,
    TError,
    { data: SetImageVisibilityRequest },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiSetStayImageVisibilityUpdate = (
  setImageVisibilityRequest: SetImageVisibilityRequest
) => {
  return HTTP<void>({
    url: `/api/v7/set-stay-image-visibility/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: setImageVisibilityRequest,
  });
};

export type ApiSetStayImageVisibilityUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSetStayImageVisibilityUpdate>>
>;
export type ApiSetStayImageVisibilityUpdateMutationBody = SetImageVisibilityRequest;
export type ApiSetStayImageVisibilityUpdateMutationError = ErrorType<Error>;

export const useApiSetStayImageVisibilityUpdate = <
  TError = ErrorType<Error>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSetStayImageVisibilityUpdate>>,
    TError,
    { data: SetImageVisibilityRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSetStayImageVisibilityUpdate>>,
    { data: SetImageVisibilityRequest }
  > = (props) => {
    const { data } = props ?? {};

    return apiSetStayImageVisibilityUpdate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiSetStayImageVisibilityUpdate>>,
    TError,
    { data: SetImageVisibilityRequest },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiSsoZendeskRetrieve = (signal?: AbortSignal) => {
  return HTTP<ApiSsoZendeskRetrieve200>({ url: `/api/v7/sso/zendesk/`, method: 'get', signal });
};

export const getApiSsoZendeskRetrieveQueryKey = () => [`/api/v7/sso/zendesk/`];

export type ApiSsoZendeskRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSsoZendeskRetrieve>>
>;
export type ApiSsoZendeskRetrieveQueryError = ErrorType<unknown>;

export const useApiSsoZendeskRetrieve = <
  TData = Awaited<ReturnType<typeof apiSsoZendeskRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiSsoZendeskRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSsoZendeskRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSsoZendeskRetrieve>>> = ({ signal }) =>
    apiSsoZendeskRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiSsoZendeskRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiSurveyRetrieve = (surveySlug: string, signal?: AbortSignal) => {
  return HTTP<RetrieveSurvey | void>({
    url: `/api/v7/surveys/${surveySlug}/`,
    method: 'get',
    signal,
  });
};

export const getApiSurveyRetrieveQueryKey = (surveySlug: string) => [
  `/api/v7/surveys/${surveySlug}/`,
];

export type ApiSurveyRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSurveyRetrieve>>
>;
export type ApiSurveyRetrieveQueryError = ErrorType<unknown>;

export const useApiSurveyRetrieve = <
  TData = Awaited<ReturnType<typeof apiSurveyRetrieve>>,
  TError = ErrorType<unknown>
>(
  surveySlug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiSurveyRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSurveyRetrieveQueryKey(surveySlug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSurveyRetrieve>>> = ({ signal }) =>
    apiSurveyRetrieve(surveySlug, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiSurveyRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!surveySlug,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiSurveyCreate = (surveySlug: string, surveySubmission: SurveySubmission) => {
  return HTTP<void>({
    url: `/api/v7/surveys/${surveySlug}/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: surveySubmission,
  });
};

export type ApiSurveyCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiSurveyCreate>>
>;
export type ApiSurveyCreateMutationBody = SurveySubmission;
export type ApiSurveyCreateMutationError = ErrorType<unknown>;

export const useApiSurveyCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiSurveyCreate>>,
    TError,
    { surveySlug: string; data: SurveySubmission },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiSurveyCreate>>,
    { surveySlug: string; data: SurveySubmission }
  > = (props) => {
    const { surveySlug, data } = props ?? {};

    return apiSurveyCreate(surveySlug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiSurveyCreate>>,
    TError,
    { surveySlug: string; data: SurveySubmission },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Get tractive discount code if user meets eligibility criteria. Can be used with or without conversation context.
 */
export const apiConversationTractiveDiscountCodeRetrieve2 = (
  params?: ApiConversationTractiveDiscountCodeRetrieve2Params,
  signal?: AbortSignal
) => {
  return HTTP<TractiveDiscountCodeResponse>({
    url: `/api/v7/tractive-discount-code/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiConversationTractiveDiscountCodeRetrieve2QueryKey = (
  params?: ApiConversationTractiveDiscountCodeRetrieve2Params
) => [`/api/v7/tractive-discount-code/`, ...(params ? [params] : [])];

export type ApiConversationTractiveDiscountCodeRetrieve2QueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationTractiveDiscountCodeRetrieve2>>
>;
export type ApiConversationTractiveDiscountCodeRetrieve2QueryError = ErrorType<unknown>;

export const useApiConversationTractiveDiscountCodeRetrieve2 = <
  TData = Awaited<ReturnType<typeof apiConversationTractiveDiscountCodeRetrieve2>>,
  TError = ErrorType<unknown>
>(
  params?: ApiConversationTractiveDiscountCodeRetrieve2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiConversationTractiveDiscountCodeRetrieve2>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiConversationTractiveDiscountCodeRetrieve2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiConversationTractiveDiscountCodeRetrieve2>>
  > = ({ signal }) => apiConversationTractiveDiscountCodeRetrieve2(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiConversationTractiveDiscountCodeRetrieve2>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiBehaviorSkillOptionsRetrieve = (signal?: AbortSignal) => {
  return HTTP<TrainingBehaviorSkillOptionsList>({
    url: `/api/v7/training/behavior-skill-options/`,
    method: 'get',
    signal,
  });
};

export const getApiBehaviorSkillOptionsRetrieveQueryKey = () => [
  `/api/v7/training/behavior-skill-options/`,
];

export type ApiBehaviorSkillOptionsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiBehaviorSkillOptionsRetrieve>>
>;
export type ApiBehaviorSkillOptionsRetrieveQueryError = ErrorType<unknown>;

export const useApiBehaviorSkillOptionsRetrieve = <
  TData = Awaited<ReturnType<typeof apiBehaviorSkillOptionsRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiBehaviorSkillOptionsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiBehaviorSkillOptionsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiBehaviorSkillOptionsRetrieve>>> = ({
    signal,
  }) => apiBehaviorSkillOptionsRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiBehaviorSkillOptionsRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Rely primarily on the super call chain, handling normal failure
modes by responding with an HTTP 400 response.
 */
export const apiTrainingConversationsList = (
  params?: ApiTrainingConversationsListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedConversationList>({
    url: `/api/v7/training/conversations/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiTrainingConversationsListQueryKey = (
  params?: ApiTrainingConversationsListParams
) => [`/api/v7/training/conversations/`, ...(params ? [params] : [])];

export type ApiTrainingConversationsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTrainingConversationsList>>
>;
export type ApiTrainingConversationsListQueryError = ErrorType<unknown>;

export const useApiTrainingConversationsList = <
  TData = Awaited<ReturnType<typeof apiTrainingConversationsList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiTrainingConversationsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiTrainingConversationsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTrainingConversationsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTrainingConversationsList>>> = ({
    signal,
  }) => apiTrainingConversationsList(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiTrainingConversationsList>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Raises EmailVerificationNeededAPIException if the user needs to validate their email.

Runs for every request method by default.
Implement get_verify_email_for_verbs to specify which methods to verify.
 */
export const apiTrainingConversationsCreate = (
  trainingConversationCreation: TrainingConversationCreation
) => {
  return HTTP<Conversation>({
    url: `/api/v7/training/conversations/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: trainingConversationCreation,
  });
};

export type ApiTrainingConversationsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTrainingConversationsCreate>>
>;
export type ApiTrainingConversationsCreateMutationBody = TrainingConversationCreation;
export type ApiTrainingConversationsCreateMutationError = ErrorType<void>;

export const useApiTrainingConversationsCreate = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTrainingConversationsCreate>>,
    TError,
    { data: TrainingConversationCreation },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTrainingConversationsCreate>>,
    { data: TrainingConversationCreation }
  > = (props) => {
    const { data } = props ?? {};

    return apiTrainingConversationsCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiTrainingConversationsCreate>>,
    TError,
    { data: TrainingConversationCreation },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiServiceRelationshipVideoLinkRetrieve = (
  conversationOpk: string,
  signal?: AbortSignal
) => {
  return HTTP<ServiceRelationshipVideoLinkRead>({
    url: `/api/v7/training/conversations/${conversationOpk}/video-link/`,
    method: 'get',
    signal,
  });
};

export const getApiServiceRelationshipVideoLinkRetrieveQueryKey = (conversationOpk: string) => [
  `/api/v7/training/conversations/${conversationOpk}/video-link/`,
];

export type ApiServiceRelationshipVideoLinkRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceRelationshipVideoLinkRetrieve>>
>;
export type ApiServiceRelationshipVideoLinkRetrieveQueryError = ErrorType<unknown>;

export const useApiServiceRelationshipVideoLinkRetrieve = <
  TData = Awaited<ReturnType<typeof apiServiceRelationshipVideoLinkRetrieve>>,
  TError = ErrorType<unknown>
>(
  conversationOpk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiServiceRelationshipVideoLinkRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiServiceRelationshipVideoLinkRetrieveQueryKey(conversationOpk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiServiceRelationshipVideoLinkRetrieve>>
  > = ({ signal }) => apiServiceRelationshipVideoLinkRetrieve(conversationOpk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiServiceRelationshipVideoLinkRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!conversationOpk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiServiceRelationshipVideoLinkUpdate = (
  conversationOpk: string,
  serviceRelationshipVideoLinkWrite: ServiceRelationshipVideoLinkWrite
) => {
  return HTTP<ServiceRelationshipVideoLinkRead>({
    url: `/api/v7/training/conversations/${conversationOpk}/video-link/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: serviceRelationshipVideoLinkWrite,
  });
};

export type ApiServiceRelationshipVideoLinkUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceRelationshipVideoLinkUpdate>>
>;
export type ApiServiceRelationshipVideoLinkUpdateMutationBody = ServiceRelationshipVideoLinkWrite;
export type ApiServiceRelationshipVideoLinkUpdateMutationError = ErrorType<void>;

export const useApiServiceRelationshipVideoLinkUpdate = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiServiceRelationshipVideoLinkUpdate>>,
    TError,
    { conversationOpk: string; data: ServiceRelationshipVideoLinkWrite },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiServiceRelationshipVideoLinkUpdate>>,
    { conversationOpk: string; data: ServiceRelationshipVideoLinkWrite }
  > = (props) => {
    const { conversationOpk, data } = props ?? {};

    return apiServiceRelationshipVideoLinkUpdate(conversationOpk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiServiceRelationshipVideoLinkUpdate>>,
    TError,
    { conversationOpk: string; data: ServiceRelationshipVideoLinkWrite },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiBundlePurchaseConversationDetailViewUpdate = (
  opk: string,
  bundleConversationDetailRequest: BundleConversationDetailRequest
) => {
  return HTTP<ConversationDetail>({
    url: `/api/v7/training/conversations/${opk}/bundle-purchase/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: bundleConversationDetailRequest,
  });
};

export type ApiBundlePurchaseConversationDetailViewUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiBundlePurchaseConversationDetailViewUpdate>>
>;
export type ApiBundlePurchaseConversationDetailViewUpdateMutationBody =
  BundleConversationDetailRequest;
export type ApiBundlePurchaseConversationDetailViewUpdateMutationError = ErrorType<unknown>;

export const useApiBundlePurchaseConversationDetailViewUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiBundlePurchaseConversationDetailViewUpdate>>,
    TError,
    { opk: string; data: BundleConversationDetailRequest },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiBundlePurchaseConversationDetailViewUpdate>>,
    { opk: string; data: BundleConversationDetailRequest }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiBundlePurchaseConversationDetailViewUpdate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiBundlePurchaseConversationDetailViewUpdate>>,
    TError,
    { opk: string; data: BundleConversationDetailRequest },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiConversationBundleRequestRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<TrainingConversationBundleRequest>({
    url: `/api/v7/training/conversations/${opk}/bundle-request/`,
    method: 'get',
    signal,
  });
};

export const getApiConversationBundleRequestRetrieveQueryKey = (opk: string) => [
  `/api/v7/training/conversations/${opk}/bundle-request/`,
];

export type ApiConversationBundleRequestRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiConversationBundleRequestRetrieve>>
>;
export type ApiConversationBundleRequestRetrieveQueryError = ErrorType<unknown>;

export const useApiConversationBundleRequestRetrieve = <
  TData = Awaited<ReturnType<typeof apiConversationBundleRequestRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiConversationBundleRequestRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiConversationBundleRequestRetrieveQueryKey(opk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiConversationBundleRequestRetrieve>>
  > = ({ signal }) => apiConversationBundleRequestRetrieve(opk, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiConversationBundleRequestRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiBundlePurchasePricingCreate = (
  opk: string,
  conversationVersion: string,
  bundlePurchasePricingBody: BundlePurchasePricingBody
) => {
  return HTTP<BundlePurchasePricingBody>({
    url: `/api/v7/training/conversations/${opk}/pricing/${conversationVersion}/bundle/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: bundlePurchasePricingBody,
  });
};

export type ApiBundlePurchasePricingCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiBundlePurchasePricingCreate>>
>;
export type ApiBundlePurchasePricingCreateMutationBody = BundlePurchasePricingBody;
export type ApiBundlePurchasePricingCreateMutationError = ErrorType<void>;

export const useApiBundlePurchasePricingCreate = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiBundlePurchasePricingCreate>>,
    TError,
    { opk: string; conversationVersion: string; data: BundlePurchasePricingBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiBundlePurchasePricingCreate>>,
    { opk: string; conversationVersion: string; data: BundlePurchasePricingBody }
  > = (props) => {
    const { opk, conversationVersion, data } = props ?? {};

    return apiBundlePurchasePricingCreate(opk, conversationVersion, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiBundlePurchasePricingCreate>>,
    TError,
    { opk: string; conversationVersion: string; data: BundlePurchasePricingBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiBundleSessionPricingCreate = (
  opk: string,
  conversationVersion: string,
  bundleSessionPricing: BundleSessionPricing
) => {
  return HTTP<BundleSessionPricing>({
    url: `/api/v7/training/conversations/${opk}/pricing/${conversationVersion}/bundle-session/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: bundleSessionPricing,
  });
};

export type ApiBundleSessionPricingCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiBundleSessionPricingCreate>>
>;
export type ApiBundleSessionPricingCreateMutationBody = BundleSessionPricing;
export type ApiBundleSessionPricingCreateMutationError = ErrorType<void>;

export const useApiBundleSessionPricingCreate = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiBundleSessionPricingCreate>>,
    TError,
    { opk: string; conversationVersion: string; data: BundleSessionPricing },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiBundleSessionPricingCreate>>,
    { opk: string; conversationVersion: string; data: BundleSessionPricing }
  > = (props) => {
    const { opk, conversationVersion, data } = props ?? {};

    return apiBundleSessionPricingCreate(opk, conversationVersion, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiBundleSessionPricingCreate>>,
    TError,
    { opk: string; conversationVersion: string; data: BundleSessionPricing },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiTrainerCredentialOrganizationsList = (
  params?: ApiTrainerCredentialOrganizationsListParams,
  signal?: AbortSignal
) => {
  return HTTP<CredentialOrganization[]>({
    url: `/api/v7/training/credential-organizations/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiTrainerCredentialOrganizationsListQueryKey = (
  params?: ApiTrainerCredentialOrganizationsListParams
) => [`/api/v7/training/credential-organizations/`, ...(params ? [params] : [])];

export type ApiTrainerCredentialOrganizationsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTrainerCredentialOrganizationsList>>
>;
export type ApiTrainerCredentialOrganizationsListQueryError = ErrorType<unknown>;

export const useApiTrainerCredentialOrganizationsList = <
  TData = Awaited<ReturnType<typeof apiTrainerCredentialOrganizationsList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiTrainerCredentialOrganizationsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiTrainerCredentialOrganizationsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiTrainerCredentialOrganizationsListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiTrainerCredentialOrganizationsList>>
  > = ({ signal }) => apiTrainerCredentialOrganizationsList(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiTrainerCredentialOrganizationsList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Uploads a trainer's credentials to their trainer profile review zendesk ticket.

This endpoint takes in multiple files but does not support partial upload success.
Either all of the files are uploaded successfully and attached to the ticket or none.

When a zendesk file is uploaded, it is stored temporarily until it is either attached
as a ticket comment, or the upload expires after 60 minutes. Therefore, there's no
harm in uploading some of the provided files only to not attach them to the ticket
in the event that one of the file uploads fails.

https://developer.zendesk.com/api-reference/ticketing/tickets/ticket-attachments/#upload-files
 */
export const apiTrainingCredentialsUploadCreate = (
  apiTrainingCredentialsUploadCreateBody: ApiTrainingCredentialsUploadCreateBody
) => {
  const formData = new FormData();
  apiTrainingCredentialsUploadCreateBody.files.forEach((value) => formData.append('files', value));

  return HTTP<void>({
    url: `/api/v7/training/credentials-upload/`,
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
};

export type ApiTrainingCredentialsUploadCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTrainingCredentialsUploadCreate>>
>;
export type ApiTrainingCredentialsUploadCreateMutationBody = ApiTrainingCredentialsUploadCreateBody;
export type ApiTrainingCredentialsUploadCreateMutationError = ErrorType<unknown>;

export const useApiTrainingCredentialsUploadCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTrainingCredentialsUploadCreate>>,
    TError,
    { data: ApiTrainingCredentialsUploadCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTrainingCredentialsUploadCreate>>,
    { data: ApiTrainingCredentialsUploadCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiTrainingCredentialsUploadCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiTrainingCredentialsUploadCreate>>,
    TError,
    { data: ApiTrainingCredentialsUploadCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiNearbyTrainerCountRetrieve = (
  providerSlug: string,
  params?: ApiNearbyTrainerCountRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<NearbyTrainerCountResponse>({
    url: `/api/v7/training/members/${providerSlug}/nearby-trainer-count/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiNearbyTrainerCountRetrieveQueryKey = (
  providerSlug: string,
  params?: ApiNearbyTrainerCountRetrieveParams
) => [
  `/api/v7/training/members/${providerSlug}/nearby-trainer-count/`,
  ...(params ? [params] : []),
];

export type ApiNearbyTrainerCountRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiNearbyTrainerCountRetrieve>>
>;
export type ApiNearbyTrainerCountRetrieveQueryError = ErrorType<unknown>;

export const useApiNearbyTrainerCountRetrieve = <
  TData = Awaited<ReturnType<typeof apiNearbyTrainerCountRetrieve>>,
  TError = ErrorType<unknown>
>(
  providerSlug: string,
  params?: ApiNearbyTrainerCountRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiNearbyTrainerCountRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiNearbyTrainerCountRetrieveQueryKey(providerSlug, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiNearbyTrainerCountRetrieve>>> = ({
    signal,
  }) => apiNearbyTrainerCountRetrieve(providerSlug, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiNearbyTrainerCountRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!providerSlug,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list/create views.
 */
export const apiBundleOfferingList = (
  providerSlug: string,
  serviceSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<BundleOffering[]>({
    url: `/api/v7/training/members/${providerSlug}/services/${serviceSlug}/bundle-offerings/`,
    method: 'get',
    signal,
  });
};

export const getApiBundleOfferingListQueryKey = (providerSlug: string, serviceSlug: string) => [
  `/api/v7/training/members/${providerSlug}/services/${serviceSlug}/bundle-offerings/`,
];

export type ApiBundleOfferingListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiBundleOfferingList>>
>;
export type ApiBundleOfferingListQueryError = ErrorType<unknown>;

export const useApiBundleOfferingList = <
  TData = Awaited<ReturnType<typeof apiBundleOfferingList>>,
  TError = ErrorType<unknown>
>(
  providerSlug: string,
  serviceSlug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiBundleOfferingList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiBundleOfferingListQueryKey(providerSlug, serviceSlug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiBundleOfferingList>>> = ({ signal }) =>
    apiBundleOfferingList(providerSlug, serviceSlug, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiBundleOfferingList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!(providerSlug && serviceSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Sets reasonable pagination defaults for all the API list/create views.
 */
export const apiBundleOfferingListCreate = (
  providerSlug: string,
  serviceSlug: string,
  bundleOfferingWrite: BundleOfferingWrite
) => {
  return HTTP<BundleOffering>({
    url: `/api/v7/training/members/${providerSlug}/services/${serviceSlug}/bundle-offerings/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: bundleOfferingWrite,
  });
};

export type ApiBundleOfferingListCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiBundleOfferingListCreate>>
>;
export type ApiBundleOfferingListCreateMutationBody = BundleOfferingWrite;
export type ApiBundleOfferingListCreateMutationError = ErrorType<void>;

export const useApiBundleOfferingListCreate = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiBundleOfferingListCreate>>,
    TError,
    { providerSlug: string; serviceSlug: string; data: BundleOfferingWrite },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiBundleOfferingListCreate>>,
    { providerSlug: string; serviceSlug: string; data: BundleOfferingWrite }
  > = (props) => {
    const { providerSlug, serviceSlug, data } = props ?? {};

    return apiBundleOfferingListCreate(providerSlug, serviceSlug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiBundleOfferingListCreate>>,
    TError,
    { providerSlug: string; serviceSlug: string; data: BundleOfferingWrite },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiBundleOfferingRetrieve = (
  providerSlug: string,
  serviceSlug: string,
  opk: string,
  signal?: AbortSignal
) => {
  return HTTP<BundleOffering>({
    url: `/api/v7/training/members/${providerSlug}/services/${serviceSlug}/bundle-offerings/${opk}/`,
    method: 'get',
    signal,
  });
};

export const getApiBundleOfferingRetrieveQueryKey = (
  providerSlug: string,
  serviceSlug: string,
  opk: string
) => [`/api/v7/training/members/${providerSlug}/services/${serviceSlug}/bundle-offerings/${opk}/`];

export type ApiBundleOfferingRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiBundleOfferingRetrieve>>
>;
export type ApiBundleOfferingRetrieveQueryError = ErrorType<unknown>;

export const useApiBundleOfferingRetrieve = <
  TData = Awaited<ReturnType<typeof apiBundleOfferingRetrieve>>,
  TError = ErrorType<unknown>
>(
  providerSlug: string,
  serviceSlug: string,
  opk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiBundleOfferingRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiBundleOfferingRetrieveQueryKey(providerSlug, serviceSlug, opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiBundleOfferingRetrieve>>> = ({
    signal,
  }) => apiBundleOfferingRetrieve(providerSlug, serviceSlug, opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiBundleOfferingRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!(providerSlug && serviceSlug && opk),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiBundleOfferingUpdate = (
  providerSlug: string,
  serviceSlug: string,
  opk: string,
  bundleOfferingWrite: BundleOfferingWrite
) => {
  return HTTP<BundleOffering>({
    url: `/api/v7/training/members/${providerSlug}/services/${serviceSlug}/bundle-offerings/${opk}/`,
    method: 'put',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: bundleOfferingWrite,
  });
};

export type ApiBundleOfferingUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiBundleOfferingUpdate>>
>;
export type ApiBundleOfferingUpdateMutationBody = BundleOfferingWrite;
export type ApiBundleOfferingUpdateMutationError = ErrorType<void>;

export const useApiBundleOfferingUpdate = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiBundleOfferingUpdate>>,
    TError,
    { providerSlug: string; serviceSlug: string; opk: string; data: BundleOfferingWrite },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiBundleOfferingUpdate>>,
    { providerSlug: string; serviceSlug: string; opk: string; data: BundleOfferingWrite }
  > = (props) => {
    const { providerSlug, serviceSlug, opk, data } = props ?? {};

    return apiBundleOfferingUpdate(providerSlug, serviceSlug, opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiBundleOfferingUpdate>>,
    TError,
    { providerSlug: string; serviceSlug: string; opk: string; data: BundleOfferingWrite },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiBundleOfferingDestroy = (
  providerSlug: string,
  serviceSlug: string,
  opk: string
) => {
  return HTTP<void>({
    url: `/api/v7/training/members/${providerSlug}/services/${serviceSlug}/bundle-offerings/${opk}/`,
    method: 'delete',
  });
};

export type ApiBundleOfferingDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiBundleOfferingDestroy>>
>;

export type ApiBundleOfferingDestroyMutationError = ErrorType<unknown>;

export const useApiBundleOfferingDestroy = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiBundleOfferingDestroy>>,
    TError,
    { providerSlug: string; serviceSlug: string; opk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiBundleOfferingDestroy>>,
    { providerSlug: string; serviceSlug: string; opk: string }
  > = (props) => {
    const { providerSlug, serviceSlug, opk } = props ?? {};

    return apiBundleOfferingDestroy(providerSlug, serviceSlug, opk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiBundleOfferingDestroy>>,
    TError,
    { providerSlug: string; serviceSlug: string; opk: string },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiBundleSessionCreateCreate = (
  providerSlug: string,
  serviceSlug: string,
  opk: string,
  trainingBundleSessionCreation: TrainingBundleSessionCreation
) => {
  return HTTP<Conversation>({
    url: `/api/v7/training/members/${providerSlug}/services/${serviceSlug}/bundle-relationship/${opk}/session/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: trainingBundleSessionCreation,
  });
};

export type ApiBundleSessionCreateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiBundleSessionCreateCreate>>
>;
export type ApiBundleSessionCreateCreateMutationBody = TrainingBundleSessionCreation;
export type ApiBundleSessionCreateCreateMutationError = ErrorType<void>;

export const useApiBundleSessionCreateCreate = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiBundleSessionCreateCreate>>,
    TError,
    { providerSlug: string; serviceSlug: string; opk: string; data: TrainingBundleSessionCreation },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiBundleSessionCreateCreate>>,
    { providerSlug: string; serviceSlug: string; opk: string; data: TrainingBundleSessionCreation }
  > = (props) => {
    const { providerSlug, serviceSlug, opk, data } = props ?? {};

    return apiBundleSessionCreateCreate(providerSlug, serviceSlug, opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiBundleSessionCreateCreate>>,
    TError,
    { providerSlug: string; serviceSlug: string; opk: string; data: TrainingBundleSessionCreation },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Rely primarily on the super call chain, handling normal failure
modes by responding with an HTTP 400 response.
 */
export const apiBundleRequestCreateList = (
  providerSlug: string,
  serviceSlug: string,
  params?: ApiBundleRequestCreateListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedConversationList>({
    url: `/api/v7/training/members/${providerSlug}/services/${serviceSlug}/bundle-request/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiBundleRequestCreateListQueryKey = (
  providerSlug: string,
  serviceSlug: string,
  params?: ApiBundleRequestCreateListParams
) => [
  `/api/v7/training/members/${providerSlug}/services/${serviceSlug}/bundle-request/`,
  ...(params ? [params] : []),
];

export type ApiBundleRequestCreateListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiBundleRequestCreateList>>
>;
export type ApiBundleRequestCreateListQueryError = ErrorType<unknown>;

export const useApiBundleRequestCreateList = <
  TData = Awaited<ReturnType<typeof apiBundleRequestCreateList>>,
  TError = ErrorType<unknown>
>(
  providerSlug: string,
  serviceSlug: string,
  params?: ApiBundleRequestCreateListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiBundleRequestCreateList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiBundleRequestCreateListQueryKey(providerSlug, serviceSlug, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiBundleRequestCreateList>>> = ({
    signal,
  }) => apiBundleRequestCreateList(providerSlug, serviceSlug, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiBundleRequestCreateList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!(providerSlug && serviceSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Raises EmailVerificationNeededAPIException if the user needs to validate their email.

Runs for every request method by default.
Implement get_verify_email_for_verbs to specify which methods to verify.
 */
export const apiBundleRequestCreateCreate = (
  providerSlug: string,
  serviceSlug: string,
  bundleRequestCreation: BundleRequestCreation
) => {
  return HTTP<Conversation>({
    url: `/api/v7/training/members/${providerSlug}/services/${serviceSlug}/bundle-request/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: bundleRequestCreation,
  });
};

export type ApiBundleRequestCreateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiBundleRequestCreateCreate>>
>;
export type ApiBundleRequestCreateCreateMutationBody = BundleRequestCreation;
export type ApiBundleRequestCreateCreateMutationError = ErrorType<void>;

export const useApiBundleRequestCreateCreate = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiBundleRequestCreateCreate>>,
    TError,
    { providerSlug: string; serviceSlug: string; data: BundleRequestCreation },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiBundleRequestCreateCreate>>,
    { providerSlug: string; serviceSlug: string; data: BundleRequestCreation }
  > = (props) => {
    const { providerSlug, serviceSlug, data } = props ?? {};

    return apiBundleRequestCreateCreate(providerSlug, serviceSlug, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiBundleRequestCreateCreate>>,
    TError,
    { providerSlug: string; serviceSlug: string; data: BundleRequestCreation },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiSessionTypeOptionsList = (
  providerSlug: string,
  serviceSlug: string,
  params?: ApiSessionTypeOptionsListParams,
  signal?: AbortSignal
) => {
  return HTTP<SessionTypeOption[]>({
    url: `/api/v7/training/members/${providerSlug}/services/${serviceSlug}/session-type-options/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiSessionTypeOptionsListQueryKey = (
  providerSlug: string,
  serviceSlug: string,
  params?: ApiSessionTypeOptionsListParams
) => [
  `/api/v7/training/members/${providerSlug}/services/${serviceSlug}/session-type-options/`,
  ...(params ? [params] : []),
];

export type ApiSessionTypeOptionsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSessionTypeOptionsList>>
>;
export type ApiSessionTypeOptionsListQueryError = ErrorType<void>;

export const useApiSessionTypeOptionsList = <
  TData = Awaited<ReturnType<typeof apiSessionTypeOptionsList>>,
  TError = ErrorType<void>
>(
  providerSlug: string,
  serviceSlug: string,
  params?: ApiSessionTypeOptionsListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiSessionTypeOptionsList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiSessionTypeOptionsListQueryKey(providerSlug, serviceSlug, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSessionTypeOptionsList>>> = ({
    signal,
  }) => apiSessionTypeOptionsList(providerSlug, serviceSlug, params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiSessionTypeOptionsList>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!(providerSlug && serviceSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiPublicTrainerProfileRetrieve = (slug: string, signal?: AbortSignal) => {
  return HTTP<PersonTrainerProfile>({
    url: `/api/v7/training/members/${slug}/`,
    method: 'get',
    signal,
  });
};

export const getApiPublicTrainerProfileRetrieveQueryKey = (slug: string) => [
  `/api/v7/training/members/${slug}/`,
];

export type ApiPublicTrainerProfileRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPublicTrainerProfileRetrieve>>
>;
export type ApiPublicTrainerProfileRetrieveQueryError = ErrorType<unknown>;

export const useApiPublicTrainerProfileRetrieve = <
  TData = Awaited<ReturnType<typeof apiPublicTrainerProfileRetrieve>>,
  TError = ErrorType<unknown>
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPublicTrainerProfileRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPublicTrainerProfileRetrieveQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPublicTrainerProfileRetrieve>>> = ({
    signal,
  }) => apiPublicTrainerProfileRetrieve(slug, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiPublicTrainerProfileRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!slug,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiTrainingSearchRetrieve = (
  params?: ApiTrainingSearchRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<TrainingSearchResponse>({
    url: `/api/v7/training/search-results/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiTrainingSearchRetrieveQueryKey = (params?: ApiTrainingSearchRetrieveParams) => [
  `/api/v7/training/search-results/`,
  ...(params ? [params] : []),
];

export type ApiTrainingSearchRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTrainingSearchRetrieve>>
>;
export type ApiTrainingSearchRetrieveQueryError = ErrorType<unknown>;

export const useApiTrainingSearchRetrieve = <
  TData = Awaited<ReturnType<typeof apiTrainingSearchRetrieve>>,
  TError = ErrorType<unknown>
>(
  params?: ApiTrainingSearchRetrieveParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiTrainingSearchRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTrainingSearchRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTrainingSearchRetrieve>>> = ({
    signal,
  }) => apiTrainingSearchRetrieve(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiTrainingSearchRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiTrainingSessionCancellationReasonsList = (
  userType: string,
  signal?: AbortSignal
) => {
  return HTTP<ModificationReasonChoices[]>({
    url: `/api/v7/training/session-cancellation-reasons/${userType}/`,
    method: 'get',
    signal,
  });
};

export const getApiTrainingSessionCancellationReasonsListQueryKey = (userType: string) => [
  `/api/v7/training/session-cancellation-reasons/${userType}/`,
];

export type ApiTrainingSessionCancellationReasonsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTrainingSessionCancellationReasonsList>>
>;
export type ApiTrainingSessionCancellationReasonsListQueryError = ErrorType<unknown>;

export const useApiTrainingSessionCancellationReasonsList = <
  TData = Awaited<ReturnType<typeof apiTrainingSessionCancellationReasonsList>>,
  TError = ErrorType<unknown>
>(
  userType: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiTrainingSessionCancellationReasonsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiTrainingSessionCancellationReasonsListQueryKey(userType);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiTrainingSessionCancellationReasonsList>>
  > = ({ signal }) => apiTrainingSessionCancellationReasonsList(userType, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiTrainingSessionCancellationReasonsList>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!userType,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiTrainerApplicationResetUpdate = () => {
  return HTTP<void>({ url: `/api/v7/training/trainer-application-reset/`, method: 'put' });
};

export type ApiTrainerApplicationResetUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTrainerApplicationResetUpdate>>
>;

export type ApiTrainerApplicationResetUpdateMutationError = ErrorType<unknown>;

export const useApiTrainerApplicationResetUpdate = <
  TError = ErrorType<unknown>,
  TVariables = void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTrainerApplicationResetUpdate>>,
    TError,
    TVariables,
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTrainerApplicationResetUpdate>>,
    TVariables
  > = () => {
    return apiTrainerApplicationResetUpdate();
  };

  return useMutation<
    Awaited<ReturnType<typeof apiTrainerApplicationResetUpdate>>,
    TError,
    TVariables,
    TContext
  >(mutationFn, mutationOptions);
};

export const apiTrainerProfileBehaviorsRetrieve = (signal?: AbortSignal) => {
  return HTTP<TrainerProfileBehaviors>({
    url: `/api/v7/training/trainer-profile/behaviors/`,
    method: 'get',
    signal,
  });
};

export const getApiTrainerProfileBehaviorsRetrieveQueryKey = () => [
  `/api/v7/training/trainer-profile/behaviors/`,
];

export type ApiTrainerProfileBehaviorsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTrainerProfileBehaviorsRetrieve>>
>;
export type ApiTrainerProfileBehaviorsRetrieveQueryError = ErrorType<unknown>;

export const useApiTrainerProfileBehaviorsRetrieve = <
  TData = Awaited<ReturnType<typeof apiTrainerProfileBehaviorsRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiTrainerProfileBehaviorsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTrainerProfileBehaviorsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTrainerProfileBehaviorsRetrieve>>> = ({
    signal,
  }) => apiTrainerProfileBehaviorsRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiTrainerProfileBehaviorsRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiTrainerProfileBehaviorsPartialUpdate = (
  patchedTrainerProfileBehaviorsWrite: PatchedTrainerProfileBehaviorsWrite
) => {
  return HTTP<TrainerProfileBehaviorsWrite>({
    url: `/api/v7/training/trainer-profile/behaviors/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedTrainerProfileBehaviorsWrite,
  });
};

export type ApiTrainerProfileBehaviorsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTrainerProfileBehaviorsPartialUpdate>>
>;
export type ApiTrainerProfileBehaviorsPartialUpdateMutationBody =
  PatchedTrainerProfileBehaviorsWrite;
export type ApiTrainerProfileBehaviorsPartialUpdateMutationError = ErrorType<unknown>;

export const useApiTrainerProfileBehaviorsPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTrainerProfileBehaviorsPartialUpdate>>,
    TError,
    { data: PatchedTrainerProfileBehaviorsWrite },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTrainerProfileBehaviorsPartialUpdate>>,
    { data: PatchedTrainerProfileBehaviorsWrite }
  > = (props) => {
    const { data } = props ?? {};

    return apiTrainerProfileBehaviorsPartialUpdate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiTrainerProfileBehaviorsPartialUpdate>>,
    TError,
    { data: PatchedTrainerProfileBehaviorsWrite },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiTrainerProfileBehaviorsCustomRetrieve = (signal?: AbortSignal) => {
  return HTTP<TrainerProfileBehaviorsCustom>({
    url: `/api/v7/training/trainer-profile/behaviors-custom/`,
    method: 'get',
    signal,
  });
};

export const getApiTrainerProfileBehaviorsCustomRetrieveQueryKey = () => [
  `/api/v7/training/trainer-profile/behaviors-custom/`,
];

export type ApiTrainerProfileBehaviorsCustomRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTrainerProfileBehaviorsCustomRetrieve>>
>;
export type ApiTrainerProfileBehaviorsCustomRetrieveQueryError = ErrorType<unknown>;

export const useApiTrainerProfileBehaviorsCustomRetrieve = <
  TData = Awaited<ReturnType<typeof apiTrainerProfileBehaviorsCustomRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiTrainerProfileBehaviorsCustomRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTrainerProfileBehaviorsCustomRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiTrainerProfileBehaviorsCustomRetrieve>>
  > = ({ signal }) => apiTrainerProfileBehaviorsCustomRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiTrainerProfileBehaviorsCustomRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiTrainerProfileBehaviorsCustomPartialUpdate = (
  patchedTrainerProfileBehaviorsCustomWrite: PatchedTrainerProfileBehaviorsCustomWrite
) => {
  return HTTP<TrainerProfileBehaviorsCustomWrite>({
    url: `/api/v7/training/trainer-profile/behaviors-custom/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedTrainerProfileBehaviorsCustomWrite,
  });
};

export type ApiTrainerProfileBehaviorsCustomPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTrainerProfileBehaviorsCustomPartialUpdate>>
>;
export type ApiTrainerProfileBehaviorsCustomPartialUpdateMutationBody =
  PatchedTrainerProfileBehaviorsCustomWrite;
export type ApiTrainerProfileBehaviorsCustomPartialUpdateMutationError = ErrorType<unknown>;

export const useApiTrainerProfileBehaviorsCustomPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTrainerProfileBehaviorsCustomPartialUpdate>>,
    TError,
    { data: PatchedTrainerProfileBehaviorsCustomWrite },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTrainerProfileBehaviorsCustomPartialUpdate>>,
    { data: PatchedTrainerProfileBehaviorsCustomWrite }
  > = (props) => {
    const { data } = props ?? {};

    return apiTrainerProfileBehaviorsCustomPartialUpdate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiTrainerProfileBehaviorsCustomPartialUpdate>>,
    TError,
    { data: PatchedTrainerProfileBehaviorsCustomWrite },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiTrainerProfileDetailRetrieve = (signal?: AbortSignal) => {
  return HTTP<TrainerProfileDetails>({
    url: `/api/v7/training/trainer-profile/details/`,
    method: 'get',
    signal,
  });
};

export const getApiTrainerProfileDetailRetrieveQueryKey = () => [
  `/api/v7/training/trainer-profile/details/`,
];

export type ApiTrainerProfileDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTrainerProfileDetailRetrieve>>
>;
export type ApiTrainerProfileDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiTrainerProfileDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiTrainerProfileDetailRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiTrainerProfileDetailRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTrainerProfileDetailRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTrainerProfileDetailRetrieve>>> = ({
    signal,
  }) => apiTrainerProfileDetailRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiTrainerProfileDetailRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiTrainerProfileDetailCreate = (trainerProfileDetails: TrainerProfileDetails) => {
  return HTTP<TrainerProfileDetails>({
    url: `/api/v7/training/trainer-profile/details/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: trainerProfileDetails,
  });
};

export type ApiTrainerProfileDetailCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTrainerProfileDetailCreate>>
>;
export type ApiTrainerProfileDetailCreateMutationBody = TrainerProfileDetails;
export type ApiTrainerProfileDetailCreateMutationError = ErrorType<unknown>;

export const useApiTrainerProfileDetailCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTrainerProfileDetailCreate>>,
    TError,
    { data: TrainerProfileDetails },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTrainerProfileDetailCreate>>,
    { data: TrainerProfileDetails }
  > = (props) => {
    const { data } = props ?? {};

    return apiTrainerProfileDetailCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiTrainerProfileDetailCreate>>,
    TError,
    { data: TrainerProfileDetails },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiTrainerProfileDetailsDataRetrieve = (signal?: AbortSignal) => {
  return HTTP<TrainerProfileDetailsDataRead>({
    url: `/api/v7/training/trainer-profile/details-data/`,
    method: 'get',
    signal,
  });
};

export const getApiTrainerProfileDetailsDataRetrieveQueryKey = () => [
  `/api/v7/training/trainer-profile/details-data/`,
];

export type ApiTrainerProfileDetailsDataRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTrainerProfileDetailsDataRetrieve>>
>;
export type ApiTrainerProfileDetailsDataRetrieveQueryError = ErrorType<unknown>;

export const useApiTrainerProfileDetailsDataRetrieve = <
  TData = Awaited<ReturnType<typeof apiTrainerProfileDetailsDataRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiTrainerProfileDetailsDataRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTrainerProfileDetailsDataRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiTrainerProfileDetailsDataRetrieve>>
  > = ({ signal }) => apiTrainerProfileDetailsDataRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiTrainerProfileDetailsDataRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiTrainerProfileDetailsDataCreate = (
  trainerProfileDetailsDataWrite: TrainerProfileDetailsDataWrite
) => {
  return HTTP<TrainerProfileDetailsDataRead>({
    url: `/api/v7/training/trainer-profile/details-data/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: trainerProfileDetailsDataWrite,
  });
};

export type ApiTrainerProfileDetailsDataCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTrainerProfileDetailsDataCreate>>
>;
export type ApiTrainerProfileDetailsDataCreateMutationBody = TrainerProfileDetailsDataWrite;
export type ApiTrainerProfileDetailsDataCreateMutationError = ErrorType<unknown>;

export const useApiTrainerProfileDetailsDataCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTrainerProfileDetailsDataCreate>>,
    TError,
    { data: TrainerProfileDetailsDataWrite },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTrainerProfileDetailsDataCreate>>,
    { data: TrainerProfileDetailsDataWrite }
  > = (props) => {
    const { data } = props ?? {};

    return apiTrainerProfileDetailsDataCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiTrainerProfileDetailsDataCreate>>,
    TError,
    { data: TrainerProfileDetailsDataWrite },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiTrainerProfileEducationRetrieve = (signal?: AbortSignal) => {
  return HTTP<TrainerProfileTrainerEducation>({
    url: `/api/v7/training/trainer-profile/education/`,
    method: 'get',
    signal,
  });
};

export const getApiTrainerProfileEducationRetrieveQueryKey = () => [
  `/api/v7/training/trainer-profile/education/`,
];

export type ApiTrainerProfileEducationRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTrainerProfileEducationRetrieve>>
>;
export type ApiTrainerProfileEducationRetrieveQueryError = ErrorType<unknown>;

export const useApiTrainerProfileEducationRetrieve = <
  TData = Awaited<ReturnType<typeof apiTrainerProfileEducationRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiTrainerProfileEducationRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTrainerProfileEducationRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTrainerProfileEducationRetrieve>>> = ({
    signal,
  }) => apiTrainerProfileEducationRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiTrainerProfileEducationRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiTrainerProfileEducationPartialUpdate = (
  patchedTrainerProfileTrainerEducationWrite: PatchedTrainerProfileTrainerEducationWrite
) => {
  return HTTP<TrainerProfileTrainerEducationWrite>({
    url: `/api/v7/training/trainer-profile/education/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedTrainerProfileTrainerEducationWrite,
  });
};

export type ApiTrainerProfileEducationPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTrainerProfileEducationPartialUpdate>>
>;
export type ApiTrainerProfileEducationPartialUpdateMutationBody =
  PatchedTrainerProfileTrainerEducationWrite;
export type ApiTrainerProfileEducationPartialUpdateMutationError = ErrorType<unknown>;

export const useApiTrainerProfileEducationPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTrainerProfileEducationPartialUpdate>>,
    TError,
    { data: PatchedTrainerProfileTrainerEducationWrite },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTrainerProfileEducationPartialUpdate>>,
    { data: PatchedTrainerProfileTrainerEducationWrite }
  > = (props) => {
    const { data } = props ?? {};

    return apiTrainerProfileEducationPartialUpdate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiTrainerProfileEducationPartialUpdate>>,
    TError,
    { data: PatchedTrainerProfileTrainerEducationWrite },
    TContext
  >(mutationFn, mutationOptions);
};

/**
 * Retrieve a list of chapters for user and user state to inform display on
training sign up hub. Chapters contain modules/accordions, their states,
and types. This is a separate view because existing sitters who otherwise
see the management hub still need to be able to see this hub if they are
signing up as trainers. This view also conditionally updates provider state
and reloads the response.
 */
export const apiTrainerSignUpHubRetrieve = (signal?: AbortSignal) => {
  return HTTP<HubResponse>({
    url: `/api/v7/training/trainer-profile/sign-up/`,
    method: 'get',
    signal,
  });
};

export const getApiTrainerSignUpHubRetrieveQueryKey = () => [
  `/api/v7/training/trainer-profile/sign-up/`,
];

export type ApiTrainerSignUpHubRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTrainerSignUpHubRetrieve>>
>;
export type ApiTrainerSignUpHubRetrieveQueryError = ErrorType<unknown>;

export const useApiTrainerSignUpHubRetrieve = <
  TData = Awaited<ReturnType<typeof apiTrainerSignUpHubRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiTrainerSignUpHubRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTrainerSignUpHubRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTrainerSignUpHubRetrieve>>> = ({
    signal,
  }) => apiTrainerSignUpHubRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiTrainerSignUpHubRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiTrainerProfileSkillsRetrieve = (signal?: AbortSignal) => {
  return HTTP<TrainerProfileSkills>({
    url: `/api/v7/training/trainer-profile/skills/`,
    method: 'get',
    signal,
  });
};

export const getApiTrainerProfileSkillsRetrieveQueryKey = () => [
  `/api/v7/training/trainer-profile/skills/`,
];

export type ApiTrainerProfileSkillsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTrainerProfileSkillsRetrieve>>
>;
export type ApiTrainerProfileSkillsRetrieveQueryError = ErrorType<unknown>;

export const useApiTrainerProfileSkillsRetrieve = <
  TData = Awaited<ReturnType<typeof apiTrainerProfileSkillsRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiTrainerProfileSkillsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTrainerProfileSkillsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTrainerProfileSkillsRetrieve>>> = ({
    signal,
  }) => apiTrainerProfileSkillsRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiTrainerProfileSkillsRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiTrainerProfileSkillsPartialUpdate = (
  patchedTrainerProfileSkillsWrite: PatchedTrainerProfileSkillsWrite
) => {
  return HTTP<TrainerProfileSkillsWrite>({
    url: `/api/v7/training/trainer-profile/skills/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedTrainerProfileSkillsWrite,
  });
};

export type ApiTrainerProfileSkillsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTrainerProfileSkillsPartialUpdate>>
>;
export type ApiTrainerProfileSkillsPartialUpdateMutationBody = PatchedTrainerProfileSkillsWrite;
export type ApiTrainerProfileSkillsPartialUpdateMutationError = ErrorType<unknown>;

export const useApiTrainerProfileSkillsPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTrainerProfileSkillsPartialUpdate>>,
    TError,
    { data: PatchedTrainerProfileSkillsWrite },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTrainerProfileSkillsPartialUpdate>>,
    { data: PatchedTrainerProfileSkillsWrite }
  > = (props) => {
    const { data } = props ?? {};

    return apiTrainerProfileSkillsPartialUpdate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiTrainerProfileSkillsPartialUpdate>>,
    TError,
    { data: PatchedTrainerProfileSkillsWrite },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiTrainerProfileSkillsCustomRetrieve = (signal?: AbortSignal) => {
  return HTTP<TrainerProfileSkillsCustom>({
    url: `/api/v7/training/trainer-profile/skills-custom/`,
    method: 'get',
    signal,
  });
};

export const getApiTrainerProfileSkillsCustomRetrieveQueryKey = () => [
  `/api/v7/training/trainer-profile/skills-custom/`,
];

export type ApiTrainerProfileSkillsCustomRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiTrainerProfileSkillsCustomRetrieve>>
>;
export type ApiTrainerProfileSkillsCustomRetrieveQueryError = ErrorType<unknown>;

export const useApiTrainerProfileSkillsCustomRetrieve = <
  TData = Awaited<ReturnType<typeof apiTrainerProfileSkillsCustomRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiTrainerProfileSkillsCustomRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiTrainerProfileSkillsCustomRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiTrainerProfileSkillsCustomRetrieve>>
  > = ({ signal }) => apiTrainerProfileSkillsCustomRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiTrainerProfileSkillsCustomRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiTrainerProfileSkillsCustomPartialUpdate = (
  patchedTrainerProfileSkillsCustomWrite: PatchedTrainerProfileSkillsCustomWrite
) => {
  return HTTP<TrainerProfileSkillsCustomWrite>({
    url: `/api/v7/training/trainer-profile/skills-custom/`,
    method: 'patch',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: patchedTrainerProfileSkillsCustomWrite,
  });
};

export type ApiTrainerProfileSkillsCustomPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTrainerProfileSkillsCustomPartialUpdate>>
>;
export type ApiTrainerProfileSkillsCustomPartialUpdateMutationBody =
  PatchedTrainerProfileSkillsCustomWrite;
export type ApiTrainerProfileSkillsCustomPartialUpdateMutationError = ErrorType<unknown>;

export const useApiTrainerProfileSkillsCustomPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTrainerProfileSkillsCustomPartialUpdate>>,
    TError,
    { data: PatchedTrainerProfileSkillsCustomWrite },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTrainerProfileSkillsCustomPartialUpdate>>,
    { data: PatchedTrainerProfileSkillsCustomWrite }
  > = (props) => {
    const { data } = props ?? {};

    return apiTrainerProfileSkillsCustomPartialUpdate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiTrainerProfileSkillsCustomPartialUpdate>>,
    TError,
    { data: PatchedTrainerProfileSkillsCustomWrite },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiTrainerRecruitmentDismissCreate = () => {
  return HTTP<void>({
    url: `/api/v7/training/trainer-recruitment/profile/dismiss/`,
    method: 'post',
  });
};

export type ApiTrainerRecruitmentDismissCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiTrainerRecruitmentDismissCreate>>
>;

export type ApiTrainerRecruitmentDismissCreateMutationError = ErrorType<unknown>;

export const useApiTrainerRecruitmentDismissCreate = <
  TError = ErrorType<unknown>,
  TVariables = void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiTrainerRecruitmentDismissCreate>>,
    TError,
    TVariables,
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiTrainerRecruitmentDismissCreate>>,
    TVariables
  > = () => {
    return apiTrainerRecruitmentDismissCreate();
  };

  return useMutation<
    Awaited<ReturnType<typeof apiTrainerRecruitmentDismissCreate>>,
    TError,
    TVariables,
    TContext
  >(mutationFn, mutationOptions);
};

export const apiServiceRelationshipVideoLinkRedirectRetrieve = (
  token: string,
  signal?: AbortSignal
) => {
  return HTTP<ServiceRelationshipVideoLinkRead>({
    url: `/api/v7/training/video-link/${token}/`,
    method: 'get',
    signal,
  });
};

export const getApiServiceRelationshipVideoLinkRedirectRetrieveQueryKey = (token: string) => [
  `/api/v7/training/video-link/${token}/`,
];

export type ApiServiceRelationshipVideoLinkRedirectRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiServiceRelationshipVideoLinkRedirectRetrieve>>
>;
export type ApiServiceRelationshipVideoLinkRedirectRetrieveQueryError = ErrorType<unknown>;

export const useApiServiceRelationshipVideoLinkRedirectRetrieve = <
  TData = Awaited<ReturnType<typeof apiServiceRelationshipVideoLinkRedirectRetrieve>>,
  TError = ErrorType<unknown>
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiServiceRelationshipVideoLinkRedirectRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiServiceRelationshipVideoLinkRedirectRetrieveQueryKey(token);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiServiceRelationshipVideoLinkRedirectRetrieve>>
  > = ({ signal }) => apiServiceRelationshipVideoLinkRedirectRetrieve(token, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiServiceRelationshipVideoLinkRedirectRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!token,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiEdgeCacheMetricsCreate = (edgeCacheMetric: EdgeCacheMetric) => {
  return HTTP<void>({
    url: `/api/v7/utilities/edge-cache-metrics/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: edgeCacheMetric,
  });
};

export type ApiEdgeCacheMetricsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiEdgeCacheMetricsCreate>>
>;
export type ApiEdgeCacheMetricsCreateMutationBody = EdgeCacheMetric;
export type ApiEdgeCacheMetricsCreateMutationError = ErrorType<unknown>;

export const useApiEdgeCacheMetricsCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiEdgeCacheMetricsCreate>>,
    TError,
    { data: EdgeCacheMetric },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiEdgeCacheMetricsCreate>>,
    { data: EdgeCacheMetric }
  > = (props) => {
    const { data } = props ?? {};

    return apiEdgeCacheMetricsCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiEdgeCacheMetricsCreate>>,
    TError,
    { data: EdgeCacheMetric },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiLocationAutocompleteRetrieve = (
  params?: ApiLocationAutocompleteRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<ApiLocationAutocompleteRetrieve200>({
    url: `/api/v7/utilities/location-autocomplete/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiLocationAutocompleteRetrieveQueryKey = (
  params?: ApiLocationAutocompleteRetrieveParams
) => [`/api/v7/utilities/location-autocomplete/`, ...(params ? [params] : [])];

export type ApiLocationAutocompleteRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiLocationAutocompleteRetrieve>>
>;
export type ApiLocationAutocompleteRetrieveQueryError = ErrorType<unknown>;

export const useApiLocationAutocompleteRetrieve = <
  TData = Awaited<ReturnType<typeof apiLocationAutocompleteRetrieve>>,
  TError = ErrorType<unknown>
>(
  params?: ApiLocationAutocompleteRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiLocationAutocompleteRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiLocationAutocompleteRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLocationAutocompleteRetrieve>>> = ({
    signal,
  }) => apiLocationAutocompleteRetrieve(params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiLocationAutocompleteRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * This is intended to be called when we have a place_id from a previous
GoogleLocationAutocomplete call to extract the postal code.
 */
export const apiLocationDetailsCreate = (params?: ApiLocationDetailsCreateParams) => {
  return HTTP<ApiLocationDetailsCreate200>({
    url: `/api/v7/utilities/location-details/`,
    method: 'post',
    params,
  });
};

export type ApiLocationDetailsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiLocationDetailsCreate>>
>;

export type ApiLocationDetailsCreateMutationError = ErrorType<unknown>;

export const useApiLocationDetailsCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiLocationDetailsCreate>>,
    TError,
    { params?: ApiLocationDetailsCreateParams },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiLocationDetailsCreate>>,
    { params?: ApiLocationDetailsCreateParams }
  > = (props) => {
    const { params } = props ?? {};

    return apiLocationDetailsCreate(params);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiLocationDetailsCreate>>,
    TError,
    { params?: ApiLocationDetailsCreateParams },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiLocationGeocodeRetrieve = (
  params?: ApiLocationGeocodeRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<ApiLocationGeocodeRetrieve200>({
    url: `/api/v7/utilities/location-geocode/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiLocationGeocodeRetrieveQueryKey = (
  params?: ApiLocationGeocodeRetrieveParams
) => [`/api/v7/utilities/location-geocode/`, ...(params ? [params] : [])];

export type ApiLocationGeocodeRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiLocationGeocodeRetrieve>>
>;
export type ApiLocationGeocodeRetrieveQueryError = ErrorType<unknown>;

export const useApiLocationGeocodeRetrieve = <
  TData = Awaited<ReturnType<typeof apiLocationGeocodeRetrieve>>,
  TError = ErrorType<unknown>
>(
  params?: ApiLocationGeocodeRetrieveParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiLocationGeocodeRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiLocationGeocodeRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLocationGeocodeRetrieve>>> = ({
    signal,
  }) => apiLocationGeocodeRetrieve(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiLocationGeocodeRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiLocationQueryRetrieve = (
  params?: ApiLocationQueryRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<ApiLocationQueryRetrieve200>({
    url: `/api/v7/utilities/location-query/`,
    method: 'get',
    params,
    signal,
  });
};

export const getApiLocationQueryRetrieveQueryKey = (params?: ApiLocationQueryRetrieveParams) => [
  `/api/v7/utilities/location-query/`,
  ...(params ? [params] : []),
];

export type ApiLocationQueryRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiLocationQueryRetrieve>>
>;
export type ApiLocationQueryRetrieveQueryError = ErrorType<ApiLocationQueryRetrieve400>;

export const useApiLocationQueryRetrieve = <
  TData = Awaited<ReturnType<typeof apiLocationQueryRetrieve>>,
  TError = ErrorType<ApiLocationQueryRetrieve400>
>(
  params?: ApiLocationQueryRetrieveParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiLocationQueryRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiLocationQueryRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLocationQueryRetrieve>>> = ({
    signal,
  }) => apiLocationQueryRetrieve(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiLocationQueryRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

/**
 * Creates a new Nonce object and related record in the database.

A Nonce has a single property, "value", that represents a random, one-time use string
meant to validate requests and prevent replay attacks.

Consumption of the Nonce occurs automatically when provided to certain endpoints,
particularly during authentication.

This endpoint is rate limited.
 */
export const apiNonceCreate = () => {
  return HTTP<ApiNonceCreate201>({ url: `/api/v7/utilities/nonce/`, method: 'post' });
};

export type ApiNonceCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiNonceCreate>>>;

export type ApiNonceCreateMutationError = ErrorType<unknown>;

export const useApiNonceCreate = <
  TError = ErrorType<unknown>,
  TVariables = void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiNonceCreate>>,
    TError,
    TVariables,
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiNonceCreate>>,
    TVariables
  > = () => {
    return apiNonceCreate();
  };

  return useMutation<Awaited<ReturnType<typeof apiNonceCreate>>, TError, TVariables, TContext>(
    mutationFn,
    mutationOptions
  );
};

export const apiPhoneExistsCreate = (apiPhoneExistsCreateBody: ApiPhoneExistsCreateBody) => {
  return HTTP<ApiPhoneExistsCreate200>({
    url: `/api/v7/utilities/phone-check/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiPhoneExistsCreateBody,
  });
};

export type ApiPhoneExistsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiPhoneExistsCreate>>
>;
export type ApiPhoneExistsCreateMutationBody = ApiPhoneExistsCreateBody;
export type ApiPhoneExistsCreateMutationError = ErrorType<unknown>;

export const useApiPhoneExistsCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiPhoneExistsCreate>>,
    TError,
    { data: ApiPhoneExistsCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiPhoneExistsCreate>>,
    { data: ApiPhoneExistsCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiPhoneExistsCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiPhoneExistsCreate>>,
    TError,
    { data: ApiPhoneExistsCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiPostalCodeLookupRetrieve = (
  params?: ApiPostalCodeLookupRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<PostalCode>({ url: `/api/v7/utilities/postal-code/`, method: 'get', params, signal });
};

export const getApiPostalCodeLookupRetrieveQueryKey = (
  params?: ApiPostalCodeLookupRetrieveParams
) => [`/api/v7/utilities/postal-code/`, ...(params ? [params] : [])];

export type ApiPostalCodeLookupRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPostalCodeLookupRetrieve>>
>;
export type ApiPostalCodeLookupRetrieveQueryError = ErrorType<unknown>;

export const useApiPostalCodeLookupRetrieve = <
  TData = Awaited<ReturnType<typeof apiPostalCodeLookupRetrieve>>,
  TError = ErrorType<unknown>
>(
  params?: ApiPostalCodeLookupRetrieveParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiPostalCodeLookupRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPostalCodeLookupRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPostalCodeLookupRetrieve>>> = ({
    signal,
  }) => apiPostalCodeLookupRetrieve(params, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiPostalCodeLookupRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiShortUrlCreate = (apiShortUrlCreateBody: ApiShortUrlCreateBody) => {
  return HTTP<ShortURL>({
    url: `/api/v7/utilities/short-url/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiShortUrlCreateBody,
  });
};

export type ApiShortUrlCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiShortUrlCreate>>
>;
export type ApiShortUrlCreateMutationBody = ApiShortUrlCreateBody;
export type ApiShortUrlCreateMutationError = ErrorType<unknown>;

export const useApiShortUrlCreate = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiShortUrlCreate>>,
    TError,
    { data: ApiShortUrlCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiShortUrlCreate>>,
    { data: ApiShortUrlCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiShortUrlCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiShortUrlCreate>>,
    TError,
    { data: ApiShortUrlCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiUserAgentRetrieve = (signal?: AbortSignal) => {
  return HTTP<ApiUserAgentRetrieve200>({
    url: `/api/v7/utilities/user-agent/`,
    method: 'get',
    signal,
  });
};

export const getApiUserAgentRetrieveQueryKey = () => [`/api/v7/utilities/user-agent/`];

export type ApiUserAgentRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiUserAgentRetrieve>>
>;
export type ApiUserAgentRetrieveQueryError = ErrorType<unknown>;

export const useApiUserAgentRetrieve = <
  TData = Awaited<ReturnType<typeof apiUserAgentRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiUserAgentRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiUserAgentRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiUserAgentRetrieve>>> = ({ signal }) =>
    apiUserAgentRetrieve(signal);

  const query = useQuery<Awaited<ReturnType<typeof apiUserAgentRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiValidatePasswordCreate = (validatePassword: ValidatePassword) => {
  return HTTP<void>({
    url: `/api/v7/validate-password/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: validatePassword,
  });
};

export type ApiValidatePasswordCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiValidatePasswordCreate>>
>;
export type ApiValidatePasswordCreateMutationBody = ValidatePassword;
export type ApiValidatePasswordCreateMutationError =
  ErrorType<ValidatePasswordValidationErrorResponse>;

export const useApiValidatePasswordCreate = <
  TError = ErrorType<ValidatePasswordValidationErrorResponse>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiValidatePasswordCreate>>,
    TError,
    { data: ValidatePassword },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiValidatePasswordCreate>>,
    { data: ValidatePassword }
  > = (props) => {
    const { data } = props ?? {};

    return apiValidatePasswordCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiValidatePasswordCreate>>,
    TError,
    { data: ValidatePassword },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiValidateZipcodeCreate = (validateZipCode: ValidateZipCode) => {
  return HTTP<void>({
    url: `/api/v7/validate-zipcode/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: validateZipCode,
  });
};

export type ApiValidateZipcodeCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiValidateZipcodeCreate>>
>;
export type ApiValidateZipcodeCreateMutationBody = ValidateZipCode;
export type ApiValidateZipcodeCreateMutationError = ErrorType<ValidateEmailValidationErrorResponse>;

export const useApiValidateZipcodeCreate = <
  TError = ErrorType<ValidateEmailValidationErrorResponse>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiValidateZipcodeCreate>>,
    TError,
    { data: ValidateZipCode },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiValidateZipcodeCreate>>,
    { data: ValidateZipCode }
  > = (props) => {
    const { data } = props ?? {};

    return apiValidateZipcodeCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiValidateZipcodeCreate>>,
    TError,
    { data: ValidateZipCode },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiVideoDetailRetrieve = (opk: string, signal?: AbortSignal) => {
  return HTTP<Video>({ url: `/api/v7/videos/${opk}/`, method: 'get', signal });
};

export const getApiVideoDetailRetrieveQueryKey = (opk: string) => [`/api/v7/videos/${opk}/`];

export type ApiVideoDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiVideoDetailRetrieve>>
>;
export type ApiVideoDetailRetrieveQueryError = ErrorType<unknown>;

export const useApiVideoDetailRetrieve = <
  TData = Awaited<ReturnType<typeof apiVideoDetailRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiVideoDetailRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiVideoDetailRetrieveQueryKey(opk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiVideoDetailRetrieve>>> = ({ signal }) =>
    apiVideoDetailRetrieve(opk, signal);

  const query = useQuery<Awaited<ReturnType<typeof apiVideoDetailRetrieve>>, TError, TData>({
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiVideoDetailDestroy = (opk: string) => {
  return HTTP<void>({ url: `/api/v7/videos/${opk}/`, method: 'delete' });
};

export type ApiVideoDetailDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiVideoDetailDestroy>>
>;

export type ApiVideoDetailDestroyMutationError = ErrorType<unknown>;

export const useApiVideoDetailDestroy = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiVideoDetailDestroy>>,
    TError,
    { opk: string },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiVideoDetailDestroy>>,
    { opk: string }
  > = (props) => {
    const { opk } = props ?? {};

    return apiVideoDetailDestroy(opk);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiVideoDetailDestroy>>,
    TError,
    { opk: string },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiVideoUploadAuthorizeCreate = (s3Upload: S3Upload) => {
  return HTTP<ApiVideoUploadAuthorizeCreate201>({
    url: `/api/v7/videos/upload/authorize/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: s3Upload,
  });
};

export type ApiVideoUploadAuthorizeCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiVideoUploadAuthorizeCreate>>
>;
export type ApiVideoUploadAuthorizeCreateMutationBody = S3Upload;
export type ApiVideoUploadAuthorizeCreateMutationError = ErrorType<
  ApiVideoUploadAuthorizeCreate400 | ApiVideoUploadAuthorizeCreate403 | void
>;

export const useApiVideoUploadAuthorizeCreate = <
  TError = ErrorType<ApiVideoUploadAuthorizeCreate400 | ApiVideoUploadAuthorizeCreate403 | void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiVideoUploadAuthorizeCreate>>,
    TError,
    { data: S3Upload },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiVideoUploadAuthorizeCreate>>,
    { data: S3Upload }
  > = (props) => {
    const { data } = props ?? {};

    return apiVideoUploadAuthorizeCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiVideoUploadAuthorizeCreate>>,
    TError,
    { data: S3Upload },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiHookUpdateStatusCreate = (
  opk: string,
  twilioWebhookNotification: TwilioWebhookNotification
) => {
  return HTTP<void>({
    url: `/api/v7/webhook-twilio-room/${opk}/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: twilioWebhookNotification,
  });
};

export type ApiHookUpdateStatusCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiHookUpdateStatusCreate>>
>;
export type ApiHookUpdateStatusCreateMutationBody = TwilioWebhookNotification;
export type ApiHookUpdateStatusCreateMutationError = ErrorType<unknown>;

export const useApiHookUpdateStatusCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiHookUpdateStatusCreate>>,
    TError,
    { opk: string; data: TwilioWebhookNotification },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiHookUpdateStatusCreate>>,
    { opk: string; data: TwilioWebhookNotification }
  > = (props) => {
    const { opk, data } = props ?? {};

    return apiHookUpdateStatusCreate(opk, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiHookUpdateStatusCreate>>,
    TError,
    { opk: string; data: TwilioWebhookNotification },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiFixZendeskConflictErrorRetrieve = (signal?: AbortSignal) => {
  return HTTP<void | ApiFixZendeskConflictErrorRetrieve202>({
    url: `/api/v7/zendesk/fix-zendesk-conflict-error/`,
    method: 'get',
    signal,
  });
};

export const getApiFixZendeskConflictErrorRetrieveQueryKey = () => [
  `/api/v7/zendesk/fix-zendesk-conflict-error/`,
];

export type ApiFixZendeskConflictErrorRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFixZendeskConflictErrorRetrieve>>
>;
export type ApiFixZendeskConflictErrorRetrieveQueryError =
  ErrorType<ApiFixZendeskConflictErrorRetrieve400>;

export const useApiFixZendeskConflictErrorRetrieve = <
  TData = Awaited<ReturnType<typeof apiFixZendeskConflictErrorRetrieve>>,
  TError = ErrorType<ApiFixZendeskConflictErrorRetrieve400>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiFixZendeskConflictErrorRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFixZendeskConflictErrorRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFixZendeskConflictErrorRetrieve>>> = ({
    signal,
  }) => apiFixZendeskConflictErrorRetrieve(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof apiFixZendeskConflictErrorRetrieve>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const apiWebhookZendeskAssignTicketsToCorrespondingAgentCreate = (
  apiWebhookZendeskAssignTicketsToCorrespondingAgentCreateBody: ApiWebhookZendeskAssignTicketsToCorrespondingAgentCreateBody
) => {
  return HTTP<void>({
    url: `/api/v7/zendesk/webhook/assign-tickets-to-corresponding-agent/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiWebhookZendeskAssignTicketsToCorrespondingAgentCreateBody,
  });
};

export type ApiWebhookZendeskAssignTicketsToCorrespondingAgentCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiWebhookZendeskAssignTicketsToCorrespondingAgentCreate>>
>;
export type ApiWebhookZendeskAssignTicketsToCorrespondingAgentCreateMutationBody =
  ApiWebhookZendeskAssignTicketsToCorrespondingAgentCreateBody;
export type ApiWebhookZendeskAssignTicketsToCorrespondingAgentCreateMutationError =
  ErrorType<unknown>;

export const useApiWebhookZendeskAssignTicketsToCorrespondingAgentCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiWebhookZendeskAssignTicketsToCorrespondingAgentCreate>>,
    TError,
    { data: ApiWebhookZendeskAssignTicketsToCorrespondingAgentCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiWebhookZendeskAssignTicketsToCorrespondingAgentCreate>>,
    { data: ApiWebhookZendeskAssignTicketsToCorrespondingAgentCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiWebhookZendeskAssignTicketsToCorrespondingAgentCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiWebhookZendeskAssignTicketsToCorrespondingAgentCreate>>,
    TError,
    { data: ApiWebhookZendeskAssignTicketsToCorrespondingAgentCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiWebhookZendeskInboundCallTicketCreate = (
  apiWebhookZendeskInboundCallTicketCreateBody: ApiWebhookZendeskInboundCallTicketCreateBody
) => {
  return HTTP<void>({
    url: `/api/v7/zendesk/webhook/inbound-call/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiWebhookZendeskInboundCallTicketCreateBody,
  });
};

export type ApiWebhookZendeskInboundCallTicketCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiWebhookZendeskInboundCallTicketCreate>>
>;
export type ApiWebhookZendeskInboundCallTicketCreateMutationBody =
  ApiWebhookZendeskInboundCallTicketCreateBody;
export type ApiWebhookZendeskInboundCallTicketCreateMutationError = ErrorType<unknown>;

export const useApiWebhookZendeskInboundCallTicketCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiWebhookZendeskInboundCallTicketCreate>>,
    TError,
    { data: ApiWebhookZendeskInboundCallTicketCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiWebhookZendeskInboundCallTicketCreate>>,
    { data: ApiWebhookZendeskInboundCallTicketCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiWebhookZendeskInboundCallTicketCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiWebhookZendeskInboundCallTicketCreate>>,
    TError,
    { data: ApiWebhookZendeskInboundCallTicketCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};

export const apiWebhookZendeskUpdateUserCreate = (
  apiWebhookZendeskUpdateUserCreateBody: ApiWebhookZendeskUpdateUserCreateBody
) => {
  return HTTP<void>({
    url: `/api/v7/zendesk/webhook/update-zendesk-user/`,
    method: 'post',
    headers: { 'Content-Type': 'application/vnd.rover.api.camel+json' },
    data: apiWebhookZendeskUpdateUserCreateBody,
  });
};

export type ApiWebhookZendeskUpdateUserCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiWebhookZendeskUpdateUserCreate>>
>;
export type ApiWebhookZendeskUpdateUserCreateMutationBody = ApiWebhookZendeskUpdateUserCreateBody;
export type ApiWebhookZendeskUpdateUserCreateMutationError = ErrorType<unknown>;

export const useApiWebhookZendeskUpdateUserCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiWebhookZendeskUpdateUserCreate>>,
    TError,
    { data: ApiWebhookZendeskUpdateUserCreateBody },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiWebhookZendeskUpdateUserCreate>>,
    { data: ApiWebhookZendeskUpdateUserCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return apiWebhookZendeskUpdateUserCreate(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof apiWebhookZendeskUpdateUserCreate>>,
    TError,
    { data: ApiWebhookZendeskUpdateUserCreateBody },
    TContext
  >(mutationFn, mutationOptions);
};
